const en = {
  "artworkModals": {
    "common": {
      "cancel": "Cancel",
      "add": "Add",
      "save": "Save",
      "delete": "Delete",
      "close": "Close",
      "browse": "Browse",
      "uploading": "Uploading…",
      "saving": "Saving…",
      "notes": "Notes",
      "height": "Height (H)",
      "width": "Width (W)",
      "depth": "Depth (D)",
      "unit": "Unit",
      "centimeters": "Centimetres",
      "inches": "Inches",
      "inchesHelp": "For dimensions in inches, use decimals, for example 10.5 instead of 10 1/2.",
      "dimensionsPositive": "Dimensions must be greater than zero."
    },
    "document": {
      "title": "Add a document",
      "types": {
        "certificate": "Certificate of authenticity",
        "invoice": "Invoice",
        "conditionReport": "Condition report",
        "exhibition": "Exhibition documents",
        "other": "Other"
      },
      "errors": {
        "tooLarge": "The file {{name}} exceeds the maximum size of 30 MB.",
        "nameRequired": "Enter a document name.",
        "typeRequired": "Select a document type.",
        "fileRequired": "Select a file.",
        "upload": "Upload error: {{message}}"
      },
      "fields": {
        "type": "Document type",
        "selectType": "Select a type…",
        "name": "Document name",
        "namePlaceholder": "Document name"
      },
      "actions": {
        "remove": "Remove"
      },
      "dropzone": "Drag and drop a file here",
      "maxSize": "Maximum size: 30 MB"
    },
    "donation": {
      "title": "Donate this artwork",
      "errors": {
        "save": "Error while saving the donation."
      },
      "fields": {
        "valuation": "Estimated value (€)",
        "recipient": "Recipient",
        "date": "Donation date"
      },
      "receiptHelp": "For the tax receipt",
      "placeholders": {
        "recipient": "Museum, foundation, charity…",
        "notes": "Additional information about the donation"
      },
      "actions": {
        "confirm": "Confirm donation"
      }
    },
    "duration": {
      "title": "Add a duration",
      "description": "Specify the duration of this artwork. Applies to videos, performances, temporary installations and sound works.",
      "inputFormat": "Input format",
      "simple": "Free text",
      "detailed": "Detailed (h/min/s)",
      "duration": "Duration",
      "placeholder": "E.g. 12 min 30 sec, 1 hr 45 min, infinite loop…",
      "examples": "Examples: “12 min”, “1 hr 30 min”, “2 hr 45 min 30 sec”, “infinite loop”…",
      "presets": "Preset durations",
      "infiniteLoop": "Infinite loop",
      "hours": "Hours",
      "minutes": "Minutes",
      "seconds": "Seconds",
      "preview": "Preview:",
      "none": "(No duration specified)",
      "errors": {
        "required": "Specify a duration."
      }
    },
    "frameSize": {
      "title": "Add framed dimensions",
      "description": "Enter the dimensions of the artwork with its frame. By default, we suggest dimensions 20% larger than the artwork itself."
    },
    "imageUpload": {
      "title": "Add images",
      "errors": {
        "unsupported": "The file {{name}} is not a supported image format.",
        "tooLarge": "The file {{name}} exceeds the maximum size of 30 MB.",
        "required": "Select at least one image.",
        "uploadFile": "Error uploading {{name}}: {{message}}",
        "publicUrl": "Could not obtain the public URL for {{name}}.",
        "noneUploaded": "No image could be uploaded.",
        "upload": "An error occurred while uploading the images."
      },
      "dropzone": "Drag and drop images here",
      "limits": "Up to 10 images. Maximum size: 30 MB per image.",
      "formats": "Supported formats: JPEG, PNG, WEBP",
      "selected": "Selected images ({{count}})",
      "progress": "Progress",
      "actions": {
        "upload": "Upload images"
      }
    },
    "insurance": {
      "title": "Insurance details",
      "notProvided": "Not provided",
      "notSpecified": "Not specified",
      "notSpecifiedFeminine": "Not specified",
      "invalidDate": "Invalid format",
      "fields": {
        "insurer": "Insurer",
        "policyNumber": "Policy number",
        "period": "Coverage period",
        "coverageAmount": "Insured amount",
        "coverage": "Coverage",
        "premium": "Annual premium",
        "deductible": "Deductible"
      },
      "actions": {
        "manage": "Manage insurance"
      }
    },
    "loan": {
      "title": "Record a loan",
      "returnTitle": "End loan",
      "errors": {
        "save": "Error while saving."
      },
      "currentInfo": "This artwork is currently on loan to {{institution}}. Confirming its return will mark it as available.",
      "unknownInstitution": "an institution",
      "fields": {
        "institution": "Institution / recipient",
        "contact": "On-site contact",
        "startDate": "Loan start",
        "endDate": "Loan end",
        "contractReference": "Contract reference",
        "insuranceRequired": "Insurance required"
      },
      "placeholders": {
        "institution": "Museum of Modern Art, regional art centre, gallery…",
        "contact": "Name, email or phone number",
        "contractReference": "Loan agreement number",
        "notes": "Special terms, clauses, restrictions…"
      },
      "actions": {
        "confirmLoan": "Confirm loan",
        "confirmReturn": "Confirm return"
      }
    },
    "location": {
      "title": "Change location",
      "description": "Select the new location for this artwork.",
      "loading": "Loading locations…",
      "unspecifiedType": "Type not specified",
      "empty": "No other location available",
      "actions": {
        "add": "Add a new location"
      }
    },
    "paperSize": {
      "title": "Add paper dimensions",
      "description": "Enter the dimensions of the paper support for this artwork. They are generally larger than the image itself.",
      "standardFormats": "Standard sizes (optional)",
      "standardHelp": "Select a standard size to apply its dimensions automatically."
    },
    "provenance": {
      "addTitle": "Add a provenance entry",
      "editTitle": "Edit provenance entry",
      "fields": {
        "type": "Provenance type",
        "date": "Date",
        "description": "Description",
        "location": "Location / comment"
      },
      "required": "(required)",
      "placeholders": {
        "description": "La Rive Gallery, Paris, private sale, 2018…",
        "location": "City, country, invoice number… (optional)"
      },
      "types": {
        "select": "— Select a type —",
        "direct_artiste": "Direct from artist",
        "echange_production": "Exchange / production",
        "galerie": "Gallery",
        "vente_privee": "Private sale",
        "encheres": "Auction",
        "succession": "Inheritance / estate",
        "don": "Gift",
        "collection_privee": "Private collection",
        "autre": "Other"
      }
    },
    "size": {
      "dimensionsTitle": "Add dimensions",
      "durationLabel": "Duration (format: HH:MM:SS)",
      "durationPlaceholder": "00:00:00",
      "durationHelp": "Format: hours:minutes:seconds, for example 01:30:00 for 1 hr 30 min."
    },
    "deleteConfirm": {
      "title": "Delete artwork",
      "messageBefore": "Are you sure you want to delete the artwork",
      "messageAfter": "This action cannot be undone and will permanently remove the artwork from your collection."
    }
  },
  "invoicesPage": {
    "title": "My invoices & payments",
    "facturxNote": "Your official invoice is in electronic format (Factur-X). It is issued and transmitted via our approved e-invoicing platform, in accordance with electronic invoicing regulations. The documents below are the corresponding payment receipts.",
    "colNumber": "Number",
    "colStatus": "Status",
    "colAmount": "Amount",
    "colReceipt": "Payment receipt",
    "colDetail": "Details",
    "download": "Download",
    "view": "View",
    "loading": "Loading…",
    "empty": "No invoices yet.",
    "loginPrompt": "Log in to view your invoices.",
    "error": "Error loading invoices."
  },
  "actusVentes": {
    "dateUnavailable": "Date not available",
    "errorMessage": "Error: {{message}}",
    "noUpcoming": "No upcoming sale for this auction house",
    "seeAll": "View all sales",
    "source": "Source: {{house}}"
  },
  "advisor": {
    "accessGranted": "Access granted",
    "expert": "Expert",
    "findOne": "Find an expert",
    "loading": "Loading…",
    "none": "No advisor linked",
    "pricing": {
      "desc": "Connection included in your subscription. Paid services (appraisals, etc.) are billed separately.",
      "title": "Pricing"
    },
    "revokeAccess": "Revoke access",
    "shareCollections": "Share collections",
    "sharedSince": "Shared since",
    "sharing": "Sharing",
    "status": {
      "accepted": "Accepted",
      "pending": "Pending",
      "rejected": "Rejected"
    },
    "subtitle": "Your personal expert to help you manage your collection",
    "title": "My advisor"
  },
  "artwork": {
    "access": {
      "granted": "Access granted",
      "pending": "Access pending",
      "revoked": "Access removed"
    },
    "accessPrivacy": {
      "badgePrivate": "Private",
      "body": "This artwork is private by default. Only people you invite can view it.",
      "hint": "You can change or remove access anytime from “Sharing”.",
      "pill1": "Controlled sharing",
      "pill2": "Tracked access",
      "pill3": "Artkiv only accesses it if you ask",
      "title": "Access & privacy"
    },
    "availability": {
      "available": "Available",
      "in_restoration": "Under Restoration",
      "not_found": "Not Found",
      "on_loan": "On Loan",
      "reserved": "Reserved",
      "sold": "Sold",
      "lost_or_stolen": "Lost / stolen",
      "to_destroy": "To destroy",
      "unavailable": "Unavailable",
      "loaned": "On loan"
    },
    "mediumCategories": {
      "design": "Design",
      "nft": "NFT / Digital Art",
      "other": "Other"
    },
    "mediums": {
      "oil_on_canvas": "Oil on canvas",
      "acrylic_on_canvas": "Acrylic on canvas",
      "oil_on_wood": "Oil on wood",
      "acrylic_on_wood": "Acrylic on wood",
      "painting_generic": "Painting",
      "paper_maroufle": "Paper mounted on panel",
      "watercolor_on_paper": "Watercolor on paper",
      "gouache_on_paper": "Gouache on paper",
      "ink_on_paper": "Ink on paper",
      "charcoal_on_paper": "Charcoal on paper",
      "pencil_on_paper": "Pencil on paper",
      "pastel_on_paper": "Pastel on paper",
      "collage_on_paper": "Collage on paper",
      "mixed_media_on_paper": "Mixed media on paper",
      "work_on_paper": "Work on paper",
      "lithograph": "Lithograph",
      "screenprint": "Screenprint",
      "engraving": "Engraving",
      "etching": "Etching",
      "aquatint": "Aquatint",
      "print": "Print",
      "photographic_print": "Photographic print",
      "silver_gelatin_print": "Silver gelatin print",
      "lambda_print": "Lambda print",
      "pigment_print": "Pigment print",
      "inkjet_print": "Inkjet print",
      "digital_print": "Digital print",
      "bronze": "Bronze",
      "marble": "Marble",
      "resin": "Resin",
      "wood": "Wood",
      "steel": "Steel",
      "aluminium": "Aluminium",
      "porcelain": "Porcelain",
      "ceramic_glazed": "Glazed ceramic",
      "mixed_media": "Mixed media",
      "textile_fiber": "Textile / fibre",
      "video_installation": "Video installation",
      "digital": "Digital art",
      "nft_art": "NFT / Digital art",
      "other": "Other",
      "painting": "Painting",
      "sculpture": "Sculpture",
      "photography": "Photography",
      "drawing": "Drawing",
      "installation": "Installation",
      "video": "Video",
      "textile": "Textile",
      "ceramic": "Ceramic",
      "nft": "NFT / Digital Art",
      "oil_on_panel": "Oil on panel",
      "oil_on_paper": "Oil on paper",
      "acrylic_on_paper": "Acrylic on paper",
      "acrylic_on_panel": "Acrylic on panel",
      "watercolor": "Watercolor",
      "gouache": "Gouache",
      "ink_on_canvas": "Ink on canvas",
      "mixed_media_on_canvas": "Mixed media on canvas",
      "collage": "Collage",
      "serigraph": "Screenprint",
      "photography_generic": "Photography",
      "c_print": "C-print",
      "iron": "Iron",
      "glass": "Glass",
      "fresco": "Fresco",
      "tempera": "Tempera",
      "oil_on_linen": "Oil on linen",
      "pencil_on_canvas": "Pencil on canvas",
      "crayon": "Crayon",
      "pen_and_ink": "Pen and ink"
    },
    "condition": {
      "excellent": "Excellent",
      "very_good": "Very Good",
      "good": "Good",
      "fair": "Fair",
      "very_poor": "Below Average",
      "heavily_damaged": "Heavily Damaged (restorable)",
      "partially_restorable": "Partially Restorable",
      "irreparable": "Irreparable",
      "poor": "Poor",
      "damaged": "Damaged",
      "to_restore": "To Restore",
      "unknown": "Unknown"
    },
    "typeOfArt": {
      "contemporary_art": "Contemporary Art",
      "postwar_art": "Post-war Art",
      "modern_art": "Modern Art",
      "impressionism": "Impressionism",
      "old_masters": "Old Masters",
      "asian_art": "Asian Art",
      "african_art": "African Art",
      "middle_eastern_art": "Middle Eastern Art",
      "latin_american_art": "Latin American Art",
      "tribal_art": "Tribal Art",
      "street_art": "Street Art",
      "photography": "Photography",
      "design": "Design",
      "decorative_arts": "Decorative Arts",
      "antiquities": "Antiquities",
      "nineteenth_century_art": "19th Century Art",
      "prints_multiples": "Prints & Multiples",
      "digital_art": "Digital Art / NFT",
      "unknown": "Not specified",
      "other": "Other"
    },
    "history": {
      "noViews": "No views yet",
      "viewedBy": "Viewed by"
    }
  },
  "artworkAccess": {
    "active": {
      "canEdit": "Can edit",
      "empty": "No shared access",
      "emptyDescription": "This artwork is not shared with anyone at the moment",
      "revoke": "Revoke access",
      "sharedAt": "Shared",
      "title": "Active access"
    },
    "confirm": {
      "revoke": "Revoke access for {{name}}?"
    },
    "error": {
      "invite": "Error sending invitation",
      "revoke": "Error revoking access"
    },
    "invite": {
      "button": "Invite",
      "description": "Invite experts, conservators, or partners to view this record",
      "emailLabel": "Email address",
      "messageLabel": "Message (optional)",
      "messagePlaceholder": "Add a personal message...",
      "roleLabel": "Role",
      "send": "Send invitation",
      "sending": "Sending...",
      "title": "Share this artwork"
    }
  },
  "artworkDetail": {
    "access": {
      "blockchain": "Each consultation is immutably recorded to ensure traceability, confidentiality, and data integrity.",
      "cta": "Manage access",
      "description": "This artwork is only accessible to people explicitly authorized by the collector.",
      "empty": "Nothing yet. As soon as a third party views this artwork, it will show up here.",
      "hint": "You retain full control over who can view this artwork, when, and under which conditions.",
      "loading": "Fetching access logs…",
      "log": "Accesses are timestamped and linked to a role (collector, expert, advisor, partner).",
      "whyArtkiv": "For security and compliance reasons, access to this artwork is exclusively handled through Artkiv."
    },
    "acquisition": {
      "date": "Acquisition date",
      "inventoryNumber": "Inventory number",
      "price": "Acquisition price",
      "source": "Source",
      "title": "Acquisition details",
      "type": "Type of acquisition"
    },
    "actions": {
      "aiTracking": "AI tracking",
      "conservation": "Conservation",
      "costs": "Costs",
      "curatorialReading": "Curator help",
      "curatorialReadingSubtext": "Partner expert service",
      "requestExpertValuation": "Request an expert valuation",
      "requestExpertValuationSubtext": "Send this artwork to a named partner expert",
      "delete": "Delete",
      "donation": "Donation",
      "downloadZip": "Download file bundle",
      "downloadZipSubtext": "Images + documents in one ZIP file",
      "edit": "Edit",
      "insurance": "Insurance",
      "maintenance": "Maintenance",
      "proposeExhibition": "Propose the artwork",
      "proposeToMuseum": "Propose to museum",
      "qrCode": "QR Code",
      "registerDonation": "Register a donation",
      "registerSale": "Register a sale",
      "requestInsurance": "Request insurance review",
      "requestTransport": "Request transport",
      "sale": "Sale",
      "showQr": "Show QR code",
      "transport": "Transport",
      "zipping": "Preparing ZIP…",
      "exportDossier": "Export file bundle",
      "loanArtwork": "Loan the artwork",
      "removeFromLoan": "End the loan",
      "declareLoss": "Report loss or theft",
      "estimateComparables": "Estimate using comparables",
      "duplicateArtwork": "Duplicate record",
      "duplicating": "Duplicating…",
      "transportTitle": "Request transport (outbound/return quote)",
      "addToLot": "Add to a lot",
      "addToLotTitle": "Group this artwork into a lot",
      "removeFromLotTitle": "Remove this artwork from the lot",
      "removeFromLotConfirm": "Remove this artwork from the lot?",
      "removeFromLotError": "The artwork could not be removed from the lot."
    },
    "ai": {
      "analyzeButton": "Run AI analysis",
      "description": "Use AI to analyze this artwork, enrich its metadata, and refine its valuation.",
      "eligible": "Eligible for the Artkiv AI module.",
      "title": "AI analysis"
    },
    "ocr": {
      "button": "Enrich with OCR",
      "loading": "Enriching…",
      "blockedPlan": "AI-powered OCR enrichment is available from the Premium plan.",
      "blockedConsent": "You have not yet accepted the AI terms of use.",
      "blockedDisabled": "AI is disabled on your account. Enable it in your preferences.",
      "viewPlans": "View plans →",
      "profile": "My profile →"
    },
    "visualAi": {
      "title": "AI visual analysis",
      "description": "Analyze the artwork images via Vision.artkiv.com",
      "launch": "Run analysis →"
    },
    "lot": {
      "fallbackName": "Lot",
      "copySingular": "{{count}} copy",
      "copyPlural": "{{count}} copies",
      "show": "show",
      "collapse": "collapse",
      "duplicateTitle": "Duplicate this copy in the lot",
      "duplicate": "Duplicate",
      "edit": "Edit lot",
      "referenceAlt": "Lot reference image",
      "referenceLabel": "Lot reference image",
      "referenceLabelUpper": "LOT REFERENCE IMAGE",
      "useAsPrimaryTitle": "Use the lot image as the primary image for this artwork",
      "useAsPrimary": "Use as primary",
      "setAsPrimary": "Set this image as primary",
      "sharedVisualTitle": "This image will be shared by all artworks in the lot",
      "uploading": "Uploading…",
      "changeVisual": "Change lot image",
      "addVisual": "Add lot image",
      "applyAllTitle": "Apply this image as primary to every artwork in the lot",
      "applying": "Applying…",
      "applyAll": "Apply to the entire lot",
      "applySuccess": "✓ Image applied to {{count}} artwork(s) in the lot.",
      "applyPartial": "⚠ Applied to {{count}} of {{total}}. {{errors}} error(s).",
      "uploadError": "Error uploading the lot image: {{message}}",
      "usePrimaryError": "Error: {{message}}",
      "applyConfirm": "Apply this image as the primary image to every artwork in the lot?\n\nArtworks with their own photo will receive this image in first position. Existing images will not be deleted.",
      "globalPriceTitle": "Global lot price (installation)",
      "globalPriceDescription": "This price applies to the entire installation ({{count}} prints). It cannot be divided per copy."
    },
    "loanBanner": {
      "status": "On loan",
      "manage": "Manage in Deposits & Loans →"
    },
    "loss": {
      "badges": {
        "vol": "Stolen artwork",
        "perte": "Lost artwork",
        "destruction": "Destroyed artwork",
        "incendie": "Fire incident",
        "inondation": "Flood incident",
        "autre": "Reported incident",
        "generic": "Lost / Stolen"
      },
      "viewRegister": "View in Losses & Theft →",
      "saveError": "The report could not be saved.",
      "types": {
        "vol": "Theft",
        "perte": "Loss",
        "destruction": "Destruction",
        "incendie": "Fire",
        "inondation": "Flood",
        "autre": "Other"
      },
      "modal": {
        "title": "Report loss or theft",
        "artwork": "Artwork",
        "type": "Type",
        "declaredValue": "Declared value (EUR)",
        "estimatedValue": "Estimated value",
        "policeReport": "Police report filed",
        "insuranceClaim": "Insurance claim filed",
        "notes": "Notes",
        "notesPlaceholder": "Describe the circumstances…",
        "notice": "The artwork will be marked as “{{status}}” and removed from your active inventory. Follow the case in Losses & Theft.",
        "cancel": "Cancel",
        "saving": "Saving…",
        "confirm": "Confirm report"
      }
    },
    "duplicate": {
      "confirm": "Duplicate this record?",
      "error": "Error while duplicating: {{message}}"
    },
    "catalogImport": {
      "title": "Incomplete record — imported from a catalogue",
      "description": "Technique, dimensions and image are missing. Photograph the corresponding double page.",
      "enrich": "Enrich →"
    },
    "pricing": {
      "atPurchaseRate": "at the purchase exchange rate"
    },
    "loginRequired": "You must be signed in.",
    "viewArtistWorks": "View all works by {{artist}}",
    "backToCollection": "Back to collection",
    "badges": {
      "archived": "Archived",
      "blockchain": "Proof of authenticity",
      "donated": "Donated (archived)",
      "heirAssigned": "Heir assigned",
      "insured": "Insured",
      "notCertified": "Not certified",
      "notInsured": "Not insured",
      "sold": "Sold (archived)"
    },
    "blockchain": {
      "badgeCertified": "Proof of authenticity",
      "badgeNotCertified": "Not certified",
      "blockchain": "Technology:",
      "contract": "Contract:",
      "link": "Link:",
      "linkLabel": "View",
      "title": "Proof of authenticity — technical detail",
      "tokenId": "ID:",
      "type": "Type:"
    },
    "proof": {
      "title": "Digital fingerprint",
      "loading": "Loading your subscription…",
      "lockedText": "Create a dated SHA-256 fingerprint of this artwork record. Available to Premium accounts.",
      "upgradeButton": "Upgrade to Premium",
      "statusPending": "Fingerprint created",
      "statusCertified": "Anchored on blockchain",
      "emptyText": "This artwork does not yet have an ARTKIV digital fingerprint.",
      "generateButton": "Create digital fingerprint",
      "generating": "Generating…",
      "generateSuccess": "Digital fingerprint created.",
      "premiumRequired": "This feature requires a Premium plan or higher.",
      "generateError": "Error while creating the fingerprint.",
      "certificateId": "ID:",
      "fingerprint": "Digital fingerprint:",
      "createdAt": "Created on:",
      "technology": "Technology:",
      "ecoFriendly": "Eco-friendly",
      "pendingInfo": "The SHA-256 fingerprint is stored in ARTKIV. It is not yet anchored on a public blockchain.",
      "downloadPdf": "Download PDF document",
      "pdfSoon": "PDF (coming soon)",
      "verifySoon": "Public verification (coming soon)",
      "viewOnChain": "View on blockchain",
      "notAnchored": "Not anchored",
      "loadError": "Unable to load the digital fingerprint.",
      "howItWorksTitle": "What does this fingerprint do?",
      "how": {
        "unique": "Unique fingerprint: your proof is identified by a code specific to this artwork.",
        "tamperproof": "Tamper-proof: any attempted change would be immediately detectable.",
        "timestamped": "Timestamped: the creation date is permanently recorded.",
        "verifiable": "Verifiable: authenticity can be confirmed at any time.",
        "comingSoon": "Coming soon: this proof will also be recorded on a public blockchain for permanent traceability."
      }
    },
    "defaultTitle": "Untitled",
    "delete": {
      "confirm": "Do you really want to delete this artwork?",
      "error": "Error while deleting."
    },
    "description": {
      "title": "Description"
    },
    "details": {
      "availability": "Availability",
      "condition": "Condition",
      "conditionNotes": "Condition notes",
      "dimensions": "Dimensions",
      "duration": "Duration",
      "edition": "Edition",
      "editionMultiple": "Multiple edition",
      "editionUnique": "Unique piece",
      "location": "Location",
      "subject": "Subject / theme",
      "type": "Type",
      "value": "Value"
    },
    "health": {
      "docsMissing": "Add documents",
      "docsOk": "{{count}} document(s)",
      "locationMissing": "Location missing",
      "locationOk": "Location added",
      "ok": "All set",
      "purchaseMissing": "Purchase price missing",
      "purchaseOk": "Purchase price added",
      "todo": "{{count}} item(s) to complete"
    },
    "history": {
      "empty": "No activity yet. Take an action (add provenance, artist certificate, move the artwork) to create a trace.",
      "emptyDesc": "Activity on this artwork will be visible here",
      "fullHistory": "Full history",
      "itemTitle": "Event",
      "loading": "Loading…",
      "noThirdParty": "No third-party access recorded",
      "noThirdPartyDesc": "Consultations by experts or partners will appear here",
      "showAll": "Show {{count}} more events",
      "showLess": "Collapse",
      "thirdPartyAccess": "Third-party access",
      "loadingFallback": "Loading history…",
      "actionViewed": "viewed the record",
      "actionUpdated": "updated information",
      "actionDocumentAdded": "added a document",
      "actionImageAdded": "added an image",
      "actionShared": "shared access",
      "actionRevoked": "revoked access",
      "actionGenericNamed": "performed an action ({{action}})",
      "actionGeneric": "performed an action",
      "thirdPartyBadge": "Third party",
      "actorYou": "You",
      "actorUnknown": "A contributor",
      "before": "Before",
      "after": "After"
    },
    "info": {
      "estimatedValue": "Value:",
      "locationLabel": "Location:"
    },
    "inventoryNumber": "Inventory reference",
    "loading": "Loading…",
    "locationMissingCta": "Add a location (find it instantly later)",
    "locationMissingReadonly": "Location not provided",
    "login": {
      "title": "Sign in to access this artwork",
      "subtitle": "This artwork is private. Sign in with an authorized account to view it.",
      "email": "Email address",
      "password": "Password",
      "forgot": "Forgot your password?",
      "submit": "Sign in",
      "loading": "Signing in…",
      "noAccount": "Don’t have an account?",
      "signup": "Create an account",
      "error": {
        "invalid": "Invalid email or password.",
        "required": "Please enter your email address and password.",
        "unknown": "Unable to sign in. Please try again."
      }
    },
    "media": {
      "noImages": "No image attached to this artwork.",
      "noMainImage": "No image",
      "title": "Artwork images"
    },
    "meta": {
      "artistLabel": "Artist:",
      "blockchainCertified": "Proof of authenticity",
      "condition": "Condition",
      "conditionNotes": "Notes on condition",
      "dimensions": "Dimensions",
      "duration": "Duration :",
      "edition": "Edition",
      "location": "Location",
      "locationUnknown": "Not specified",
      "mediumLabel": "Medium: ",
      "notSet": "Not set",
      "ownerStatus": {
        "owner": "You are the owner",
        "ownerShared": "This record is shared",
        "sharedAccess": "Shared access granted by the owner"
      },
      "subjectMatter": "Subject",
      "typeOfArt": "Type of art:",
      "yearLabel": "Year:"
    },
    "nextAction": {
      "docs": {
        "cta": "Add a document",
        "desc": "Add at least one document (invoice, certificate, email, photo).",
        "title": "Secure the file in 1 minute"
      },
      "location": {
        "cta": "Add a location",
        "desc": "Add a location for logistics and traceability.",
        "title": "Find it instantly later"
      },
      "ok": {
        "cta": "View history",
        "desc": "Your artwork is complete. You can track activity and share access.",
        "title": "Everything is ready"
      },
      "purchase": {
        "cta": "Add purchase price",
        "desc": "Add the purchase price to calculate the value evolution.",
        "title": "Track your value change"
      },
      "viewTab": "Open tab"
    },
    "noDescription": "No description yet for this artwork.",
    "noDescriptionCta": "Add a description (30 seconds)",
    "noImage": "No image available for this artwork",
    "noLocation": "Unknown:",
    "notFound": {
      "back": "Back to dashboard",
      "cta": "Back to my collection",
      "description": "Some artworks on Artkiv are protected by private access.\n\nTo ensure security, traceability, and a clear viewing history, each artwork page is only visible to invited users.",
      "hint": "If you believe you should have access, simply request an invitation.",
      "title": "This artwork isn’t accessible right now"
    },
    "qr": {
      "download": "Download",
      "scanText": "Scan this QR code.",
      "title": "QR Code"
    },
    "services": {
      "aiInsights": "AI recommendations",
      "conservation": "Conservation & restoration",
      "costManagement": "Cost management",
      "donationOption": "🎁 Make a donation",
      "insurance": "Insurance & coverage",
      "insuranceDesc": "Prepare a complete file for your insurer or our insurance partners.",
      "museumProposal": "Museum proposal",
      "saleDonation": "Sale / Donation",
      "saleDonationDesc": "Structure a sale, donation or bequest with Artkiv and your advisors.",
      "saleOption": "📈 Put up for sale",
      "title": "Services around this artwork",
      "transport": "Transport & logistics",
      "valuation": "Valuation & appraisal",
      "valuationDesc": "Request an updated valuation using Artkiv AI and our partner experts."
    },
    "shared": {
      "description": "Consult, document and manage all information related to this artwork.",
      "title": "Artwork detail"
    },
    "story": {
      "acquisition": "Acquisition",
      "action": "Edit",
      "empty": "No entries yet. Add a document or provenance to start the story.",
      "event": "Event",
      "provenance": "Provenance",
      "subtitle": "A clear trace at a glance",
      "title": "Artwork story",
      "unknownDate": "Unknown date",
      "view": "View"
    },
    "tabs": {
      "access": "Access & traceability",
      "details": "Details",
      "documents": "Documents",
      "history": "History",
      "images": "Images",
      "location": "Location",
      "medias": "Images",
      "provenance": "Provenance",
      "specifications": "Specifications",
      "valuations": "Valuations"
    },
    "tags": {
      "title": "Keywords"
    },
    "valuations": {
      "acquisitionDateLabel": "Date:",
      "acquisitionPrice": "Acquisition price",
      "acquisitionSourceLabel": "Source:",
      "acquisitionTypeLabel": "Type:",
      "acquisitionUnknown": "Not provided",
      "current": "Current value",
      "currentHint": "Indicative value.",
      "currentUnknown": "Not provided",
      "plusValue": "Capital gain",
      "plusValueHint": "Formula: value – purchase price.",
      "plusValueNA": "N/A",
      "title": "Valuations"
    },
    "value": {
      "acquiredOn": "Acquired on",
      "noValue": "Not available",
      "premiumBadge": "Advanced features available with a Premium plan",
      "title": "Value",
      "vsPurchase": " Added Value : Value – Acquisition price."
    }
  },
  "importJournal": {
    "title": "Import journal",
    "subtitle": "Your recent imports. You can undo an import (the created artworks will be deleted).",
    "undo": "Undo import",
    "undoing": "Undoing…",
    "undone": "{{n}} artwork(s) deleted.",
    "error": "Undo failed.",
    "confirm": "Undo this import and delete the {{n}} created artwork(s)? This cannot be undone.",
    "skipped": "skipped",
    "col": { "file": "File", "collection": "Collection", "date": "Date", "result": "Result", "status": "Status" },
    "status": { "running": "Running", "completed": "Completed", "completed_with_errors": "Completed (with errors)", "cancelled": "Cancelled" }
  },
  "concentration": {
    "eyebrow": "Analysis",
    "title": "Collection concentration",
    "subtitle": "Value distribution — a heritage indicator, not a financial index.",
    "top5": "Weight of top 5",
    "stale": "No recent valuation",
    "insured": "Insured",
    "byArtist": "By artist (top 5)",
    "byMedium": "By medium (top 5)",
    "confidence": "Value confidence",
    "confHigh": "high",
    "confMedium": "medium",
    "confLow": "low"
  },
  "valuationHistory": {
    "eyebrow": "Traceability",
    "title": "Value history",
    "add": "Add a value",
    "cancel": "Cancel",
    "save": "Save value",
    "saving": "Saving…",
    "empty": "No value recorded yet.",
    "showHistory": "View full history ({{n}})",
    "hideHistory": "Hide full history",
    "type": {
      "acquisition": "Acquisition price",
      "market_estimate": "Market estimate",
      "algorithmic": "Algorithmic value",
      "expert": "Expert value",
      "retained": "Retained value",
      "insurance": "Insurance value"
    },
    "field": {
      "type": "Type", "min": "Min amount", "max": "Max amount", "retained": "Retained",
      "currency": "Currency", "date": "Date", "source": "Source",
      "sourcePh": "invoice, expert, Artprice…", "confidence": "Confidence"
    },
    "confidence": { "low": "Low", "medium": "Medium", "high": "High" },
    "col": { "date": "Date", "type": "Type", "amount": "Amount", "source": "Source", "confidence": "Confidence" }
  },
  "aiDisclosure": {
    "type": {
      "generated": "AI-generated",
      "extracted": "Automatically extracted · please verify",
      "suggested": "AI suggestion",
      "assisted": "AI-assisted",
      "simulation": "Indicative simulation · no automated decision"
    },
    "status": { "reviewed": "Reviewed by user", "expertValidated": "Expert validated" },
    "confidence": "Confidence: {{n}}%",
    "learnMore": "Learn more about AI at ARTKIV"
  },
  "artworkEdit": {
    "artist": {
      "living": "living",
      "rank": "Artprice #{{n}}",
      "hint": "Suggestions from the price-reference list — free text allowed.",
      "linked": "Referenced artist",
      "best": "top result"
    },
    "edit": {
      "cancel": "Cancel",
      "confidentialLocationBody": "The precise location of this artwork is confidential and is not available with your current access rights.",
      "confidentialLocationTitle": "Confidential location",
      "consentNote": "These data are used only in aggregated and anonymized form.",
      "consentText": "Allow this artwork to be included in Artkiv aggregated statistics and analyses.",
      "consentTitle": "Use in Artkiv statistics",
      "editTitle": "Edit “{{title}}”",
      "loadError": "Error loading the artwork.",
      "loading": "Loading artwork…",
      "noEditRights": "You do not have permission to edit this artwork.",
      "notFound": "Artwork not found or access not authorized.",
      "save": "Save",
      "saveError": "Error saving the artwork.",
      "saving": "Saving…",
      "sharedNotice": "You are editing a shared artwork according to the permissions granted by its owner.",
      "tabDetails": "Details",
      "tabDocuments": "Documents",
      "tabExpertise": "CUP appraisal",
      "tabLocation": "Location",
      "tabNft": "NFT / Blockchain",
      "tabProvenance": "Provenance & acquisition",
      "tabSpecifications": "Specifications",
      "untitled": "Untitled",
      "updated": "Artwork updated.",
      "imageUploadError": "An error occurred while uploading the images.",
      "imageDeleteError": "An error occurred while deleting the image.",
      "imagePrimaryError": "Unable to set the primary image.",
      "saveErrorDetailed": "Error saving the artwork. {{message}}",
      "noRowUpdated": "No row was updated. Check your permission to edit this artwork."
    },
    "detail": {
      "acquisition": "Acquisition details",
      "acquisitionDate": "Acquisition date",
      "acquisitionPrice": "Acquisition price",
      "acquisitionSource": "Source (gallery, auction house, artist...)",
      "acquisitionType": "Acquisition type",
      "artist": "Artist",
      "availability": "Availability",
      "subject": "Subject / theme",
      "subjectPlaceholder": "Portrait, landscape, abstraction...",
      "priceGallery": "Price / gallery",
      "priceLow": "Lower range",
      "priceHigh": "Upper range",
      "salePriceGallery": "Desired gallery sale price",
      "salePriceGallerySlash": "Desired sale price / gallery",
      "expertValuation": "Expert valuation",
      "valuationRange": "Valuation range",
      "galleryCap": "Gallery upper bound",
      "indicative": "indicative",
      "publicForSale": "Display this artwork as available for sale / gallery",
      "priceGalleryHelp": "Separate fields: price range, desired gallery sale price, and public visibility.",
      "currencyGalleryHelp": "This currency applies to gallery prices: lower range, upper range, and desired sale price.",
      "conditionSection": "Condition",
      "condition": "Condition",
      "conditionLabel": "Condition",
      "conditionPlaceholder": "— Select —",
      "conditionNotes": "Condition notes",
      "conditionNotesPlaceholder": "Scratches, restorations, accidents...",
      "conditionDecoteWarning": "A discount will be automatically applied to the CUP valuation.",
      "conditionFair": "Fair (−20%)",
      "conditionVeryPoor": "Below Average (−30%)",
      "conditionHeavilyDamaged": "Heavily Damaged, restorable (−50%)",
      "conditionPartiallyRestorable": "Partially Restorable (−65%)",
      "conditionIrreparable": "Irreparable — total depreciation",
      "currency": "Currency",
      "description": "Description",
      "descriptionPlaceholder": "Artwork description, context, exhibition, etc.",
      "edition": "Edition / multiples (lithograph, photography, sculpture...)",
      "inventoryNumber": "Inventory number",
      "medium": "Medium",
      "mediumCategory": "Category",
      "mediumCategoryCeramics": "Ceramics",
      "mediumCategoryDesign": "Design",
      "mediumCategoryDrawing": "Drawing",
      "mediumCategoryFilmVideo": "Film / Video",
      "mediumCategoryInstallation": "Installation",
      "mediumCategoryMixedMedia": "Mixed Media",
      "mediumCategoryNft": "NFT / Digital Art",
      "mediumCategoryOther": "Other",
      "mediumCategoryPainting": "Painting",
      "mediumCategoryPhotography": "Photography",
      "mediumCategoryPrints": "Prints",
      "mediumCategorySculpture": "Sculpture",
      "mediumCategoryTextile": "Textile Art",
      "mediumCategoryWorkOnPaper": "Works on Paper",
      "mediumPlaceholder": "E.g. Silver gelatin print Ed. 1/3, Oil on canvas...",
      "noDescription": "No description available.",
      "notSpecified": "Not specified",
      "notSpecifiedF": "Not specified",
      "select": "Select",
      "signature": "Signature",
      "statsTitle": "Anonymous statistics participation",
      "tagsAdd": "Add",
      "tagsAI": "AI suggestions",
      "tagsApiSettings": "API settings",
      "tagsClear": "Remove all keywords",
      "tagsCount": "/ 10 keywords used",
      "tagsLocal": "Local suggestions",
      "tagsManual": "Manual",
      "tagsMode": "Mode:",
      "tagsPlaceholder": "Add a keyword and press Enter",
      "tagsRemove": "Remove",
      "tagsTitle": "Keywords / tags",
      "titleLabel": "Artwork title",
      "typeOfArt": "Type of art",
      "valueLabel": "Current estimated value",
      "year": "Year",
      "yearHint": "Estimated date set to January 1st — update if you have the exact date."
    },
    "yearModal": {
      "body": "Only the year is recorded. In contemporary art, this is often sufficient. Would you still like to set",
      "bodyEnd": "as the reference date?",
      "jan1": "1 January {{year}}",
      "confirm": "Set to {{date}}",
      "hint": "You can always correct this date if you have the exact information.",
      "keepYear": "Keep year only",
      "label": "Creation year"
    },
    "provenanceTab": {
      "entryEyebrow": "Acquisition & provenance",
      "entryTitle": "Entry into the collection",
      "entryHelp": "Enter the details of the artwork’s current acquisition. Earlier ownership history remains documented separately in the provenance record.",
      "historyEyebrow": "History",
      "historyTitle": "Earlier provenance",
      "historyHelp": "Document the owners, collections, sales and transfers that preceded the artwork’s entry into your collection.",
      "journeyEyebrow": "Artwork journey",
      "journeyTitle": "Provenance history",
      "journeyHelp": "Trace the artwork’s successive owners, collections, sales and transfers.",
      "addHistory": "Add provenance record",
      "emptyHistory": "No earlier provenance history has been entered."
    },
    "acquisitionForm": {
      "type": "Acquisition type",
      "date": "Acquisition date",
      "sourceGeneric": "Source / seller",
      "sourcePlaceholder": "Gallery, auction house, artist, private collection…",
      "purchaseCurrency": "Acquisition currency",
      "price": "Acquisition price",
      "pricePlaceholder": "Amount paid, excluding fees",
      "city": "Acquisition city",
      "country": "Acquisition country",
      "exchangeRate": "Exchange rate to EUR",
      "priceEur": "Acquisition price converted to EUR",
      "selectType": "— Select —",
      "typeGallery": "Gallery",
      "typeAuction": "Auction",
      "typePrivate": "Private sale",
      "typeArtist": "Direct purchase from the artist",
      "typeDonation": "Gift",
      "typeInheritance": "Inheritance / bequest",
      "typeExchange": "Exchange",
      "typeCommission": "Commission",
      "typePurchase": "Purchase",
      "typeOther": "Other",
      "currencyEUR": "euro",
      "currencyUSD": "US dollar",
      "currencyGBP": "pound sterling",
      "currencyCHF": "Swiss franc",
      "currencyJPY": "Japanese yen",
      "currencyCNY": "Chinese yuan",
      "currencyHKD": "Hong Kong dollar",
      "currency": {
        "EUR": "euro",
        "USD": "US dollar",
        "GBP": "pound sterling",
        "CHF": "Swiss franc",
        "JPY": "Japanese yen",
        "CNY": "Chinese yuan",
        "HKD": "Hong Kong dollar"
      },
      "currencies": {
        "EUR": "euro",
        "USD": "US dollar",
        "GBP": "pound sterling",
        "CHF": "Swiss franc",
        "JPY": "Japanese yen",
        "CNY": "Chinese yuan",
        "HKD": "Hong Kong dollar"
      },
      "currencyLabels": {
        "EUR": "euro",
        "USD": "US dollar",
        "GBP": "pound sterling",
        "CHF": "Swiss franc",
        "JPY": "Japanese yen",
        "CNY": "Chinese yuan",
        "HKD": "Hong Kong dollar"
      },
      "currencyNames": {
        "EUR": "euro",
        "USD": "US dollar",
        "GBP": "pound sterling",
        "CHF": "Swiss franc",
        "JPY": "Japanese yen",
        "CNY": "Chinese yuan",
        "HKD": "Hong Kong dollar"
      },
      "currencyOptions": {
        "EUR": "euro",
        "USD": "US dollar",
        "GBP": "pound sterling",
        "CHF": "Swiss franc",
        "JPY": "Japanese yen",
        "CNY": "Chinese yuan",
        "HKD": "Hong Kong dollar"
      },
      "currencyLabelEUR": "euro",
      "currencyLabelUSD": "US dollar",
      "currencyLabelGBP": "pound sterling",
      "currencyLabelCHF": "Swiss franc",
      "currencyLabelJPY": "Japanese yen",
      "currencyLabelCNY": "Chinese yuan",
      "currencyLabelHKD": "Hong Kong dollar",
      "currencyNameEUR": "euro",
      "currencyNameUSD": "US dollar",
      "currencyNameGBP": "pound sterling",
      "currencyNameCHF": "Swiss franc",
      "currencyNameJPY": "Japanese yen",
      "currencyNameCNY": "Chinese yuan",
      "currencyNameHKD": "Hong Kong dollar",
      "currencyOptionEUR": "euro",
      "currencyOptionUSD": "US dollar",
      "currencyOptionGBP": "pound sterling",
      "currencyOptionCHF": "Swiss franc",
      "currencyOptionJPY": "Japanese yen",
      "currencyOptionCNY": "Chinese yuan",
      "currencyOptionHKD": "Hong Kong dollar",
      "currencyHelp": "This currency applies only to the acquisition price. It is separate from the currency used for gallery and sale prices.",
      "exchangeRateHelp": "Enter the conversion rate to euros on the acquisition date when the currency is not EUR."
    }
  },
  "artworksDashboard": {
    "action": {
      "open": "Open →"
    },
    "addArtwork": "Add artwork",
    "addFirstArtwork": "Add my first artwork",
    "empty": "No artwork matches your criteria",
    "importPremiumTitle": "Import artworks",
    "count": "{{count}} artwork(s) found",
    "fallback": {
      "noTitle": "(Untitled)"
    },
    "draftBadge": "Draft",
    "filter": {
      "allCollections": "All collections",
      "artist": "Artist",
      "artistPlaceholder": "Search an artist",
      "collection": "Collection",
      "maxValue": "Max value (€)",
      "minValue": "Min value (€)",
      "tags": "Tags",
      "tagsPlaceholder": "tag1, tag2",
      "category": "Category",
      "medium": "Medium",
      "location": "Location",
      "inventory": "Inventory",
      "inventoryPlaceholder": "Search inventory number",
      "condition": "Condition",
      "conditionAll": "All conditions",
      "conditionExcellent": "Excellent",
      "conditionGood": "Good",
      "conditionFair": "Fair",
      "conditionPoor": "Poor"
    },
    "importNeedCollection": "To import, please select a collection first.",
    "importPremium": "Import CSV/XLSX",
    "importWithExpert": "Import (with expert)",
    "loading": "Loading artworks...",
    "noResults": {
      "subtitle": "Try adjusting filters or adding artworks.",
      "title": "No artwork matches your criteria"
    },
    "sort": {
      "dateAsc": "Oldest",
      "dateDesc": "Newest",
      "label": "Sort by:",
      "titleAsc": "Title A–Z",
      "titleDesc": "Title Z–A",
      "inventoryAsc": "Inventory A–Z",
      "valueAsc": "Lowest value",
      "valueDesc": "Highest value"
    },
    "table": {
      "actions": "Actions",
      "artist": "Artist",
      "artwork": "Artwork",
      "date": "Date",
      "type": "Type",
      "value": "Value"
    },
    "title": "Artworks",
    "of": "–",
    "artworks": "artwork(s)",
    "pagination": {
      "previous": "← Previous",
      "next": "Next →",
      "page": "Page {{page}} / {{total}}"
    },
    "view": {
      "grid": "Grid view",
      "label": "View:",
      "list": "List view",
      "mosaic": "Mosaic view"
    }
  },
  "beneficiaries": {
    "add": {
      "emailPlaceholder": "Email",
      "namePlaceholder": "Name",
      "relationPlaceholder": "Relation (son, daughter, nephew, friend…)",
      "submit": "Add",
      "title": "Add an heir"
    },
    "empty": "You have not added any heirs to your profile yet.",
    "remove": "Remove",
    "title": "Heirs management"
  },
  "beneficiary": {
    "permissions": {
      "full": "Full management",
      "read": "Read only",
      "title": "Permissions for {{name}}",
      "valuation": "Valuation only"
    }
  },
  "billing": {
    "alert": {
      "demoDisabled": "This feature is disabled on demo accounts.\n\nTo access the real billing portal, please create a real customer account.",
      "noSubscription": "You must subscribe to a plan first.",
      "portalOpenFailed": "Unable to open the billing portal: {{error}}"
    },
    "demo": {
      "badge": "Demo",
      "bannerText": "Some features (payment, billing portal) are disabled in demo mode.",
      "bannerTitle": "Demo mode",
      "noSub": {
        "button": "View plans (demo)",
        "note": "💡 Note: To preview how an active subscription looks, ask the administrator to enable a simulated subscription on this account.",
        "text": "This demo account can be used without an active subscription. All features are available in test mode.",
        "title": "Demo account"
      },
      "pageTitle": "Billing & Subscription (demo)",
      "status": {
        "active": "Active",
        "canceled": "Cancelled",
        "none": "None",
        "past_due": "Past due",
        "trialing": "Trial"
      },
      "withSub": {
        "aboutLink": "Create a customer account",
        "aboutText": "This account is in demo mode. To access real billing and payment features, create a real customer account.",
        "aboutTitle": "About demo mode",
        "button": {
          "invoices": "My invoices",
          "portalDisabled": "Open portal (disabled)",
          "seeOffers": "View plans"
        },
        "explainer": "On a real account, this portal lets you update your payment method, view invoices, change plan or cancel your subscription.",
        "nextPayment": "Next payment",
        "nextPaymentValue": "N/A (demo)",
        "note": "🎭 Demo mode: this subscription is simulated. No real payment is made on this account. Billing features are disabled.",
        "plan": "Plan",
        "price": "Monthly price",
        "priceValue": "€29 (simulated)"
      }
    },
    "portal": {
      "checking": "Checking access…",
      "loginButton": "Log in to access billing",
      "requireLogin": "You must be logged in to access the billing portal.",
      "title": "Billing portal"
    },
    "real": {
      "button": {
        "changePlan": "Change plan",
        "invoices": "My invoices",
        "portal": "Open portal"
      },
      "explainer": "From your billing portal you can update your payment method, view invoices, change plan or cancel your subscription at any time.",
      "help": {
        "link": "Contact support",
        "text": "For any question regarding your subscription or billing, our team is here to help.",
        "title": "Need help?"
      },
      "noSub": {
        "button": "Browse plans",
        "text": "You don't have a subscription yet. Choose a plan to start managing your art collection.",
        "title": "No active subscription"
      },
      "pageTitle": "Billing & Subscription"
    },
    "status": {
      "active": "Active",
      "canceled": "Cancelled",
      "none": "No subscription",
      "past_due": "Past due",
      "trialing": "Trial period"
    }
  },
  "client": {
    "proposals": {
      "operational": {
        "title": "Exhibition, loan & donation",
        "desc": "Track requests you have sent to institutions for an artwork."
      },
      "alert": {
        "cancellationError": "Unable to send the cancellation request.",
        "cancellationRequested": "Cancellation request sent to the expert.",
        "deleted": "Proposal deleted.",
        "deleteError": "Failed to delete the proposal."
      },
      "artwork": {
        "unknownArtist": "Unknown artist"
      },
      "button": {
        "cancel": "Cancel"
      },
      "chip": {
        "blockchain": "Proof of Authenticity",
        "proposals": "Institutional Proposals",
        "vision": "AI Vision"
      },
      "column": {
        "action": "Action",
        "artwork": "Artwork",
        "date": "Date",
        "institution": "Institution",
        "type": "Type"
      },
      "confirm": {
        "delete": "Do you want to delete this proposal?",
        "requestCancellation": "Do you want to request the cancellation of this proposal?"
      },
      "empty": {
        "desc": "When you propose an artwork to an institution, your requests will appear here.",
        "title": "No requests yet"
      },
      "error": {
        "fetch": "Error while loading proposals: {{error}}"
      },
      "explainer": "Here you track artworks you’ve proposed to institutions (museums, foundations, companies) for exhibition, acquisition, donation, or cultural tax donation.",
      "help": {
        "point1": "You propose an artwork to an institution for exhibition, purchase, donation, or cultural tax donation.",
        "point2": "We keep a clear record of exchanges and statuses (pending, paid, cancellation requested).",
        "point3": "You can cancel a pending request or request cancellation if it has already been processed.",
        "title": "What are these requests?"
      },
      "learnMore": "Learn more",
      "loading": "Loading proposals...",
      "title": "Proposals overview",
      "type": {
        "auction": "Sale",
        "institution": "Institution"
      },
      "value": {
        "blockchain": "This proof strengthens the traceability and authenticity of your records.",
        "desc": "With Artkiv, your artworks aren't just listed: they're analyzed, verified and ready for real-world actions — exhibition, sale, donation or transmission.",
        "proposals": "Track exhibition, acquisition, donation, and long-term loan opportunities.",
        "title": "More than inventory.",
        "vision": "AI helps detect missing info, check documents, and prepare your files."
      }
    }
  },
  "collectionDetail": {
    "alt": {
      "image": "Collection image"
    },
    "back": "← Back",
    "backToCollections": "Back to collections",
    "button": {
      "delete": "Delete",
      "edit": "Edit",
      "export": "Export",
      "generateForThis": "Generate for this collection",
      "generateReport": "Generate report",
      "seeReports": "View reports",
      "shareAccess": "Share access"
    },
    "details": {
      "createdAt": "Created on",
      "dateUnknown": "Unknown date",
      "description": "Description",
      "owner": "Owner",
      "ownerUnknown": "Unknown owner"
    },
    "loading": "Loading collection...",
    "noBio": "No biography available for this artist.",
    "noDescription": "No description provided.",
    "notFound": {
      "back": "← Back to collections",
      "id": "Collection ID not found."
    },
    "section": {
      "about": "About",
      "artworks": "Artworks",
      "details": "Details",
      "reports": "Reports",
      "servicesCuratorial": "Curatorial services",
      "summary": "Summary"
    },
    "servicesCuratorial": {
      "description": "Access the curatorial services linked to your collection: narrative reading, overall coherence, institutional loans, exhibition dossiers and bespoke advisory.",
      "open": "Open curatorial service"
    },
    "shared": "Shared collection",
    "summary": {
      "count": "Number of artworks",
      "estimatedValue": "Estimated value",
      "purchasePrice": "Purchase price"
    }
  },
  "collectionEdit": {
    "action": {
      "addArtwork": "Add artwork",
      "create": "Create",
      "delete": "Delete",
      "save": "Save"
    },
    "alt": {
      "preview": "Image preview"
    },
    "artwork": {
      "dimensions": "Dimensions",
      "label": "Artwork",
      "manage": "Manage artwork",
      "medium": "Medium",
      "new": "New",
      "saveFirst": "Save the collection first",
      "title": "Title",
      "year": "Year"
    },
    "cancel": "Cancel",
    "empty": {
      "artworks": "No artworks in this collection."
    },
    "error": {
      "auth": "You must be logged in to perform this action.",
      "deleteArtwork": "Error while deleting the artwork.",
      "load": "Error while loading the collection.",
      "save": "Error while saving.",
      "upload": "Error while uploading the image."
    },
    "field": {
      "addImage": "Add image",
      "changeImage": "Change image",
      "comments": "Comments",
      "curator": "Artist / Curator",
      "description": "Description",
      "image": "Collection image",
      "title": "Collection title"
    },
    "page": {
      "create": "Create a collection",
      "edit": "Edit collection"
    },
    "saving": "Saving…",
    "section": {
      "artworks": "Collection artworks",
      "general": "General information"
    }
  },
  "collectionsListSidebar": {
    "title": "Actions",
    "createCollection": { "desc": "Add a new collection to your holdings." },
    "importZip": { "desc": "Import several artworks at once from a ZIP folder (photos, invoices)." },
    "createReport": { "desc": "Generate a report (inventory, valuation, insurance, condition/conservation…) — each type covers a different aspect, combine them for a complete picture. Batches under 50 artworks for a reliable PDF." },
    "reports": { "desc": "View previously generated reports." },
    "exportAll": { "desc": "Data only (CSV), no photos. For images, use “Create a report” instead." }
  },
  "collectionsList": {
    "artworkCount": "{{count}} artwork(s)",
    "createCollection": "Create a collection",
    "createFirst": "Create my first collection",
    "createReport": "Create a report",
    "defaultTitle": "To sort",
    "deleteCollection": "Delete this collection",
    "exportAll": "Export (all)",
    "filter": "Filter",
    "noneSubtitle": "Start by creating your first collection to organise your artworks.",
    "noneTitle": "No collections yet",
    "reports": "Reports",
    "title": "All collections",
    "viewCollection": "View collection",
    "importZip": "Import a ZIP folder",
    "editCollection": "Edit",
    "downloadReport": "↓ PDF Report",
    "sharedBadge": "Shared",
    "accessEdit": "Edit",
    "accessView": "View",
    "noTypeTitle": "No collection of this type",
    "noTypeSubtitle": "You don't have any collections with this status yet. Go back to \"All\" to see all your collections.",
    "showAll": "View all collections",
    "collectionCount_one": "{{count}} collection",
    "collectionCount_other": "{{count}} collections",
    "stats": {
      "patrimonialValue": "Art heritage",
      "foundationValue": "Foundation-owned value",
      "excludeDeposits": "excluding deposits",
      "excludeLoans": "excluding loans and deposits",
      "totalArtworks": "Total artworks",
      "inalienable": "Inalienable",
      "foundationOwned": "Foundation-owned",
      "inalienableSubtitle": "protected regime",
      "foundationOwnedSubtitle": "acquired by the foundation",
      "deposit": "On deposit",
      "foundationLoans": "Loans and deposits",
      "nonPatrimonial": "non-patrimonial"
    },
    "tabs": {
      "all": "All",
      "private": "Private",
      "inalienable": "Inalienable",
      "deposit": "Deposit",
      "foundationOwned": "Foundation-owned",
      "foundationFounder": "Founder loan",
      "foundationDonation": "Donations / bequests",
      "foundationDeposit": "Institutional deposits"
    }
  },
  "common": {
    "accept": "Accept",
    "close": "Close",
    "comingSoon": "Coming soon",
    "error": {
      "fallback": "Something went wrong, please reload"
    },
    "hide": "Hide",
    "loading": {
      "fallback": "Getting things ready",
      "safe": "Loading…"
    },
    "okUnderstood": "OK, got it",
    "refresh": "Refresh",
    "reject": "Decline",
    "revoke": "Revoke",
    "share": "Share",
    "unknown": "Unknown",
    "untitled": "Untitled",
    "cancel": "Cancel",
    "save": "Save",
    "back": "Back",
    "notSpecified": "Not specified"
  },
  "comparePlans": {
    "cat": {
      "ai": "AI & Vision",
      "collection": "Collection",
      "integrations": "Integrations",
      "multiClient": "Multi-client",
      "reporting": "Reporting",
      "support": "Support"
    },
    "cta": {
      "details": "View plan details",
      "expert": "Talk to an expert",
      "subtitle": "All our plans are commitment-free. Change or cancel at any time.",
      "title": "Ready to choose?"
    },
    "faq": {
      "a1": "Yes, you can upgrade or downgrade your plan at any time. Changes take effect at the next billing cycle.",
      "a2": "Yes, all plans include a 14-day free trial. No credit card required.",
      "a3": "Your data is kept for 30 days after cancellation. You can export everything at any time.",
      "a4": "Yes, for Family Office and enterprise plans. Contact us for a custom quote.",
      "q1": "Can I switch plans at any time?",
      "q2": "Is there a free trial?",
      "q3": "What happens to my data if I cancel?",
      "q4": "Do you offer volume discounts?",
      "title": "Frequently asked questions"
    },
    "features": {
      "ai": {
        "conservation": "Conservation AI",
        "inheritanceMatching": "Succession matching",
        "mediaWatch": "Media watch",
        "visualAnalysis": "Visual analysis"
      },
      "collection": {
        "artistsLocations": "Artists & locations",
        "artworks": "Artworks",
        "photosMultiple": "Multiple photos",
        "provenance": "Provenance"
      },
      "integrations": {
        "api": "API access",
        "erp": "ERP integration",
        "sso": "SSO",
        "webhooks": "Webhooks"
      },
      "multiClient": {
        "clientInvites": "Client invitations",
        "coBrandedReports": "Co-branded reports",
        "collectionsCount": "Collections managed",
        "multiPortfolio": "Multi-portfolio"
      },
      "reporting": {
        "accountingExports": "Accounting exports",
        "customDashboards": "Custom dashboards",
        "pdfExports": "PDF exports",
        "taxReports": "Tax reports"
      },
      "support": {
        "accountManager": "Account manager",
        "email": "Email support",
        "sla": "SLA",
        "training": "Training sessions"
      }
    },
    "plan": {
      "foundation": {
        "name": "Foundation",
        "target": "Institutions & cultural foundations",
        "price": "On request",
        "contact": "Contact us"
      },
      "artAdvisor": {
        "name": "Art Advisor",
        "target": "Independent advisors"
      },
      "artAdvisorPremium": {
        "name": "Art Advisor Premium",
        "target": "Senior advisors"
      },
      "familyOffice": {
        "name": "Family Office",
        "target": "Multi-family structures"
      },
      "premium": {
        "name": "Premium",
        "target": "Serious collectors"
      },
      "standard": {
        "name": "Standard",
        "target": "Individual collectors"
      }
    },
    "showAll": "View all features",
    "subtitle": "Find the right plan for your needs. Switch anytime, no commitment.",
    "title": "Compare our plans",
    "value": {
      "advanced": "Advanced",
      "basic": "Basic",
      "custom": "On request",
      "france": "France",
      "france_ch": "France & Switzerland",
      "limited": "Limited",
      "multiCountry": "Multi-country",
      "session1": "1 session",
      "session2": "2 sessions",
      "unlimited": "Unlimited",
      "videos": "Videos"
    }
  },
  "consentIA": {
    "checkboxLabel": "I choose to enable the Artkiv AI features described above and consent to the processing necessary to provide them using my artworks’ data.",
    "description": "Artkiv’s AI features are assistive tools. They can analyse information you submit to suggest enrichments, observations or valuation indications. You keep the final decision.",
    "error": {
      "load": "Your AI consent status could not be loaded.",
      "save": "Unable to save your consent status on the server."
    },
    "loading": "Loading your AI setting…",
    "saving": "Saving your choice…",
    "success": {
      "enabled": "AI features enabled.",
      "disabled": "AI features disabled."
    },
    "signedAt": "Activation recorded on {{date}}.",
    "previousConsent": "Last consent recorded on {{date}}. AI is currently disabled.",
    "controlHint": "You can withdraw your consent at any time from this setting. Withdrawal disables AI features for future processing.",
    "detailsToggle": "View processing details",
    "withoutAI": "Without activation, you can continue to manage your collection manually; features that require AI remain unavailable.",
    "purposes": {
      "title": "What the AI modules can do",
      "visual": {
        "title": "Visual analysis",
        "body": "Analyse artwork images to suggest classification, style or descriptive information."
      },
      "documents": {
        "title": "Documents & OCR",
        "body": "Read an invoice, certificate or other document and suggest information that can be added to the artwork record."
      },
      "conservation": {
        "title": "Conservation",
        "body": "Help identify and structure observations relevant to monitoring an artwork’s condition from the information provided."
      },
      "valuation": {
        "title": "Valuation",
        "body": "Help produce value indications from available data, comparables and market information used by ARTKIV."
      }
    },
    "data": {
      "title": "Data that may be processed",
      "body": "Depending on the module used: artwork images, documents and extracted text, artwork metadata, conservation information, valuation data and comparables you provide to ARTKIV."
    },
    "guardrails": {
      "title": "What AI does not decide for you",
      "suggestions": "AI outputs are suggestions or indications and do not, on their own, constitute a definitive conclusion.",
      "noAuthentication": "AI analysis is not an authentication or certification of an artwork.",
      "humanValidation": "Information suggested by OCR or AI must be reviewable, correctable, acceptable or dismissible before it updates sensitive business data.",
      "professional": "AI analysis does not replace an expert, conservator, insurer, notary or other professional where professional advice is required."
    },
    "access": {
      "standard": {
        "title": "AI features are not included in your current plan",
        "body": "You can continue to manage your collection without AI. Vision modules and AI processing require a plan that includes them; this setting cannot unlock them on its own."
      },
      "waitingConsent": {
        "title": "Your consent is required before any AI analysis",
        "body": "Your plan includes AI features, but they remain disabled until you explicitly enable them. No artwork should be analysed by these modules without this consent."
      },
      "enabled": {
        "title": "AI features enabled",
        "body": "Your consent authorises the processing required when you use an AI feature. It does not mean that all of your artworks are analysed automatically."
      },
      "viewPlans": "View plans that include AI →",
      "upgradeRequired": "Your current plan does not allow AI features to be enabled."
    },
    "scope": {
      "title": "Two separate choices",
      "account": "This setting controls the use of AI features at account level. It is recorded in your profile and can be withdrawn at any time.",
      "artworkOptIn": "Including an artwork in Artkiv’s aggregated and anonymised statistics and analyses remains a separate artwork-level choice. Enabling AI never enables that option automatically."
    },
    "moreInfo": {
      "text": "Detailed purposes, operation, data, providers and your rights:",
      "link": "Read the full AI information notice"
    },
    "title": "AI features & consent"
  },
  "contact": {
    "back": "Back",
    "familyOffice": {
      "next": {
        "title": "What happens next"
      }
    },
    "form": {
      "clientCount": "Number of clients/collections managed",
      "company": "Company name",
      "email": "Work email",
      "employees": "Team members using the platform",
      "firstname": "First name",
      "lastname": "Last name",
      "location": "Location",
      "message": "Message",
      "phone": "Phone"
    },
    "sent": {
      "back": "Back to home",
      "text": "Thank you for your request. Our team will contact you within 24 hours.",
      "title": "Message sent!"
    },
    "submit": {
      "demo": "Request a demo",
      "quote": "Request a quote",
      "send": "Send",
      "sending": "Sending..."
    }
  },
  "contacts": {
    "action": {
      "manageAccess": "Manage access",
      "remove": "Remove",
      "share": "Share"
    },
    "add": {
      "advisor": {
        "browse": "Browse directory",
        "desc": "Share your collection with a trusted art advisor",
        "title": "Invite an advisor"
      },
      "button": "Add",
      "expert": {
        "browse": "Browse directory",
        "desc": "Register your valuation, restoration or authentication experts",
        "title": "Add an expert"
      },
      "insurer": {
        "browse": "View partners",
        "desc": "Register your art insurance contacts",
        "title": "Add an insurer"
      },
      "satellite": "Add as satellite"
    },
    "advisors": {
      "active": {
        "title": "Art advisors"
      },
      "confirmed": {
        "separator": "Confirmed advisors"
      },
      "declined": {
        "title": "Declined invites"
      },
      "pendingInvites": {
        "title": "Pending invites"
      },
      "pendingShare": {
        "title": "Waiting for access"
      }
    },
    "alert": {
      "accessRevoked": "Access revoked ✅",
      "advisorAdded": "Advisor added successfully! You can now select them when sharing your collection.",
      "advisorEmailRequired": "Advisor email is required",
      "deleteError": "Error while deleting",
      "expertAdded": "Expert added successfully!",
      "expertRevoked": "Expert revoked ✅",
      "insurerAdded": "Insurer added successfully!",
      "insurerRevoked": "Insurer revoked ✅",
      "invitationDeleted": "Invite deleted",
      "missingId": "Can’t revoke: missing identifier.",
      "satelliteInviteSent": "Satellite invite sent ✅"
    },
    "anonymous": "Anonymous",
    "delete": {
      "confirm": "Are you sure you want to delete this invitation?",
      "error": "Error deleting invitation",
      "invitation": "Delete invitation",
      "success": "Invitation deleted successfully"
    },
    "empty": {
      "advisors": {
        "helper": "Invite an advisor to start structuring your collection."
      },
      "experts": "No expert registered",
      "insurers": "No insurer recorded"
    },
    "invite": {
      "declined": "Invitation declined",
      "pending": {
        "helper": "Waiting for the expert to accept."
      }
    },
    "list": {
      "advisors": "Art advisors",
      "experts": "Experts",
      "insurers": "Insurers"
    },
    "loading": "Loading your contacts...",
    "pendingShare": {
      "cta": "Share now",
      "helper": "They accepted your invitation. All that’s left is sharing your collection.",
      "subtitle": "These experts are ready to start",
      "title": "Waiting for sharing"
    },
    "satelliteDrawer": {
      "title": "Satellite collaborator"
    },
    "serviceRequest": {
      "sent": "Art advisory request sent.",
      "status": {
        "active": "Mission in progress",
        "waiting": "Waiting for access"
      },
      "waitingAccess": "The expert is waiting for access to your collections."
    },
    "sharedSince": "Shared since",
    "stats": {
      "advisors": "Advisors",
      "experts": "Experts",
      "insurers": "Insurers",
      "total": "All contacts"
    },
    "subtitle": "Manage your advisors, experts and insurers. These contacts remain strictly private and confidential.",
    "title": "Address book",
    "type": {
      "advisor": "Advisor",
      "expert": "Expert",
      "insurer": "Insurer"
    },
    "viewAll": "View all"
  },
  "cta": {
    "back": {
      "dashboard": "Back to dashboard"
    },
    "invite": {
      "expert": "Invite an expert"
    },
    "share": {
      "collection": "Share my collection"
    }
  },
  "dashboard": {
    "access": {
      "ctaOpen": "Open access panel",
      "desc": "Share your collection with an expert, an advisor or a trusted contact.",
      "drawerTitle": "Manage access",
      "hint": "Each person sees only what you authorise.",
      "mobileSummary": "Access",
      "tap": "Tap to manage",
      "title": "Access & sharing",
      "ctaFindExpert": "Find an expert",
      "ctaShareAccess": "Share access",
      "ctaManage": "Manage",
      "freeConnection": {
        "title": "✓ Free introduction (included)",
        "description": "An introduction to an Artkiv personal advisor is completely free.",
        "paidLabel": "Paid assignments:",
        "paidText": "displayed price + 5% platform fee (e.g. a €149 valuation → you pay €156.45 excl. VAT)."
      }
    },
    "actions": {
      "title": "Actions",
      "subtitle": "Protect, assess, share and prepare what happens next for your artworks.",
      "protect": "Protect",
      "assess": "Assess",
      "certify": "Certify",
      "opportunities": "Institutional opportunities",
      "expertise": {
        "title": "Expertise & valuation",
        "desc": "Find a professional when an artwork needs expertise, valuation or specialist advice."
      },
      "authenticity": {
        "title": "Authenticity — submit a dossier",
        "desc": "Submit the artwork and supporting documents for human review by a qualified expert.",
        "note": "Submitting a dossier does not itself constitute a certificate of authenticity.",
        "cta": "Submit a dossier"
      },
      "fingerprint": {
        "title": "Digital fingerprint",
        "desc": "Create a dated SHA-256 fingerprint of the artwork record to verify the integrity of the recorded data.",
        "note": "Current phase: ARTKIV fingerprint. Public Tezos anchoring is not active yet.",
        "cta": "View digital fingerprint"
      },
      "future": "Prepare the future",
      "succession": {
        "title": "Transmission & succession",
        "desc": "Prepare beneficiaries, ownership situations and private scenarios for the future of your collection.",
        "note": "ARTKIV provides a preparation and simulation framework, not legal or tax advice.",
        "cta": "Prepare transmission"
      }
    },
    "addArtwork": "Add an artwork",
    "buy": "Purchase",
    "confidenceIndex": {
      "high": "High",
      "label": "Confidence index",
      "low": "Low",
      "medium": "Medium",
      "tooltip": "Index based on the information provided: artist, year, medium, purchase price and image."
    },
    "contacts": {
      "sub": "Address book"
    },
    "cta": {
      "addFirst": "Add my first artwork"
    },
    "details": "View details",
    "empty": {
      "subtitle": "Add your first artwork to start structuring your collection.",
      "title": "No artworks yet"
    },
    "emptyShared": {
      "cta": "Manage access",
      "ctaPrimary": "Share access",
      "ctaSecondary": "Find an expert",
      "desc": "Invite an expert or advisor, or ask someone to share a collection with you.",
      "hint": "You stay in control: view-only or edit, anytime.",
      "title": "No shared collections yet"
    },
    "emptyWorks": {
      "cta": "Add an artwork",
      "ctaPrimary": "Add my first artwork",
      "ctaSecondary": "Follow galleries",
      "desc": "Add your first artwork (photo + details) and Artkiv will track its value, documents and upcoming alerts.",
      "hint": "Tip: one artwork = one photo + a title + an artist. The rest can come later.",
      "title": "Your collection starts here ✨"
    },
    "error": {
      "reload": "Reload page",
      "title": "Loading error"
    },
    "estimate": {
      "sub": "Request a valuation",
      "value": "Estimate"
    },
    "forSale": "For sale",
    "galleries": "Galleries",
    "insurance": {
      "sub": "Protect",
      "summary": {
        "answered": "Reply received",
        "ctaFollow": "Track",
        "ctaNew": "Insure an artwork",
        "desc": "Protect your artworks and track ongoing offers over time.",
        "latestStatus": "Latest status",
        "pending": "In progress",
        "seen": "Viewed",
        "title": "Insurance",
        "total": "Total"
      }
    },
    "loading": {
      "auth": "Checking authentication…",
      "collection": "Loading your collection…"
    },
    "manageCollections": "Manage collections",
    "marketplace": {
      "empty": "No artworks currently for sale.",
      "loading": "Loading artworks for sale..."
    },
    "news": {
      "subtitle": "Follow news from artists in your collection",
      "tabs": {
        "alerts": "My alerts",
        "fairs": "Art fairs",
        "sales": "Sales & Records",
        "artists": "Artists & fairs",
        "galleries": "Galleries"
      },
      "grouped": {
        "title": "My news",
        "subtitle": "Follow artists in your collection, art fairs and your favourite galleries"
      },
      "switchToGalleries": "View galleries",
      "switchToArtists": "View artists",
      "stats": {
        "artists": "Artists followed",
        "galleries": "Galleries",
        "fairs": "Upcoming fairs",
        "alerts": "Active alerts"
      }
    },
    "noSharedCollections": "No shared collections yet",
    "notAvailable": "Not available",
    "noWorks": "Your collection is empty for now",
    "plusValue": "Unrealised gain",
    "proposals": {
      "title": "Your actions",
      "subtitle": "Track everything related to your artworks, with a clear view for today and for passing them on later."
    },
    "propose": {
      "sub": "Museum / Sale"
    },
    "purchase": "Purchase price",
    "purchaseMissingCta": "Add purchase price",
    "purchaseMissingReadonly": "Purchase price not provided",
    "putForSale": "Put up for sale",
    "share": {
      "sub": "Invite an advisor"
    },
    "shareAccess": "Share access",
    "shared": {
      "title": "Collections shared with me"
    },
    "sharedByMe": {
      "access": {
        "edit": "Edit",
        "view": "View"
      },
      "accessLabel": "Access level",
      "collectionsCount": "{{count}} collection(s)",
      "cta": {
        "editAccess": "Edit access",
        "manage": "Manage",
        "refresh": "Refresh"
      },
      "empty": {
        "cta": "Invite an advisor",
        "desc": "You haven't shared your collection with anyone yet.",
        "title": "No sharing yet"
      },
      "hint": "Shared people can see only what you authorise.",
      "loading": "Loading…",
      "stats": {
        "people": "{{count}} person(s)",
        "shares": "{{count}} share(s)"
      },
      "subtitle": "Manage who has access to your collections.",
      "title": "Sharing",
      "withYou": "Shared with you"
    },
    "sharedCollections": "Shared collections",
    "sincePurchase": "since purchase",
    "stats": {
      "sub": "Analyse"
    },
    "subtitle": "Overview of your collection and services",
    "title": "Dashboard",
    "totalEstimate": "Current estimated value",
    "totalPurchase": "Total purchase value",
    "ungrouped": "Unassigned artworks",
    "viewDetails": "View details",
    "works": "My artworks",
    "errors": {
      "module": "An error occurred in this module.",
      "delegatedMissing": "Delegated access could not be found or has expired.",
      "delegatedForbidden": "You no longer have viewing permission.",
      "collectionsLoad": "The collections could not be loaded.",
      "sharedCollectionsLoad": "The shared collections could not be loaded."
    },
    "navigation": {
      "overview": "Overview",
      "overviewHint": "Where does my collection stand?",
      "contactsAccess": "Contacts & access",
      "contactsAccessHint": "Who do I work with, and who can see what?",
      "collection": "My artworks",
      "collectionHint": "What do I own?",
      "sharing": "Sharing",
      "marketNews": "Market & news",
      "marketNewsHint": "What is happening around my artists and the market?",
      "proposals": "Proposals",
      "actions": "Actions",
      "actionsHint": "What do I want to do with my artworks?"
    },
    "market": {
      "title": "Market & news",
      "subtitle": "The sales, exhibitions and information that truly concern the artists in your collection.",
      "preferences": "Manage my follows",
      "viewAll": "View all",
      "estimate": "Estimate",
      "details": "View detail",
      "why": "Why you see it",
      "read": "Read the news",
      "reason": { "collection": "Artist in your collection", "priority": "Artist followed as priority" },
      "type": { "exhibition": "Exhibition" },
      "stats": {
        "watched": "Watched artists", "watchedDetail": "Collection + follows",
        "auctions": "Matching sales", "auctionsDetail": "Upcoming",
        "unread": "Unread news", "unreadDetail": "To discover",
        "events": "Upcoming event", "eventsDetail": "Fairs & exhibitions"
      },
      "tabs": { "auctions": "Upcoming sales", "news": "News", "followed": "My follows" },
      "auctions": { "title": "Upcoming sales for your collection", "subtitle": "Selected from your watched artists.", "empty": "No sale matching your artists has been detected yet. ARTKIV keeps watching the market." },
      "news": { "title": "Your artists' news", "subtitle": "Partner galleries, exhibitions, fairs and market.", "empty": "No news for your artists yet. ARTKIV keeps watching galleries, fairs and exhibitions." },
      "followed": {
        "title": "Watched artists",
        "subtitle": "Artists in your collection are watched automatically. Add a priority to reinforce tracking.",
        "add": "Follow an artist",
        "addPrompt": "Name of the artist to follow:",
        "inCollection": "In my collection",
        "priority": "Followed as priority",
        "prioritize": "Follow as priority",
        "unprioritize": "Remove priority",
        "note": "No artist is counted twice: the total combines your collection and your manual follows.",
        "empty": "No watched artist yet. Add artworks to your collection or follow an artist."
      }
    },
    "collectionSummary": {
      "summary": "Collection summary",
      "artworks": "artworks",
      "collections": "collections",
      "note": "To keep the dashboard easy to read, the complete view is available under “Collections” in the menu.",
      "ctaAdd": "Add an artwork"
    },
    "breakdown": {
      "title": "Collection positioning",
      "subtitle": "Breakdown by medium, type, period and location",
      "hide": "Hide",
      "show": "Analyse my collection"
    },
    "losses": {
      "title": "Loss & theft",
      "description": "Report an artwork that is missing, stolen or destroyed for tax and insurance tracking.",
      "cta": "View register"
    }
  },
  "authenticityRequest": {
    "eyebrow": "Authenticity",
    "title": "Submit an authenticity dossier",
    "intro": "Gather the information and documents useful for reviewing the artwork. The dossier can then be directed to a qualified expert.",
    "notice": "ARTKIV structures and forwards the dossier. Submission is not a certificate: only a qualified expert can issue an opinion or authenticity document.",
    "artwork": {
      "label": "Artwork",
      "placeholder": "Choose an artwork…",
      "empty": "Add the artwork to your collection before creating its dossier.",
      "add": "Add an artwork",
      "existingCertificate": "A certificate is already recorded on this artwork."
    },
    "provenance": {
      "label": "Context & provenance",
      "help": "Share what you know: acquisition source, gallery, auction house, artist, family history, exhibition, publication or known ownership history.",
      "placeholder": "E.g. acquired from gallery…, invoice dated…, family provenance since…"
    },
    "documents": {
      "label": "Supporting documents",
      "help": "Add any available evidence: invoice, existing certificate, front/back photos, signature, labels, provenance documents, publication or previous report.",
      "cta": "Add documents"
    },
    "notes": {
      "label": "Your request",
      "placeholder": "Describe your question, any specific doubt or the context of the request."
    },
    "declaration": "I confirm that the information provided is accurate to the best of my knowledge and that I am authorized to submit these documents for review.",
    "submit": "Submit dossier",
    "submitting": "Submitting dossier…",
    "errors": {
      "artworks": "Unable to load your artworks.",
      "artworkRequired": "Choose the artwork concerned.",
      "declarationRequired": "Confirm the declaration before submitting.",
      "fileType": "Unsupported format. Use PDF, JPG, PNG or WebP.",
      "fileSize": "A file exceeds the 15 MB limit.",
      "submit": "The dossier could not be submitted. Check the Supabase configuration and try again."
    },
    "success": {
      "title": "Dossier submitted",
      "text": "Your dossier has been recorded. Its status will change to “under review” once it is taken in charge.",
      "dashboard": "Back to Actions",
      "collection": "View my collection"
    }
  },
  "demo": {
    "advisor": {
      "badge": "ART ADVISOR PLAN",
      "cta": {
        "demo": "Request a live demo",
        "start": "Start now"
      },
      "final": {
        "cta": {
          "start": "Start for free",
          "team": "Talk to our team"
        },
        "note": "No commitment • Cancel anytime",
        "subtitle": "Join the art advisors who manage their client collections with Artkiv",
        "title": "Ready to transform your practice?"
      },
      "hero": {
        "subtitle": "The essential tools for art advisors managing up to 5 collectors at once",
        "title": "Manage multiple client collections like a pro"
      },
      "price": "€99",
      "section": {
        "compare": {
          "title": "Need more? Switch to Art Advisor Premium"
        },
        "features": {
          "subtitle": "Features designed for your art advisory practice",
          "title": "Everything you need"
        },
        "screenshots": {
          "subtitle": "See how Artkiv simplifies your daily work",
          "title": "The interface in pictures"
        }
      },
      "testimonials": {
        "title": "They trust us"
      }
    },
    "advisorPremium": {
      "api": {
        "badge": "IN DEVELOPMENT"
      },
      "badge": "ART ADVISOR PREMIUM PLAN",
      "cta": {
        "compare": "Compare plans",
        "demo": "Request a personalised demo"
      },
      "features": {
        "subtitle": "Everything in the Art Advisor plan, and more",
        "title": "Premium features"
      },
      "final": {
        "cta": {
          "demo": "Book a personalised demo",
          "plans": "View all plans"
        },
        "subtitle": "Join the leading art advisors",
        "title": "Ready to scale up?"
      },
      "hero": {
        "subtitle": "Unlimited clients, full AI, advanced integrations.",
        "title": "The complete solution for professionals"
      },
      "price": "€199",
      "roi": {
        "title": "Calculate your ROI"
      },
      "testimonial": {
        "title": "They trust us"
      },
      "usecases": {
        "subtitle": "Different profiles, one shared solution",
        "title": "Who uses Art Advisor Premium?"
      },
      "why": {
        "subtitle": "The benefits that make all the difference",
        "title": "Why go Premium?"
      }
    },
    "fo": {
      "badge": "ENTERPRISE SOLUTION",
      "features": {
        "title": "Enterprise features"
      },
      "final": {
        "title": "Let’s discuss your needs"
      },
      "hero": {
        "cta": {
          "demo": "Schedule a presentation",
          "quote": "Request a tailored quote"
        },
        "subtitle": "The art wealth management platform for demanding family offices, private banks and institutions.",
        "title": "Artkiv Family Office"
      },
      "industries": {
        "title": "Our institutional clients"
      },
      "onboarding": {
        "title": "Enterprise onboarding process"
      },
      "pricing": {
        "title": "Pricing options"
      },
      "security": {
        "title": "Bank-grade security & compliance"
      },
      "why": {
        "title": "Why Artkiv for your Family Office?"
      }
    }
  },
  "edition": {
    "detailsHelp": "Indicate edition number, total run, presence of artist proofs (EA/AP), HC, etc. You can also specify the edition for a video (e.g. \"Edition of 3 video boxes + 1 AP\").",
    "detailsLabel": "Edition details",
    "detailsPlaceholder": "Examples: \"2/6 + 2 AP\", \"Edition of 3\", \"HC, pigment print\", \"1/3 + 1 AP\", etc.",
    "isEditionLabel": "This work is part of an edition, print run or multiple (lithograph, photograph, sculpture, etc.).",
    "loading": "Loading…",
    "readOnlyDetailsTitle": "Edition details:",
    "readOnlyEditionTitle": "Edition / multiples",
    "readOnlyIsEdition": "Work in edition:",
    "readOnlyNo": "No, unique piece",
    "readOnlyYes": "Yes (multiple / edition)"
  },
  "estimation": {
    "artwork": {
      "badge": {
        "estimated": "✓ Estimated"
      },
      "lastEstimate": "Last estimate: {{value}} €",
      "noEstimate": "Not yet estimated",
      "untitled": "Untitled"
    },
    "guide": {
      "assurance": {
        "text": "Use the points-based method or comparable works, then complete with the Insurance valuation module to build your supporting file.",
        "title": "For your insurance"
      },
      "highValue": {
        "text": "CNES expertise in France is mandatory for insurance and strongly recommended for major transactions. Contact our accredited experts.",
        "title": "For high-value works (> €80k)"
      },
      "note": "💡 You can use several methods for the same artwork. Each valuation is archived in the artwork’s history to follow its value over time.",
      "sale": {
        "text": "Favour Comparable works to know the current market price. If your artist has little market data, the points-based method provides a solid baseline.",
        "title": "To sell your artwork"
      },
      "succession": {
        "text": "Use the Estate valuation module, which automatically applies the tax rules of your jurisdiction (France, Belgium, Switzerland).",
        "title": "For an inheritance"
      },
      "title": "💡 Need help choosing?"
    },
    "methods": {
      "assurance": {
        "cost": "Free (expert opinion optional)",
        "description": "Build a complete supporting file for your insurer: declared value, purchase proofs, comparables, expert opinion if needed.",
        "duration": "15–20 min",
        "feature1": "Full supporting file",
        "feature2": "Calculated replacement value",
        "feature3": "CNES expertise recommendations (France) if > €80k",
        "feature4": "Ready for your insurer",
        "title": "Insurance valuation",
        "whenToUse": "To subscribe or renew your art insurance. Calculates replacement value (20–30% uplift over market value)."
      },
      "button": {
        "quote": "Request a quote",
        "start": "Start this method"
      },
      "comparables": {
        "cost": "Free",
        "description": "Market analysis based on similar sales: same artist, medium, dimensions, period...",
        "duration": "10–15 min",
        "feature1": "Real market data",
        "feature2": "Outlier filtering",
        "feature3": "Reflects current demand",
        "feature4": "Multiple sources (Artprice, Artnet, galleries)",
        "title": "Comparable works",
        "whenToUse": "Ideal to prepare a sale or for artists with an active market. You need to enter recent comparable sales yourself (auctions, galleries) — unless an Art Advisor expert handles it for you."
      },
      "points": {
        "cost": "Free",
        "description": "Valuation based on objective criteria: technique, dimensions, period, condition, signature, rarity...",
        "duration": "5 min",
        "feature1": "Automatically calculated score",
        "feature2": "Precise estimate range",
        "feature3": "Accepted by insurers",
        "feature4": "Transparent methodology",
        "title": "Points-based method",
        "whenToUse": "Ideal for insurance or a first estimation when you don't have recent comparable sales. Particularly suited for classic works or lesser-known artists."
      },
      "recommended": {
        "badge": "Recommended"
      },
      "subtitle": "Each method serves a specific purpose. Select the one that matches your needs.",
      "succession": {
        "cost": "Free",
        "description": "Tool to support estate planning and tax declaration depending on jurisdiction: France (5% flat rate), Belgium (dation 120%), Switzerland (26 cantons).",
        "duration": "20–30 min",
        "feature1": "Tax scales by country",
        "feature2": "Inheritance tax simulations",
        "feature3": "Dation recommendations (> €150k)",
        "feature4": "Report for your notary",
        "title": "Estate / inheritance valuation",
        "whenToUse": "To anticipate inheritance tax, prepare a donation or work with your notary/family office. Tax calculations aligned with local law."
      },
      "title": "Choose your estimation method",
      "whenToUseLabel": "When to use it?"
    },
    "page": {
      "subtitle": "Choose the method that fits your objective",
      "title": "Estimate an artwork"
    },
    "pro": {
      "expertise": {
        "button": "Request a quote",
        "desc": "Physical expertise by a CNES-accredited expert (mandatory above €80,000 in France). On-site visit, in-depth examination, certified report.",
        "point1": "Physical examination of the work",
        "point2": "Guaranteed approved value",
        "point3": "From €300 (Artkiv commission included)",
        "title": "Full CNES expertise – France"
      },
      "footer": "💡 Artkiv receives a commission on expert services to maintain platform quality and develop new tools",
      "subtitle": "For works that require expert validation or a formal expertise",
      "title": "Artkiv professional services",
      "validation": {
        "button": "Request a validation",
        "desc": "An Artkiv expert reviews your estimation (points or comparables) and checks its consistency with the market. Ideal to strengthen your insurance file.",
        "point1": "Validation within 48 hours",
        "point2": "Signed statement provided",
        "point3": "€150 (Artkiv commission included)",
        "title": "Validation by an Artkiv expert"
      }
    },
    "selected": {
      "changeArtwork": "Change artwork"
    },
    "step1": {
      "addArtwork": "Add an artwork",
      "empty": "You don't have any artworks in your collection yet.",
      "title": "Select the artwork to estimate"
    },
    "steps": {
      "chooseArtwork": "Choose the artwork",
      "chooseMethod": "Choose the method"
    },
    "ui": {
      "filtrerLaSelection": "Filter the selection",
      "retrouvezRapidementUneUvreParTitreArtisteTechniqueOu": "Quickly find a work by title, artist, medium or sub-collection.",
      "reinitialiser": "Reset",
      "rechercherTitreArtiste": "Search by title or artist…",
      "tousLesArtistes": "All artists",
      "toutesLesTechniques": "All mediums",
      "toutesLesSousCollections": "All sub-collections",
      "uvreSAfficheeSSur": "work(s) shown out of",
      "aucuneUvreNeCorrespondAuxFiltres": "No works match these filters.",
      "voirToutesLesUvres": "View all works",
      "filterResults": "{{shown}} artwork(s) shown out of {{total}}"
    }
  },
  "expert": {
    "add": {
      "title": "Add an expert"
    },
    "alert": {
      "error": "Error while adding expert: {{error}}",
      "mustBeLoggedIn": "You must be logged in to add an expert.",
      "success": "Expert added successfully."
    },
    "button": {
      "submit": "Save"
    },
    "clients": {
      "cockpitDescription": "You manage two flows here in one place: (1) collectors from your network inviting you to access their collection, and (2) access requests you have sent to collectors already on Artkiv. Everything is centralized for a clear and reliable history."
    },
    "Dashboard": {
      "complete": {
        "common": {
          "expert": "Expert",
          "userNotLoggedIn": "User not signed in",
          "errorWithMessage": "Error: {{message}}",
          "loading": "Loading…",
          "cancel": "Cancel",
          "send": "Send",
          "sending": "Sending…"
        },
        "errors": {
          "sharedDashboardLoad": "The shared collections module could not be loaded."
        },
        "profile": {
          "updated": "Profile updated.",
          "saveError": "An error occurred while saving the profile.",
          "visibilityError": "An error occurred while changing visibility.",
          "photoUpdated": "Photo updated.",
          "photoUploadError": "An error occurred while uploading the photo.",
          "cvUploaded": "CV uploaded.",
          "cvUploadError": "An error occurred while uploading the CV."
        },
        "invites": {
          "emailPlaceholder": "Client email",
          "notePlaceholder": "Short note (optional)"
        },
        "sidebar": {
          "plan": "{{plan}} plan",
          "features": {
            "unlimitedClients": "Unlimited clients",
            "fullAi": "Full AI analyses",
            "customReports": "Custom reports",
            "prioritySupport": "Priority support"
          },
          "manageSubscription": "Manage my subscription"
        },
        "services": {
          "pageTitle": "Service requests",
          "pageSubtitle": "Manage appraisal, valuation and specialist service requests from your clients.",
          "types": {
            "custom": "Request",
            "validation": "Valuation / validation",
            "authentication": "Authentication",
            "placementInstitution": "Museum proposal",
            "placementAuction": "Auction sale",
            "service": "Service"
          },
          "collector": "Collector",
          "collectorWithId": "Collector ({{id}}…)",
          "invitation": "Invitation",
          "newMessages": "New messages",
          "openArtwork": "Open artwork",
          "start": "Start",
          "markReflection": "Submit for review",
          "submittedForReview": "The request has been submitted to the client. You can continue the discussion through messaging.",
          "awaitingClientFeedback": "Awaiting client feedback",
          "accept": "Accept",
          "reject": "Decline",
          "chatWithClient": "Message the client",
          "completedOn": "Service completed on {{date}}",
          "acceptLoading": "Accepting…",
          "acceptedClosed": "Client accepted. The request is now closed.",
          "rejectConfirm": "Are you sure you want to decline this client?",
          "rejectLoading": "Declining…",
          "rejected": "Request declined.",
          "conversationOpening": "Opening conversation…",
          "conversationOpened": "Conversation opened",
          "conversationOpenError": "The conversation could not be opened.",
          "columns": {
            "new": "New",
            "inProgress": "In progress",
            "awaitingFeedback": "Awaiting feedback",
            "completed": "Completed",
            "cancelled": "Cancelled"
          },
          "empty": {
            "new": "Nothing new here",
            "inProgress": "No requests in progress",
            "awaitingFeedback": "Nothing awaiting feedback",
            "completed": "No completed services yet",
            "cancelled": "Nothing to report"
          },
          "status": {
            "pending": "New",
            "in_progress": "In progress",
            "awaiting_feedback": "Awaiting feedback",
            "completed": "Completed",
            "cancelled": "Cancelled"
          }
        },
        "overview": {
          "noRecentActivity": "No recent activity",
          "quickActions": {
            "requests": "View requests",
            "clientCollections": "Client collections",
            "inventoryReport": "Inventory report PDF",
            "valuationReport": "Valuation report",
            "inflationReport": "Inflation report (CPI)",
            "artistQuotes": "Artist valuations",
            "warehouseVisit": "Storage visit",
            "inviteClient": "Invite a client",
            "profile": "My Artkiv profile"
          },
          "completionRate": "Completion rate",
          "averageTime": "Average time",
          "averageTimeValue": "2.5 days",
          "visionQuote": "Analyse the condition, style and anomalies of each artwork directly from your clients’ collections.",
          "visionTool": "Artkiv AI Vision tool",
          "openVision": "Open AI Vision"
        },
        "collections": {
          "title": "Registered collections",
          "description": "Registered collections are the artwork inventories your clients have chosen to share with you. You can review artwork details, provenance, condition and associated documents. This access helps you provide tailored advice, recommend suitable services and monitor the development of your clients’ collections."
        },
        "portfolio": {
          "clientFallback": "Client",
          "clientWithId": "Client {{id}}…",
          "collectionFallback": "Collection",
          "untitled": "Untitled",
          "noAccessibleCollection": "No client collection is currently accessible",
          "inviteFromClientsTab": " Invite a client from the Clients tab to get started.",
          "analysisTitles": {
            "ai": "AI-assisted analysis • Compliance review required",
            "rules": "Rule-based analysis and aggregated calculations"
          },
          "readyDescription": "The scope is sufficiently substantial for a credible portfolio analysis: concentration, diversification and allocation decisions are now meaningful.",
          "structuringDescription": "The collection is still being structured. Focus remains on the works, documentation and growing depth before discussing patrimonial allocation.",
          "metrics": {
            "trackedValue": "Tracked value (estimate)",
            "valuationCoverageNote": "{{coverage}}% of artworks have a valuation basis",
            "artworks": "Artworks",
            "artistsCategoriesNote": "{{artists}} artists • {{categories}} categories",
            "artistConcentration": "Artist concentration",
            "topThreeShare": "Share of the three leading artists in total value",
            "dominantArtistsShare": "Share of the leading artists",
            "technicalDiversity": "Technical diversity",
            "techniquesCount": "{{count}} techniques",
            "techniquesRecorded": "Recorded techniques",
            "documentationCoverage": "Documentation coverage",
            "documentationNote": "Certificates, condition reports and supporting documents available"
          },
          "volumeWarning": "volume",
          "artworkCount": "{{count}} artwork",
          "artworkCount_plural": "{{count}} artworks",
          "artworkCount_one": "{{count}} artwork",
          "artworkCount_other": "{{count}} artworks",
          "artistsEmpty": "Add valuations to reveal the relative weight of each artist.",
          "categoryChartAria": "Distribution of artworks by category",
          "dominantCategoryNote": "Leading category by number of artworks. {{count}} categories identified.",
          "categoryDistributionEmpty": "The distribution will appear once artworks are shared.",
          "categoryAllocationEmpty": "Add values to assess the economic weight of each category.",
          "valueVsArtworks": "{{valueShare}}% value • {{artworkShare}}% artworks",
          "artworksShareTitle": "Share of artworks",
          "valueShareTitle": "Share of value",
          "valueVolumeEmpty": "Value-to-volume differences will appear once valuations are available.",
          "techniquesEmpty": "Techniques will appear once the shared artworks have been documented."
        },
        "tools": {
          "title": "Professional tools",
          "subtitle": "Expert tools for producing reports, valuing artworks and managing on-site visits.",
          "organizedSubtitle": "Prepare your data, build your analysis, then produce the deliverables intended for your clients.",
          "sections": {
            "prepare": {
              "title": "Prepare the file",
              "description": "Import your references, organise your valuations and collect information in the field."
            },
            "analyze": {
              "title": "Analyse and value",
              "description": "Cross-reference the available data to build your professional analysis."
            },
            "deliver": {
              "title": "Produce a deliverable",
              "description": "Turn your work into a clear, customisable document ready to share with your client."
            }
          },
          "categories": {
            "prepare": "Preparation",
            "analysis": "Analysis",
            "report": "Report"
          },
          "badges": {
            "vision": "ARTKIV Vision",
            "advisorPremium": "Art Advisor Premium"
          },
          "inventory": {
            "title": "Inventory report",
            "kicker": "Custom PDF",
            "description": "Generate a PDF report for a client’s collection using your own branding. Select the fields to include and export the document in one click.",
            "cta": "Open report builder"
          },
          "valuation": {
            "title": "Valuation report",
            "description": "Build a structured valuation report for insurance, estate planning, sale or collateral purposes, including a value range, sources and rationale. Export to PDF and editable Word.",
            "cta": "Create a report"
          },
          "inflation": {
            "title": "Inflation-adjusted value",
            "description": "Adjust the purchase price in line with cost-of-living changes. Available as soon as a purchase price and acquisition date are entered, with no comparable-sales valuation required. Export to PDF and Word.",
            "cta": "Generate report",
            "calculateCta": "Calculate adjusted value"
          },
          "artistQuotes": {
            "title": "Artist valuations",
            "kicker": "Private expert library",
            "description": "Reuse your A/B/C artist profiles and personal ranges by medium and format. Valuations remain linked to your expert account and can prefill future reports.",
            "cta": "Open my valuations"
          },
          "warehouse": {
            "title": "Storage visit",
            "kicker": "On-site inspection",
            "description": "Use the mobile interface during storage visits. Review artworks by location, record condition and risk, and add your on-site observations.",
            "cta": "Start a visit"
          },
          "artprice": {
            "title": "Artprice import",
            "kicker": "Market data",
            "description": "Import auction results from Artprice to enrich artwork records with market references.",
            "cta": "Import data"
          },
          "curatorial": {
            "title": "AI curatorial note",
            "description": "Generate a structured curatorial note organised by thematic strands using collection data. Export to PDF and editable Word.",
            "cta": "Open AI Vision"
          },
          "conservation": {
            "title": "Condition",
            "kicker": "Full report",
            "description": "Open the inventory report filtered by condition to identify artworks requiring particular attention.",
            "cta": "Condition report"
          },
          "comparables": {
            "title": "Comparable-sales valuation",
            "kicker": "Expert valuation",
            "description": "Value an artwork using internal and external comparables. AI Vision refinement is reserved for experts.",
            "cta": "Start a valuation"
          }
        },
        "acceptContact": {
          "title": "Confirm client introduction",
          "body": "This introduction is <free>free for the client</free> and included in their Artkiv subscription.<br/><br/>As the expert, you pay <price>€49 excluding VAT (€58.80 including VAT)</price> to access this qualified client.",
          "commission": "<title>New commission model:</title> For paid assignments, including €149 valuations and appraisals, <share>you receive 85% of the price</share> and Artkiv receives 15%. The client also pays a 5% platform fee.<br/><br/><example>Example: €149 valuation → you receive €126.65 (85%), the client pays €156.45 excluding VAT (€149 + €7.45 fee), and Artkiv receives €29.80 in total (20%).</example>",
          "invoiceNote": "This amount will be added to your next Artkiv invoice.",
          "confirm": "Confirm and accept"
        }
      },
      "actions": {
        "addNote": "Add a note",
        "inviteExpert": "Invite an expert",
        "removeAccess": "Remove access",
        "overview": "Dashboard",
        "clients": "Clients",
        "collections": "Collections",
        "invitations": "Invitations",
        "activity": "Activity",
        "aiAnalyses": "AI Analyses",
        "reports": "Reports",
        "new": "NEW",
        "services": "Requests",
        "outils": "Tools",
        "billing": "Billing",
        "profile": "Pro Profile",
        "manageSubscription": "Manage my subscription",
        "collaborateurs": "Collaborators",
        "missions": "Missions"
      },
      "alerts": {
        "none": "No alerts for now.",
        "title": "Alerts & Notifications"
      },
      "clientInvites": {
        "accepted": "Invitation to study the collection: accepted.",
        "acceptError": "Error while accepting invitation.",
        "declined": "Invitation declined.",
        "declineError": "Error while declining invitation.",
        "empty": "No pending invitations.",
        "expires": "Expires on",
        "invitedAt": " Invited at",
        "loadError": "Unable to load invitations.",
        "messageLabel": "Message",
        "subtitle": "Accept or decline access to a shared collection.",
        "title": "Collector invitations",
        "unknownClient": "Collector"
      },
      "clients": {
        "empty": "No clients yet.",
        "loading": "Loading your clients…",
        "none": "No clients for now.",
        "search": "Search a client…",
        "subtitle": "Review your clients, the families attached to them and the collections under management.",
        "title": "Client management",
        "viewAnalyses": "View AI analyses",
        "viewCollection": "View collection",
        "viewDocuments": "View shared documents"
      },
      "invitations": {
        "accept": "Accept",
        "decline": "Decline",
        "none": "No invitations yet.",
        "title": "Received Invitations"
      },
      "invites": {
        "emailInvalid": "Invalid email.",
        "emailLabel": "Client email",
        "error": "Invitation failed. Please try again.",
        "list": {
          "empty": "No invitations sent yet.",
          "title": "Sent invitations"
        },
        "noteLabel": "Personal message (optional)",
        "send": "Send invitation",
        "sending": "Sending…",
        "subtitle": "Invite your clients to create their own ArtKiv account and share their collections with you.",
        "success": "Invitation sent successfully.",
        "title": "Invite a client"
      },
      "modal": {
        "confirmDecline": {
          "cancel": "Cancel",
          "confirm": "Decline",
          "text": "Do you really want to decline this invitation?",
          "title": "Decline invitation"
        },
        "removeAccess": {
          "cancel": "Cancel",
          "confirm": "Remove",
          "text": "Do you want to remove this client's access?",
          "title": "Remove access"
        }
      },
      "notes": {
        "add": "Add note",
        "none": "No notes recorded.",
        "placeholder": "Write a note…",
        "title": "Internal Notes"
      },
      "overview": {
        "activeCollections": "Active collections",
        "currentRequests": "Current requests",
        "activeClients": "Active clients",
        "completedServices": "Completed services",
        "recentActivity": "Recent activity",
        "portfolioAnalysisTitle": "Client portfolio analysis",
        "portfolioAnalysisHint": "Value, artists, documentation and conservation — in detail.",
        "quickActions": "Quick actions",
        "performance": "Performance",
        "completionRate": "Completion rate",
        "avgTime": "Average time",
        "noRecentActivity": "No recent activity",
        "trendThisMonthPlus2": "+2 this month",
        "trendThisMonthPlus5": "+5 this month"
      },
      "kanban": {
        "new": "New",
        "inProgress": "In progress",
        "awaitingFeedback": "Awaiting feedback",
        "completed": "Completed",
        "cancelled": "Cancelled",
        "emptyNew": "Nothing new here",
        "emptyInProgress": "No requests in progress",
        "emptyAwaiting": "No pending feedback",
        "emptyCompleted": "No completed services yet",
        "emptyCancelled": "Nothing to report (good news)"
      },
      "quickActions": {
        "requests": "View requests",
        "collections": "Client collections",
        "inventory": "Inventory PDF report",
        "valuation": "Valuation report",
        "warehouse": "Warehouse visit",
        "invite": "Invite a client",
        "profile": "My Artkiv profile"
      },
      "plan": {
        "feature1": "Unlimited clients",
        "feature2": "Full AI analyses",
        "feature3": "Custom reports",
        "feature4": "Priority support"
      },
      "outils": {
        "title": "Professional tools",
        "subtitle": "Your expert tools to generate reports, appraise artworks and manage your field visits."
      },
      "permissions": {
        "expired": "Access expired",
        "expires": "Expires on {{date}}",
        "fullAccess": "Full access",
        "readOnly": "Read only",
        "renew": "Renew access",
        "title": "Access & Permissions"
      },
      "portfolio": {
        "kpiValueTracked": "Tracked value (estimate)",
        "kpiValueNote": "of artworks with a valuation basis",
        "kpiArtworks": "Artworks",
        "artists": "artists",
        "mediums": "mediums",
        "kpiArtistConcentration": "Artist concentration",
        "kpiArtistNote": "Share of top 3 artists in total value",
        "kpiArtistNoteAlt": "Share of dominant artists",
        "kpiMediumDiversity": "Medium diversity",
        "kpiMediumOk": "Balanced distribution",
        "kpiMediumWeak": "Diversification needed",
        "kpiDocCoverage": "Documentation coverage",
        "kpiDocNote": "Certificates, condition reports and documents present",
        "liquidityPotential": "Potential liquidity",
        "liquidityNote": "Score calculated from value, artist, documents, comparables, medium, photos, certificate and condition report",
        "titleLabel": "Expert portfolio reading",
        "title": "Expert view between selected client and major client",
        "subtitle": "By default, the dashboard focuses on the major client — the one that offers the richest patrimonial reading today. You can then refine the analysis by collection.",
        "focus": "Focus",
        "autoMajorClient": "Automatic major client",
        "noSharedCollection": "No shared collection",
        "noAccessibleCollection": "No accessible collection",
        "updating": "Updating…",
        "artworksAnalyzedTotal": "{{count}} artworks analysed in total",
        "collection": "Collection",
        "allCollections": "All collections",
        "noClientCollectionTitle": "No client collection accessible yet",
        "noClientCollectionText": "Collections will appear here once a client has shared their collection with you.",
        "inviteClient": "Invite a client",
        "aiEnhancedTitle": "AI signal-enhanced analysis • Compliance check required",
        "ruleBasedTitle": "Analysis based on code, rules and aggregations",
        "aiEnhancedText": "This view uses some signals from AI processing present in the artwork records. It remains an aid for portfolio reading: any patrimonial, insurance or investment recommendation must be reviewed and validated by the expert before being shared with the client.",
        "ruleBasedText": "This view relies on internal calculations, thresholds and aggregations. It can be displayed without claiming AI analysis if no AI signal is actually used.",
        "majorClient": "Major client",
        "selectedClient": "Selected client",
        "portfolioReadyRules": "Portfolio ready rules",
        "patrimonialLevel": "Patrimonial level",
        "dominantArtists": "Dominant artists (by value)",
        "mediumBreakdown": "Medium breakdown",
        "signals": "Signals to process",
        "showTopArtists": "View top {{count}} ›",
        "reduce": "Show less",
        "collectionUntitled": "Untitled",
        "readablePortfolioText": "The scope is dense enough for a credible portfolio reading: concentration, diversification and arbitrage become legible.",
        "structuringPortfolioText": "The collection is still in a structuring phase. We track content, documentation and density growth before discussing patrimonial allocation.",
        "ruleValue": "Tracked value ≥ €150,000",
        "ruleArtworks": "Number of artworks ≥ 12",
        "ruleArtists": "At least 3 different artists",
        "ruleMediums": "At least 2 different mediums",
        "ruleValuationCoverage": "Valuation coverage ≥ 60%",
        "strongPatrimonyReached": "Strong patrimony level reached.",
        "closeToStrongPatrimony": "Close to strong patrimony level",
        "collectionStructuring": "Collection in structuring phase",
        "recommendedObjective": "Recommended objective:",
        "objectiveValue": "≥ €500,000 tracked value",
        "objectiveArtworks": "and ≥ 25 artworks",
        "dominantArtistsByCount": "Dominant artists (by number of artworks)",
        "showByArtworkCount": "By artwork count",
        "showByValue": "By value",
        "topArtists": {
          "showMore": "View top {{count}} ›",
          "showLess": "Show less",
          "notEnough": "Fewer than 6 valued artists: the full list is already displayed."
        },
        "ruleCategories": "At least 2 different categories",
        "categoryBreakdown": "Breakdown by category",
        "categoryValueAllocation": "Categories: artworks vs value",
        "techniqueBreakdown": "Main techniques"
      },
      "services": {
        "badge": {
          "assignedToMe": "Assigned to you",
          "done": "Done",
          "in_progress": "In progress",
          "new": "New"
        },
        "done": {
          "success": "Request marked as done."
        },
        "empty": "No service requests.",
        "filter": {
          "all": "All",
          "done": "Done",
          "in_progress": "In progress",
          "new": "New"
        },
        "filters": {
          "all": "All services",
          "done": "Completed",
          "inProgress": "In progress",
          "new": "New"
        },
        "heading": "ArtKiv service requests",
        "intro": "These requests come from ArtKiv clients seeking your expertise. By taking them in charge, you become their trusted contact.",
        "intro1": "All requests sent to you through Artkiv are listed here.",
        "intro2": "Use the status filters to organise your expert work and set priorities.",
        "loading": "Loading service requests...",
        "none": "No service requests for now.",
        "request": {
          "markDone": "Mark as done",
          "take": "Take in charge",
          "title": "Service request"
        },
        "take": {
          "success": "Request taken in charge."
        },
        "title": "Services related to your clients’ collections",
        "errorMessage": "Unable to load service requests.",
        "errorToast": "An error occurred while loading requests.",
        "toasts": {
          "taken": "Request started."
        }
      },
      "shared": {
        "description": "Registered collections group the artworks your clients have decided to share with you. You can review details, provenance, conservation status and documents in order to provide tailored advice and monitor the evolution of their art holdings.",
        "empty": "No shared collections yet.",
        "error": "The shared collections module could not be loaded.",
        "heading": "Registered collections",
        "loading": "Loading shared collections…",
        "loadingCollections": "Loading shared collections…"
      },
      "status": {
        "accepted": "Accepted",
        "declined": "Declined",
        "pending": "Pending"
      },
      "subtitle": "Track shared collections, ongoing services and your invitations.",
      "tab": {
        "clients": "Clients",
        "invitations": "Invitations",
        "services": "Service requests",
        "shared": "Shared collections"
      },
      "title": "Expert dashboard",
      "collaborateurs": {
        "title": "My team & access",
        "subtitle": "Invite assistants or occasional experts to access your collections. Every access is traceable and revocable at any time.",
        "quotaLabel": "Your plan",
        "quotaUnlimited": "unlimited collaborators",
        "quotaMax": "up to {{count}} collaborators"
      },
      "news": {
        "loading": "Loading news…"
      }
    },
    "form": {
      "company": {
        "placeholder": "Company"
      },
      "email": {
        "placeholder": "Email"
      },
      "name": {
        "placeholder": "Expert name"
      },
      "phone": {
        "placeholder": "Phone number"
      },
      "speciality": {
        "placeholder": "Specialty (e.g. modern art, photography…)"
      },
      "specialty": {
        "placeholder": "Specialty, e.g. modern art or photography"
      },
      "years": {
        "placeholder": "Years of experience"
      },
      "certified": {
        "label": "Certified expert"
      }
    }
  },
  "expertBilling": {
    "bicLabel": "BIC",
    "bicPlaceholder": "AGRIFRPP…",
    "ibanLabel": "IBAN",
    "ibanPlaceholder": "FR76…",
    "payouts": {
      "title": "Payments (received / scheduled)"
    },
    "save": "Save",
    "status": {
      "paid": "Paid",
      "pending": "Pending",
      "scheduledFor": "Scheduled for {{date}}",
      "paidOn": "Paid on {{date}}",
      "unknown": "Unknown status",
      "values": {
        "paid": "Paid",
        "scheduled": "Scheduled",
        "pending": "Pending",
        "failed": "Failed",
        "cancelled": "Cancelled",
        "canceled": "Canceled"
      }
    },
    "ticketLabel": "Ticket {{ticketId}}",
    "title": "Expert billing",
    "stats": {
      "totalEarned": "Total earned",
      "pending": "Pending",
      "nextPayout": "Next payout",
      "none": "None"
    },
    "bank": {
      "title": "Bank details",
      "save": "Save",
      "saving": "Saving…"
    },
    "security": {
      "title": "Payment security",
      "description": "Your bank details are stored securely and are used only to pay your fees. Payouts are made automatically 7 days after a service is completed."
    },
    "history": {
      "title": "Payout history",
      "ticket": "Ticket #{{id}}",
      "emptyTitle": "No payouts yet",
      "emptyDescription": "Your payouts will appear here after your first services are completed."
    },
    "fullBilling": {
      "title": "Complete billing management",
      "description": "Open your complete dashboard to manage your rates, review detailed statistics and view the history of all your services.",
      "open": "Open complete billing"
    }
  },
  "family": {
    "dashboard": {
      "subtitle": "Family office portfolio overview",
      "title": "Family Office Dashboard"
    }
  },
  "familyOffice": {
    "dashboard": {
      "actions": {
        "viewCollection": "View collection",
        "viewFamily": "Open family"
      },
      "buildSuccess": "Build successful - {{date}}",
      "empty": "No family has been configured yet in your Family Office space.",
      "filters": {
        "plan": "Plan",
        "status": "Status"
      },
      "loading": "Loading families…",
      "ok": "Family Office Dashboard is running!",
      "plan": {
        "premium": "Premium",
        "standard": "Standard"
      },
      "stats": {
        "alerts": "Priority alerts",
        "totalArtworks": "Artworks under management",
        "totalFamilies": "Active families",
        "totalValue": "Aggregated value"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "table": {
        "actions": "Actions",
        "artworks": "Artworks",
        "family": "Family",
        "lastActivity": "Last activity",
        "plan": "Plan",
        "valuation": "Valuation"
      },
      "title": "Family Office dashboard"
    }
  },
  "fiscal": {
    "client": {
      "add": "Add",
      "adding": "Adding…",
      "emptyList": "No accessible list detected (permissions). Add a client by email:",
      "label": "Client",
      "loading": "Loading…",
      "placeholder": "client@email.com",
      "select": "— Select a client —"
    },
    "description": "Select a client to view or define their default tax regime (used in sales/donations exports).",
    "error": {
      "emailNotFound": "No profile found with this email.",
      "loadClients": "Unable to load client list.",
      "save": "Unable to save (permissions/RLS?)."
    },
    "hint": "Tip: this preference will be used by default for export (sales/donations). It can later be adjusted per artwork or per operation.",
    "loading": {
      "pref": "Loading…",
      "save": "Saving…"
    },
    "notes": {
      "clientLabel": "Client:",
      "label": "Notes (optional)",
      "placeholder": "Ex: apply FR_PLUS_VALUE by default except artworks acquired before 2010…"
    },
    "regime": {
      "DE_PRIVATE_1Y_RULE": "Germany — Exempt if held > 1 year",
      "FR_FORFAIT_6_5": "France — Flat rate 6.5%",
      "FR_PLUS_VALUE": "France — Capital gain (19% + 17.2%)",
      "label": "Tax regime",
      "none": "— None (no calculation) —",
      "UK_CGT_SIMPLE_20": "United Kingdom — CGT (20% simplified)"
    },
    "role": {
      "expert": "Expert",
      "fo": "Family Office"
    },
    "title": "Tax preferences — {{role}} management"
  },
  "footer": {
    "copyright": "All rights reserved",
    "info": {
      "cookies": "Cookies",
      "legal": "Legal Notice",
      "privacy": "Privacy Policy",
      "title": "Information"
    },
    "newsletter": {
      "error": {
        "empty": "Please enter your email address",
        "generic": "An error occurred"
      },
      "placeholder": "your@email.com",
      "subtitle": "Get art market updates and Artkiv news",
      "success": "Thank you! You’ve subscribed to the newsletter.",
      "title": "Stay informed"
    },
    "platform": {
      "insurance": "Insurance",
      "pricing": "Pricing",
      "resources": "Resources",
      "title": "Platform"
    }
  },
  "galleries": {
    "confirmUnfollow": "Are you sure you want to unfollow this gallery?",
    "followed": {
      "empty": {
        "subtitle": "Use the search above or browse our suggestions.",
        "title": "You don't follow any gallery yet."
      }
    },
    "links": {
      "instagram": "Instagram →",
      "newsletter": "Newsletter →",
      "website": "Website →"
    },
    "modal": {
      "cancel": "Cancel",
      "confirm": "Confirm",
      "text": "Do you want to follow this gallery and receive its updates?",
      "title": "Confirm follow"
    },
    "news": {
      "empty": "No news available at the moment.",
      "more": "See more"
    },
    "newsletter": {
      "markAsSubscribed": "Mark as subscribed",
      "subscribed": "✓ Subscribed to the newsletter"
    },
    "search": {
      "follow": "Follow this gallery",
      "placeholder": "Gallery name...",
      "submit": "Search",
      "title": "Search a gallery"
    },
    "stats": {
      "currentExhibitions": "Current shows",
      "followed": "Followed galleries",
      "news": "News",
      "suggestions": "Suggestions"
    },
    "subtitle": "Follow your favourite galleries and receive their news.",
    "suggestions": {
      "button": {
        "follow": "Follow"
      },
      "commonArtists": "Artists in common: {{artists}}",
      "empty": {
        "subtitle": "Add artworks to your collection to generate suggestions.",
        "title": "No suggestion available."
      },
      "hint": "💡 These galleries represent artists present in your collection",
      "matchBadge": "{{score}} match(es)"
    },
    "tabs": {
      "followed": "My galleries",
      "news": "News",
      "search": "Results",
      "suggestions": "Suggestions"
    },
    "title": "Galleries",
    "unfollow": "Unfollow"
  },
  "header": {
    "admin": "Admin",
    "login": "Sign in",
    "logout": "Sign out",
    "nav": {
      "collection": "My Collection",
      "dashboard": "Dashboard",
      "estimates": "Valuations",
      "analysesIA": "AI Analyses",
      "services": "Tools",
      "myAdvisor": "My advisor",
      "importDoc": "Import a document",
      "start": "Get started"
    },
    "profile": "My Profile",
    "services": {
      "deposits": {
        "desc": "Entrusted collections & artworks on loan",
        "title": "Deposits & Loans"
      },
      "estate": {
        "desc": "Wealth transfer",
        "title": "Estate Planning"
      },
      "insurance": {
        "desc": "Protect your artworks",
        "title": "Insurance"
      },
      "locations": {
        "desc": "Precise geolocation",
        "title": "Locations"
      },
      "sales": {
        "desc": "Transaction management",
        "title": "Sales & Donations"
      },
      "losses": "Losses & Thefts",
      "lossesDesc": "Lost, stolen or destroyed artwork"
    }
  },
  "insurance": {
    "addArtwork": "Add an artwork",
    "addInsurer": "Add a new insurer",
    "back": "Back",
    "error": "Error",
    "form": {
      "insurer": "-- Select insurer --",
      "policyPlaceholder": "Insurance policy number",
      "type": "-- Type of coverage --",
      "value": "Insured value (€)"
    },
    "insuredWorks": "Recorded coverage",
    "insurer": "Insurer",
    "loading": "Loading...",
    "noArtworks": "You don't have any artworks in your collection yet.",
    "noneYet": {
      "text": "If one of your artworks is already insured, record the policy details here to keep the insurer, insured value and policy references attached to the artwork.",
      "title": "No insurance coverage recorded yet"
    },
    "notProvided": "Not provided",
    "notSpecified": "Not specified",
    "policyNumber": "Policy number",
    "section": {
      "new": "Add existing coverage"
    },
    "selectArtwork": "-- Select an artwork --",
    "simulate": "Simulate coverage",
    "status": {
      "answered": "Reply received",
      "pending": "In progress",
      "seen": "Viewed"
    },
    "submit": "Save coverage",
    "successAdded": "Coverage recorded successfully!",
    "title": "Insurance & coverage records",
    "type": "Type",
    "unknownArtwork": "Unknown artwork",
    "validUntil": "Policy valid until",
    "value": "Insured value",
    "recordIntro": {
      "title": "Already insured?",
      "body": "Use this page to record insurance coverage already in place and attach it to the artwork record: insurer, insured value, coverage type, policy number and expiry date.",
      "newInsurance": "Need new insurance? Use Actions → Insurance to prepare and send a request to a partner."
    },
    "coverage": {
      "title": "Coverage vs estimated value",
      "totalEstimated": "Total estimated value",
      "totalInsured": "Total insured value",
      "gap": "Coverage gap",
      "underinsured": "{{count}} underinsured artwork",
      "underinsured_plural": "{{count}} underinsured artworks",
      "wellCovered": "{{count}} adequately covered artwork",
      "wellCovered_plural": "{{count}} adequately covered artworks",
      "insuredLabel": "Insured",
      "estimatedLabel": "Estimated",
      "gapLabel": "Gap",
      "covered": "{{pct}}% covered",
      "update": "Update →",
      "expired": "EXPIRED",
      "expireSoon": "EXPIRES SOON",
      "cloaAClou": "Nail to nail",
      "percentCovered": "{{percent}}% covered"
    },
    "authRequired": "Please sign in to access this page.",
    "notConnected": "Not connected",
    "types": {
      "theft": "Theft",
      "fire": "Fire",
      "waterDamage": "Water damage",
      "transport": "Transport",
      "allRisks": "All risks",
      "nailToNail": "Nail to nail"
    },
    "addError": "Error while adding coverage.",
    "currency": "EUR"
  },
  "insurer": {
    "add": {
      "title": "Add an insurer"
    },
    "alert": {
      "error": "Error while adding insurer: {{error}}",
      "mustBeLoggedIn": "You must be logged in to add an insurer.",
      "success": "Insurer added successfully."
    },
    "button": {
      "submit": "Save"
    },
    "form": {
      "company": {
        "placeholder": "Company"
      },
      "email": {
        "placeholder": "Contact email"
      },
      "name": {
        "placeholder": "Contact name"
      },
      "phone": {
        "placeholder": "Contact phone"
      },
      "reputation": {
        "placeholder": "Reputation score (0–10)"
      }
    }
  },
  "bienvenue": {
    "meta": {
      "title": "Welcome — Your Transmission Studio | Artkiv"
    },
    "connecting": "Signing you in…",
    "expired": {
      "title": "This link is no longer valid",
      "body": "Your sign-in link has expired or has already been used. Sign in again to reach your space.",
      "cta": "Sign in"
    },
    "eyebrow": "Your Transmission Studio is ready",
    "hello": "Welcome, {{name}}.",
    "helloNoName": "Welcome.",
    "yourProfile": "Your profile",
    "archetype": {
      "batisseur": "The Builder",
      "passionne": "The Aficionado",
      "connecteur": "The Connector",
      "gardien": "The Keeper",
      "mecene": "The Benefactor"
    },
    "trial": {
      "title": "Your 14 free days start now.",
      "until": "Full access until {{date}}.",
      "generic": "Full access for 14 days.",
      "noCard": "No credit card required."
    },
    "mission": {
      "label": "Your first step",
      "text": "Add the first artwork you would never want your heirs to misunderstand.",
      "cta": "Add an artwork"
    },
    "skip": "Explore my space first"
  },
  "landing": {
    "gestures": {
      "label": "What you'll do",
      "title": "One simple gesture at every step",
      "intro": "No technical jargon. You take a photo, ARTKIV understands and suggests — you stay in control.",
      "flow": {
        "gather": "Gather",
        "document": "Document",
        "understand": "Understand",
        "protect": "Protect",
        "value": "Value",
        "transmit": "Transmit"
      },
      "cards": {
        "addArtwork": {
          "title": "Add an artwork",
          "text": "Photograph a work: ARTKIV creates its record and enriches it."
        },
        "scanDocs": {
          "title": "Scan your documents",
          "text": "Photograph an invoice or a certificate. ARTKIV extracts the information and offers to complete the record."
        },
        "documentState": {
          "title": "Document its condition",
          "text": "Photograph details and damage: images and analysis stay attached to the work."
        },
        "trackValue": {
          "title": "Track its value",
          "text": "Work and comparables together: a value range, tracked over time."
        },
        "prepareFuture": {
          "title": "Prepare its future",
          "text": "Collection and transmission structured, ready for your notary."
        },
        "advisor": {
          "title": "Work with your Art Advisor",
          "text": "Secure sharing: everyone accesses what their permissions allow."
        },
        "phone": {
          "title": "Continue on your phone",
          "text": "Scan a QR from your computer: your phone opens straight to the right task."
        }
      }
    },
    "archetypes": {
      "label": "The five profiles",
      "title": "Five ways to collect. Five blind spots.",
      "intro": "How you collect determines how a collection must be documented, valued and passed on. Every profile has its strengths — and its blind spot.",
      "riskLabel": "Blind spot",
      "batisseur": {
        "name": "The Builder",
        "text": "They follow ratings, careers, market trends. The collection is run like a portfolio.",
        "risk": "Documentation focused on resale value, neglecting provenance and condition — everything that will one day justify the price."
      },
      "passionne": {
        "name": "The Aficionado",
        "text": "They buy on impulse, without calculation. The collection tells a personal story.",
        "risk": "Little traceability, scattered acquisitions. When the day comes, the heirs inherit a collection with no instruction manual."
      },
      "connecteur": {
        "name": "The Connector",
        "text": "They collect through encounters: artists, curators, dealers. The collection mirrors their network.",
        "risk": "Documentation that lives in their memory and relationships rather than on paper."
      },
      "gardien": {
        "name": "The Keeper",
        "text": "They already think legacy, institution, foundation. Instinctively the closest profile to what an estate requires.",
        "risk": "A strong intention, rarely turned into a legal and fiscal dossier that actually exists."
      },
      "mecene": {
        "name": "The Benefactor",
        "text": "They collect to support: artists, institutions, causes.",
        "risk": "A collection scattered across gifts and loans, whose overall value becomes impossible to read."
      },
      "punchline": "None of these profiles — not even the most methodical — has, by default, a collection ready to be passed on.",
      "punchlineSub": "That is precisely the blind spot Artkiv addresses, without asking you to change the way you collect.",
      "cta": "Find my profile"
    },
    "badge": "14-day free trial on the Standard plan",
    "meta": {
      "title": "ARTKIV — The Collection After You",
      "description": "Document, value and pass on your collection. Discover your collector profile in 2 minutes."
    },
    "nav": {
      "explore": "The platform",
      "how": "How it works",
      "login": "Sign in"
    },
    "cta": {
      "button": {
        "createAccount": "Create an account",
        "quiz": "Take the Collector Legacy Test",
        "note": "14-day free trial on the Standard plan. No credit card.",
        "privacy": "Privacy policy"
      },
      "text": "Your artworks stay private, but your proof becomes solid. Collection, certificates, valuations, secure sharing: in one place, for you today and for your family next.",
      "title": "The collection after you"
    },
    "footer": {
      "cookies": "Cookies",
      "copyright": "© {{year}} Artkiv — All rights reserved",
      "legal": "Legal notice",
      "privacy": "Privacy"
    },
    "hero": {
      "button": {
        "demo": "Request a demo",
        "start": "Get started with Artkiv"
      },
      "eyebrow": "The Collection After You",
      "explore": "See the platform",
      "login": "Sign in",
      "quiz": "Take the Collector Legacy Test",
      "quizNote": "3 minutes. Your archetype appears right away; your full card is sent to your inbox.",
      "subtitle": "Every artwork carries a story only you know: where it came from, what you paid, why you bought it. Artkiv gathers that proof into one clear dossier — for you today, for your family next.",
      "title": "You know why you collect. Do you know what happens next?",
      "trial": "14-day free trial on the Standard plan.",
      "trust": "Built with specialists in art, insurance and wealth transmission."
    },
    "quiz": {
      "label": "Legacy Map",
      "title": "What kind of collector are you?",
      "text": "Fourteen questions, three minutes. Your collector archetype appears immediately. Your five axes, your blind spot and your collection's readiness index are sent to your inbox.",
      "cta": "Take the Collector Legacy Test",
      "note": "Free, no account required.",
      "archetype": {
        "builder": {
          "name": "The Builder",
          "text": "You assemble a coherent whole, made to last."
        },
        "aficionado": {
          "name": "The Aficionado",
          "text": "You buy on instinct, and every work has its story."
        },
        "connector": {
          "name": "The Connector",
          "text": "Your collection lives through artists and encounters."
        },
        "keeper": {
          "name": "The Keeper",
          "text": "You preserve, document and protect what was entrusted to you."
        },
        "benefactor": {
          "name": "The Benefactor",
          "text": "You support, lend and give: the collection serves beyond you."
        }
      }
    },
    "section": {
      "how": {
        "ctaPrimary": "Explore the platform",
        "ctaSecondary": "Create my account",
        "step1": {
          "text": "Browse the interface and the modules: collection, documents, AI analysis, certificates.",
          "title": "Explore"
        },
        "step2": {
          "text": "See how one artwork becomes a complete, clear, shareable dossier.",
          "title": "See a real example"
        },
        "step3": {
          "text": "Create your account and start with the artwork that matters most.",
          "title": "Move to your collection"
        },
        "stepLabel": "Step {{n}}",
        "text": "You can browse everything without an account. You start the trial when you decide to.",
        "title": "Three steps, no commitment"
      },
      "who1": {
        "text": "A life log for every artwork: provenance, invoices, certificates, restorations, value. Everything that proves, in one place.",
        "title": "Private collectors"
      },
      "who2": {
        "text": "Inheriting a collection? Understand what you have, what it is worth and what it meant, without starting from scratch.",
        "title": "Families and heirs"
      },
      "who3": {
        "text": "A traceable, shareable dossier. Less uncertainty, faster insurance, anticipated risk.",
        "title": "Family offices, insurers, advisors"
      },
      "why": {
        "point1": "Find an invoice or certificate in seconds.",
        "point2": "Share a secure dossier with an expert, an insurer or a family member.",
        "point3": "Track value and key events: sales, appraisals, restorations.",
        "point4": "Optionally add a dated, tamper-proof proof of authenticity to an artwork's history.",
        "text": "An artwork outlives its owner. The certificate, the invoice, the restorer's name, the reason for the purchase: those do not. Without that proof, a collection is passed on as an inventory of objects — and sometimes settled as a dispute.",
        "title": "What gets lost is never the artwork"
      }
    },
    "title": "ARTKIV — manage, value and secure your art collection"
  },
  "lang": {
    "selector": {
      "currency": "Currency",
      "eur": "€ EUR",
      "france": "FR - France",
      "language": "Language",
      "location": "Location"
    }
  },
  "location": {
    "add": {
      "title": "Add a location"
    },
    "alert": {
      "error": "Error while adding location: {{error}}",
      "mustBeLoggedIn": "You must be logged in to add a location.",
      "success": "Location added successfully."
    },
    "button": {
      "create": "Create",
      "submit": "Save"
    },
    "error": {
      "auth": "Authentication error: {{error}}",
      "create": "Error while creating location: {{error}}"
    },
    "form": {
      "address": {
        "placeholder": "Address"
      },
      "city": {
        "placeholder": "City"
      },
      "country": {
        "placeholder": "Country"
      },
      "name": {
        "placeholder": "Location name (e.g. Living room, Storage, Gallery…)"
      },
      "notes": {
        "placeholder": "Notes (optional)"
      },
      "type": "Type",
      "types": {
        "exhibition": "Exhibition",
        "loan": "Loan",
        "main": "Main residence",
        "office": "Office",
        "other": "Other",
        "secondary": "Second home",
        "storage": "Storage"
      }
    }
  },
  "login": {
    "create": "Create an account",
    "email": {
      "label": "Email",
      "placeholder": "your@email.com",
      "hint": "Please check the email format."
    },
    "error": {
      "default": "Incorrect email or password",
      "loadProfile": "Unable to load your profile. Please try again.",
      "noProfile": "User profile not found."
    },
    "forgot": "Forgot your password?",
    "security": {
      "hint": "Secure sign-in. Your data stays private."
    },
    "altCta": "I’d rather explore the platform first",
    "softNote": "You can explore without signing up. Your trial starts when you’re ready.",
    "hero": {
      "alt": "Art gallery",
      "copy": "The platform that helps you manage, protect and grow the value of your art collection.",
      "exploreCta": "See how it works",
      "pricingCta": "Compare plans",
      "proHint": "Family Office, expert, partner: you sign in here too."
    },
    "loading": "Signing you in...",
    "mobile": {
      "subtitle": "Sign in, or explore the platform in 2 minutes.",
      "explore": "See how it works",
      "compare": "Compare plans"
    },
    "noAccount": "Don’t have an account yet?",
    "password": {
      "label": "Password",
      "placeholder": "Your password",
      "show": "Show",
      "hide": "Hide"
    },
    "submit": "Sign in",
    "subtitle": "Access your personal space",
    "title": "Sign in"
  },
  "mesDemandes": {
    "error": "Unable to load your requests at the moment.",
    "empty": "You don’t have any requests yet. Start a proposal from an artwork (button “Propose to museum” or “Sale”).",
    "institutionFallback": "Institution not specified",
    "loading": "Loading…",
    "seeAll": "View all",
    "sendMethod": {
      "email": "Sent by email",
      "self": "Independent submission",
      "unknown": "Submission method not specified",
      "service": "Pro service"
    },
    "stats": {
      "draft": "Drafts: {{count}}",
      "pending_one": "In progress: {{count}}",
      "pending_other": "In progress: {{count}}",
      "sent_one": "Sent: {{count}}",
      "sent_other": "Sent: {{count}}",
      "paid_one": "Paid: {{count}}",
      "paid_other": "Paid: {{count}}",
      "draft_one": "Draft: {{count}}",
      "draft_other": "Drafts: {{count}}",
      "paid": "Paid: {{count}}",
      "pending": "In progress: {{count}}",
      "sent": "Sent: {{count}}"
    },
    "status": {
      "awaiting_payment": "Awaiting payment",
      "canceled": "Cancelled",
      "completed": "Completed",
      "in_progress": "In progress",
      "cancelled": "Cancelled",
      "draft": "Draft",
      "paid": "Paid",
      "pending": "In progress",
      "rejected": "Rejected",
      "sent": "Sent",
      "unknown": "Status: {{status}}"
    },
    "title": "My requests",
    "subtitle": "Proposals you sent to museums, institutions or auction houses (gift, loan, auction) from your artworks.",
    "backDashboard": "← Back to dashboard",
    "listTitle": "All my proposals",
    "listSubtitle": "Proposals sent to museums, institutions or auction houses (gift, loan, auction) from your artworks.",
    "filters": {
      "all": "All"
    },
    "type": {
      "auction": "Auction sale",
      "auction_sale": "Auction sale",
      "institution_gift": "Gift to an institution",
      "institution_loan": "Loan to an institution",
      "institution": "Institution",
      "unknown": "Other proposal",
      "museum": "Institution / Museum"
    },
    "view": {
      "label": "View",
      "title": "Open request"
    }
  },
  "nav": {
    "dashboard": "Dashboard",
    "logout": "Sign out",
    "profile": "My profile"
  },
  "news": {
    "alerts": {
      "collection": {
        "empty": "No artist in your collection yet",
        "follow": "Follow",
        "followed": "Followed",
        "title": "Artists in my collection"
      },
      "follow": {
        "button": "Follow",
        "placeholder": "Artist name...",
        "title": "Follow an artist"
      },
      "followed": {
        "empty": "You’re not following any artist yet. Use the form above to start.",
        "title": "Followed artists",
        "unfollow": "Unfollow"
      },
      "stats": {
        "collection": "In my collection",
        "followed": "Artist followed"
      }
    },
    "auctions": {
      "subtab": {
        "myArtists": "My artists",
        "topTen": "Global top 10"
      },
      "upcoming": {
        "dateUnknown": "Date to be confirmed",
        "empty": "No upcoming sale on your followed artists.",
        "fallbackTitle": "Sale",
        "title": "Upcoming sales"
      }
    },
    "exhibitions": {
      "dateArrow": "→",
      "dateRangeBoth": "Dates to be confirmed",
      "dateRangeStart": "—",
      "empty": "No upcoming exhibition detected.",
      "rpcHint": "The get_client_exhibitions RPC function must be created in Supabase",
      "sourceLink": "View exhibition",
      "title": "Exhibitions"
    },
    "fairs": {
      "empty": "No upcoming fair for now.",
      "link": "View website",
      "title": "Upcoming art fairs"
    },
    "loading": "Loading news...",
    "records": {
      "empty": "No recent record.",
      "estimatePrefix": "Est.",
      "noPrice": " Price not disclosed",
      "saleFallback": "Sale",
      "sourceLink": "View source",
      "title": "Sales records",
      "unknownCity": "—",
      "unknownCountry": "—",
      "unknownDate": "Unknown date"
    },
    "subtitle": "Follow the news of the artists in your collection",
    "tabs": {
      "alerts": "My alerts",
      "auctions": "Sales & Records",
      "fairs": "Art fairs"
    },
    "title": "News"
  },
  "payment": {
    "success": {
      "button": {
        "invoices": "My invoices",
        "profile": "My profile"
      },
      "institution": {
        "label": "Destination"
      },
      "invoice": {
        "amount": "Amount",
        "downloadPdf": "Download invoice (PDF)",
        "label": "Invoice",
        "none": "No invoice retrieved.",
        "viewOnline": "View online"
      },
      "invoiceError": "Invoice error: {{error}}",
      "loadingInvoice": "Preparing your invoice…",
      "subtitle": "Thank you! Your request has been recorded. Our expert will now take over.",
      "title": "Payment confirmed",
      "work": {
        "fallback": "Artwork",
        "label": "Artwork"
      }
    }
  },
  "pricing": {
    "alert": {
      "confirm": {
        "change": "Do you want to change your subscription to {{plan}}?\n\nProration will be calculated automatically and applied immediately."
      },
      "demo": {
        "change": "Change your demo plan to {{plan}}?",
        "success": "Demo plan updated successfully!"
      },
      "error": {
        "change": "Error while changing plan: {{error}}",
        "generic": "An error occurred. Please try again.",
        "subscription": "Error: {{error}}"
      },
      "success": {
        "change": "Your plan has been updated successfully!"
      }
    },
    "compare": {
      "button": {
        "compare": "Compare plans",
        "expert": "Talk to an expert"
      },
      "subtitle": "Check our detailed comparison table or contact our team",
      "title": "Need help choosing?"
    },
    "currentPlan": {
      "bannerTitle": "You have an active subscription",
      "text": "Your current plan: {{plan}}. You can change plan anytime. Proration will be calculated automatically."
    },
    "faq": {
      "a1": "Yes, you can upgrade or downgrade your plan at any time. Proration is calculated automatically.",
      "a2": "Art Advisor lets you manage up to 5 client collections, while Premium offers unlimited clients with full AI features.",
      "a3": "Yes, each Family Office subscription includes customised onboarding and a dedicated account manager.",
      "q1": "Can I change plan at any time?",
      "q2": "What is the difference between Art Advisor and Art Advisor Premium?",
      "q3": "Does the Family Office plan include training?",
      "title": "Frequently asked questions"
    },
    "hero": {
      "subtitle": "From personal collections to institutional portfolios, choose the plan that fits your activity",
      "title": "A solution for every need"
    },
    "period": {
      "month": "/month"
    },
    "plan": {
      "artAdvisor": {
        "badge": "PRO",
        "cta": "Discover",
        "feature1": "Manage 5 client collections",
        "feature2": "Multi-portfolio interface",
        "feature3": "Custom client reports",
        "feature4": "Presentation tools",
        "feature5": "Priority support",
        "tagline": "Multi-client & pro tools"
      },
      "artAdvisorPremium": {
        "badge": "PRO+",
        "cta": "Discover",
        "feature1": "Unlimited client collections",
        "feature2": "AI & analysis for all clients",
        "feature3": "White-label reports",
        "feature4": "Aggregated dashboard",
        "feature5": "Dedicated 24/7 support",
        "tagline": "Unlimited clients & full AI"
      },
      "badge": {
        "current": "CURRENT PLAN"
      },
      "button": {
        "current": "Current plan",
        "downgrade": "Switch to {{title}}",
        "upgrade": "Upgrade to {{title}}"
      },
      "currentNote": "You are currently using this plan",
      "familyOffice": {
        "badge": "ENTERPRISE",
        "cta": "Subscribe",
        "feature1": "Unlimited portfolios",
        "feature2": "Advanced custom reporting",
        "feature3": "ERP/PMS integration",
        "feature4": "Regulatory compliance",
        "feature5": "Dedicated account manager",
        "feature6": "Guaranteed SLA",
        "tagline": "Tailored institutional solution"
      },
      "fondation": {
        "badge": "INSTITUTION",
        "cta": "Subscribe",
        "feature1": "Unlimited institutional inventory",
        "feature2": "Loans, deposits and exhibition management",
        "feature3": "Multi-user & curatorial team access",
        "feature4": "Institutional and public reports",
        "feature5": "Vision AI across the entire collection",
        "feature6": "Heritage and regulatory compliance",
        "tagline": "Heritage management for cultural institutions"
      },
      "premium": {
        "cta": "Upgrade to Premium",
        "feature1": "Advanced AI visual analysis",
        "feature2": "Conservation recommendations",
        "feature3": "Inheritance matching",
        "feature4": "Media watch & market alerts",
        "feature5": "Detailed reports",
        "tagline": "Artificial intelligence & insights"
      },
      "standard": {
        "cta": "Get started",
        "feature1": "Unlimited artwork inventory",
        "feature2": "Artist & location management",
        "feature3": "Basic tax & conservation tools",
        "feature4": "Exports and PDF reports",
        "tagline": "Essential inventory & management"
      },
      "trialBadge": "14 days free"
    },
    "section": {
      "collectors": {
        "subtitle": "Manage your personal collection with simplicity and intelligence",
        "title": "For collectors"
      },
      "pro": {
        "subtitle": "Advanced tools for art advisors, family offices and institutions",
        "title": "For professionals"
      }
    },
    "trial": {
      "text": "Enjoy a 14-day free trial on the Standard plan for any registration before 15 February 2026. Discover all features with no commitment.",
      "title": "Exclusive launch offer"
    }
  },
  "ocr": {
    "enrich": {
      "button": "Analyze document",
      "loading": "Analyzing…",
      "success": "Document successfully analyzed",
      "error": "Error during analysis",
      "noFile": "No file selected",
      "unsupported": "Unsupported format"
    },
    "fields": {
      "title": "Title",
      "artist": "Artist",
      "year": "Year",
      "medium": "Medium",
      "dimensions": "Dimensions",
      "price": "Price",
      "currency": "Currency",
      "source": "Source",
      "auctionHouse": "Auction house",
      "saleDate": "Sale date"
    },
    "invoice": {
      "label": "Invoice",
      "detected": "Invoice detected",
      "number": "Invoice number",
      "total": "Total amount",
      "buyer": "Buyer",
      "seller": "Seller"
    }
  },
  "profile": {
    "demo": {
      "ribbon": {
        "label": "DEMO PROFILE",
        "text": "You are browsing a demo account. Some actions (payments, emails, subscriptions) are simulated."
      }
    },
    "edit": {
      "birthYear": "Year of birth",
      "company": "Company",
      "confirmPassword": "Confirm password",
      "error": {
        "birthYear": "Please enter a valid birth year between 1900 and {{currentYear}}.",
        "generic": "An error occurred: {{message}}",
        "passwordMatch": "Passwords do not match.",
        "required": "Please fill in the last name and first name fields."
      },
      "firstName": "First name",
      "lastName": "Last name",
      "password": "New password",
      "save": "Save",
      "success": "Profile updated successfully!",
      "title": "Edit profile"
    },
    "firstname": "First name",
    "fiscal": {
      "description": "Choose your default regime for the sales/donations PDF export. If not set, the export will only show amounts (no tax calculation).",
      "error": {
        "save": "Unable to save tax preference."
      },
      "saving": "Saving…",
      "select": {
        "DE_PRIVATE_1Y_RULE": "Germany — Exemption > 1 year",
        "FR_FORFAIT_6_5": "France — Flat rate 6.5%",
        "FR_PLUS_VALUE": "France — Capital gain (19% + 17.2%)",
        "none": "None (do not calculate)",
        "UK_CGT_SIMPLE_20": "United Kingdom — CGT (20% simplified)"
      },
      "title": "Tax preference"
    },
    "info": {
      "birthYear": "Year of birth",
      "company": "Company",
      "email": "Email",
      "firstName": "First name",
      "lastName": "Last name",
      "loading": "Loading profile…",
      "title": "Personal information"
    },
    "page": {
      "title": "My profile",
      "eyebrow": "Personal space",
      "subtitle": "Manage your information, subscription and privacy preferences."
    },
    "sections": {
      "identity": {
        "eyebrow": "Profile",
        "title": "My identity",
        "desc": "Your personal information and contact details."
      },
      "billing": {
        "eyebrow": "Settings",
        "title": "Preferences & billing",
        "desc": "Your subscription, tax preferences and billing information."
      },
      "privacy": {
        "eyebrow": "Data",
        "title": "Privacy & AI",
        "desc": "Your consents for artificial intelligence features."
      }
    },
    "subscription": {
      "beta": {
        "confirm": {
          "cta": "Confirm my subscription"
        },
        "discount": {
          "hint": "Discount",
          "lifetime": "for life after confirmation",
          "text": "Your beta discount is active on your subscriptions.",
          "title": "Beta: -30% for life"
        },
        "ended": {
          "text": "Your free access ended. Confirm to keep -30% for life.",
          "title": "Beta period ended"
        },
        "free": {
          "text": "Your account is part of the beta program.",
          "title": "Beta: 6 months free"
        },
        "title": "Beta program"
      },
      "billingButton": "Billing",
      "currentPlan": {
        "none": "No plan"
      },
      "currentPlanLabel": "Current plan",
      "demo": {
        "actionsDisabled": "Payment actions are disabled on this demo account.",
        "info": {
          "text": "You are using a demo account. To access full features, create a real account.",
          "title": "Demo account:"
        },
        "mode": "🎭 Demo mode",
        "note": "Note: This is a demo subscription. Invoices and payments are simulated for testing purposes.",
        "planLabel": "Plan {{plan}}",
        "portalButton": "Billing portal (demo)",
        "portalDisabledTooltip": "Feature disabled in demo mode",
        "status": {
          "active": "Active (simulated)",
          "canceled": "Cancelled (simulated)",
          "none": "No subscription",
          "past_due": "Past due (simulated)",
          "trialing": "Free trial (simulated)"
        }
      },
      "demoNoSub": {
        "badge": "🎭 Demo account",
        "help": "To test how an active subscription looks, ask the administrator to enable a simulated subscription on this demo account.",
        "text": "This account does not require a real subscription. All features are accessible in demo mode.",
        "title": "Subscription (Demo)"
      },
      "demoWithSub": {
        "title": "Subscription & billing"
      },
      "error": {
        "payment": "Error: {{message}}",
        "portal": "Error: {{message}}",
        "portalUnavailable": "Billing portal unavailable",
        "missingPrice": "The Stripe price ID is missing for this plan.",
        "stripeUnavailable": "Stripe has not been initialized.",
        "checkoutUnavailable": "The Stripe checkout session could not be created."
      },
      "freeAccess": {
        "noBilling": "Billing is disabled for this account.",
        "note": "Full access unlocked for testing. No payment needed.",
        "until": "Valid until"
      },
      "loading": "Loading...",
      "manageButton": "Manage my subscription",
      "satellite": {
        "text": "Billing is managed by the account owner.",
        "title": "👤 Collaborator account",
        "textNamed": "Your access is included in {{name}}’s subscription. No payment is required from you.",
        "caption": "Collaborator account · no subscription required"
      },
      "sectionTitle": "My subscription",
      "status": {
        "active": "Active",
        "demo": "Demo",
        "freeAccess": "Complimentary",
        "inactive": "Inactive",
        "trialing": "Free trial"
      },
      "sectionSubtitle": "Plans, Stripe billing and access to Artkiv modules.",
      "currentPlanButton": "Current plan",
      "processing": "Redirecting…",
      "choosePlan": "Choose this plan",
      "compareButton": "Compare plans",
      "portalProcessing": "Opening…",
      "billingPortalButton": "Stripe portal"
    },
    "title": "Your profile details",
    "update": {
      "help": "Keep your profile details up to date to get the most out of your account."
    },
    "plans": {
      "standard": {
        "label": "Standard",
        "description": "Inventory, location tracking, exports and essential collection management."
      },
      "premium": {
        "label": "Premium",
        "description": "AI Vision, collaborators, experts, insurance and succession planning."
      },
      "artAdvisor": {
        "label": "Art Advisor",
        "description": "Multi-client management for up to 20 collections, with limited AI access."
      },
      "artAdvisorPremium": {
        "label": "Art Advisor Premium",
        "description": "Unlimited clients, full AI access, curatorial analysis and advanced reports."
      },
      "familyOffice": {
        "label": "Family Office",
        "description": "Multi-family overview, wealth reporting, governance and audit trail."
      }
    },
    "ia": {
      "error": {
        "save": "The AI setting could not be saved."
      },
      "title": "AI features & consent",
      "description": "Choose whether to enable Artkiv AI modules and review exactly what they do before giving your consent.",
      "descriptionUnavailable": "Your current plan does not include Artkiv AI modules. You can continue to manage your collection without AI.",
      "status": {
        "active": "AI enabled",
        "unavailable": "AI not included",
        "inactive": "AI disabled"
      },
      "saving": "Saving your choice…"
    },
    "loading": "Loading profile…",
    "error": {
      "missing": {
        "title": "Profile unavailable",
        "text": "The profile could not be loaded. Check that the user has a row in profiles and that the RLS policy allows read access."
      }
    }
  },
  "questionnaire": {
    "comments": {
      "label": "Other comments:",
      "placeholder": "Additional information or specific preferences."
    },
    "interest": {
      "high": "High",
      "label": "Your level of interest in managing the collection:",
      "low": "Low",
      "medium": "Medium"
    },
    "preferred": {
      "label": "Preferred or desired pieces:",
      "placeholder": "Describe the artworks you would like to manage or inherit."
    },
    "select": "Select...",
    "submit": "Submit",
    "title": "Questionnaire for {{name}}"
  },
  "rapportValorisationAdvisor": {
    "common": {
      "noValue": "—",
      "unknownArtist": "Unknown artist",
      "untitled": "Untitled"
    },
    "finality": {
      "assurance": {
        "badge": "Replacement value",
        "description": "Determines the replacement value for contractual coverage. Usually retains the highest market value.",
        "label": "Insurance valuation"
      },
      "marche": {
        "badge": "Disposition value",
        "description": "A realistic range for sale or acquisition. Cross-checks auction results, private market data and the artist’s market standing.",
        "label": "Fair market value"
      },
      "pret": {
        "badge": "Forced-sale value",
        "description": "Forced-sale value used as banking collateral. Usually represents 50 to 70% of fair market value.",
        "label": "Loan collateral"
      },
      "succession": {
        "badge": "Fair market value on the relevant date",
        "description": "Used for estate declarations or transmission. Must remain consistent with applicable tax and notarial scales.",
        "label": "Estate valuation"
      }
    },
    "header": {
      "badge": "Report · Art Advisor Premium",
      "subtitle": "Build a professional valuation report for your client. Choose the purpose, select the artworks, enter your data, then export to PDF or editable Word format.",
      "title": "Valuation Report"
    },
    "methods": {
      "assurance_doc": "Insurer document / insurance report",
      "physique": "Physical expertise (external)",
      "point": "Point method (artist rating)",
      "semblables": "Valuation by comparable works",
      "succession": "Artkiv estate module"
    },
    "sources": {
      "artnet": "Artnet",
      "artprice": "Artprice",
      "bonhams": "Bonhams",
      "christies": "Christie's",
      "drouot": "Drouot",
      "insuranceReport": "Insurance report",
      "other": "Other",
      "primaryGallery": "Gallery (primary market)",
      "privateMarket": "Private market",
      "sothebys": "Sotheby's"
    },
    "step1": {
      "advisorName": "Your name (signing advisor)",
      "clientName": "Client name (optional)",
      "clientNamePlaceholder": "E.g.: Dupont Collection",
      "continue": "Continue →",
      "subtitle": "The purpose determines the reference methodology and the level of value to retain.",
      "title": "What is the purpose of this valuation?"
    },
    "step2": {
      "allCollections": "All collections",
      "artworksCount": "{{count}} artwork",
      "artworksCount_plural": "{{count}} artworks",
      "back": "← Back",
      "chosenFinality": "Selected purpose:",
      "emptySearch": "No artworks match your search.",
      "emptySource": "No artworks in this collection.",
      "next": "Next →",
      "nextManual": "Continue → (manual entry)",
      "nextWithCount": "Continue → ({{count}} artwork)",
      "nextWithCount_plural": "Continue → ({{count}} artworks)",
      "noEstimate": "No valuation",
      "noSourceSelected": "Choose a source above to display artworks.",
      "offPlatformHint": "The artworks will be entered manually in the next step.",
      "offPlatformPlaceholder": "E.g.: Martin Family",
      "offPlatformTitle": "Off-platform client name",
      "pageSelection": "Page ({{count}})",
      "paginationSummary": "{{count}} artwork · p.{{page}}/{{total}}",
      "paginationSummary_plural": "{{count}} artworks · p.{{page}}/{{total}}",
      "previous": "← Previous",
      "searchPlaceholder": "Search title, artist, inventory number…",
      "selectAll": "Select all ({{count}})",
      "selectedCount": "{{count}} selected",
      "sourceOffPlatform": "Off-platform client",
      "sourceOwn": "My collections",
      "sourceSharedClient": "Shared client",
      "sourceTitle": "Collection source",
      "title": "Select the artworks to value",
      "unselectAll": "Unselect all"
    },
    "step3": {
      "addArtwork": "+ Add artwork",
      "artkivReference": "Artkiv reference",
      "back": "← Back",
      "delete": "Delete",
      "finalValuePlaceholder": "Final value",
      "highRange": "High range (€)",
      "justification": "Justification for retained value",
      "justificationPlaceholder": "E.g.: Direct comparable sold at Drouot in 2024 for €18,000. A 10% discount was applied due to the conservation condition.",
      "lowRange": "Low range (€)",
      "manualArtistPlaceholder": "Artist",
      "manualEmpty": "Click “+ Add artwork” to enter this client’s artworks.",
      "manualTitlePlaceholder": "Title",
      "method": "Method used",
      "next": "View summary →",
      "notes": "Global advisor recommendations (optional)",
      "notesPlaceholder": "Your overall recommendations: sales strategy, conservation alerts, complementary acquisition paths…",
      "required": "*",
      "retainedValue": "Retained value (€)",
      "sources": "Sources consulted",
      "subtitle": "For each artwork, enter the range, retained value, method and sources. Existing Artkiv references appear automatically.",
      "title": "Enter valuation data",
      "totalDraft": "Provisional total value"
    },
    "step4": {
      "disclaimer": "This report is provided for information purposes only. It does not constitute a legally binding appraisal. A physical examination by an accredited expert remains necessary for any transaction, estate matter or dispute.",
      "disclaimerItalic": "Artkiv supports the Advisor without replacing their expertise.",
      "downloadPdf": "Download PDF",
      "downloadWord": "Download Word (.docx)",
      "editData": "← Edit data",
      "generating": "Generating…",
      "newReport": "New report",
      "subtitle": "Review the summary, then download it as PDF (client delivery) or Word (free editing).",
      "summary": {
        "artworks": "Artworks",
        "date": "Date",
        "finality": "Purpose",
        "totalValue": "Total value"
      },
      "title": "Report ready for export"
    },
    "stepper": {
      "artworks": "Artworks",
      "data": "Data",
      "export": "Export",
      "finality": "Purpose"
    }
  },
  "reports": {
    "data": {
      "includeArtist": "Artist name",
      "includeLocation": "Location",
      "includeMedium": "Medium",
      "includePrice": "Price / Estimated value",
      "includeSize": "Dimensions",
      "title": "Data to include"
    },
    "error": "Error:",
    "generate": {
      "button": "Generate PDF",
      "loading": "Generating..."
    },
    "layout": {
      "groupBy": {
        "artist": "Artist",
        "location": "Location",
        "medium": "Medium",
        "none": "No grouping",
        "year": "Year"
      },
      "sortBy": {
        "acquisitionDate": "Acquisition date",
        "artist": "Artist",
        "creationYear": "Creation year",
        "name": "Title",
        "value": "Value"
      },
      "title": "Layout"
    },
    "name": {
      "label": "Report name"
    },
    "options": {
      "includeDate": "Include today's date",
      "includePurchaseValue": "Total purchase value",
      "includeThumbnails": "Include thumbnails (artwork images)",
      "includeValueTotal": "Total value of artworks",
      "title": "Report options"
    },
    "title": "Create a report",
    "type": {
      "acquisition": "Acquisition history",
      "artist": "Artist report",
      "condition": "Condition report",
      "exhibition": "Exhibition catalog",
      "insurance": "Insurance report",
      "inventory": "Inventory report",
      "label": "Report type",
      "location": "Location report",
      "valuation": "Valuation report"
    },
    "viewExisting": "View existing reports",
    "whiteLabel": {
      "companyName": {
        "current": "Currently: {{name}}",
        "label": "Your company or firm name",
        "notSet": "Not set"
      },
      "editProfile": "Edit in my profile →",
      "enable": "Enable",
      "info": "💡 Your reports will be generated with your professional identity instead of the Artkiv brand. Ideal for presenting to your clients.",
      "logo": {
        "add": "Add a logo →",
        "change": "Change logo →",
        "label": "Your logo",
        "notSet": "No logo uploaded. Add your logo in your profile to customize your reports."
      },
      "subtitle": "Generate a report with your professional identity",
      "title": "Custom report"
    }
  },
  "sale": {
    "conditionNotes": {
      "title": "Condition notes"
    },
    "description": {
      "title": "Description"
    },
    "details": {
      "condition": "Condition",
      "dimensions": "Dimensions",
      "signature": "Signature",
      "subject": "Subject",
      "technique": "Technique",
      "title": "Details",
      "type": "Art type",
      "year": "Year"
    },
    "dimensions": "Dimensions: {{value}}",
    "loading": "Loading...",
    "none": "No artwork found.",
    "notAvailable": "Artwork not available for sale.",
    "notFound": "Artwork not found.",
    "options": "Options: Shipping / Transport on request.",
    "price": {
      "label": "Sale price",
      "note": "(excluding taxes, transport and customs fees)",
      "undefined": "Not defined"
    },
    "request": {
      "button": "Request information (condition, provenance, etc.)",
      "checkbox": "I understand that this information is confidential and will remain private.",
      "errorCheckbox": "Please check the confidentiality box before submitting.",
      "success": "Your information request has been sent. An advisor will contact you shortly.",
      "title": "Request for more information"
    },
    "tags": {
      "title": "Tags"
    },
    "yearMedium": "{{year}} — {{medium}}",
    "imageAlt": "Artwork"
  },
  "salesDonations": {
    "addModal": {
      "addDocuments": "Add documents",
      "documentsHelper": "Add invoices, tax receipts or certificates.",
      "field": {
        "amount": "Sale amount (€)",
        "artist": "Artist",
        "artwork": "Artwork title",
        "buyer": "Buyer",
        "date": "Transaction date",
        "details": "Details",
        "documents": "Documents",
        "recipient": "Recipient",
        "taxYear": "Tax year",
        "type": "Transaction type",
        "valuation": "Estimated value (€)"
      },
      "title": "New transaction",
      "type": {
        "donation": "Donation",
        "sale": "Sale"
      }
    },
    "details": {
      "field": {
        "amount": "Amount",
        "artist": "Artist",
        "artwork": "Artwork",
        "buyer": "Buyer",
        "date": "Date",
        "details": "Details",
        "documents": "Documents",
        "estimatedValue": "Estimated value",
        "recipient": "Recipient",
        "taxYear": "Tax year",
        "type": "Type"
      },
      "title": "Transaction details",
      "viewDocument": "View"
    },
    "export": {
      "button": "GENERATE PDF",
      "yearAll": "All",
      "yearToGenerate": "Tax year to generate"
    },
    "filters": {
      "taxYear": {
        "all": "All tax years",
        "label": "Tax year"
      },
      "transactionType": {
        "all": "All transactions",
        "donation": "Donations",
        "donations": "Donations only",
        "lossVol": "Losses & Thefts",
        "sale": "Sales",
        "sales": "Sales only",
        "label": "Transaction type"
      },
      "taxYearOptions": {
        "all": "All"
      },
      "transactionTypeOptions": {
        "all": "All",
        "donation": "Donations",
        "sale": "Sales"
      }
    },
    "history": {
      "addTransaction": "Add a transaction",
      "col": {
        "actions": "Actions",
        "amount": "Amount",
        "artist": "Artist",
        "artwork": "Artwork",
        "counterparty": "Buyer / Recipient",
        "date": "Date",
        "police": "Police report",
        "taxYear": "Tax year",
        "type": "Type"
      },
      "noEvent": "No event for this filter.",
      "title": "Transaction history",
      "viewDetails": "Details",
      "noTransaction": "No transaction matches this filter."
    },
    "losses": {
      "badge": {
        "noPolice": "No police report",
        "policeNo": "No",
        "policeYes": "✓ Filed",
        "recovered": "Recovered",
        "withPolice": "✓ Police report filed"
      },
      "events": "{{count}} event",
      "events_plural": "{{count}} events",
      "modal": {
        "ctaRecover": "✓ Artwork recovered",
        "fiscalNoteNoPolice": "⚠ Without a police report, the tax deductibility of this loss generally does not apply.",
        "fiscalNoteWithPolice": "✓ Police report filed — this loss may be tax-deductible. Please consult your tax advisor.",
        "insuranceNo": "No",
        "insuranceYes": "✓ Yes",
        "notRecovered": "Not recovered",
        "policeNo": "No — loss not deductible",
        "policeYes": "✓ Yes",
        "recovered": "✓ Recovered on {{date}}",
        "recovering": "Processing…",
        "title": "Loss / Theft — Detail",
        "reference": "Ref. {{reference}}",
        "fields": {
          "type": "Type",
          "artwork": "Artwork",
          "artist": "Artist",
          "date": "Date",
          "declaredValue": "Declared value",
          "indemnity": "Insurance payment",
          "taxYear": "Tax year",
          "location": "Location",
          "policeReport": "Police report filed",
          "insuranceClaim": "Insurance claim",
          "status": "Status",
          "notes": "Notes"
        }
      },
      "recovered": "{{count}} recovered",
      "recovered_plural": "{{count}} recovered",
      "deductionPrefix": "−",
      "taxYear": "Tax year {{year}}",
      "events_one": "{{count}} event",
      "events_other": "{{count}} events",
      "recovered_one": "{{count}} recovered",
      "recovered_other": "{{count}} recovered",
      "types": {
        "theft": "Theft",
        "loss": "Loss",
        "destruction": "Destruction",
        "disappearance": "Disappearance",
        "generic": "Loss / Theft"
      }
    },
    "pdf": {
      "column": {
        "amount": "Amount (€)",
        "count": "Count",
        "section": "Section"
      },
      "disclaimer": {
        "body": "This document is generated from the information you have entered in Artkiv (amounts, dates, supporting documents, selected tax regime). Artkiv does not provide tax advice, does not guarantee the accuracy, completeness or updating of the data, and cannot be held liable for input errors, interpretation, or use of this document. Calculations and estimates are indicative only and must be reviewed by your tax advisor/lawyer. Tax rules may vary depending on the country, the taxpayer’s situation and changes in applicable laws.",
        "title": "Disclaimer / Limitation of liability."
      },
      "donationsDetails": {
        "artist": "Artist",
        "artwork": "Artwork",
        "date": "Date",
        "estimatedValue": "Estimated value (€)",
        "none": "No donations declared for {{year}}.",
        "recipient": "Recipient",
        "title": "Donation details"
      },
      "error": "Unable to generate the PDF.",
      "generatedFromArtkiv": "Document automatically prepared from the sales and donations data recorded in Artkiv.",
      "notes": {
        "de": "Note: DE – private sale is exempt if holding period > 1 year; otherwise taxation depends on income tax and is not estimated here.",
        "frForfait": "Note: FR – flat tax 6% + 0.5% CRDS applied per sale if the price is above €5,000.",
        "frPlusValue": "Note: FR – capital gain taxed at 19% + 17.2% (social contributions) with a 5% annual allowance from year 3 (full exemption after 22 years).",
        "none": "Note: no tax regime is selected — this report shows amounts without tax computation.",
        "uk": "Note: UK – simplified estimate at 20% on the capital gain (excluding annual allowance and banding)."
      },
      "row": {
        "donations": "Donations",
        "estimatedTax": "Estimated tax (if computable)",
        "regime": "Selected tax regime",
        "sales": "Sales",
        "totalOperations": "Total operations"
      },
      "salesDetails": {
        "artist": "Artist",
        "artwork": "Artwork",
        "buyer": "Buyer",
        "date": "Date",
        "none": "No sales declared for {{year}}.",
        "price": "Price (€)",
        "purchaseDate": "Acquisition date",
        "purchasePrice": "Purchase price",
        "title": "Sales details"
      },
      "titleAllYears": "Tax report – All years",
      "titleYear": "Tax report – {{year}}",
      "yearTitle": "Tax year {{year}}"
    },
    "regime": {
      "de": "Germany – Exempt if holding period > 1 year",
      "frForfait": "France – Flat tax 6.5% (per sale > €5,000)",
      "frPlusValue": "France – Capital gains (19% + 17.2%, 5% allowance per year after year 2)",
      "none": "No regime selected",
      "uk": "United Kingdom – CGT estimated 20% (simplified)"
    },
    "summary": {
      "col": {
        "actions": "Actions",
        "donations": "Total donations",
        "losses": "Deductible losses",
        "lossesTooltip": "Losses/thefts with police report filed, not recovered",
        "sales": "Total sales",
        "total": "Total",
        "year": "Tax year"
      },
      "estimatedTax": "Estimated tax:",
      "exportYear": "Export PDF",
      "noRegime": "No tax regime is defined for your account. Go to My Profile > Tax preference to choose one (FR / UK / DE). The PDF export will show amounts without any tax calculation until a regime is selected.",
      "regimeLabel": {
        "frForfait": "Flat tax 6.5% (per sale > €5,000)",
        "frPlusValue": "Capital gain tax (19% + 17.2%, 5% allowance per year after year 2)"
      },
      "title": "Tax summary"
    },
    "title": "Sales & Donations",
    "eyebrow": "Assets · Transactions",
    "errors": {
      "updateLoss": "Unable to update the record: {{message}}"
    }
  },
  "sharedAccess": {
    "collection": {
      "all": "All collections",
      "sharedOn": "Shared on {date}",
      "unnamed": "Untitled collection"
    },
    "empty": "No shared access for now",
    "error": "Unable to load shared access",
    "expert": {
      "certified": "Certified",
      "collections": "Shared collections ({count})"
    },
    "loading": "Loading...",
    "permission": {
      "edit": "Edit",
      "read": "Read-only"
    },
    "role": {
      "expert": "Expert",
      "familyOffice": "Family Office",
      "team": "Team",
      "user": "User"
    },
    "section": {
      "experts": "Experts ({count})",
      "users": "Other users ({count})"
    },
    "subtitle": "{experts} expert(s) • {users} user(s)",
    "title": "Shared access"
  },
  "signature": {
    "title": "Signature & authentication",
    "authLabel": "Certificate / authentication",
    "authPlaceholder": "Gallery COA, artist archivist…",
    "description": "Describe the signature, authenticity certificates, and any traceability element.",
    "notesLabel": "Additional notes",
    "notesPlaceholder": "Handwritten notes, stamp, seal…",
    "signatureLabel": "Signature",
    "signatureBooleanLabel": "Signed artwork",
    "signaturePlaceholder": "Signed lower right, dated…",
    "certificateLabel": "Certificate of authenticity",
    "certificatePresent": "Certificate present",
    "certificateInDocuments": "Available in documents:",
    "certificateFallbackName": "Certificate of authenticity",
    "noCertificate": "No certificate provided",
    "lotHelp": "This artwork is part of a lot. You can apply this signature to all artworks in the lot.",
    "applyToLot": "Apply to the whole lot",
    "applyToLotLoading": "Applying…",
    "applyToLotConfirm": "Apply this signature to all artworks in the lot?",
    "applyToLotError": "Failed to apply to the lot.",
    "applyToLotSuccess": "Signature applied to {{count}} artwork(s) in the lot."
  },
  "subscriptionGuard": {
    "currentStatus": "Current status",
    "explanation": "Your subscription is inactive. Please renew to access the platform.",
    "invoices": "My invoices",
    "openPortal": "Open billing portal",
    "payNow": "Pay now",
    "plan": "Plan",
    "title": "Subscription required",
    "processing": "Processing…",
    "freeUntil": "Free access until {{date}}.",
    "demo": {
      "noStripe": "Demo account: no Stripe payment.",
      "noPaymentRequired": "Demo mode: no payment required."
    },
    "errors": {
      "checkout": "Unable to start checkout. Please try again shortly.",
      "portal": "Unable to open the billing portal.",
      "stripeUnavailable": "Stripe is currently unavailable."
    },
    "status": {
      "demo": "demo",
      "free": "free",
      "active": "active",
      "trialing": "trial",
      "past_due": "past due",
      "canceled": "canceled",
      "cancelled": "cancelled",
      "unpaid": "unpaid",
      "none": "inactive"
    },
    "plans": {
      "standard": "Standard",
      "premium": "Premium",
      "demo": "Demo",
      "internal_demo": "Internal demo",
      "beta_demo": "Beta demo"
    }
  },
  "estimationSemblables": {
    "methodology": {
      "toDefine": {
        "badge": "To catalogue",
        "socle": "No personal artist quote is yet attached to this artwork.",
        "signal": "Add or import comparables, then catalogue the artist to lock in the methodology.",
        "adjustment": "The engine cannot yet distinguish a direct CUP, an analogy CUP, or a points method.",
        "conclusion": "The estimate remains preparatory until the methodological basis is defined."
      },
      "pointMethod": {
        "badge": "Points method",
        "socle": "Group C — no sufficiently established secondary market.",
        "signal": "Valuation is based on the expert grid: medium, dimensions, condition and any documentary bonuses.",
        "adjustment": "Gallery prices or external signals serve as context but do not replace the points method.",
        "conclusion": "The displayed value is an indicative fair value, based on a framed primary market rather than auction liquidity."
      },
      "quasiDirectCup": {
        "badge": "Quasi direct CUP",
        "socle": "Group B — analogy CUP in the initial quote.",
        "adjustment": "Recent sales are now numerous and consistent enough to reduce the initial prudential discount.",
        "conclusion": "The estimate remains in Group B, but the engine reading approaches a partial direct CUP."
      },
      "hybridReinforced": {
        "badge": "Reinforced hybrid",
        "socle": "Group B — analogy CUP: historically limited or inconsistent secondary market.",
        "adjustment": "These fresh sales partially reinforce the reliability of the valuation and correct the initial cautious reading.",
        "conclusion": "The engine combines expert quote, recent own results, freshness, technical proximity and weighted median."
      },
      "analogyPrudent": {
        "badge": "Prudent analogy",
        "socle": "Group B — analogy CUP: recent own results remain insufficient.",
        "signalOne": "Only one recent comparable is present: it serves as a signal, not an autonomous basis.",
        "signalNone": "No sufficient recent signal has yet been detected in the complete comparables.",
        "adjustment": "The prudential discount remains mostly active until the recent market is better documented.",
        "conclusion": "The estimate should be read as an analogical valuation, with caution on liquidity."
      },
      "directCupActive": {
        "badge": "Direct CUP active",
        "socle": "Group A — direct CUP: documented secondary market.",
        "adjustment": "Recent sales are weighted by dimensions, technique, artist proximity and freshness.",
        "conclusion": "The weighted median retains the most reliable comparables without directly modifying observed prices."
      },
      "directCupIncomplete": {
        "badge": "Direct CUP to complete"
      },
      "dynamic": {
        "badge": "Dynamic reading",
        "adjustment": "The engine weights results by freshness, technical proximity and dimensional consistency.",
        "conclusion": "The final valuation remains a decision-support tool and must be validated by the expert."
      },
      "groupB": {
        "b1label": "Reinforced hybrid",
        "b1desc": "Recent own results exist but remain insufficient for a direct CUP. The engine weights own results and analogies, with reduced prudence (-8%).",
        "b2label": "Prudent analogy",
        "b2desc": "No sufficient recent own results. Valuation is based on analogous artists of similar profile. Standard prudential discount of -15% applied per CUP methodology.",
        "b3label": "Quasi direct CUP",
        "b3desc": "Recent own results are sufficient and consistent for a reading close to a partial direct CUP. The prudential discount is lifted."
      }
    },
    "memory": {
      "addFromCup": "Click Add to estimate from the CUP assistant or ratio tool. Choices will appear here next time too.",
      "extrapolation": "Extrapolation",
      "retainedSale": "Retained sale",
      "untitledExtrapolation": "Untitled extrapolation",
      "untitledComparable": "Untitled comparable",
      "artistMissing": "Artist not specified",
      "sourceMissing": "Source not specified",
      "weight": "weight {{value}}",
      "remove": "Remove",
      "low": "Low",
      "high": "High"
    },
    "save": {
      "missingId": "Cannot save: estimation_id or user is missing.",
      "valuationError": "Error saving the estimate.",
      "resolveFailed": "Unable to resolve the estimation.",
      "irreparableAlert": "This artwork is classified Irreparable — total depreciation. No value can be saved. Document the decision in the artwork notes.",
      "missingQuote": "The artist quote exists, but a range or usable comparables are missing.",
      "catalogFirst": "Please catalogue this artist in your personal quotes first."
    },
    "ui": {
      "donationDirecteDeLArtisteEquivCertificat": "Direct donation from the artist, equivalent to a certificate",
      "certificatDAuthenticite": "Certificate of authenticity",
      "provenanceArtiste1erMarche": "Artist / primary-market provenance",
      "suiviDocumentaireComplet": "Complete documentary trail",
      "irreparableWriteOff": "Irreparable, write-off",
      "partiellementRestaurable65": "Partially restorable −65%",
      "tresAbimeRestaurable50": "Heavily damaged but restorable −50%",
      "tresMoyen30": "Very poor condition −30%",
      "etatMoyen20": "Fair condition −20%",
      "etatDeConservation": "Condition",
      "decotePrudentielle": "Prudence discount",
      "abattementLiquidite": "Liquidity discount",
      "bonificationsDocumentaires": "Documentary bonuses",
      "decotePrudentielleGroupeB": "Group B prudence discount",
      "abattementDeLiquiditeGroupeC": "Group C liquidity discount",
      "aucunAjustementMethodologiqueApplicable": "No methodological adjustment applies",
      "ajustementsAppliques": "Adjustments applied",
      "aucunAjustement": "No adjustment",
      "groupeB": "Group B ·",
      "baseBruteAvantDecotes": "Gross basis before discounts",
      "valeurApresAjustements": "Value after adjustments",
      "valeurRetenue": "Retained value",
      "ordreAppliqueEtatDeConservationDecotePrudentielleLiquiditeBonus": "Order applied: condition → prudence / liquidity discount → documentary bonuses.",
      "methodologieADefinir": "Methodology to be defined",
      "lectureMethodologiqueArtkiv": "ARTKIV methodology reading",
      "socleMethodologique": "Methodological basis",
      "signalMarcheRecent": "Recent market signal",
      "ajustementDynamique": "Dynamic adjustment",
      "conclusionMoteur": "Engine conclusion",
      "comparablesComplets": "Complete comparables:",
      "recents": "· recent:",
      "confiance": "· confidence:",
      "irreparableValeurNulleDepreciationTotale": "Irreparable, zero value, total impairment",
      "lectureJustificationMarche": "read market justification",
      "sauvegardeJustificationMarche": "save market justification",
      "lectureExpertDuMarche": "Expert market assessment",
      "ventesDirectes": "Direct sales:",
      "extrapolations": "· extrapolations:",
      "analogies": "· analogies:",
      "enregistrement": "Saving…",
      "enregistrerLaJustification": "Save justification",
      "lesExtrapolationsEtAnalogiesConstituentDesOutilsDAide": "Extrapolations and analogies support expert decision-making and do not guarantee an achievable sale price.",
      "enregistreLe": "saved on",
      "memoireExpertDeCetteEstimation": "Expert record for this estimation",
      "aucunChoixExpertEnregistre": "No expert selection saved",
      "ceBlocRecapituleLesVentesEtExtrapolationsReellementRetenues": "This section summarises the sales and extrapolations actually retained by the expert to support this appraisal.",
      "mediane": "Median",
      "extrapolationse5783c": "Extrapolations:",
      "fourchetteMemoire": "Recorded range:",
      "sauvegardeValuationArtwork": "save artwork valuation",
      "creationComparablesManuelsNeutres": "create neutral manual comparables",
      "sauvegardeComparablesRetenus": "save retained comparables",
      "cetteFonctionnaliteEstReserveeAuxComptesArtAdvisorPremium": "This feature is reserved for Art Advisor Premium accounts.",
      "ajoutezAuMoins3ComparablesCompletsAvantDeLancer": "Add at least three complete comparables before launching Vision.",
      "impossibleDeLancerLAnalyseVisionPourLeMoment": "Vision analysis cannot be started at the moment.",
      "veuillezDAbordSelectionnerUneUvreDepuisLa": "First select an artwork from the",
      "pageDEstimation": "estimation page",
      "retourAuxEstimations": "Back to estimations",
      "estimationParUvresComparables": "Comparable-artwork estimation",
      "comparezVotreUvreAvecDesVentesRecentesSimilaires": "Compare your artwork with recent similar sales",
      "commentCaMarche": "💡 How does it work?",
      "recherchezDes": "Find",
      "uvresSimilaires": "similar artworks",
      "venduesRecemmentMemeArtisteStylePeriodeDimensions": "sold recently, with the same artist, style, period and similar dimensions",
      "auMoins3Comparables": "at least three comparables",
      "avecLeurPrixDeVente": "with their sale prices",
      "indiquezVos": "Enter your",
      "artpriceChristieSSothebySGaleries": "Artprice, Christie's, Sotheby's, galleries…",
      "lEquipeArtkiv": "The Artkiv team",
      "valideEtAffine": "reviews and refines",
      "votreEstimationSous4872h": "your estimation within 48–72 hours",
      "votreUvre": "Your artwork",
      "uvre": "Artwork",
      "sansTitre": "Untitled",
      "artiste": "Artist:",
      "technique": "Medium:",
      "dimensions": "Dimensions:",
      "cetteUvreFaitPartie": "This artwork is part",
      "dUnLot": "of a lot",
      "pasBesoinDEstimerChaqueExemplaireSeparementALa": "You do not need to estimate each item separately. At the end of this process, you can",
      "appliquerCetteEstimationAToutLeLotEnUn": "apply this estimation to the entire lot in one click",
      "laDecoteSelonLEtatDeConservationSeraAppliquee": ". The condition discount will be applied separately to each item, for example fair −20% or very poor −30%.",
      "allerAuBoutonDApplicationAuLot": "Go to the apply-to-lot button ↓",
      "chargementDesAutresExemplaires": "Loading the other items…",
      "aucunAutreExemplaireDetectePourCeLotVerifiezLes": "No other item was detected for this lot. Check permissions or the lot_id join.",
      "trouverDesUvresComparables": "Find comparable artworks",
      "recherchezSurArtpriceMaisonsDeVentesGaleries": "Search Artprice, auction houses and galleries…",
      "forfaitUvreTemporelle": "Flat rate, time-based artwork",
      "groupeCMethodeAPoints": "Group C, points method",
      "ouChercher": "🔍 Where to search",
      "artpriceBaseDeDonneesMondiale": "→ Artprice, global database",
      "christieSVentesAuxEncheres": "→ Christie's, auction sales",
      "sothebySVentesAuxEncheres": "→ Sotheby's, auction sales",
      "artsyGaleries": "→ Artsy, galleries",
      "verificationDeVotreCotationPersonnelleArtiste": "Checking your personal artist rating…",
      "artisteNonEncoreCatalogueDansVosCotationsPersonnelles": "This artist is not yet catalogued in your personal ratings.",
      "classezDAbordLArtisteDansVosCotationsExpert": "First classify the artist in your expert ratings as Group A, B or C, then return here to launch the appropriate estimation.",
      "cataloguerCetArtiste": "Catalogue this artist",
      "cotationPersonnelleDetectee": "Personal rating detected:",
      "mediumNonRenseigne": "Medium not specified",
      "segmentSpecifiqueDetecte": "Specific segment detected:",
      "choisirUneCotationSegmentExpert": "Choose an expert rating / segment",
      "a": "to",
      "ajustementsAppliquesALaCotationPersonnelle": "Adjustments applied to the personal rating:",
      "base": "· base",
      "final": "→ final",
      "bonusDocumentairesDetectes": "Documentary bonuses detected:",
      "total": "→ total",
      "integreALaMethodologieFinale": "included in the final methodology.",
      "irreparableDepreciationTotaleValeurNulle": "Irreparable, total impairment, zero value",
      "uvreTemporelleVideoInstallationFormulePointsInapplicable": "Time-based artwork, video or installation: points formula not applicable.",
      "forfait": "Flat rate:",
      "forfaitCotationHorsFormulePoints": "Rating flat rate, outside the points formula:",
      "retenu": "· retained",
      "formule": "Formula: (",
      "cm": ") cm",
      "text": "×",
      "pt": "€/pt",
      "forfaitExpert": "Expert flat rate:",
      "dimensionsAbsentesFormuleNonApplicable": "dimensions missing, formula not applicable",
      "overrideExpertActifPriceLowPriceHighExclusDu": "Expert override active; price_low and price_high excluded from the calculation.",
      "decoteConservation": "Condition discount:",
      "apresDecote": "→ after discount",
      "bonusDocumentairesAppliques": "Documentary bonuses applied:",
      "integreDansLaValeurFinale": "% included in the final value",
      "methodologieFinaleGroupeC": "Final Group C methodology",
      "prixGalerieActuelArtsyArtsperGalerieBorneHauteIndicative": "Current gallery price, Artsy, Artsper or gallery, indicative upper benchmark",
      "jamaisIntegreDansLaMoyennePondereeSertDePlafond": "Never included in the weighted average. Used as a reading ceiling and retained in the record for traceability.",
      "ex23000": "E.g. 23,000",
      "borneGalerie": "Gallery benchmark (",
      "inferieureALaFourchetteHauteCalculee": ") below the calculated upper range (",
      "coherenceAVerifier": ") — consistency should be reviewed",
      "borneGalerie0f2755": "Gallery benchmark",
      "auDessusDeLaFourchetteCalculee": "— above the calculated range ✓",
      "modeActuel": "Current mode:",
      "fourchetteCalculee": "calculated range",
      "viaComparablesEncheres": "from auction comparables",
      "cotationPersonnelle": "personal rating",
      "expert": "expert",
      "ajustements": "· adjustments:",
      "partirSurLaCotationPersonnelle": "Use the personal rating →",
      "revenirAuxComparablesCalcules": "← Return to calculated comparables",
      "b3": "· B3",
      "b1HybrideRenforce": "· B1 reinforced hybrid",
      "b2AnalogiePrudente": "· B2 prudent analogy",
      "methodologieFinaleCotationPersonnelleGroupeA": "Final personal-rating methodology, Group A",
      "estimationIdComparableId": "estimation_id,comparable_id",
      "sauvegardeComparablesRetenusAutocup": "save retained AutoCUP comparables",
      "sauvegardeComparablesRetenusb4562d": "Retained comparables saved:",
      "sauvegardeComparablesRetenusNonBloquanteRequeteAnnulee": "Non-blocking save of retained comparables: request cancelled.",
      "sauvegardeComparablesRetenusNonBloquante": "Non-blocking save of retained comparables:",
      "b3QuasiCupDirecte": "· B3 quasi-direct CUP",
      "methodologieFinaleGroupeA": "Final Group A methodology",
      "artistesAnaloguesRetenusSaisissezLeursResultatsAuxEncheresCi": "Retained analogue artists: enter their auction results below",
      "cliquezSurUnNomPourPreRemplirLeChamp": "Click a name to prefill the artist field. Find results on Artprice, Artnet or Christie's.",
      "comparable": "Comparable #",
      "decesRecent": "Recent death",
      "titreDeLUvre": "Artwork title",
      "exSansTitreSerieAbstraite": "E.g. Untitled, abstract series",
      "nomDeLArtiste": "Artist name",
      "prixDeVente": "Sale price (€)",
      "ex15000": "E.g. 15000",
      "dateDeVente": "Sale date",
      "exArtpriceChristieS": "E.g. Artprice, Christie's…",
      "lienOptionnel": "Link, optional",
      "ajouterUneUvreComparable": "+ Add a comparable artwork (",
      "validationParLEquipeArtkiv": "📋 Validation by the Artkiv team",
      "votreAbonnement": "Your subscription",
      "inclutUneValidationHumaineUneFoisVosComparablesAjoutes": "includes human validation. Once your comparables have been added, our team will analyse them and send you a validated estimation within",
      "validationPrioritairePremium": "✅ Priority Premium validation",
      "vousDonneAccesAUneValidation": "gives you access to validation",
      "sous24h": "within 24 hours",
      "parNotreEquipeDExperts": "by our expert team.",
      "affinageVision": "Vision refinement",
      "outilExpertPourAffinerLesComparablesEtEnrichirL": "Expert tool for refining comparables and enriching the analysis.",
      "accesVisionCompletRequis": "Full Vision access required",
      "votreCompteExpertEstReconnuMaisLAnalyseVision": "Your expert account is recognised, but full Vision analysis is reserved for",
      "artAdvisorPremium": "Art Advisor Premium",
      "lAnalyseVisionSeraDisponibleDesQueVousAurez": "Vision analysis will become available once you have at least",
      "3ComparablesComplets": "3 complete comparables",
      "importezDesFichesArtpriceOuAjoutezManuellementDesComparables": "Import Artprice records or manually add comparables with title, artist and price to enable automatic refinement.",
      "lancezUneAnalyseVisionPourAffinerLaCoherenceDes": "Run a Vision analysis to assess the consistency of your comparables, identify differences in medium, period, format or market proximity, and strengthen your expert assessment before validation.",
      "analyseVisionEnCours": "Vision analysis in progress…",
      "analyserAvecVision": "Analyse with Vision",
      "resultatVision": "Vision result",
      "fourchetteSuggeree": "Suggested range:",
      "recapitulatifFinalGroupeC": "Final Group C summary",
      "recapitulatifFinalCotationPersonnelle": "Final personal-rating summary",
      "recapitulatifFinalGroupeA": "Final Group A summary",
      "etatDeConservationNonReconnu": "⚠ Unrecognised condition:",
      "laValeurStockeeEnBaseEst": "the value stored in the database is",
      "laquoNbsp": "“",
      "nbspRaquo": "”",
      "aucuneDecoteNEstAppliqueeValeursAttendues": "No discount is applied. Expected values:",
      "writeOff": "write-off",
      "corrigerLaFicheUvrePourAppliquerLaDecoteCorrectement": "Correct the artwork record to apply the appropriate discount.",
      "noteDeLExpertJustificationDeLEstimation": "Expert note: justification of the estimation",
      "cetteNoteApparaitDansLeRapportDExpertiseElle": "This note appears in the appraisal report and supplements the technical adjustments. It is prefilled from the most recently saved note and can be edited.",
      "exUvreEstimeeParAnalogieAvecLesSerigraphiesDu": "E.g. Artwork estimated by analogy with screenprints of the same format. A 15% discount was applied due to the absence of a certificate of authenticity. The artist's secondary market was active in 2024–2025.",
      "classementIrreparableValeurNulle": "Irreparable classification, zero value",
      "cetteActionEnregistre": "This action records",
      "commeValeurRetenueEtAppliqueLaMethode": "as the retained value and applies the method",
      "surLaFicheOeuvreDocumentezObligatoirementLaDecisionCi": "to the artwork record. You must document the decision below.",
      "noteDeJustification": "Justification note",
      "exEtatIrreparableConstateLorsDeLaVisiteDu": "E.g. Irreparable condition observed during the inspection on 01/06/2025. Canvas torn across 60% of the surface and stretcher broken. Restoration is not possible according to the findings.",
      "confirmerValeur0": "Confirm, value €0",
      "documenterLeWriteOffValeur0": "Document write-off, value €0",
      "enregistrerLEstimation": "Save estimation",
      "continuerVersLaValidation": "Continue to validation",
      "appliquerCetteEstimationAToutesLesUvresDuLot": "Apply this estimation to all artworks in the lot, with an individual condition discount for each item",
      "enregistrerAppliquerAuLot": "Save and apply to lot (",
      "serviceDeValidation": "💳 Validation service",
      "10ValidationsGratuitesMoisPuis150ParValidation": ": 10 free validations/month, then €150 per validation",
      "50ValidationsGratuitesMoisPuis150ParValidation": ": 50 free validations/month, then €150 per validation",
      "nosExpertsVerifierontVosComparablesSous4872hOuvres": "Our experts will review your comparables within 48–72 business hours",
      "questionsFrequentes": "Frequently asked questions",
      "combienDeComparablesDoisJeAjouter": "How many comparables should I add?",
      "groupeAMinimum3ComparablesGroupeBIdealement5": "Group A: at least 3 comparables. Group B: ideally 5 cross-checked references. Group C: the points method can be applied directly from the artist rating.",
      "quelsCriteresPourChoisirUneUvreComparable": "Which criteria should I use to select a comparable artwork?",
      "privilegiezMemeArtisteMemePeriodeStyleDimensionsSimilairesTechni": "Prioritise: same artist > same period/style > similar dimensions > same medium > recent sales under two years.",
      "combienDeTempsPourRecevoirLEstimationValidee": "How long does it take to receive the validated estimation?",
      "standard4872hPremiumSous24hJoursOuvres": "Standard: 48–72h | Premium: within 24h, business days",
      "applicationAuLot": "Apply to lot",
      "appliquerLEstimationA": "— apply the estimation to",
      "uvres": "artworks",
      "lEstimationDeReferenceEstDupliqueeSurToutesLes": "The reference estimation is duplicated across all artworks in the lot. The condition discount is applied individually to each artwork.",
      "estimationDeReferenceAvantDecoteEtat": "Reference estimation before condition discount",
      "repartitionParEtatDeConservation": "Breakdown by condition",
      "etat": "Condition",
      "nbUvres": "No. of artworks",
      "valeurRetenueUnite": "Retained value / unit",
      "1d9e75": "#1D9E75",
      "ef9f27": "#EF9F27",
      "d85a30": "#D85A30",
      "1a1a1a": "#1A1A1A",
      "a32d2d": "#A32D2D",
      "totalLot": "Lot total",
      "fourchetteTotaleLot": "Total lot range:",
      "voirLeDetailUvreParUvre": "View artwork-by-artwork details (",
      "nInv": "Inventory no.",
      "uvreSource": "source artwork",
      "estimationAppliqueeA": "Estimation applied to",
      "chaqueUvreAEteMiseAJourAvecSa": "Each artwork has been updated with its own condition discount.",
      "appliquees": "applied,",
      "enErreur": "errors",
      "echecSauvegardeUvreSourceLotNonModifie": "Failed to save the source artwork. The lot was not modified.",
      "applicationEnCours": "Applying…"
    },
    "segment": {
      "primary": "Primary comparable",
      "secondary": "Secondary comparable",
      "analogTrend": "Trend analogue",
      "analogContext": "Contextual analogue"
    },
    "dynamic": {
      "groupCLiquidityNote": "For Group C artists, the points method provides a bounded primary-market value. This value is then adjusted by a liquidity discount to reflect the absence of an established secondary market and dependence on gallery strategy. The standard discount is 45%, adjustable between 30% and 55% according to institutional recognition, documentation and presumed liquidity.",
      "writeOffNote": "The artwork is marked as irreparable. Under the value-adjustment grid, an irreparable condition results in total impairment: retained current value EUR 0.",
      "conditionDiscount": "Condition discount: {{label}}",
      "prudenceDiscount": "Group B prudence discount: −{{pct}}%",
      "liquidityDiscount": "Liquidity discount: −{{pct}}%",
      "documentaryBonuses": "Documentary bonuses: {{bonuses}}",
      "recentArtistDeath": "Recent death of the artist ({{year}}): market signal to monitor.",
      "ownRecentResults": "{{count}} recent artist-specific results were detected among the complete comparables.",
      "recentImported": "{{count}} recent comparable(s) imported from the last three years.",
      "recentDetectedThreeYears": "{{count}} recent comparable(s) detected over the last three years.",
      "recentDetected": "{{count}} recent comparable(s) detected.",
      "pointFlatRateSummary": "Group C — Flat rate: {{low}} – {{high}}",
      "pointFormulaSummary": "Group C — ({{height}} + {{width}}) × {{lowRate}}–{{highRate}} €/pt{{condition}}",
      "pointExpertFlatRateSummary": "Group C — expert flat rate: {{low}} – {{high}}",
      "savedChoices": "{{count}} selection(s) already saved",
      "lotOf": "of a lot containing {{count}} items",
      "minimum": "minimum {{count}}",
      "quoteDate": " · date: {{date}}",
      "segment": " · segment {{segment}}",
      "theoreticalBase": " (theoretical basis before discount: {{low}} – {{high}})",
      "finalPersonalGroupB": "Final personal-rating methodology, Group B{{suffix}}",
      "finalGroupB": "Final Group B methodology{{suffix}}",
      "finalSummaryGroupB": "Final Group B summary{{suffix}}",
      "confirmApplyLot": "Confirm — apply to {{count}} artworks",
      "appliedLot": "Estimation applied to {{count}} artworks in the lot.",
      "loading": "Loading…",
      "example": "e.g.",
      "maximumComparables": "Maximum {{count}} comparable artworks",
      "goodVeryGood": "Good / Very good",
      "defaultWriteOffNote": "Irreparable condition — total impairment. Write-off documented.",
      "writeOffSaved": "Artwork classified as irreparable — value 0 saved.",
      "estimationSaved": "Estimation saved to the artwork record.",
      "lot": "Lot"
    },
    "adjustmentType": {
      "bonus": "Bonus",
      "discount": "Discount",
      "neutral": "Neutral"
    },
    "medium": {
      "painting": "Painting",
      "sculpture": "Sculpture",
      "photography": "Photography",
      "drawing": "Drawing",
      "print": "Print",
      "mixed_media": "Mixed media",
      "installation": "Installation",
      "video": "Video",
      "textile": "Textile",
      "ceramic": "Ceramic",
      "nft": "NFT / Digital art",
      "other": "Other",
      "oil_on_canvas": "Oil on canvas",
      "acrylic_on_canvas": "Acrylic on canvas",
      "ink_on_paper": "Ink on paper",
      "watercolor_on_paper": "Watercolour on paper",
      "pencil_on_paper": "Pencil on paper",
      "charcoal_on_paper": "Charcoal on paper",
      "mixed_media_on_paper": "Mixed media on paper"
    },
    "methodGroup": {
      "point_method": "Group C — Points method",
      "analogy_cup": "Group B — CUP by analogy",
      "direct_cup": "Group A — Direct CUP",
      "direct_cup_prudent": "Prudent direct CUP",
      "analogy_cup_ratio": "Ratio-based analogue CUP",
      "hybrid_points_cup": "Hybrid points + comparables",
      "personal_quote_analogy_cup": "Expert rating by market analogy",
      "personal_quote_direct_segment": "Identified market micro-segment",
      "group_b_analogy": "Group B — CUP by analogy",
      "group_b_hybrid": "Group B — Mixed CUP",
      "unknown": "Method not specified"
    },
    "humanMethod": {
      "direct_cup": "Direct CUP",
      "analogy_cup": "CUP by analogy",
      "point_method": "Points method",
      "points": "Points method",
      "forfait": "Expert flat rate"
    },
    "snapshot": {
      "manualDirect": "Artist-specific result entered manually",
      "manualAnalogy": "Analogy entered manually",
      "autoAnalogy": "AutoCUP analogy",
      "autoDirect": "Artist-specific AutoCUP result",
      "summaryA": "The secondary market is sufficiently documented: {{direct}} consistent auction result(s) retained. The range is based mainly on observed results.",
      "summaryB": "The secondary market is limited: {{direct}} artist-specific result(s) and {{analogies}} analogy(ies) retained, supplemented by {{extrapolations}} expert extrapolation(s) where necessary.",
      "summaryC": "The secondary market is scarce or insufficiently consistent: the valuation relies mainly on qualitative analysis, market analogies and expert prudence.",
      "sourceMethod": "Source method: {{method}}.",
      "extrapolations": "{{count}} extrapolation(s) retained as decision support, not as price evidence.",
      "depthWarning": "Market depth does not support a purely statistical reading; the expert retains a defensible range rather than artificial precision."
    },
    "marketStrength": {
      "strong": "Strong market",
      "limited": "Limited market",
      "scarce": "Scarce market / extrapolation-led"
    },
    "marketLabel": {
      "analogTrend": "Trend analogue · higher market discounted",
      "comparable": "Comparable"
    }
  },
  "perteVol": {
    "title": "Losses & Thefts",
    "subtitle": "History of lost or stolen artworks",
    "eyebrow": "Assets · Events",
    "declare": "+ Report an event",
    "allClientLosses": "All client losses / thefts",
    "clientLosses": "Client losses / thefts",
    "artworkLosses": "Loss / theft history for this artwork",
    "viewAllClientLosses": "View all client losses / thefts",
    "backToArtwork": "Back to artwork",
    "noLosses": "No loss or theft recorded",
    "noClientLosses": "No loss or theft found for this client",
    "lossType": "Type",
    "lossDate": "Date",
    "taxYear": "Tax year",
    "declaredValue": "Declared value",
    "inventoryNumber": "Inventory reference",
    "artist": "Artist",
    "artworkTitle": "Artwork",
    "lossTypes": {
      "vol": "Theft",
      "perte": "Loss",
      "destruction": "Destruction",
      "incendie": "Fire",
      "inondation": "Flood",
      "autre": "Other",
      "disparition": "Disappearance"
    },
    "purchasePrice": "Acquisition price",
    "indemnity": "Insurance payout",
    "netLoss": "Net loss",
    "markRecovered": "Mark as recovered",
    "recovered": "Recovered",
    "recoveredOn": "Recovered on {{date}}",
    "recoveredBy": "Recovered by",
    "recoveredNotes": "Recovery notes",
    "recoverConfirm": "Confirm that this artwork has been recovered?",
    "recoverError": "Unable to update the artwork",
    "recoveredHistory": "History of recovered artworks",
    "exportPdf": "Export PDF",
    "stats": {
      "events": "Events",
      "active": "Active",
      "recovered": "Recovered",
      "declaredValue": "Declared value",
      "purchasePrice": "Acquisition price",
      "indemnities": "Insurance payouts",
      "netLoss": "Net loss"
    },
    "filters": {
      "allTypes": "All types",
      "allYears": "All years"
    },
    "table": {
      "type": "Type",
      "date": "Date",
      "artwork": "Artwork",
      "artist": "Artist",
      "purchasePrice": "Purchase price",
      "declaredValue": "Declared value",
      "indemnity": "Insurance payout",
      "status": "Status",
      "taxYear": "Tax year"
    },
    "status": {
      "active": "Active",
      "recovered": "Recovered"
    },
    "empty": {
      "all": "No event has been recorded.",
      "filtered": "No event matches these filters."
    },
    "common": {
      "loading": "Loading…",
      "details": "Details",
      "detailsArrow": "Details →",
      "untitled": "Untitled",
      "uploading": "Uploading…",
      "updating": "Updating…",
      "delete": "Delete"
    },
    "mobile": {
      "purchasePrice": "Purchase",
      "declared": "Declared",
      "indemnity": "Payout"
    },
    "actor": {
      "user": "User {{id}}…",
      "unknown": "Not provided"
    },
    "messages": {
      "saveError": "Could not save the event: {{message}}",
      "deleteConfirm": "Delete this event?",
      "recoverConfirm": "Confirm that this artwork has been recovered and should return to the active collection?",
      "recoveryNotePrompt": "Recovery note (optional)",
      "recoverError": "Unable to mark this artwork as recovered."
    },
    "fiscalNote": {
      "title": "Tax note",
      "body": "In France, losses and thefts of artworks may be deductible under certain conditions. A police report is generally required for a tax deduction or an insurance payout. Consult your notary or accountant regarding the procedures applicable to your situation."
    },
    "addModal": {
      "title": "Report an event",
      "artwork": "Artwork",
      "selectArtwork": "— Select an artwork —",
      "artworkTitle": "Artwork title",
      "inventoryNumber": "Inventory reference",
      "eventDate": "Event date",
      "declaredValuePlaceholder": "Estimated value on the date of the event",
      "initialPurchasePrice": "Initial purchase price",
      "currency": "Currency",
      "indemnityReceived": "Insurance payout received",
      "indemnityPlaceholder": "After insurance",
      "locationAtLoss": "Location at the time of the event",
      "locationPlaceholder": "E.g. gallery, warehouse, home…",
      "notes": "Notes / Circumstances",
      "notesPlaceholder": "Describe the circumstances…"
    },
    "duplicate": {
      "title": "An active report already exists for this artwork",
      "createdBy": "Created on {{date}} by {{actor}}"
    },
    "procedures": {
      "title": "Official procedures",
      "policeReport": "Police report filed",
      "policeReference": "Police report reference",
      "insuranceClaim": "Insurance claim",
      "insuranceReference": "Insurance claim reference"
    },
    "destructionProof": {
      "title": "Proof of destruction",
      "selectFile": "Click to select a file",
      "helper": "PDF, image or supporting document",
      "remove": "Remove",
      "viewDocument": "View document",
      "none": "No proof provided"
    },
    "details": {
      "location": "Location",
      "recoveredBy": "Recovered by {{actor}}.",
      "activeLoss": "Active loss / theft",
      "traceability": "Audit trail",
      "createdOn": "Report created on",
      "createdBy": "Created by",
      "procedures": "Procedures",
      "circumstances": "Circumstances"
    },
    "pdf": {
      "title": "Loss and theft report",
      "allYears": "All years",
      "taxYear": "Tax year {{year}}",
      "purchasePriceShort": "Purchase price",
      "activeRecovered": "Active: {{active}} · Recovered: {{recovered}}",
      "theftAlert": "{{count}} theft — check that a police report has been filed with the relevant authorities",
      "theftAlert_plural": "{{count}} thefts — check that police reports have been filed with the relevant authorities",
      "theftAlert_one": "{{count}} theft — check that a police report has been filed with the relevant authorities",
      "theftAlert_other": "{{count}} thefts — check that police reports have been filed with the relevant authorities",
      "artworkArtist": "Artwork / Artist",
      "declaredShort": "Declared",
      "purchaseShort": "Purchase",
      "indemnityShort": "Payout",
      "recoveredDate": "Recovered {{date}}",
      "recoveryNotesTitle": "Recovery notes",
      "recoveryNoteLine": "{{artwork}} — recovered on {{date}}",
      "eventNotesTitle": "Notes by event",
      "eventNoteLine": "{{artwork}} — {{artist}} ({{date}})",
      "disclaimer": "This document is provided for reporting purposes. Purchase prices, declared values, insurance payouts and recovery statuses are based on information recorded in Artkiv. Consult your notary, accountant or lawyer regarding tax and estate implications.",
      "footer": "Confidential document — Generated via Artkiv",
      "page": "Page {{page}} / {{total}}",
      "filename": "losses_thefts_report_{{year}}.pdf",
      "filenameAll": "all",
      "acquisitionPrice": "Acquisition price",
      "declaredValue": "Declared value",
      "indemnity": "Insurance payout",
      "netLoss": "Net loss",
      "recoveredStatus": "Recovery status",
      "recoveredYes": "Recovered",
      "recoveredNo": "Not recovered"
    }
  },
  "succession": {
    "actions": {
      "assign": "Assign",
      "copyLink": "Copy link",
      "edit": "Edit",
      "end": "Finish",
      "missingEmail": "Missing email",
      "removeAssignment": "Remove this artwork",
      "sendQuestionnaire": "Send questionnaire"
    },
    "addBeneficiary": "Add beneficiary",
    "delegate": {
      "banner": "You are viewing and completing {{name}}'s file as a delegate."
    },
    "alert": {
      "linkCopied": "Link copied. You can paste it in your email.",
      "questionnaireAlreadyDone": "Questionnaire already completed ✅",
      "questionnaireSent": "Questionnaire sent again to {{name}} ({{email}})",
      "updateLimited": "Contact details updated (read access limited by permissions).",
      "updateOk": "Contact details updated ✅"
    },
    "artwork": {
      "allAssigned": "All your artworks are already assigned",
      "artistUnknown": "Unknown artist",
      "untitled": "Untitled"
    },
    "assign": {
      "allAssigned": "All your artworks are already assigned. You can adjust the distribution from each beneficiary.",
      "back": "Back",
      "close": "Close window",
      "end": "Finish",
      "noneLeft": "No artworks left to assign",
      "purchase": "Purchase price",
      "subtitle": "Choose the artworks you want to assign",
      "title": "Assign artworks to {{name}}",
      "value": "Current estimated value"
    },
    "assignButton": "Assign",
    "balance": {
      "title": "Transmission balance",
      "subtitle": "At-a-glance summary: what is allocated, to whom, and in what proportions.",
      "collectionValue": "Collection value",
      "assigned": "Allocated",
      "unassigned": "Unallocated",
      "coverage": "{{pct}}% of the collection allocated",
      "heirShare": "Share per heir",
      "ofEstate": "of total estate",
      "ofCollection": "of the collection",
      "reserveOk": "Balanced distribution against the indicative threshold.",
      "reserveWarn": "One heir concentrates {{pct}}% of the base: review against forced-heirship rules.",
      "reserveNote": "Indicator, not legal advice: forced heirship is assessed on the entire estate (securities, real estate, cash…) and your family situation. Confirm with your notary.",
      "baseCollectionOnly": "Basis = collection value only.",
      "baseGlobal": "Basis = total estate (source: {{source}}).",
      "connectFO": "Connect your family office to compute shares on the total estate.",
      "empty": "Add beneficiaries and allocate artworks to see the distribution.",
      "valuationDated": "Most recent values as of {{date}}; the estate uses the market value at the date of death.",
      "valuationNone": "No artwork has a dated valuation; the estate uses the market value at the date of death.",
      "undatedCount": "{{count}} artwork(s) without a dated valuation.",
      "estimateCta": "Value these artworks →"
    },
    "valuation": {
      "asOf": "as of {{date}}",
      "undated": "undated",
      "source": {
        "estimation": "Estimate",
        "declared": "Declared value",
        "purchase": "Purchase price",
        "none": "Not valued"
      }
    },
    "dossier": {
      "cta": "Export transmission dossier (PDF)",
      "generating": "Generating dossier…",
      "ctaXls": "Export to Excel (.xlsx)",
      "generatingXls": "Generating Excel…",
      "error": "Could not generate the dossier. Please try again shortly.",
      "title": "Transmission dossier",
      "client": "Collector",
      "date": "Issued on",
      "synthesisTitle": "1. Estate summary",
      "heirsTitle": "2. Allocation & taxation per heir",
      "heirsTitleNoTax": "2. Allocation per heir",
      "xls": {
        "sheetSummary": "Summary",
        "sheetHeirs": "Allocation",
        "sheetInventory": "Inventory",
        "sheetToEstimate": "To value",
        "coverage": "Coverage (%)",
        "colNum": "#",
        "colTitle": "Title",
        "colArtist": "Artist",
        "colDate": "Dated valuation",
        "colToEstimate": "To value",
        "colHeir": "Heir",
        "colShareValue": "Share (€)",
        "colSharePct": "Share (%)",
        "colRegime": "Regime",
        "colDuties": "Estimated duties (€)",
        "yes": "Yes"
      },
      "inventoryTitle": "3. Artwork inventory",
      "toEstimateTitle": "4. Artworks to be valued",
      "toEstimateIntro": "{{count}} artwork(s) without a dated valuation — list to hand to your expert for a valuation at the date of death.",
      "legalTitle": "Notices",
      "value": "Value",
      "heirs": "Heir(s)",
      "provenance": "Provenance",
      "location": "Location",
      "toEstimate": "to be valued",
      "none": "—",
      "confidential": "Document generated by Artkiv — indicative and confidential, to be confirmed with your notary.",
      "page": "Page {{n}} / {{total}}"
    },
    "tax": {
      "estimatedLabel": "Estimated duties",
      "exempt": "Exempt",
      "totalLabel": "Estimated inheritance duties (total)",
      "note": "Order of magnitude (France), not tax advice: allowance and scale applied to the art share alone, whereas they apply to everything the heir receives. Regime inferred from the relationship. Confirm with your notary.",
      "regime": {
        "directLine": "Direct line (assumed)",
        "spouse": "Spouse / civil partner",
        "sibling": "Sibling",
        "nephew": "Nephew / niece",
        "institution": "Institution (exempt under conditions)",
        "other": "Non-relative"
      }
    },
    "legal": {
      "notice": "The allocations entered here are planning wishes. They are not a will: to be enforceable, they must be formalized (bequest, gift) with your notary."
    },
    "beneficiaries": {
      "title": "My beneficiaries and allocations"
    },
    "card": {
      "valueLabel": "Value: ",
      "worksLabel": "Works: "
    },
    "edit": {
      "error": "Unable to update the beneficiary at this time. Please try again.",
      "sessionExpired": "Your session has expired. Please log in again to edit this beneficiary.",
      "updated": "Beneficiary updated successfully.",
      "updatedLimited": "Beneficiary updated, but some information was not available server-side."
    },
    "error": {
      "add": "Unable to add the beneficiary. Please check the information and try again.",
      "addBeneficiary": "Unable to add the beneficiary.",
      "assign": "Unable to assign this artwork. Please try again in a moment.",
      "assignArtwork": "Unable to assign the artwork.",
      "beneficiaryNotFound": "Beneficiary not found.",
      "copyLink": "Unable to copy the link.",
      "edit": "An error occurred while updating the beneficiary. Please try again in a moment.",
      "load": "Error loading data. Please try again or contact the Artkiv team if the problem persists.",
      "loading": "Error while loading data",
      "noEmail": "This beneficiary has no email address.",
      "remove": "Unable to remove the assignment for this artwork. Please try again in a moment.",
      "removeArtwork": "Unable to remove the artwork.",
      "selectionNotAllowed": "Selection not found or not allowed",
      "send": "An issue occurred while sending the questionnaire. Please check the email address or contact the Artkiv team.",
      "sendQuestionnaire": "Error while sending the questionnaire.",
      "sendQuestionnairePrefix": "Sending error: {{message}}",
      "sessionExpired": "Session expired. Please log in again.",
      "updateFailed": "Update failed: {{message}}"
    },
    "heirStatus": {
      "completed": "Questionnaire completed",
      "inProgress": "Questionnaire in progress",
      "pending": "Questionnaire to send"
    },
    "quiz": {
      "title": "Collection & legacy: your profile",
      "body": "In 14 questions, discover your collector archetype — and what it concretely means for preparing your transmission.",
      "cta": "Take the test",
      "duration": "≈ 3 minutes"
    },
    "hint": {
      "emailRequiredAdd": "Required to send the questionnaire",
      "emailRequiredEdit": "Email is required to send the questionnaire."
    },
    "loading": "Loading your estate planning...",
    "menu": {
      "assignments": "Artwork allocations",
      "backToDashboard": "Back to dashboard",
      "beneficiaries": "Beneficiaries",
      "resources": "Resources"
    },
    "modal": {
      "add": "Add",
      "addTitle": "New beneficiary",
      "cancel": "Cancel",
      "editTitle": "Edit beneficiary",
      "email": "Email (optional)",
      "emailHelp": "The email allows you to automatically send the intergenerational matching questionnaire.",
      "name": "Full name",
      "phone": "Phone (optional)",
      "relation": "Relation",
      "relationDaughter": "Daughter",
      "relationFamily": "Family (generic)",
      "relationFriend": "Friend",
      "relationInstitution": "Institution / Foundation",
      "relationOther": "Other",
      "relationPlaceholder": "E.g. Daughter, son, spouse, friend, foundation…",
      "relationSon": "Son",
      "relationSpouse": "Spouse / Partner",
      "save": "Save"
    },
    "noAssigned": "No assigned artworks",
    "noBeneficiaries": {
      "text": "Add your heirs to begin your estate planning.",
      "title": "No beneficiaries yet"
    },
    "premium": {
      "button": "Open AI matching",
      "completed": "{{count}} completed questionnaire(s).",
      "text": "You have access to intergenerational AI matching on vision.artkiv.com.",
      "title": "AI matching enabled"
    },
    "removeAssignment": "Remove this artwork",
    "resources": {
      "dation": {
        "desc": "Understand how artworks can be used to pay part of your inheritance taxes.",
        "title": "Payment in lieu (dation en paiement)"
      },
      "description": "Find here the key resources to prepare your estate transmission.",
      "estimate": {
        "desc": "Prepare a structured valuation file for your notary or legal advisor.",
        "title": "Estate appraisal"
      },
      "title": "Useful resources for your planning"
    },
    "standard": {
      "premiumTeaser": {
        "button": "Upgrade to Premium",
        "paragraph": "With ArtKiv Premium, you can access vision.artkiv.com and benefit from our breakthrough AI matching system that analyses your heirs’ psychological profiles to intelligently allocate each artwork.",
        "point1": "Sophisticated psychological questionnaires for each heir",
        "point2": "Matching algorithm based on artistic and emotional preferences",
        "point3": "Art Market 2025 data for precise wealth valuation",
        "point4": "Detailed reports with compatibility scores",
        "sectionTitle": "What you get:",
        "stat1": {
          "label": "Psychological matching accuracy"
        },
        "stat2": {
          "label": "Integrated market data"
        },
        "stat3": {
          "label": "Analysis criteria per heir"
        },
        "subtitle": "Access vision.artkiv.com",
        "title": "Upgrade to Premium for AI matching"
      },
      "text": "In the Standard plan, you can add beneficiaries and manually allocate artworks to them. Allocation is based on the purchase value of your works.",
      "title": "Manual allocation of your artworks"
    },
    "stats": {
      "assignedWorks": "Assigned works",
      "beneficiaries": "Beneficiaries",
      "completed": "Completed questionnaires"
    },
    "subtitle": "Organize the transfer of your art collection thoughtfully and efficiently.",
    "subtitleDelegate": "View and complete the transmission of {{name}}'s collection.",
    "title": "Estate Planning",
    "titleDelegate": "Estate file — {{name}}",
    "why": {
      "p1": "According to the UBS Global Family Office 2025 report, only 53% of family offices have set up an estate plan. Nearly half risk a disorganized transfer of wealth.",
      "p2": "Artworks carry both financial and emotional heritage. A well-orchestrated transmission ensures your works reach the heirs who will preserve and appreciate them.",
      "p2Delegate": "Artworks carry both financial and emotional heritage. A well-orchestrated transmission ensures {{name}}'s works reach the heirs who will preserve and carry their spirit forward.",
      "title": "Why estate planning is essential"
    }
  },
  "conservationPage": {
    "title": "Conservation & logistics file",
    "tabs": {
      "storage": "Current condition",
      "ideal": "Ideal conservation",
      "transport": "Transport",
      "history": "History",
      "monitoring": "Latest condition",
      "idealStorage": "Ideal conservation"
    },
    "history": {
      "subtitle": "History of interventions, movements and exhibition conditions.",
      "addEntry": "+ Add entry",
      "empty": "No entries recorded yet. Add the first one above.",
      "loading": "Loading…",
      "form": {
        "title": "New entry",
        "type": "Type *",
        "date": "Date *",
        "contact": "Operator / contact",
        "contactPlaceholder": "Studio, carrier…",
        "cost": "Cost (€)",
        "notes": "Notes",
        "notesPlaceholder": "Description of the intervention…",
        "cancel": "Cancel",
        "save": "Save",
        "saving": "Saving…"
      },
      "entryTypes": {
        "Acquisition": "Acquisition",
        "Inspection": "Inspection",
        "Restauration": "Restoration",
        "Nettoyage": "Cleaning",
        "Encadrement": "Framing",
        "Transport": "Transport",
        "Accrochage": "Hanging",
        "Décrochage": "Removal",
        "Traitement préventif": "Preventive treatment",
        "Autre": "Other"
      },
      "intervenant": "Operator",
      "cost": "Cost"
    },
    "generatePdf": "GENERATE FULL PDF FILE",
    "generating": "Generating…",
    "storage": {
      "title": "Optimal conservation conditions",
      "specificBadge": "Specific instructions",
      "genericBadge": "Generic guidance – {{type}}",
      "specificBody": "These recommendations are specific to this artwork and were provided by the artist, conservator or gallery.",
      "genericBody": "These recommendations are generated automatically according to the artwork type, materials and condition.",
      "genericTitle": "Generic guidance:",
      "genericNotice": "These recommendations provide a preventive-conservation baseline and should only be used when no specific instructions are available from the artist, conservator or gallery.",
      "temperature": "Temperature",
      "humidity": "Humidity",
      "light": "Light",
      "placement": "Placement",
      "rotation": "Rotation",
      "additional": "Additional recommendations – {{type}}",
      "specificActive": "Specific instructions active",
      "specificActiveBody": "Specific conservation instructions are currently being used for this artwork.",
      "modify": "Edit",
      "returnGeneric": "Return to generic guidance",
      "specificAvailable": "Specific instructions available?",
      "specificAvailableBody": "If you received specific conservation instructions from the artist, a conservator or the gallery, add them here to replace the generic guidance.",
      "addSpecific": "Add artwork-specific instructions",
      "important": "Important",
      "importantBody": "This generic guidance must be adapted to the artwork’s specific materials. When in doubt, always consult a qualified conservator-restorer.",
      "removed": "Specific instructions removed. Generic guidance restored.",
      "removeError": "Unable to remove the instructions.",
      "comingSoon": "Feature under development.",
      "specificActiveTitle": "Artwork-specific instructions enabled",
      "edit": "Edit",
      "backGeneric": "Return to generic guidance",
      "specificAvailableTitle": "Artwork-specific instructions available?",
      "importantTitle": "Important"
    },
    "monitoring": {
      "loading": "Loading…",
      "overdue": "Overdue item(s):",
      "visualInspection": "Visual inspection",
      "fullReport": "Full report",
      "emptyTitle": "No conservation report",
      "emptyBody": "Create the first report to begin monitoring.",
      "update": "Update",
      "create": "Create a report"
    },
    "transport": {
      "title": "Transport logistics",
      "body": "These specifications are recommended to keep the artwork safe during transport.",
      "requestQuote": "Request a transport quote",
      "missingId": "Artwork ID missing",
      "openForm": "Open transport form",
      "qr": "Generate QR code",
      "downloadPdf": "Download PDF",
      "pdfError": "PDF generation failed.",
      "generating": "Generating…",
      "generatePdf": "GENERATE COMPLETE PDF RECORD",
      "fields": {
        "caseType": "Case type",
        "caseSize": "Case size",
        "packagingMethod": "Packing method",
        "transportMode": "Transport mode",
        "carrier": "Carrier",
        "estimatedCost": "Estimated cost",
        "insurance": "Insurance",
        "customs": "Customs",
        "temperatureControl": "Temperature control"
      },
      "values": {
        "caseType": "Double-wall insulated case with custom foam",
        "packagingMethod": "Acid-free tissue wrapping with corner protection",
        "transportMode": "Specialist road transport for artworks",
        "insurance": "Recommended cover: €150,000",
        "customs": "ATA Carnet required for temporary international exhibitions",
        "temperatureControl": "Active temperature control during transport"
      },
      "generateQr": "Generate QR code"
    },
    "qr": {
      "title": "Quick-access QR code",
      "alt": "Quick-access QR code",
      "body": "This QR code provides access to the full conservation and transport record for the artwork. It is suitable for carriers and museum conservators.",
      "secure": "Secure",
      "quick": "Quick access",
      "close": "Close",
      "download": "Download",
      "description": "This QR code opens the complete conservation and transport record for the artwork. It is suitable for carriers and museum conservators.",
      "quickAccess": "Quick access"
    },
    "types": {
      "photographie": "Photography",
      "peinture": "Painting",
      "sculpture": "Sculpture",
      "art_interactif": "Interactive / digital art",
      "generale": "General"
    },
    "templates": {
      "photographie": {
        "light": "Maximum 50 lux, no direct UV exposure",
        "placement": "Avoid exterior walls and heat sources",
        "rotation": "Rotation recommended every 3 months",
        "recommendations": {
          "0": "Regularly check for dust or discoloration",
          "1": "Use cotton gloves for all handling",
          "2": "Keep in a dust-free environment with filtered air",
          "3": "After moving, allow 24 hours for acclimatization before unpacking",
          "4": "Avoid sudden temperature and humidity changes",
          "5": "Store in acid-free boxes or polyester sleeves",
          "6": "UV protection required (filtering glass or acrylic)",
          "7": "Avoid direct contact with adhesives or acidic materials"
        }
      },
      "peinture": {
        "light": "Maximum 150 lux, no direct UV exposure",
        "placement": "Avoid exterior walls and heat sources",
        "rotation": "Rotation recommended every 6 months",
        "recommendations": {
          "0": "Regularly check for cracks, flaking or discoloration",
          "1": "Use cotton gloves for all handling",
          "2": "Inspect the support and stretcher",
          "3": "After moving, wait 24 hours before unpacking",
          "4": "Avoid sudden temperature and humidity changes",
          "5": "Monitor for signs of infestation",
          "6": "Maintain a safe distance from walls",
          "7": "Avoid vibrations and impacts",
          "8": "Regularly check the protective varnish",
          "9": "Photographically document any condition change"
        }
      },
      "sculpture": {
        "light": "Maximum 200 lux, UV protection recommended",
        "placement": "Stable surface, away from traffic areas",
        "rotation": "Inspection recommended every 6 months",
        "recommendations": {
          "0": "Adapt conditions to the specific materials",
          "1": "Check the stability of the base and fixings",
          "2": "Use gloves suitable for the material",
          "3": "Check for corrosion, cracks or deterioration",
          "4": "Use suitable handling equipment",
          "5": "Avoid sudden temperature and humidity changes",
          "6": "Monitor organic materials for infestation",
          "7": "Maintain a safety perimeter around the artwork",
          "8": "Document surface condition and alterations",
          "9": "Use a base suited to the weight and shape",
          "10": "Regularly check balance and stability"
        }
      },
      "art_interactif": {
        "light": "According to the artwork’s technical specifications",
        "placement": "Electrically stable area, away from magnetic fields",
        "rotation": "Functional test recommended every 3 months",
        "recommendations": {
          "0": "Document and archive all technical components",
          "1": "Keep a backup copy of digital files",
          "2": "Check file-format compatibility",
          "3": "Periodically test interactive elements",
          "4": "Prepare a technology migration plan",
          "5": "Keep the original technical documentation",
          "6": "Back up on multiple media",
          "7": "Monitor technological obsolescence",
          "8": "Maintain a detailed component inventory",
          "9": "Keep critical spare parts"
        }
      },
      "generale": {
        "light": "Maximum 150 lux, no direct UV exposure",
        "placement": "Avoid exterior walls and heat sources",
        "rotation": "Rotation recommended every 6 months",
        "recommendations": {
          "0": "Regularly check for dust or discoloration",
          "1": "Use cotton gloves for all handling",
          "2": "After moving, wait 24 hours before unpacking",
          "3": "Avoid sudden temperature and humidity changes"
        }
      }
    }
  },
  "partner": {
    "emptyState": {
      "title": "Your partner workspace is ready.",
      "body": "Complete your partner profile to appear in the ARTKIV directory and help collectors and professionals understand your specialties at a glance.",
      "completeProfile": "Complete my profile",
      "viewDirectory": "View the directory",
      "nextTitle": "Set up your workspace while you wait for your first request",
      "filtered": "No requests match this filter."
    },
    "common": {
      "loading": "Loading…",
      "refresh": "Refresh",
      "back": "Back",
      "noSession": "No active session",
      "artwork": "Artwork",
      "untitled": "Untitled",
      "unknownArtist": "Unknown artist",
      "client": "Client",
      "email": "Email",
      "type": "Type",
      "value": "Value",
      "notes": "Notes",
      "created": "Created on {{date}}",
      "urgent": "Urgent",
      "processing": "Processing…",
      "sending": "Sending…",
      "saving": "Saving…",
      "yes": "Yes",
      "no": "No"
    },
    "specialties": {
      "generic": "Partner Workspace",
      "insurance": "Insurance Partner",
      "transport": "Transport Partner",
      "valuation": "Valuation Expert",
      "conservation": "Conservation Expert"
    },
    "sidebar": {
      "space": "Partner workspace",
      "navigation": "Partner navigation",
      "requests": "Requests",
      "completed": "Completed cases",
      "profile": "Public profile",
      "directory": "ARTKIV directory",
      "contract": "My agreement",
      "guide": "Getting the most from ARTKIV",
      "support": "Contact ARTKIV",
      "profileProgress": "Profile complete",
      "improveVisibility": "Improve my visibility",
      "contractStatus": "ARTKIV partnership",
      "activeUntil": "Active until {{date}}",
      "contractAvailable": "Find your partnership information here.",
      "viewContract": "View my agreement"
    },
    "filters": {
      "all": "All",
      "pending": "Pending",
      "seen": "Viewed",
      "answered": "Answered",
      "quoted": "Quote sent",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "done": "Closed",
      "in_progress": "In progress",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "status": {
      "pending": "Pending",
      "seen": "Viewed",
      "answered": "Answered",
      "quoted": "Quote sent",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "done": "Closed",
      "in_progress": "In progress",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "dashboard": {
      "eyebrow": "ARTKIV professional portal",
      "howItWorks": "How it works",
      "title": "Partner Workspace",
      "subtitle": "Your requests",
      "subtitleConservation": "Assessments, recommendations, restoration and conservation",
      "intro": "Centralize requests received through ARTKIV, review only the information shared for each engagement and track every exchange through to case closure.",
      "steps": {
        "receive": "Receive a qualified request",
        "review": "Review authorized information",
        "respond": "Reply and track the case"
      },
      "partnershipTitle": "My ARTKIV partnership",
      "partnershipStatus": "Status",
      "accessMode": "Access",
      "relationship": "Relationship",
      "validUntil": "Valid until",
      "noExpiry": "No expiry date",
      "manageProfile": "Manage my profile",
      "noPartnershipRecord": "Your partner record is not linked to this account yet. Contact ARTKIV to complete activation.",
      "partnerStatus": {
        "draft": "Draft",
        "invited": "Invited",
        "active": "Active",
        "suspended": "Suspended",
        "expired": "Expired"
      },
      "accessModes": {
        "free": "Complimentary",
        "paid": "Paid",
        "custom": "Custom",
        "none": "None"
      },
      "relationships": {
        "marketplace_provider": "Marketplace provider",
        "operational_provider": "Operational provider",
        "institutional_free": "Institutional partner",
        "directory_only": "Directory only",
        "strategic": "Strategic partner"
      },
      "metrics": {
        "total": "All requests",
        "pending": "To process",
        "active": "In progress",
        "done": "Closed"
      },
      "loadingSpace": "Loading your partner workspace…",
      "configurationHint": "Check the partner record and type in the administration area.",
      "scope": "The information shown is limited to the data shared for each request.",
      "open": "Open request",
      "markSeen": "Mark as viewed",
      "loadError": "Unable to load requests.",
      "seenError": "Unable to mark the request as viewed."
    },
    "requests": {
      "request": "Request",
      "insuredValue": "Value to insure",
      "insuranceExpected": "Expected: quote, certificate or coverage adjustment",
      "pickup": "Pickup",
      "delivery": "Delivery",
      "transportExpected": "Expected: cost estimate, time slot and packing requirements",
      "valuationExpected": "Expected: value range, comments or document request",
      "conservationRequest": "Conservation request",
      "issue": "Issue",
      "conservationExpected": "Expected: assessment, recommendations or restoration quote",
      "viewDetails": "View details",
      "detailTodo": "The request details and business actions still need to be connected."
    },
    "insurance": {
      "title": "Insurance Partner Workspace",
      "subtitle": "Manage quote, certificate and value-update requests",
      "requestTitle": "Insurance request",
      "treatment": "Partner processing",
      "intervention": "Scope of work",
      "interventionBody": "This information was shared by the collector for this insurance request. It does not provide access to the full collection.",
      "context": "Context",
      "homePremium": "High-end home insurance",
      "fineArtPolicy": "Dedicated fine-art policy",
      "policyType": "Coverage type",
      "nailToNail": "Nail to nail",
      "allRisks": "All risks",
      "transportRequired": "Transport required",
      "event": "Event: {{start}} → {{end}}",
      "analysisData": "Data supplied for insurance analysis.",
      "requestedValue": "Requested value",
      "clientMessage": "Client message",
      "reply": "Reply",
      "messageLabel": "Message to the collector",
      "messagePlaceholder": "Questions, required details, coverage terms, timeframe…",
      "quoteAmount": "Quote amount (EUR)",
      "sendMessage": "Send message",
      "sendQuote": "Send quote",
      "close": "Close request",
      "locked": "This request has status {{status}}. The client has made a decision or the case is closed, so no further changes are possible.",
      "invalidQuote": "Invalid quote amount.",
      "loadError": "Unable to load the request.",
      "updateError": "Unable to update the request.",
      "seenSuccess": "Request marked as viewed.",
      "answerSuccess": "Message sent to the collector.",
      "quoteSuccess": "Quote sent successfully.",
      "closeSuccess": "Request closed."
    },
    "transport": {
      "title": "Transport Partner Workspace",
      "subtitle": "Manage transport, handling and quote requests",
      "defaultRequest": "Artwork transport"
    },
    "valuation": {
      "title": "Valuation Expert Workspace",
      "subtitle": "Manage valuation requests and access shared artwork records",
      "tipTitle": "Gather the relevant information",
      "tipBody": "Review the photos, dimensions, date, signature, technical details, provenance and condition shared by the collector.",
      "requestTitle": "Valuation request",
      "backToList": "Back to my requests",
      "artworkImage": "Artwork image",
      "details": "Detailed information",
      "titleLabel": "Title",
      "artist": "Artist",
      "year": "Creation year",
      "medium": "Medium",
      "dimensions": "Dimensions",
      "support": "Support",
      "signature": "Signature",
      "certificate": "Certificate",
      "provenance": "Provenance",
      "condition": "Condition",
      "additionalNotes": "Additional notes",
      "collector": "Collector",
      "name": "Name",
      "company": "Company",
      "quickActions": "Quick actions",
      "start": "Start valuation",
      "yourValuation": "Your valuation",
      "estimatedValue": "Estimated value",
      "expertNotes": "Notes and rationale",
      "notesPlaceholder": "Valuation rationale, comparables, market conditions…",
      "save": "Save valuation",
      "invalidValue": "Please enter a valid estimated value.",
      "loadError": "Unable to load the request.",
      "updateError": "Unable to update the status.",
      "saveError": "Unable to save the valuation.",
      "saveSuccess": "Valuation saved successfully."
    },
    "contract": {
      "title": "My ARTKIV partnership",
      "status": "Status",
      "active": "Active",
      "startsAt": "Start date",
      "endsAt": "End date",
      "renewal": "Renewal",
      "renewalAutomatic": "Automatic renewal",
      "renewalManual": "Manual renewal",
      "document": "Agreement document",
      "download": "Download agreement",
      "contact": "Contact ARTKIV about this agreement",
      "noDocument": "No agreement document is available in your workspace."
    },
    "guide": {
      "title": "Get more from ARTKIV",
      "profileTitle": "Make your profile visible",
      "profileBody": "Add your specialties, service areas, languages, references and contact details.",
      "responseTitle": "Respond promptly",
      "responseBody": "A short initial reply reassures the requester, even if the full quote comes later.",
      "statusTitle": "Keep statuses up to date",
      "statusBody": "Statuses let the client and ARTKIV follow the case without unnecessary reminders.",
      "privacyTitle": "Respect the shared scope",
      "privacyBody": "Only use information made available for the relevant engagement."
    },
    "insuranceDashboard": {
      "eyebrow": "Insurance request operations",
      "intro": "Review coverage needs submitted through ARTKIV, request missing information, send a quote or certificate, and track each case through its decision.",
      "workflowTitle": "Insurance workflow",
      "workflow": {
        "review": "Review the shared artwork, value and context",
        "qualify": "Clarify the risk, coverage and required documents",
        "quote": "Send a quote, certificate or coverage terms",
        "follow": "Track acceptance, rejection or case closure"
      },
      "partnershipTitle": "Partnership framework",
      "commercialTerms": "Insurance commercial terms are governed by your individual agreement with ARTKIV; the valuation 85/15 split is not applied automatically.",
      "privacyBody": "You only access data authorized for the insurance request, never the full collection.",
      "metrics": {
        "total": "Requests received",
        "pending": "To review",
        "quoted": "Replies or quotes",
        "accepted": "Accepted or closed"
      },
      "emptyTitle": "No insurance request to process",
      "emptyBody": "New requests will appear here with the information expressly shared by the requester."
    },
    "valuationDashboard": {
      "eyebrow": "Valuation assignments",
      "intro": "Process valuation assignments received through ARTKIV, review the shared documentation, formalize your opinion and deliver a supported value.",
      "workflowTitle": "Valuation workflow",
      "workflow": {
        "review": "Check the artwork record and available documents",
        "analyze": "Assess condition, provenance, market and comparables",
        "document": "Document the value and methodology used",
        "deliver": "Deliver the valuation and close the assignment"
      },
      "partnershipTitle": "Mandate and terms",
      "commercialTerms": "For eligible marketplace assignments, compensation follows the terms agreed with ARTKIV, including the 85/15 split where specified in the agreement.",
      "privacyBody": "Only information shared for the assignment is accessible.",
      "metrics": {
        "total": "Assignments received",
        "pending": "To accept",
        "in_progress": "Under analysis",
        "completed": "Delivered"
      },
      "emptyTitle": "No valuation assignment to process",
      "emptyBody": "New assignments allocated to you will appear here with their documentation."
    }
  },
  "clientMissions": {
    "title": "My assignments",
    "active": "{{count}} active assignment with your advisor — track its progress.",
    "active_plural": "{{count}} active assignments with your advisor — track their progress.",
    "active_one": "{{count}} active assignment with your advisor — track its progress.",
    "active_other": "{{count}} active assignments with your advisor — track their progress.",
    "view": "View"
  },
  "advisorHelp": {
    "button": "Need help?",
    "menuTitle": "Art Advisor help",
    "items": {
      "reports": "Generate a professional report",
      "understandValue": "Understand an artwork’s value",
      "valuation": "Value an artwork",
      "insurance": "Prepare an insurance file",
      "salesDonations": "Sales & donations",
      "clientCollections": "Manage your clients’ collections",
      "privacyAccess": "Privacy & client access"
    },
    "allGuides": "All practical guides"
  },
  "billingIdentity": {
    "title": "Billing identity",
    "businessToggle": "I am billing on behalf of a company",
    "description": "Required for mandatory B2B e-invoicing. The identifier depends on the country: <siren>SIREN</siren> in France, an <vat>intra-Community VAT number</vat> in the EU. Your data remains private and is used for billing only.",
    "countries": {
      "france": "France",
      "belgium": "Belgium",
      "luxembourg": "Luxembourg",
      "germany": "Germany",
      "italy": "Italy",
      "spain": "Spain",
      "netherlands": "Netherlands",
      "portugal": "Portugal",
      "austria": "Austria",
      "ireland": "Ireland",
      "greece": "Greece",
      "switzerlandNonEu": "Switzerland (non-EU)",
      "unitedKingdomNonEu": "United Kingdom (non-EU)",
      "unitedStatesNonEu": "United States (non-EU)",
      "other": "Other country"
    },
    "validation": {
      "sirenLength": "The SIREN number must contain 9 digits.",
      "sirenInvalid": "Invalid SIREN number (check digit).",
      "sirenValid": "Valid SIREN number.",
      "siretLength": "The SIRET number must contain 14 digits.",
      "siretInvalid": "Invalid SIRET number (check digit).",
      "siretValid": "Valid SIRET number.",
      "vatFormat": "Expected format: country prefix + number (e.g. BE0123456789).",
      "vatPrefix": "The VAT number should begin with “{{expected}}” for this country.",
      "vatValid": "Valid VAT format (VIES validation still required)."
    },
    "errors": {
      "companyRequired": "The legal company name is required for business billing.",
      "sirenRequiredFrance": "In France, a 9-digit SIREN number is required for a compliant business invoice.",
      "vatRequiredEu": "Within the EU, an intra-Community VAT number is required for B2B identification."
    },
    "fields": {
      "country": "Billing country *",
      "companyName": "Legal company name *",
      "siren": "SIREN * (9 digits)",
      "siret": "SIRET (14 digits, optional)",
      "vatOptional": "Intra-Community VAT no. (optional)",
      "vatRequired": "Intra-Community VAT no. *",
      "taxIdOptional": "Tax identifier (optional)",
      "address": "Billing address",
      "postalCode": "Postal code",
      "city": "City",
      "billingEmail": "Billing email (optional)"
    },
    "placeholders": {
      "companyName": "e.g. Durand Gallery Ltd",
      "taxId": "Tax identification number, if applicable",
      "address": "12 Beaux-Arts Street",
      "city": "Paris",
      "billingEmail": "accounts@…"
    },
    "saving": "Saving…",
    "save": "Save",
    "saved": "Saved"
  },
  "register": {
    "title": "Create your Artkiv account",
    "titleDelegated": "Join with delegated access",
    "stepAccountTitle": "Create your account",
    "stepPlanTitle": "Choose your plan",
    "stepProgress": "Step {{current}} of {{total}}",
    "firstNameLabel": "First name",
    "firstNamePlaceholder": "Your first name",
    "continue": "Continue",
    "back": "Back",
    "showPw": "Show",
    "hidePw": "Hide",
    "accountRecap": "Account",
    "editAccount": "Edit",
    "emailInvalid": "Invalid email address.",
    "passwordShort": "6 characters minimum.",
    "heroEyebrow": "ARTKIV",
    "heroCopy": "Document, value and pass on your collection with confidence.",
    "heroPoint1": "Centralised inventory and documents",
    "heroPoint2": "AI-powered estimation and valuation",
    "heroPoint3": "Transmission prepared with peace of mind",
    "errors": {
      "invalidInviteLink": "This invitation link is invalid or has expired.",
      "inviteRevoked": "This invitation has been revoked.",
      "inviteAlreadyUsed": "This invitation has already been used.",
      "invalidInvite": "Invalid invitation.",
      "demoInviteIncompatible": "A collaborator invitation cannot be used with a demo account.",
      "userNotCreated": "The user was not created. Check Supabase settings (is email confirmation required?).",
      "signup": "An error occurred during registration"
    },
    "invite": {
      "subtitle": "You have been invited to collaborate on a collection. No subscription is required.",
      "emailLabel": "Invited email:",
      "emailMismatch": "Please use the invited email address."
    },
    "demo": {
      "title": "Demo account",
      "body": "You are using a demo account. Your plan will be changed immediately without payment.",
      "planUpdated": "Demo plan updated successfully!"
    },
    "launch": {
      "title": "Launch offer",
      "body": "Get a <trial>14-day free trial</trial> of the Standard plan when you register before <date>15 February 2026</date>. You will not be charged during the trial period."
    },
    "fields": {
      "email": "Email address",
      "password": "Password"
    },
    "placeholders": {
      "email": "you@example.com",
      "password": "At least 6 characters"
    },
    "sections": {
      "collectors": "Collectors",
      "professionals": "Professionals"
    },
    "plans": {
      "perMonth": "/month",
      "standard": {
        "name": "Standard",
        "description": "Complete collection management",
        "trial": "14 days free"
      },
      "premium": {
        "name": "Premium",
        "badge": "POPULAR",
        "description": "Advanced AI & inheritance matching"
      },
      "artAdvisor": {
        "name": "Art Advisor",
        "badge": "PRO",
        "description": "Up to 5 clients"
      },
      "artAdvisorPremium": {
        "name": "AA Premium",
        "badge": "PRO+",
        "description": "Unlimited clients"
      },
      "fondation": {
        "name": "Foundation",
        "badge": "INSTITUTION",
        "description": "Foundations and endowments"
      },
      "familyOffice": {
        "name": "Family Office",
        "badge": "ENTERPRISE",
        "price": "Custom quote",
        "description": "Tailored solution"
      }
    },
    "buttons": {
      "changing": "Changing plan…",
      "creating": "Creating account…",
      "createDelegated": "Create my delegated access",
      "changePlan": "Change plan",
      "createAccount": "Create my account"
    },
    "trialFootnote": "You will not be charged during the 14-day free trial. You can cancel at any time before the trial ends.",
    "professionalFollowup": "After creating your account, you will be redirected to contact us and schedule a personalised demonstration.",
    "legal": {
      "terms": "Terms and Conditions",
      "privacy": "Privacy Policy",
      "sentence": "By registering, you agree to our <terms>Terms and Conditions</terms> and <privacy>Privacy Policy</privacy>."
    },
    "login": {
      "prompt": "Already have an account?",
      "link": "Log in"
    }
  },
  "mobileCapture": {
    "newArtwork": {
      "heading": "Photograph an artwork"
    },
    "verb": {
      "scan": "Scan",
      "photo": "Photograph"
    },
    "doc": {
      "invoice": "Invoice",
      "certificate": "Certificate",
      "verso": "Back",
      "signature": "Signature",
      "condition": "Condition / defect",
      "detail": "Detail",
      "main": "Main view",
      "generic": "Document"
    },
    "auth": {
      "title": "Sign in",
      "body": "Sign this phone in to the same Artkiv account, then rescan the QR code.",
      "cta": "Sign in"
    },
    "error": {
      "title": "Link unavailable",
      "expired": "This QR code has expired. Generate a new one from your computer.",
      "completed": "This capture has already been sent.",
      "generic": "Session not found. Regenerate the QR from your computer."
    },
    "takePhoto": "Take the photo",
    "hint": "The camera opens directly.",
    "use": "Use this photo",
    "retake": "Retake",
    "sending": "Sending…",
    "done": {
      "title": "Sent",
      "body": "You can return to your computer: the document already appears there."
    }
  },
  "usePhone": {
    "title": "Use my phone",
    "subtitle": "Scan this QR code with your phone camera.",
    "qrAlt": "Capture QR code",
    "waiting": "Waiting for the phone…",
    "connected": "Phone connected — take the photo",
    "error": "Could not generate the QR. Try again.",
    "cancel": "Cancel",
    "close": "Close",
    "chooseType": "What do you want to capture?",
    "received": {
      "title": "Received from your phone",
      "body": "It has been attached to the artwork."
    }
  },
  "onboarding": {
    "welcome": {
      "eyebrow": "Welcome to ARTKIV",
      "helloName": "Welcome, {{name}}.",
      "helloNoName": "Welcome.",
      "intro": "Your environment is already set up. A few quick questions will let us tailor your experience — nothing to configure.",
      "start": "Get started",
      "space": {
        "collectionneurPlan": "Your {{plan}} subscription is active.",
        "collectionneurGeneric": "Your space is ready.",
        "advisor": "Your Art Advisor access is active.",
        "family_office": "Your Family Office space is ready.",
        "fondation": "Your Foundation space is ready.",
        "notaire": "Your Notary space is ready.",
        "assureur": "Your Insurer space is ready."
      }
    },
    "progress": "Question {{current}} / {{total}}",
    "back": "Back",
    "skip": "Skip",
    "continue": "Continue",
    "finish": "Finish",
    "saving": "Saving…",
    "yes": "Yes",
    "no": "No",
    "saveError": "Saving failed. You can retry or continue directly.",
    "done": {
      "eyebrow": "All set",
      "title": "Your space is personalized.",
      "actionLabel": "First action",
      "importExisting": "Import my existing records"
    },
    "dashboard": {
      "title": "Getting started",
      "hello": "Let's pick up where you left off.",
      "helloName": "Let's continue, {{name}}.",
      "dismiss": "Hide",
      "shortcutsLabel": "Shortcuts",
      "stage": {
        "collectionneur": "You have {{count}} artwork(s) in your collection.",
        "advisor": "You support {{count}} client(s).",
        "family_office": "You manage {{count}} family/families.",
        "fondation": "You manage {{count}} collection(s).",
        "notaire": "{{count}} estate case(s).",
        "assureur": "{{count}} request(s) received."
      },
      "advice": {
        "support": "Assisted import can structure your collection quickly — upload your documents to get a recommendation.",
        "centralize": "Start by centralizing your documents: upload them and ARTKIV analyzes them for you.",
        "transmission": "Prepare transmission: add your beneficiaries and document your key works.",
        "insure": "To insure well, keep values up to date and your supporting documents at hand.",
        "market": "Track your artists' ratings to seize the right moments.",
        "inventory": "Add your works one by one, or upload a file to go faster.",
        "generic": "Upload your existing records: ARTKIV structures them and suggests next steps."
      },
      "shortcuts": {
        "succession": "Plan transmission",
        "insure": "Insure my collection",
        "market": "Track the market",
        "addWork": "Add a work",
        "deposit": "Upload my documents",
        "estimate": "Value a work",
        "home": "My space",
        "importExisting": "Import existing records"
      }
    },
    "questions": {
      "collectionneur": {
        "collection_size": {
          "label": "Approximate size of your collection?",
          "opts": {
            "lt20": "Fewer than 20 works",
            "b20_100": "20 to 100 works",
            "b100_500": "100 to 500 works",
            "gt500": "More than 500 works"
          }
        },
        "documents_location": {
          "label": "Where are your documents today?",
          "opts": {
            "paper": "Paper / binders",
            "computer": "Files on my computer",
            "cloud": "Cloud (Drive, Dropbox…)",
            "scattered": "A bit everywhere"
          }
        },
        "main_goal": {
          "label": "What is your main goal?",
          "opts": {
            "inventory": "Inventory my collection",
            "transmission": "Prepare transmission",
            "insure": "Insure / value",
            "market": "Track the market"
          }
        },
        "wants_support": {
          "label": "Would you like support to get started?"
        }
      },
      "advisor": {
        "already_clients": {
          "label": "Do you already work with collectors?"
        },
        "clients_count": {
          "label": "How many clients do you want to manage?",
          "opts": {
            "b1_5": "1 to 5",
            "b6_20": "6 to 20",
            "b21_50": "21 to 50",
            "gt50": "More than 50"
          }
        },
        "has_inventories": {
          "label": "Do you already have inventories, PDFs or Excel files to import?"
        }
      },
      "family_office": {
        "families_count": {
          "label": "How many families do you support?",
          "opts": {
            "b1_3": "1 to 3",
            "b4_10": "4 to 10",
            "gt10": "More than 10"
          }
        },
        "works_with_experts": {
          "label": "Do you already work with experts?"
        },
        "create_first_family": {
          "label": "Would you like to create your first family now?"
        }
      },
      "fondation": {
        "foundation_name": {
          "label": "Name of the foundation?",
          "placeholder": "e.g. Foundation…"
        },
        "collections_count": {
          "label": "How many collections do you manage?",
          "opts": {
            "one": "1",
            "b2_5": "2 to 5",
            "gt5": "More than 5"
          }
        },
        "has_inventory": {
          "label": "Do you already have an inventory?"
        },
        "collaborators_count": {
          "label": "How many collaborators will use ARTKIV?",
          "opts": {
            "solo": "Just me",
            "b2_5": "2 to 5",
            "gt5": "More than 5"
          }
        }
      },
      "notaire": {
        "handles_art_successions": {
          "label": "Do you already handle estates that include artworks?"
        },
        "create_first_dossier": {
          "label": "Would you like to open your first case now?"
        }
      },
      "assureur": {
        "collections_count": {
          "label": "How many collections do you manage?",
          "opts": {
            "b1_5": "1 to 5",
            "b6_20": "6 to 20",
            "gt20": "More than 20"
          }
        },
        "has_portfolio": {
          "label": "Do you already have an existing portfolio to import?"
        }
      }
    },
    "actions": {
      "collectionneur": {
        "title": "Ready to start your collection?",
        "cta": "Get started"
      },
      "advisor": {
        "title": "Invite your first client.",
        "cta": "Invite a client"
      },
      "family_office": {
        "title": "Create your first family.",
        "cta": "Create a family"
      },
      "fondation": {
        "title": "Create your first collection.",
        "cta": "Create a collection"
      },
      "notaire": {
        "title": "Open your first estate case.",
        "cta": "Open a case"
      },
      "assureur": {
        "title": "Access your insurer space.",
        "cta": "View my requests"
      }
    },
    "deposit": {
      "eyebrow": "First action",
      "title": "Upload your first documents.",
      "intro": "PDFs, photos, certificates, invoices, Excel files… ARTKIV takes over your existing records and analyzes them for you. Nothing to structure by hand to start.",
      "choose": "Choose files",
      "filesPicked": "{{count}} file(s) — {{size}} MB",
      "hint": "PDF · JPG/PNG · CSV/XLSX — up to {{max}} files",
      "more": "+ {{count}} more…",
      "uploading": "Uploading… {{done}}/{{total}}",
      "later": "Later",
      "submit": "Upload and analyze",
      "submitting": "Uploading…",
      "error": "An error occurred during the upload.",
      "sources": {
        "upload": "Upload",
        "dropbox": "Dropbox",
        "drive": "Google Drive",
        "email": "Email"
      },
      "comingSoon": "The {{source}} connection is coming soon. Meanwhile, you can upload your files directly.",
      "chooseUpload": "Upload files",
      "byMetier": {
        "advisor": {
          "title": "Import your existing portfolio.",
          "intro": "Client inventories, PDFs, Excel files, exports… ARTKIV takes over your files and structures them for you."
        },
        "family_office": {
          "title": "Bring in your wealth files.",
          "intro": "Families, estates, inventories and documents… upload your records and ARTKIV structures them."
        },
        "fondation": {
          "title": "Import your inventory.",
          "intro": "Inventories, collections, governance documents, certificates… ARTKIV takes over and structures your holdings."
        },
        "notaire": {
          "title": "Upload the case documents.",
          "intro": "Estate inventories, appraisals, PDFs… ARTKIV reads and sorts the documents for you."
        },
        "assureur": {
          "title": "Import your insured portfolio.",
          "intro": "Portfolio, policies, collections, documents… ARTKIV takes over and structures your files."
        }
      }
    },
    "reco": {
      "loading": "Loading your analysis…",
      "consentRequired": "The AI analysis was not run because AI consent is not enabled. Enable it in your profile to get the automatic summary. Your files are safely saved.",
      "analyzingEyebrow": "Analysis in progress",
      "analyzingTitle": "ARTKIV is analyzing your documents…",
      "analyzingBody": "Reading and classifying your files takes a moment. You can wait here — the recommendation will appear automatically.",
      "analyzingProgress": "{{done}} / {{total}} documents analyzed",
      "tooLong": "The analysis is taking longer than expected.",
      "continueAnyway": "Continue without waiting",
      "resultEyebrow": "Analysis — {{metier}}",
      "resultTitle": "Here is what ARTKIV detected.",
      "errorBody": "The analysis ran into an issue, but your files are safely saved.",
      "howContinue": "How would you like to continue?",
      "counts": {
        "documents": "documents",
        "oeuvres": "works detected",
        "certificats": "certificates",
        "factures": "invoices",
        "aStructurer": "to structure"
      },
      "reason": {
        "autonome": "Few documents ({{documents}}) and easy to read: you can structure them yourself.",
        "express": "Moderate volume ({{documents}} documents): a quick assisted import is enough.",
        "premium": "Large volume ({{documents}} documents) or {{aStructurer}} to structure: a full human review is recommended."
      },
      "recommended": "Recommended",
      "payRedirect": "Redirecting to payment…",
      "offers": {
        "autonomous": {
          "title": "Continue on my own",
          "price": "Free",
          "desc": "Structure your collection at your own pace."
        },
        "express": {
          "title": "Express Import",
          "price": "€99",
          "desc": "For a simple collection. Quick assisted import."
        },
        "premium": {
          "title": "Premium Import",
          "price": "€399",
          "desc": "Full import, human review, document structuring."
        },
        "concierge": {
          "title": "Concierge / Migration",
          "price": "on quote",
          "desc": "You entrust us your archives, ARTKIV builds your collection."
        }
      },
      "offersByMetier": {
        "collectionneur": {
          "premiumDesc": "Full import, human review, document structuring.",
          "top": {
            "title": "Collection Concierge",
            "price": "€1,490",
            "desc": "You send us your archives, ARTKIV builds your collection."
          }
        },
        "advisor": {
          "premiumDesc": "Import of clients, collections, works and documents, full structuring, human review.",
          "top": {
            "title": "Practice Migration",
            "price": "from €2,500",
            "desc": "Full migration of your practice, on quote."
          }
        },
        "family_office": {
          "premiumDesc": "Import of families, collections, wealth files and heirs, human review.",
          "top": {
            "title": "Family Office Migration",
            "price": "from €2,500",
            "desc": "Full migration, on quote."
          }
        },
        "fondation": {
          "premiumDesc": "Inventory import, collections, documents and document governance, human review.",
          "top": {
            "title": "Foundation Migration",
            "price": "from €2,500",
            "desc": "Large foundations, multiple sites, tens of thousands of works. On quote."
          }
        },
        "notaire": {
          "premiumDesc": "Import of inventories, estates, PDFs and appraisals, human review.",
          "top": {
            "title": "Dedicated support",
            "price": "on quote",
            "desc": "Full handling of your cases, on quote."
          }
        },
        "assureur": {
          "premiumDesc": "Import of portfolio, policies, collections and documents, human review.",
          "top": {
            "title": "Portfolio Migration",
            "price": "from €2,500",
            "desc": "Full migration of your portfolio, on quote."
          }
        }
      },
      "payError": "Payment could not start.",
      "metier": {
        "collectionneur": "Collector",
        "advisor": "Art Advisor",
        "family_office": "Family Office",
        "fondation": "Foundation",
        "notaire": "Notary",
        "assureur": "Insurer",
        "generic": "Your space"
      }
    }
  },
  "teamDashboard": {
    "accessDenied": {
      "title": "Access not granted",
      "description": "The “Partners & insurance” workspace has not been assigned to you. Ask an administrator to enable it.",
      "back": "Back to my workspace"
    },
    "actions": {
      "refresh": "Refresh",
      "search": "Search",
      "importClient": "Import for a client",
      "importClientTitle": "Import artworks for a client (CSV/XLSX)",
      "manageAuctionHouses": "Manage auction houses",
      "open": "Open",
      "details": "Details",
      "viewInTool": "View in tool",
      "close": "Close",
      "cancel": "Cancel",
      "saving": "Saving…"
    },
    "common": {
      "loading": "Loading…",
      "none": "None",
      "active": "Active",
      "inactive": "Inactive",
      "notAvailable": "n/a"
    },
    "header": {
      "mySpace": "My workspace",
      "partnersTitle": "Partners & insurance",
      "hubTitle": "Team dashboard",
      "partnersSubtitle": "Contracts, billable events, insurance requests and curatorial services.",
      "hubSubtitle": "Your workspace: access your assigned work areas."
    },
    "hub": {
      "spacesTitle": "Your workspaces",
      "spacesSubtitle": "The work areas you can access.",
      "manageTeamAccess": "Manage team and access",
      "noSpaces": "No workspace has been assigned to you yet. Ask an administrator to grant you access.",
      "comingSoon": "coming soon"
    },
    "kpis": {
      "partnerRequests": "Partner requests",
      "insurancePending": "Pending insurance requests",
      "pending": "Pending",
      "sent": "Sent",
      "urgent": "Urgent"
    },
    "operations": {
      "eyebrow": "Immediate operations",
      "title": "Processing & priorities"
    },
    "activity": {
      "title": "Recent activity",
      "subtitle": "Live partner, support and insurance requests.",
      "supportTicket": "Support ticket",
      "clientNumber": "Client #{{id}}",
      "clientNamed": "Client: {{name}}",
      "channelNamed": "Channel: {{channel}}",
      "artworkNumber": "Artwork #{{id}}",
      "proposalNumber": "Proposal #{{id}}",
      "insuranceTitle": "Insurance — {{context}}{{policyKind}}{{insuredValue}}",
      "createdAgo_one": "{{actor}} • Created {{count}} day ago",
      "createdAgo_other": "{{actor}} • Created {{count}} days ago",
      "empty": "No activity for this filter.",
      "filters": {
        "all": "All",
        "pending": "Pending",
        "sent": "Sent",
        "urgent": "Urgent"
      },
      "badges": {
        "sent": "Sent",
        "urgent": "Urgent",
        "toProcess": "To process",
        "pending": "Pending",
        "new": "New"
      },
      "demo": {
        "basquiat": "Basquiat file – submission to an institution",
        "soulages": "Soulages – proposal to Christie’s",
        "insuranceQuestion": "AXA insurance question – certificate"
      }
    },
    "insurance": {
      "title": "Insurance requests",
      "subtitle": "Triage, manual assignment, then partner follow-up.",
      "loading": "Loading insurance requests…",
      "empty": "No insurance requests yet.",
      "unassigned": "— Unassigned —",
      "assignmentError": "An error occurred while assigning the partner.",
      "table": {
        "date": "Date",
        "client": "Client",
        "context": "Context",
        "value": "Value",
        "artwork": "Artwork",
        "status": "Status",
        "partner": "Partner",
        "action": "Action"
      }
    },
    "workflows": {
      "eyebrow": "Business workflows",
      "title": "Partners, content & orchestration"
    },
    "curatorial": {
      "title": "Curatorial services",
      "subtitle": "Manage curatorial support requests"
    },
    "valuationExpert": {
      "title": "Expert valuation requests",
      "subtitle": "Artwork valuation requests addressed to a named partner expert"
    },
    "partners": {
      "title": "Partners",
      "subtitle": "Active contracts and billable events.",
      "searchPlaceholder": "Search for a partner by email…",
      "count_one": "{{count}} partner",
      "count_other": "{{count}} partners",
      "empty": "No partner with the “partner” role was found.",
      "table": {
        "email": "Email",
        "specialty": "Specialty",
        "activeContract": "Active contract",
        "pendingFiles": "Pending cases",
        "actions": "Actions"
      }
    },
    "resources": {
      "eyebrow": "Resources",
      "title": "Personal workspace & shared data"
    },
    "personal": {
      "title": "Personal workspace",
      "profile": "My profile",
      "shortcuts": "Shortcuts",
      "allRequests": "All requests",
      "help": "Help",
      "systemStatus": "System status",
      "database": "Database",
      "operational": "Operational"
    },
    "shared": {
      "title": "Shared collections & artworks",
      "subtitle": "This section automatically lists everything Artkiv clients have shared with your account."
    },
    "drawer": {
      "partner": "Partner",
      "newContract": "New contract",
      "newEvent": "New event",
      "contracts": "Contracts",
      "noContracts": "No contract for this partner.",
      "commissionRate": "Commission rate: {{value}}",
      "fixedAmount": "Fixed amount: {{value}}",
      "contractDocument": "Contract document",
      "billableEvents": "Billable events (latest 25)",
      "noEvents": "No events.",
      "occurredAt": "Event date",
      "base": "Base",
      "linkedContract": "Linked contract"
    },
    "contractModal": {
      "title": "New partner contract",
      "create": "Create contract",
      "createError": "Unable to create contract: {{message}}",
      "commissionPlaceholder": "E.g. 10.00",
      "amountPlaceholder": "E.g. 1,200.00"
    },
    "eventModal": {
      "title": "New billable event",
      "selectContract": "— Select —",
      "noContract": "No contract is available for this partner.",
      "create": "Create event",
      "createError": "Unable to create event: {{message}}",
      "amountPlaceholder": "E.g. 2,500"
    },
    "fields": {
      "partnerId": "Partner ID",
      "partnerType": "Partner type",
      "contractType": "Contract type",
      "startDate": "Start date",
      "endDateOptional": "End date (optional)",
      "currency": "Currency",
      "active": "Active contract",
      "commissionRate": "Commission rate",
      "fixedAmount": "Fixed amount",
      "contractDocumentOptional": "Contract URL (optional)",
      "internalNotesOptional": "Internal notes (optional)",
      "contractId": "Contract ID",
      "eventType": "Event type",
      "referenceAmount": "Reference amount",
      "occurredAt": "Event date and time",
      "artworkIdOptional": "Artwork ID (optional)",
      "collectionIdOptional": "Collection ID (optional)",
      "clientIdOptional": "Client ID (optional)"
    },
    "validation": {
      "partnerRequired": "Partner ID is required.",
      "startDateRequired": "Start date is required.",
      "contractRequired": "Contract ID is required.",
      "occurredAtRequired": "Event date is required."
    },
    "enums": {
      "statuses": {
        "pending": "Pending",
        "sent": "Sent",
        "assigned": "Assigned",
        "open": "Open",
        "in_progress": "In progress",
        "answered": "Answered",
        "closed": "Closed",
        "done": "Done",
        "completed": "Completed",
        "cancelled": "Cancelled",
        "active": "Active",
        "inactive": "Inactive",
        "paid": "Paid",
        "overdue": "Overdue",
        "invoice_sent": "Invoice sent",
        "partially_paid": "Partially paid",
        "draft": "Draft"
      },
      "partnerTypes": {
        "insurance": "Insurance",
        "transport": "Transport",
        "valuation_expert": "Valuation expert",
        "conservation_expert": "Conservation expert"
      },
      "contractTypes": {
        "commission": "Commission",
        "reverse": "Reverse commission",
        "forfait": "Fixed fee"
      },
      "eventTypes": {
        "expertise": "Expert appraisal",
        "transport": "Transport",
        "insurance_policy": "Insurance policy",
        "restoration": "Restoration"
      },
      "insuranceContexts": {
        "insurance": "Insurance",
        "permanent_collection": "Permanent collection",
        "exhibition": "Exhibition",
        "transport": "Transport",
        "loan": "Loan",
        "storage": "Storage",
        "event": "Event",
        "temporary": "Temporary coverage"
      },
      "policyKinds": {
        "all_risks": "All risks",
        "named_perils": "Named perils",
        "wall_to_wall": "Wall-to-wall",
        "transit": "Transit",
        "exhibition": "Exhibition",
        "storage": "Storage"
      },
      "requestTypes": {
        "general": "General request",
        "museum": "Museum",
        "auction": "Auction",
        "sale": "Sale",
        "loan": "Loan",
        "exhibition": "Exhibition",
        "insurance": "Insurance",
        "transport": "Transport",
        "expertise": "Expert appraisal"
      }
    },
    "coins": {
      "partenaires": {
        "title": "Partners & insurance",
        "description": "Contracts, insurance requests and billable events."
      },
      "support": {
        "title": "Support",
        "description": "Support tickets and assistance requests."
      },
      "newsletters": {
        "title": "Newsletters",
        "description": "Prepare and track communications."
      },
      "galeries": {
        "title": "Galleries",
        "description": "Manage galleries and auction houses."
      },
      "curatorial": {
        "title": "Curatorial services",
        "description": "Curatorial requests and support."
      },
      "curatoriaux": {
        "title": "Curatorial services",
        "description": "Curatorial requests and support."
      },
      "import": {
        "title": "Import",
        "description": "Import client collections and artworks."
      },
      "imports": {
        "title": "Imports",
        "description": "Import client collections and artworks."
      },
      "recherche": {
        "title": "Search",
        "description": "Search across Artkiv data."
      },
      "search": {
        "title": "Search",
        "description": "Search across Artkiv data."
      },
      "administration": {
        "title": "Administration",
        "description": "Platform administration tools."
      },
      "collections": {
        "title": "Collections",
        "description": "Shared collections and artworks."
      }
    }
  },
  "advisorMissions": {
    "focus": {
      "active": "Missions in progress",
      "ready_to_deliver": "Deliverables to send",
      "to_invoice": "Missions to invoice",
      "follow_up": "Clients to follow up",
      "filtered": "Filtered",
      "clear": "Clear filter"
    },
    "common": {
      "client": "Client",
      "loading": "Loading…"
    },
    "disabled": {
      "title": "Missions module not enabled",
      "description": "This module is being rolled out. Please check back soon."
    },
    "header": {
      "eyebrow": "Art Advisor",
      "title": "Missions",
      "description": "ARTKIV organises the mission. You retain your clients, fees and accounting."
    },
    "actions": {
      "close": "Close",
      "newMission": "+ New mission",
      "creating": "Creating…",
      "create": "Create mission"
    },
    "form": {
      "titleLabel": "Title *",
      "titlePlaceholder": "E.g. Inventory of Collection X",
      "typeLabel": "Mission type",
      "clientLabel": "Client",
      "noClientOption": "— None / external contact —",
      "collectionLabel": "Collection",
      "noCollectionOption": "— None —",
      "clientEntityLabel": "Client file",
      "noClientEntityOption": "— No file —",
      "dueDateLabel": "Due date",
      "priorityLabel": "Priority",
      "billingModeLabel": "Billing method",
      "scopeLabel": "Scope (optional)",
      "scopePlaceholder": "Describe the mission scope, deliverables or constraints."
    },
    "kpis": {
      "inProgress": "Missions in progress",
      "readyToInvoice": "Ready to invoice",
      "invoiced": "Invoiced (declared)",
      "received": "Received (declared)",
      "overdue": "Overdue (declared)",
      "disclaimer": "Tracking data only. Your accounting and declarations remain your responsibility and that of your accounting tool."
    },
    "table": {
      "mission": "Mission",
      "client": "Client",
      "progress": "Progress",
      "dueDate": "Due date",
      "billing": "Billing",
      "lastActivity": "Last activity",
      "empty": "No missions yet. Create one to get started."
    },
    "errors": {
      "create": "Error: {{message}}"
    },
    "enums": {
      "missionTypes": {
        "inventory": "Inventory",
        "valuation": "Valuation",
        "appraisal": "Appraisal",
        "expertise": "Expert appraisal",
        "conservation": "Conservation",
        "condition_report": "Condition report",
        "insurance": "Insurance",
        "transport": "Transport",
        "sale": "Sale",
        "acquisition": "Acquisition",
        "succession": "Estate planning",
        "donation": "Donation",
        "loan": "Loan",
        "exhibition": "Exhibition",
        "curatorial": "Curatorial support",
        "documentation": "Documentation",
        "other": "Other"
      },
      "statuses": {
        "draft": "Draft",
        "planned": "Planned",
        "in_progress": "In progress",
        "waiting_client": "Waiting for client",
        "waiting_partner": "Waiting for partner",
        "ready_to_deliver": "Ready to deliver",
        "delivered": "Delivered",
        "closed": "Closed",
        "cancelled": "Cancelled"
      },
      "priorities": {
        "low": "Low",
        "normal": "Normal",
        "high": "High",
        "urgent": "Urgent"
      },
      "billingModes": {
        "external": "Direct billing by the Advisor",
        "artkiv": "Billing through ARTKIV",
        "artkiv_invoice": "Billing through ARTKIV",
        "platform": "Billing through the platform",
        "included": "Included in fees",
        "free": "No charge"
      }
    }
  },
  "advisorBillingIdentity": {
    "title": "Billing identity",
    "description": {
      "before": "Your legal entity and VAT regime. This information is used in your documents and to ",
      "emphasis": "determine the VAT applied to your assignments",
      "after": ". You remain responsible for its accuracy."
    },
    "validation": {
      "sirenLength": "The SIREN must contain 9 digits.",
      "sirenInvalid": "Invalid SIREN (check digit).",
      "sirenValid": "Valid SIREN."
    },
    "fields": {
      "legalName": "Legal name / legal entity",
      "tradeName": "Trading name (optional)",
      "legalForm": "Legal form",
      "siren": "SIREN (9 digits)",
      "siret": "SIRET (14 digits, optional)",
      "vatNumber": "Intra-EU VAT number",
      "vatRegime": "VAT regime",
      "defaultVatRate": "Default VAT rate (%)",
      "exemptionMention": "VAT exemption wording (shown on the invoice)",
      "billingEmail": "Billing email",
      "address": "Registered office address",
      "postalCode": "Postcode",
      "city": "City"
    },
    "placeholders": {
      "legalName": "e.g. Delorme Conseil Ltd",
      "legalForm": "Ltd, sole trader, partnership…"
    },
    "vatRegimes": {
      "standard": "VAT registered (standard VAT)",
      "franchiseBase": "Small-business exemption (not VAT registered)",
      "custom": "Custom"
    },
    "actions": {
      "saving": "Saving…",
      "save": "Save billing identity",
      "saved": "Saved"
    }
  },
  "expertIdentity": {
    "title": "Professional identity",
    "subtitle": "These details appear on your client reports and, if you enable your public profile, in the Artkiv directory.",
    "fields": {
      "professionalTitle": "Professional title"
    },
    "placeholders": {
      "professionalTitle": "e.g. Modern & Contemporary Art Expert, Paris"
    },
    "hints": {
      "professionalTitle": "Displayed below your name in PDF reports and the directory."
    },
    "pdfLogo": {
      "title": "Client report logo",
      "description": "Shown only in your private PDFs. Your clients see your brand, not the public directory.",
      "name": "PDF logo",
      "preview": "PDF logo preview"
    },
    "publicLogo": {
      "title": "Public directory logo",
      "description": "Visible in the Artkiv directory only when your public profile is enabled.",
      "name": "Directory logo",
      "preview": "Directory logo preview"
    },
    "acceptedFormats": "Accepted formats: PNG, JPG, SVG — maximum 2 MB. A transparent background is recommended (PNG or SVG).",
    "validation": {
      "imageOnly": "Please select an image (PNG, JPG, SVG).",
      "maxSize": "The logo must not exceed 2 MB."
    },
    "actions": {
      "uploading": "Uploading…",
      "changeLogo": "Change logo",
      "remove": "Remove",
      "saving": "Saving…",
      "save": "Save identity"
    },
    "toasts": {
      "logoUpdated": "{{label}} updated.",
      "saved": "Professional identity saved."
    },
    "errors": {
      "urlNotGenerated": "URL was not generated",
      "upload": "Upload error: {{message}}",
      "save": "Error: {{message}}"
    }
  },
  "expertProfile": {
    "welcome": {
      "title": "Welcome to Artkiv!",
      "description": "To join our network of certified experts and be listed in our directory, complete your professional profile below. Once approved, you will be able to invite your Artkiv clients to endorse your expertise.",
      "stepsTitle": "The 4 steps towards certification:",
      "steps": {
        "completeProfileTitle": "Complete your profile",
        "completeProfileDetail": "(name, specialty, bio, location, photo)",
        "activatePresenceTitle": "Enable your presence",
        "activatePresenceDetail": "in the Artkiv directory",
        "inviteClientsTitle": "Invite at least 3 Artkiv clients",
        "inviteClientsDetail": "to endorse your expertise",
        "getBadge": "Earn the “Certified Expert” badge"
      }
    },
    "incomplete": {
      "title": "Incomplete profile",
      "before": "Complete the essential fields (",
      "fields": "name, specialty, bio, location",
      "after": ") before enabling your directory presence."
    },
    "ready": {
      "title": "Your profile is ready to publish!",
      "description": "Your profile is complete. Enable your Artkiv public presence below to appear in our directory and start receiving client enquiries.",
      "hint": "Once your profile is public, you can invite clients to endorse your expertise and earn the “Certified Expert” badge."
    },
    "directory": {
      "title": "Artkiv directory presence",
      "publicStatus": "Your profile is visible in the public directory",
      "privateStatus": "Your profile is currently private",
      "completeFirst": "Complete your profile first (name, specialty, bio, location) to enable this feature.",
      "visibleOn": "Your profile is visible at",
      "aboutTitle": "About directory presence:",
      "aboutText": "An Artkiv expert can manage clients, receive invitations from others and, if desired, enable a professional showcase. Profiles are standardised in our directory to ensure transparency and service quality.",
      "criteriaTitle": "Directory eligibility criteria:",
      "criteria": {
        "experience": "Have worked as an art professional for at least 5 years",
        "education": "Demonstrate advanced education and experience in art history",
        "noStock": "Hold no inventory and accept no artworks on consignment",
        "clientPaid": "Be paid solely by clients",
        "transparency": "Provide transparency about the fee structure",
        "clientInterest": "Put clients’ interests first"
      }
    },
    "photo": {
      "alt": "Expert",
      "uploading": "Uploading…",
      "change": "Change photo"
    },
    "cv": {
      "analyzing": "Analysing CV…",
      "upload": "Upload a CV (PDF)"
    },
    "certified": "Certified",
    "fields": {
      "fullName": "Full name",
      "specialty": "Specialty",
      "organization": "Organisation",
      "location": "Location",
      "contactEmail": "Contact email",
      "phone": "Phone",
      "experience": "Experience",
      "languages": "Languages",
      "bio": "Professional biography",
      "specializations": "Specialisations",
      "credentials": "Certifications and credentials"
    },
    "placeholders": {
      "fullName": "e.g. Marie Dupont",
      "specialty": "e.g. Modern Art",
      "organization": "e.g. XYZ Auction House",
      "location": "e.g. Paris, France",
      "contactEmail": "e.g. expert@example.com",
      "phone": "e.g. +44 7…",
      "experience": "e.g. 25+ years, expert since 2000",
      "languages": "e.g. EN, FR, ES",
      "bio": "Summary of your background and expertise (400–700 characters recommended)",
      "specializations": "e.g. Impressionism, Art Deco",
      "credentials": "e.g. ILAB, SFEP"
    },
    "actions": {
      "saving": "Saving…",
      "save": "Save profile",
      "refresh": "Refresh"
    },
    "certification": {
      "title": "Expert certification",
      "subtitle": "Invite your Artkiv clients to endorse your expertise and earn the “Certified Expert” badge.",
      "howToTitle": "How do I obtain endorsements?",
      "steps": {
        "shareTitle": "Share your profile",
        "shareDetail": "with your existing clients",
        "inviteTitle": "Invite them to join Artkiv",
        "inviteDetail": "if they are not members yet",
        "validateBefore": "Once signed in, they can",
        "validateStrong": "endorse your expertise",
        "validateAfter": "from your profile.",
        "badgeBefore": "After",
        "badgeStrong": "3 endorsements",
        "badgeAfter": ", you automatically earn the “Certified Expert” badge."
      },
      "importantTitle": "Important:",
      "importantText": "Only Artkiv members can endorse an expert. Your clients must first create an Artkiv account.",
      "privateMessage": "Enable your public presence to access certification."
    }
  },
  "expertBillingManager": {
    "common": {
      "loading": "Loading…",
      "signInRequired": "Please sign in",
      "notAvailable": "N/A"
    },
    "toasts": {
      "loadError": "Unable to load billing data.",
      "feesSaved": "Fees updated successfully.",
      "feesSaveError": "Unable to save fees."
    },
    "serviceTypes": {
      "validation": "Valuation validation",
      "expertiseCnes": "CNES expertise",
      "placementInstitution": "Institutional placement",
      "placementAuction": "Auction placement",
      "custom": "Custom service"
    },
    "statuses": {
      "pending": "Pending",
      "inProgress": "In progress",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "header": {
      "title": "Billing & Fees",
      "before": "Track your revenue, configure your fees and manage payouts transparently. Each completed service automatically generates a payout scheduled 7 days later.",
      "modelLabel": "New 2026 model:",
      "after": "You receive 85% of your service price (Artkiv takes 15%), while the client pays an additional 5% platform fee. This model includes 2026-compliant e-invoicing, secure payments and dedicated tax support."
    },
    "navigation": {
      "overview": "Overview",
      "services": "Services",
      "fees": "Fees",
      "payouts": "Payouts"
    },
    "overview": {
      "totalGrossRevenue": "Total gross revenue",
      "completedServices": "{{count}} completed service",
      "completedServices_one": "{{count}} completed service",
      "completedServices_other": "{{count}} completed services",
      "completedServices_plural": "{{count}} completed services",
      "netRevenue": "Net revenue",
      "afterCommission": "After Artkiv commission",
      "pending": "Pending",
      "servicesInProgress": "Services in progress",
      "averageTicket": "Average fee",
      "perService": "Per service",
      "revenueBreakdown": "Revenue breakdown",
      "yourNetShare": "Your net share",
      "artkivCommission": "Artkiv commission",
      "totalGross": "Gross total",
      "latestServices": "Latest services"
    },
    "actions": {
      "viewAll": "View all",
      "saving": "Saving…",
      "saveFees": "Save fees",
      "reset": "Reset"
    },
    "empty": {
      "noServices": "No services yet",
      "noPayouts": "No payouts yet"
    },
    "services": {
      "historyTitle": "Service history",
      "columns": {
        "service": "Service",
        "artwork": "Artwork",
        "date": "Date",
        "status": "Status",
        "amountInclTax": "Amount incl. VAT",
        "commission": "Commission",
        "yourShare": "Your share"
      }
    },
    "fees": {
      "title": "Fee settings",
      "subtitle": "Set your fees for each service type. The Artkiv commission is calculated automatically.",
      "youReceive": "You receive (85%)",
      "commissionHint": "Artkiv: 15% • Client: +5% fee",
      "validation": {
        "title": "Valuation validation",
        "subtitle": "Standard 48-hour service",
        "priceLabel": "Price incl. VAT (recommended: €49)"
      },
      "cnes": {
        "restrictedInfo": "CNES-certified expertise is reserved for accredited experts. Your package is applied automatically to assignments compatible with your status.",
        "certifiedTitle": "Certified expertise (CNES)",
        "deepOpinionTitle": "In-depth expert opinion",
        "certifiedSubtitle": "CNES-certified physical expertise",
        "deepOpinionSubtitle": "Non-certified expert analysis (outside CNES)",
        "baseRateLabel": "Base fee (recommended: €300)"
      },
      "hourly": {
        "title": "Hourly rate",
        "subtitle": "For additional services",
        "priceLabel": "Price excl. VAT per hour (recommended: €80)"
      },
      "placement": {
        "title": "Institutional or auction placement",
        "subtitle": "Fixed fee plus variable commission",
        "priceLabel": "Fixed fee excl. VAT (recommended: €500)",
        "noteTitle": "Note:",
        "noteText": "variable commission on the final sale price under the Terms and Conditions (generally 2–5%)."
      }
    },
    "commissionModel": {
      "title": "New commission model (2026)",
      "youReceiveLabel": "You receive:",
      "artkivTakesLabel": "Artkiv takes:",
      "clientPaysLabel": "The client pays:",
      "youPayLabel": "You pay:",
      "exampleLabel": "Example:",
      "fees": "fee",
      "total": "total",
      "paidServices": {
        "title": "Paid services (valuations, expertise, etc.)",
        "youReceive": "85% of the service price",
        "artkivTakes": "15% (deducted from your share)",
        "clientPays": "the service price plus a 5% platform fee",
        "exampleTitle": "€149 valuation",
        "exampleYouReceive": "You receive: €126.65 (85%)",
        "exampleClientPays": "The client pays: €156.45 excl. VAT (€149 + €7.45 fee)",
        "exampleArtkivTakes": "Artkiv takes: €29.80 (20% total)"
      },
      "introduction": {
        "title": "“Personal Advisor” introduction",
        "clientPays": "€0 (free, included in the subscription)",
        "youPay": "€49 excl. VAT (€58.80 incl. VAT) if you accept",
        "artkivTakes": "€49 (access to a qualified client)"
      },
      "why": {
        "title": "Why this model?",
        "intro": "These commissions enable Artkiv to:",
        "platform": "maintain the platform and provide 2026-compliant e-invoicing",
        "payments": "manage secure payments (guaranteed within 48 hours)",
        "support": "provide dedicated client and tax support",
        "savings": "save you approximately €1,560 per year in software and accounting costs"
      }
    },
    "payouts": {
      "title": "Payout history",
      "paidOn": "Paid on {{date}}",
      "scheduledOn": "Scheduled for {{date}}",
      "statuses": {
        "paid": "Paid",
        "scheduled": "Scheduled"
      }
    }
  },
  "collaborators": {
    "title": "Collaborators",
    "subtitle": "Collection access (team, assistants, experts)",
    "common": {
      "loading": "Loading…"
    },
    "stats": {
      "total": "{{count}} total",
      "total_one": "{{count}} total",
      "total_other": "{{count}} total",
      "active": "{{count}} active",
      "active_one": "{{count}} active",
      "active_other": "{{count}} active",
      "active_plural": "{{count}} active",
      "pending": "{{count}} pending",
      "pending_one": "{{count}} pending",
      "pending_other": "{{count}} pending"
    },
    "actions": {
      "invite": "Invite",
      "assistantAccess": "Assistant access",
      "hide": "Hide",
      "details": "Details",
      "cancel": "Cancel",
      "update": "Update",
      "sendInvitation": "Send invitation",
      "copy": "Copy",
      "close": "Close"
    },
    "empty": {
      "title": "No collaborators",
      "text": "Invite an assistant or expert to help complete the collection."
    },
    "roles": {
      "labels": {
        "teamReadonly": "Team member (read only)",
        "teamMember": "Team member",
        "expert": "Expert",
        "collectorClient": "Collector client",
        "assistant": "Assistant",
        "familyOfficeUser": "Family Office user",
        "artAdvisor": "Art Advisor",
        "familyOffice": "Family Office"
      },
      "descriptions": {
        "teamReadonly": "1 read-only member",
        "teamMember": "Up to 5 members with permissions",
        "expert": "Experts invited as needed",
        "collectorClientLimited": "Maximum 20 clients",
        "collectorClientUnlimited": "Unlimited clients",
        "assistant": "Up to 3 assistants",
        "familyOfficeUser": "Unlimited users",
        "artAdvisor": "Art advisory and curatorial follow-up",
        "familyOffice": "Wealth management and financial oversight"
      }
    },
    "statuses": {
      "pending": "Pending",
      "active": "Active",
      "suspended": "Suspended",
      "revoked": "Revoked"
    },
    "tooltips": {
      "activate": "Activate manually (the user has registered)",
      "resend": "Resend invitation",
      "copyLink": "Copy access link",
      "edit": "Edit",
      "suspend": "Suspend",
      "reactivate": "Reactivate",
      "revoke": "Revoke"
    },
    "permissions": {
      "label": "Permissions",
      "none": "none",
      "view": "View artworks",
      "edit": "Edit records",
      "add": "Add artworks",
      "delete": "Delete artworks",
      "export": "Export data",
      "reports": "Generate reports",
      "ai": "Access AI tools",
      "short": {
        "view": "view",
        "edit": "edit",
        "add": "add",
        "delete": "delete",
        "export": "export",
        "reports": "reports",
        "ai": "AI"
      }
    },
    "collections": {
      "label": "Collections",
      "noneDefined": "no collection defined"
    },
    "modal": {
      "editTitle": "Edit collaborator",
      "inviteTitle": "Invite a collaborator"
    },
    "form": {
      "role": "Role",
      "email": "Email",
      "firstName": "First name",
      "lastName": "Last name",
      "phone": "Phone",
      "accessibleCollections": "Accessible collections",
      "collectionsHint": "The collaborator will only see the selected collections.",
      "noCollectionsLoaded": "No collections loaded. Access will remain linked to the current collection if one exists.",
      "notes": "Notes",
      "notesPlaceholder": "Internal notes about this collaborator…"
    },
    "presets": {
      "readonly": "Read only",
      "assistant": "Assistant",
      "expert": "Expert"
    },
    "linkModal": {
      "title": "Collaborator invitation link",
      "description": "Send this link to your collaborator. They can create an account or sign in to accept."
    },
    "fallbacks": {
      "unknownClient": "Unknown client",
      "untitledCollection": "Untitled collection",
      "collectionWithId": "Collection {{id}}"
    },
    "confirm": {
      "revoke": "Are you sure you want to revoke this collaborator?",
      "activate": "Manually activate this collaborator’s access? The user will be able to sign in immediately."
    },
    "toasts": {
      "inviteReady": "Collaborator invitation ready ✍️",
      "invitationResent": "Invitation resent by email ✅",
      "linkCopied": "Invitation link copied ✅",
      "activating": "Activating…",
      "activated": "Collaborator activated ✅"
    },
    "errors": {
      "load": "Unable to load collaborators: {{message}}",
      "unknownPlan": "Unknown plan",
      "roleLimit": "The limit for this role has been reached ({{current}}/{{limit}}). Upgrade your plan or revoke an access.",
      "selectCollection": "Select at least one accessible collection.",
      "generic": "Error: {{message}}",
      "resend": "Unable to resend: {{message}}",
      "unknown": "unknown",
      "noToken": "No token is available. Select “Resend invitation” first.",
      "copyLink": "Unable to copy the link.",
      "copyManually": "Select the link and copy it manually.",
      "activateImpossible": "Unable to activate this collaborator.",
      "activate": "Activation error: {{message}}"
    },
    "audit": {
      "revokeReason": "Revoked from the dashboard"
    }
  },
  "artworksForSale": {
    "loading": "Loading artworks for sale…",
    "empty": "No artworks are currently listed for sale.",
    "untitledArtwork": "Untitled artwork",
    "unknownTechnique": "Technique unknown",
    "undefined": "Not specified",
    "sections": {
      "mine": "Your artworks for sale",
      "others": "Artworks listed by other collectors"
    },
    "labels": {
      "estimate": "Estimate",
      "purchasePrice": "Purchase price",
      "salePrice": "Sale price",
      "proposedPrice": "Asking price"
    },
    "actions": {
      "view": "View details",
      "remove": "Remove",
      "makeOffer": "Make an offer"
    },
    "confirmRemove": "Are you sure you want to remove this artwork from sale?",
    "errors": {
      "loadingUnknown": "An unknown error occurred while loading.",
      "remove": "Unable to remove the artwork from sale: {{message}}",
      "unknown": "unknown error"
    }
  },
  "estimationPage": {
    "title": "Artwork valuations",
    "form": {
      "title": "Add a new valuation",
      "methodIntro": "The valuation type determines the method used to assess the artwork’s value:"
    },
    "methods": {
      "ai": {
        "label": "AI valuation",
        "description": "Generated automatically by our internal algorithms using comparable artworks, medium, dimensions, artist and market trends."
      },
      "physical": {
        "label": "Physical appraisal",
        "description": "Performed by an expert after direct, in-person inspection at a gallery, storage facility or another location."
      },
      "comparables": {
        "label": "Comparable-artwork valuation",
        "description": "Based on direct comparison with similar artworks that have already been valued or sold, using internal data or external sources."
      },
      "insurance": {
        "label": "Insurance valuation",
        "description": "Provided by an insurer or authorised intermediary to establish a contractual insured value."
      },
      "succession": {
        "label": "Estate valuation",
        "description": "Prepared for an asset declaration or transfer in accordance with tax and notarial requirements."
      }
    },
    "fields": {
      "artwork": "Artwork",
      "artist": "Artist",
      "appraiser": "Appraiser",
      "date": "Date",
      "estimatedValue": "Estimated value (€)",
      "estimatedValueShort": "Estimated value",
      "method": "Valuation type",
      "notes": "Notes",
      "document": "Document (PDF or image)",
      "documentShort": "Document"
    },
    "placeholders": {
      "selectArtwork": "Select an artwork",
      "selectExpert": "Select an expert",
      "searchArtwork": "🔍 Search for an artwork…"
    },
    "actions": {
      "newEstimation": "New valuation",
      "comparableEstimation": "Comparable-artwork valuation",
      "pointsEstimation": "Points-based valuation",
      "cancel": "Cancel",
      "addExpert": "Add",
      "save": "Save",
      "download": "Download"
    },
    "history": {
      "title": "Valuation history",
      "empty": "No valuations match your search."
    },
    "fallbacks": {
      "unknownArtwork": "Unknown artwork",
      "unknownArtist": "Unknown artist"
    },
    "alerts": {
      "required": "Please enter at least the artwork and estimated value.",
      "uploadError": "An error occurred while uploading the document.",
      "saveError": "An error occurred while saving: {{message}}",
      "saved": "Valuation saved successfully!"
    }
  },
  "depositsPage": {
    "title": "Deposits & Loans",
    "subtitle": "Collections entrusted to third parties and individual artworks on loan",
    "museumSidebar": {
      "title": "Propose to a museum",
      "text": "Build a proposal dossier for an institution from your artworks.",
      "cta": "Create a museum dossier"
    },
    "tabs": {
      "deposits": "Deposited collections",
      "loans": "Artworks on loan",
      "risks": "To clarify"
    },
    "ownerTypes": {
      "a_clarifier": "To clarify",
      "private_collector": "Private collector",
      "institution": "Institution",
      "family_succession": "Family / estate"
    },
    "contract": {
      "noEndDate": "⚠ No end date",
      "expiredAgo": "EXPIRED {{count}} day ago",
      "expiredAgo_plural": "EXPIRED {{count}} days ago",
      "expiredAgo_one": "EXPIRED {{count}} day ago",
      "expiredAgo_other": "EXPIRED {{count}} days ago",
      "expiresIn": "⚠ Expires in {{count}} day",
      "expiresIn_plural": "⚠ Expires in {{count}} days",
      "expiresIn_one": "⚠ Expires in {{count}} day",
      "expiresIn_other": "⚠ Expires in {{count}} days",
      "validUntil": "Valid until {{date}}",
      "urgentSummary": "{{count}} contract expired or due for renewal within 60 days",
      "urgentSummary_plural": "{{count}} contracts expired or due for renewal within 60 days",
      "urgentSummary_one": "{{count}} contract expired or due for renewal within 60 days",
      "urgentSummary_other": "{{count}} contracts expired or due for renewal within 60 days"
    },
    "toast": {
      "depositSaved": "Deposit record saved",
      "loanMarked": "Artwork marked as on loan",
      "loanRemoved": "Loan status removed",
      "error": "Error: {{message}}"
    },
    "depositModal": {
      "title": "Deposit record",
      "ownerType": "Owner type",
      "ownerName": "Owner name",
      "ownerNamePlaceholder": "Name or legal entity",
      "contact": "Contact",
      "contactPlaceholder": "Email, phone…",
      "contractStart": "Contract start",
      "contractEnd": "Contract end",
      "insuranceRequired": "Insurance required",
      "insuranceHolderPlaceholder": "Who holds the insurance? (depositor, custodian…)",
      "specialConditions": "Special conditions",
      "specialConditionsPlaceholder": "Clauses, restrictions, obligations…"
    },
    "loanModal": {
      "removeTitle": "Remove from loan",
      "markTitle": "Mark as on loan",
      "destination": "Loan destination / beneficiary",
      "destinationPlaceholder": "e.g. Museum of Modern Art, Paris",
      "confirmReturn": "Confirm return",
      "confirmLoan": "Confirm loan"
    },
    "empty": {
      "depositsTitle": "No deposited collections",
      "depositsText": "Create a collection with the “Deposit” type from My Collection to manage it here.",
      "loansTitle": "No artworks on loan",
      "loansText": "Mark artworks as “on loan” from their individual records or from this page.",
      "viewCollections": "View my collections",
      "viewCollection": "View my collection"
    },
    "risks": {
      "allLocated": "All your artworks have a location",
      "loanLocatedHint": "Artworks on loan are considered located at the borrowing institution.",
      "unknownLocationTitle": "Unknown location —",
      "unknownLocationText": "These artworks have neither a storage location nor a recorded loan. In the event of a claim, their location cannot be demonstrated to the insurer.",
      "collectionLabel": "Collection: {{collection}}"
    },
    "actions": {
      "complete": "Complete",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…",
      "edit": "Edit",
      "view": "View"
    },
    "depositCard": {
      "badge": "Deposit",
      "artworkCount_one": "{{count}} artwork",
      "artworkCount_other": "{{count}} artworks",
      "insurance": "Insurance: {{holder}}",
      "toDefine": "to be defined",
      "missingRecord": "⚠ No deposit record completed — contract, owner and insurance are unknown"
    },
    "loanCard": {
      "estimatedValue": "Estimated value: {{value}}",
      "return": "Return",
      "record": "Record"
    }
  },
  "locationManager": {
    "page": {
      "title": "My locations",
      "subtitle": "A few details are enough to care for each artwork, wherever it lives — at home or in a specialised space."
    },
    "status": {
      "suitable": "Suitable",
      "improve": "To improve",
      "monitor": "To monitor"
    },
    "microcopy": {
      "headerTitle": "Care for your artworks, where they live",
      "headerSub": "A few details are enough to receive advice tailored to each artwork — at home or in a specialised space.",
      "homeTitle": "Kept at home? That's often perfectly suitable.",
      "homeText": "ARTKIV simply helps you check light, humidity, heat and the safety of the hanging.",
      "unknownTitle": "Don't have all the answers? No problem.",
      "unknownText": "Note what you know today. You can complete it later.",
      "proTitle": "Need a more technical environment?",
      "proText": "For some sensitive, large or frequently moved artworks, specialised storage can add further services.",
      "privacyTitle": "Your address and photos stay private.",
      "privacyText": "You choose exactly who can see the location details."
    },
    "actions": {
      "newLocation": "New location",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "transfer": "Transfer",
      "confirm": "Confirm",
      "save": "Save"
    },
    "fields": {
      "type": "Type",
      "address": "Address",
      "notes": "Notes",
      "status": "Status"
    },
    "types": {
      "primaryResidence": "Primary residence",
      "secondaryResidence": "Secondary residence",
      "office": "Office / professional premises",
      "personalReserve": "Personal reserve",
      "selfStorage": "Self-storage unit",
      "artWarehouse": "Specialised art warehouse",
      "professionalDeposit": "Gallery / studio / dealer",
      "museum": "Museum / institution",
      "transit": "Transport / transit",
      "freeport": "Bonded warehouse / freeport",
      "storage": "Storage",
      "loan": "Loan",
      "exhibition": "Exhibition",
      "other": "Other"
    },
    "security": {
      "intrusionAlarm": "Intrusion alarm",
      "videoSurveillance": "Video surveillance",
      "restrictedAccess": "Restricted access",
      "specificInsurance": "Specific insurance"
    },
    "risks": {
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "conditions": {
      "temperature": "Temperature",
      "humidity": "Humidity",
      "light": "Light",
      "ventilation": "Ventilation",
      "humidityRelative": "Relative humidity",
      "lightUv": "Light / UV",
      "packagingVentilation": "Packaging / Ventilation",
      "temperaturePlaceholder": "E.g. 18-20°C, stable, climate-controlled",
      "humidityPlaceholder": "E.g. 50-55% RH, controlled",
      "lightPlaceholder": "E.g. total darkness, filtered UV, blinds",
      "ventilationPlaceholder": "E.g. acid-free rolls, wooden crates, ventilated area"
    },
    "form": {
      "sections": {
        "general": "General information",
        "conservation": "Conservation conditions",
        "security": "Security measures",
        "risk": "Overall risk level",
        "observationsPhotos": "Observations & photos"
      },
      "name": "Location name",
      "generalObservations": "General observations",
      "observationsPlaceholder": "Observed risks, planned work, access, security staff…"
    },
    "photos": {
      "title": "Space photos",
      "uploadingShort": "Uploading…",
      "uploading": "Upload in progress…",
      "add": "+ Add",
      "addPhotos": "+ Add photos",
      "addSpacePhotos": "Add photos of the space",
      "addMore": "Add more photos"
    },
    "artworks": {
      "atLocation": "Artworks at this location:"
    },
    "transfer": {
      "selectDestination": "Select a destination",
      "confirmTitle": "Confirm transfer",
      "destination": "Destination"
    },
    "delete": {
      "confirmTitle": "Delete this location?",
      "containsArtworks": "This location contains {{count}} artwork. Transfer it before deleting.",
      "containsArtworks_plural": "This location contains {{count}} artworks. Transfer them before deleting.",
      "containsArtworks_one": "This location contains {{count}} artwork. Transfer it before deleting.",
      "containsArtworks_other": "This location contains {{count}} artworks. Transfer them before deleting.",
      "irreversible": "This action cannot be undone."
    },
    "fallback": {
      "untitled": "Untitled",
      "unknownArtist": "unknown artist"
    },
    "notifications": {
      "uploadError": "Upload error: {{message}}",
      "selectTransfer": "Select a destination and the artworks to transfer.",
      "transferSuccess": "Artworks transferred successfully!",
      "transferError": "An error occurred during the transfer.",
      "updateSuccess": "Location updated!",
      "updateError": "An error occurred while updating the location.",
      "createSuccess": "New location added.",
      "createError": "An error occurred while creating the location.",
      "deleteBlocked": "Cannot delete: {{count}} artwork is stored at this location. Transfer it first.",
      "deleteBlocked_plural": "Cannot delete: {{count}} artworks are stored at this location. Transfer them first.",
      "deleteBlocked_one": "Cannot delete: {{count}} artwork is stored at this location. Transfer it first.",
      "deleteBlocked_other": "Cannot delete: {{count}} artworks are stored at this location. Transfer them first.",
      "deleteSuccess": "Location deleted.",
      "deleteError": "An error occurred while deleting the location."
    }
  },
  "estimationValidation": {
    "cancelled": {
      "ui": {
        "paiementAnnule": "Payment cancelled",
        "vousAvezAnnuleLeProcessusDePaiementAucunMontant": "You cancelled the payment process. No amount was charged. Your validation request was not created.",
        "retourAuxEstimations": "Back to valuations"
      }
    },
    "success": {
      "ui": {
        "verificationDuPaiement": "Checking payment...",
        "paiementConfirme": "Payment confirmed!",
        "votreDemandeDeValidationAEteTransmiseANotre": "Your validation request has been sent to our expert team. You will receive the validated valuation by email within",
        "4872hOuvres": "48–72 business hours",
        "prochainesEtapes": "Next steps",
        "vousRecevrezUnEmailDeConfirmationImmediatement": "You will receive a confirmation email immediately",
        "notreEquipeAnalyseraVotreEstimationDansLes4872h": "Our team will review your valuation within 48–72 hours",
        "vousRecevrezLeRapportDetailleParEmail": "You will receive the detailed report by email",
        "retourAuxEstimations": "Back to valuations",
        "monCompte": "My account"
      }
    },
    "request": {
      "ui": {
        "aucuneDonneeDEstimationTrouveeVeuillezDAbordEffectuer": "No valuation data was found. Please complete the calculation first.",
        "votreDemandeDeValidationAEteEnvoyeeAL": "✅ Your validation request has been sent to the Artkiv team. You will receive an email notification within 48–72 hours.",
        "calculDEstimationRequis": "Valuation calculation required",
        "vousDevezDAbordEffectuerLeCalculDEstimation": "You must first calculate the valuation using the points method or comparable works before requesting validation.",
        "retourAuxEstimations": "Back to valuations",
        "demandeDeValidationDEstimation": "Valuation validation request",
        "serviceExpertArtkivValidationSous4872h": "Artkiv expert service · Validation within 48–72 hours",
        "recapitulatifDeVotreEstimation": "Summary of your valuation",
        "sansTitre": "Untitled",
        "methodeUtilisee": "Method used",
        "methodeParPoints": "Points method",
        "uvresComparables": "Comparable works",
        "valeurEstimee": "Estimated value",
        "indiceDeConfiance": "Confidence score",
        "estimationProvisoireBaseDeComparablesInsuffisantePourValidationC": "Provisional valuation · insufficient comparable data for full CUP validation.",
        "validationGratuiteIncluse": "Free validation included",
        "servicePayant": "Paid service",
        "votreAbonnement": "Your subscription",
        "validationsGratuitesParMois": "free validations per month.",
        "validationsUtiliseesCeMois": "Validations used this month",
        "validationsGratuitesRestantes": "Free validations remaining",
        "coutDeCetteValidation": "Cost of this validation",
        "passezALAbonnementPremiumPourObtenir50Validations": ": Upgrade to Premium to receive 50 free validations per month",
        "commentCaMarche": "How does it work?",
        "envoiDeVotreDemande": "Submit your request",
        "votreCalculDEstimationEstTransmisALEquipe": "Your valuation calculation is sent to the Artkiv team",
        "verificationExperte": "Expert review",
        "nosExpertsAnalysentVosDonneesVerifientLesSourcesEt": "Our experts analyse your data, verify the sources and refine the valuation",
        "receptionSous4872h": "Receive it within 48–72 hours",
        "vousRecevezLEstimationValideeParEmailAvecUn": "You receive the validated valuation by email with a detailed report",
        "envoiEnCours": "Sending...",
        "envoyerPourValidation": "Submit for validation",
        "gratuit": "(Free)",
        "noteImportante": "Important note:",
        "cetteValidationNEstPasUneExpertiseOfficielleCnes": "This validation is not an official CNES appraisal. For high-value works (> €80,000) or legal purposes such as succession or insurance, a physical appraisal by an accredited expert may be required.",
        "enSavoirPlus": "Learn more",
        "loading": "Loading…",
        "submitError": "❌ Error while sending the request: {{message}}",
        "planIncludes": "Your {{plan}} subscription includes {{count}} free validations per month.",
        "tip": "Tip",
        "range": "Range"
      }
    },
    "info": {
      "ui": {
        "serviceDeValidationDEstimation": "Estimation validation service",
        "commentFaireValiderVotreEstimationParUnExpertArtkiv": "How to have your estimation validated by an Artkiv expert",
        "leProcessusEn3Etapes": "The process in 3 steps",
        "effectuezVotreEstimation": "Complete your estimation",
        "utilisezLUneDeNosDeuxMethodesPourCalculer": "Use one of our two methods to calculate the value of your artwork:",
        "methodeParPoints": "Points-based method",
        "calculBaseSurLesDimensionsEtLaCoteDe": ": calculation based on the artwork's dimensions and the artist's market rating",
        "uvresComparables": "Comparable artworks",
        "analyseDeVentesSimilairesRecentes": ": analysis of recent similar sales",
        "demandezLaValidation": "Request validation",
        "uneFoisVotreCalculTermineCliquezSurDemanderUne": "Once your calculation is complete, click “Request expert validation”. You will immediately see whether validation is free, based on your monthly allowance, or paid (€150).",
        "recevezLEstimationValidee": "Receive the validated estimation",
        "nosExpertsVerifientVosDonneesConsolidentLesSourcesEt": "Our experts review your data, consolidate the sources and refine the estimation. You will receive a detailed report by email within",
        "4872hOuvres": "48–72 business hours",
        "tarificationTransparente": "Transparent pricing",
        "lesValidationsNeSontPasAutomatiquementInclusesDansVotre": "Validations are NOT automatically included in your subscription",
        "abonnementStandard": "Standard subscription",
        "validationsGratuites": "Free validations",
        "10Mois": "10 / month",
        "auDelaDuQuota": "Beyond the allowance",
        "150Validation": "€150 / validation",
        "abonnementPremium": "Premium subscription",
        "recommande": "Recommended",
        "50Mois": "50 / month",
        "ceQuiEstInclusDansLaValidation": "What the validation includes",
        "verificationDesDonnees": "Data review",
        "controleDeCoherenceDesInformationsSaisies": "Consistency check of the information entered",
        "consolidationDesSources": "Source consolidation",
        "verificationEtEnrichissementDesComparables": "Review and enrichment of comparables",
        "affinementDeLEstimation": "Estimation refinement",
        "ajustementsBasesSurLExpertiseDuMarche": "Adjustments based on market expertise",
        "rapportDetaille": "Detailed report",
        "documentPdfProfessionnelAvecMethodologie": "Professional PDF document with methodology",
        "notreEngagementTransparence": "💎 Our commitment to transparency",
        "artkivNeModifieJamaisVosCalculs": "Artkiv never alters your calculations.",
        "notreValidationEnrichitVotreAnalyseAvecDesVentesComplementaires": "Our validation enriches your analysis with additional sales identified in our professional databases, including Artprice, Artnet and auction-house archives.",
        "chaqueAjoutEstJustifie": "Every addition is justified",
        "etTraceDansLeRapportFinal": "and traceable in the final report.",
        "vousVerrezExactement": "You will see exactly:",
        "votreCalculInitial": "Your initial calculation",
        "reproduitTelQuelInchange": "(reproduced exactly as submitted, unchanged)",
        "lesVentesAjouteesParArtkiv": "Sales added by Artkiv",
        "avecSourcesExactesMaisonDeVentesDateLotEt": "with exact sources, including auction house, date and lot, plus the reason for inclusion",
        "lesVentesEcartees": "Excluded sales",
        "siNecessaireAvecJustificationDetaillee": "where applicable, with a detailed explanation",
        "lEcartEntreVotreEstimationEtLaNotre": "The difference between your estimation and ours",
        "avecExplicationMethodologique": "with a methodological explanation",
        "notreSeuleMission": "Our sole purpose:",
        "vousDonnerLEstimationLaPlusJustePossibleBasee": "to provide the fairest possible estimation based on the real market. We receive no commission on any subsequent sale or insurance contract. Our revenue comes solely from validation fees.",
        "importantValidationVsExpertiseCnes": "⚠️ Important: Validation vs CNES appraisal",
        "laValidationDEstimationArtkiv": "Artkiv estimation validation",
        "nEstPas": "is not",
        "uneExpertiseOfficielleParUnExpertAgreeCnesElle": "an official appraisal by a CNES-accredited expert. It is suitable for:",
        "assurancePourDesUvres80000": "• Insurance for artworks under €80,000",
        "gestionDeCollectionPersonnelle": "• Personal collection management",
        "premiereEvaluationAvantVente": "• Initial valuation before a sale",
        "pourLesUvresDeHauteValeur80000Ou": "For high-value artworks above €80,000, or for legal purposes such as inheritance, donation or litigation, a",
        "expertiseCnes": "CNES appraisal",
        "estRecommandeeOuObligatoire": "is recommended or required.",
        "enSavoirPlus": "Learn more",
        "questionsFrequentes": "Frequently asked questions",
        "commentPuisJeEtreSurEQuArtkivN": "💎 How can I be sure Artkiv does not invent sales to justify a higher price?",
        "excellenteQuestionEtNousLaComprenonsParfaitement": "An excellent question, and one we fully understand.",
        "laTransparenceEstAuCUrDeNotreService": "Transparency is at the heart of our validation service. Here are our four safeguards:",
        "votreCalculResteIntact": "Your calculation remains intact",
        "nousReproduisonsExactementVotreEstimationInitialeDansLeRapport": "We reproduce your original estimation EXACTLY in Section 1 of the report, without any modification, so you can compare both analyses side by side.",
        "sourcesVerifiables": "Verifiable sources",
        "chaqueVenteAjouteeInclutMaisonDeVentesDateExacte": "Every added sale includes the auction house, exact date, lot number and, where available, a link to public archives. You can verify everything.",
        "justificationSystematique": "Systematic justification",
        "pourChaqueVenteAjouteeNousExpliquonsPourquoiElleEst": "For every sale added, we explain WHY it is relevant, for example similar dimensions, the same period or a leading auction house.",
        "aucunConflitDInteret": "No conflict of interest",
        "nousNeTouchonsAucuneCommissionSurVosVentesOu": "We receive NO commission on your future sales or insurance contracts. Our only revenue is the €150 validation fee, unless it is included in your subscription.",
        "notreReputationDependDeNotreHonneteteUnClientInsatisfait": "Our reputation depends on our integrity. A dissatisfied client can share our report with other experts for review. We have no incentive to manipulate the data.",
        "quellesSourcesDeDonneesUtilisezVousPourEnrichirMon": "Which data sources do you use to enrich my estimation?",
        "notreValidationReposeSurUnAccesProfessionnelAPlusieurs": "Our validation is based on professional access to several leading art-market databases:",
        "basesDeDonneesMondiales": "📊 Global databases",
        "30mResultatsDeVentes": ": 30M+ auction results",
        "ventesInternationalesDepuis1985": ": International sales since 1985",
        "theArtMarket": "The Art Market",
        "analysesSectorielles": ": Sector analyses",
        "archivesMaisonsDeVentes": "🏛️ Auction-house archives",
        "christieSSothebySBonhams": "• Christie's, Sotheby's, Bonhams",
        "artcurialTajanPiasaMillon": "• Artcurial, Tajan, Piasa, Millon",
        "cataloguesSpecialisesParArtiste": "• Artist-specific catalogues",
        "sourcesAcademiques": "📚 Academic sources",
        "cataloguesRaisonnesSiDisponibles": "• Catalogues raisonnés, where available",
        "publicationsDExpertsSpecialises": "• Publications by specialist experts",
        "archivesGaleriesHistoriques": "• Historical gallery archives",
        "expertiseInterne": "👥 In-house expertise",
        "expertsDiplomesHistoireDeLArt": "• Experts with art-history degrees",
        "specialisationsParPeriode": "• Period-specific specialisations",
        "veilleContinueDuMarche": "• Continuous market monitoring",
        "notreValeurAjoutee": "Our added value:",
        "nousCroisonsCesSourcesProfessionnellesSouventPayantesOuA": "We cross-reference these professional sources, many of which are paid or access-restricted, to identify the most relevant sales you may not have found on your own.",
        "toutesLesVentesAjouteesDansVotreRapportInclurontLa": "Every sale added to your report includes its exact source so that you can verify its authenticity.",
        "commentFonctionneLeQuotaMensuelDeValidationsGratuites": "How does the monthly allowance of free validations work?",
        "chaqueAbonnementInclutUnCertainNombreDeValidationsGratuites": "Each subscription includes a number of free validations per month:",
        "standard29Mois": "Standard (€29/month):",
        "10ValidationsGratuites": "10 free validations",
        "premium199Mois": "Premium (€199/month):",
        "50ValidationsGratuites": "50 free validations",
        "important": "📅 Important:",
        "leQuotaSeRenouvelleAutomatiquementLe1erDeChaque": "The allowance renews automatically on the first day of each month. Unused validations do not roll over to the following month.",
        "auDelaDuQuotae1b639": "Beyond the allowance:",
        "chaqueValidationSupplementaireCoute150QuelQueSoitVotre": "Each additional validation costs €150, regardless of your subscription.",
        "astuce": "💡 Tip:",
        "siVousFaitesRegulierementPlusDe2ValidationsPayantes": "If you regularly purchase more than two additional validations per month, upgrading to Premium becomes cost-effective: €199 for 50 validations represents €3.98 per validation in subscription value.",
        "puisJeAvoirUneValidationEnMoinsDe48h": "Can I receive validation in under 48 hours if it is urgent?",
        "leDelaiStandardEstDe": "The standard turnaround is",
        "4872HeuresOuvrees": "48–72 business hours",
        "lundiVendrediHorsJoursFeries": "Monday to Friday, excluding public holidays.",
        "pourUne": "For an",
        "validationExpress24h": "express validation within 24 hours",
        "nousPouvonsEtudierVotreDemandeAuCasParCas": ", we can review your request on a case-by-case basis:",
        "contactezNousA": "Contact us at",
        "expertsArtkivCom": "experts@artkiv.com",
        "avantDeFaireLaDemande": "BEFORE submitting the request",
        "supplementDe75Total225OuQuota75": "Additional fee of €75, for a total of €225 or allowance plus €75",
        "selonDisponibiliteDeNosExpertsPasGaranti": "Subject to expert availability and not guaranteed",
        "attention": "⚠️ Please note:",
        "memeEnExpressNousMaintenonsLaMemeQualiteD": "Even for express requests, we maintain the same standard of analysis. If the complexity requires more time, we will let you know.",
        "queFaireAvecLeRapportDeValidationUneFois": "How can I use the validation report once I receive it?",
        "leRapportDeValidationArtkivPeutEtreUtilisePour": "The Artkiv validation report can be used for:",
        "usagesRecommandes": "✅ Recommended uses",
        "assuranceUvres80000": "• Insurance for artworks under €80,000",
        "gestionCollectionPersonnelle": "• Personal collection management",
        "partageAvecConseillerPatrimoine": "• Sharing with a wealth adviser",
        "discussionAvecGaleriste": "• Discussion with a gallery",
        "valorisationPatrimoniale": "• Wealth-asset valuation",
        "necessiteExpertiseCnes": "❌ Requires a CNES appraisal",
        "successionDeclarationFiscale": "• Inheritance tax declaration",
        "donationActeNotarie": "• Donation by notarial deed",
        "contentieuxJuridique": "• Legal proceedings",
        "assuranceUvres800004aa7fe": "• Insurance for artworks above €80,000",
        "venteMaisonInternationale": "• Sale through an international auction house",
        "litigeAuthenticite": "• Authenticity dispute",
        "pourAllerPlusLoin": "💼 To go further:",
        "siVotreSituationNecessiteUneExpertiseCnesOfficielleContactez": "If your situation requires an official CNES appraisal, contact us at experts@artkiv.com. The Artkiv report will provide a solid basis for the physical appraisal.",
        "queSePasseTIlSiJeNeSuis": "What happens if I am not satisfied with the report?",
        "votreSatisfactionEstNotrePrioriteSiVousAvezDes": "Your satisfaction is our priority. If you have questions or wish to challenge any point:",
        "contactezNousSous7Jours": "Contact us within 7 days",
        "emailExpertsArtkivComAvecVotreReferenceDeValidation": "Email experts@artkiv.com with your validation reference",
        "echangeAvecLExpertValidateur": "Speak with the validating expert",
        "nousOrganisonsUnAppelPourClarifierLesPointsContestes": "We arrange a call to clarify the points in question",
        "correctionSiErreurDeNotrePart": "Correction if we made an error",
        "siNousAvonsFaitUneErreurFactuelleNousCorrigeons": "If we have made a factual error, we will correct it free of charge within 48 hours",
        "important7cb751": "⚠️ Important:",
        "unSimpleDesaccordMethodologiqueNeConstituePasUneErreur": "A methodological difference of opinion does not constitute an error. All our estimations are based on verifiable real sales, and we will explain our reasoning in detail.",
        "mesDonneesEtImagesDUvresSontEllesConfidentielles": "Are my data and artwork images confidential?",
        "laConfidentialiteEstGarantieA100": "Confidentiality is guaranteed 100%:",
        "aucunPartageAvecDesTiers": "No sharing with third parties",
        "vosImagesEtInformationsNeSortentJamaisDArtkiv": "- Your images and information never leave Artkiv without your explicit consent",
        "conformiteRgpd": "GDPR compliance",
        "toutesVosDonneesSontProtegeesSelonLeReglementEuropeen": "- All your data are protected under the European General Data Protection Regulation",
        "hebergementSecuriseEurope": "Secure European hosting",
        "serveursHetznerEnAllemagneChiffrementSauvegardesQuotidiennes": "- Hetzner servers in Germany, encryption and daily backups",
        "accesRestreint": "Restricted access",
        "seulLExpertAssigneAVotreValidationAccedeA": "- Only the expert assigned to your validation can access your data during processing",
        "suppressionALaDemande": "Deletion on request",
        "vousPouvezDemanderLaSuppressionDeVosDonneesA": "- You may request deletion of your data at any time under the right to erasure",
        "pourPlusDInformations": "For more information:",
        "politiqueDeConfidentialite": "Privacy Policy",
        "pretAEstimerVotreUvre": "Ready to estimate your artwork?",
        "commencezParChoisirVotreMethodeDEstimation": "Start by choosing your estimation method",
        "commencerLEstimation": "Start estimating",
        "absolument": "Absolutely."
      }
    }
  },
  "estimationSuccession": {
    "ui": {
      "dansQuelPaysSeSitueLaSuccession": "In which country is the estate located?",
      "lesReglesDEvaluationDesUvresDArtVarient": "The valuation rules for works of art vary according to local legislation.",
      "changerDePays": "Change country",
      "successionEnBelgique": "🇧🇪 Estate in Belgium",
      "valeurVenaleAuJourDuDecesPossibiliteDeDation": "Fair market value on the date of death. Works of art may be transferred in lieu of payment, with a 120% valuation in Flanders since 2023.",
      "selectionnezLaRegionDuDefunt": "Select the deceased's region",
      "lesDroitsDeSuccessionVarientSelonLaRegionDe": "Inheritance tax varies according to the deceased's region of residence.",
      "evaluationDeLUvreDArt": "Valuation of the work of art",
      "valeurVenaleDeLUvreAuJourDuDeces": "Fair market value of the work on the date of death",
      "ex50000": "E.g. 50000",
      "estimationParCommissairePriseurOuExpertRecommandee": "Valuation by an auctioneer or expert recommended",
      "valeurTotaleDeLaSuccession": "Total value of the estate",
      "ex500000": "E.g. 500000",
      "lienDeParenteAvecLeDefunt": "Relationship to the deceased",
      "selectionner": "Select",
      "conjointCohabitantLegal": "Spouse / Legal cohabitant",
      "ligneDirecteEnfantsParents": "Direct line (children, parents)",
      "freresSUrsOnclesTantes": "Brothers, sisters, uncles and aunts",
      "autresHeritiers": "Other heirs",
      "optionDationEnPaiement": "💡 Option: transfer in lieu of payment",
      "vousPouvezPayerLesDroitsDeSuccessionEnCedant": "You can pay inheritance tax by transferring works of art that form part of Belgian cultural heritage.",
      "avantageFlandreReforme2023": "🇧🇪 Flanders advantage (2023 reform)",
      "evaluationA": "• Valuation at",
      "120DeLaValeurVenale": "120% of fair market value",
      "elargissementAuxBiensCulturelsBijouxManuscritsObjetsArcheologiqu": "• Extended to “cultural assets” such as jewellery, manuscripts and archaeological objects",
      "remboursementDuSurplusSiValeurDroitsDus": "• Refund of any surplus when the value exceeds the tax due",
      "envisagerLaDationEnPaiement": "Consider a transfer in lieu of payment",
      "necessiteAccordDeLEtatEtExpertiseFraisA": "Requires government approval and an appraisal; fees may apply",
      "pointsClesBelgique": "📋 Key points · Belgium",
      "valeurVenale": "Fair market value",
      "auJourDuDecesMarcheDesBiensDOccasion": "on the date of death, based on the second-hand market",
      "expertiseRecommandee": "Appraisal recommended",
      "parCommissairePriseurPourUvresImportantes": "by an auctioneer for significant works",
      "tauxVariables": "Variable rates",
      "selonRegionDegreDeParenteEtMontant": "depending on the region, degree of kinship and amount",
      "dationPossible": "Transfer in lieu of payment available",
      "cessionDUvresAuLieuDuPaiementEnNumeraire": ": transfer of works instead of a cash payment",
      "controleFiscal": "Tax review",
      "lAdministrationPeutDemanderUneExpertiseDeControle": ": the authorities may request a control appraisal",
      "retour": "← Back",
      "demanderUneExpertise": "Request an appraisal",
      "successionEnSuisse": "🇨🇭 Estate in Switzerland",
      "26RegimesCantonauxDifferentsValeurVenaleAuJourDu": "There are 26 different cantonal systems. Fair market value applies on the date of death. Schwyz and Obwalden levy no inheritance tax. Transfers in lieu of payment are available in certain cantons, including Geneva and Vaud.",
      "selectionnezLeCantonDuDernierDomicileDuDefunt": "Select the canton of the deceased's last residence",
      "lImpotSurLesSuccessionsEstPreleveParLe": "Inheritance tax is levied by the canton in which the deceased resided.",
      "cantonDe": "Canton of",
      "aucunImpotSurLesSuccessionsDansCeCanton": "✓ No inheritance tax in this canton",
      "informationsSurLUvre": "Information about the work",
      "valeurVenaleDeLUvreChf": "Fair market value of the work (CHF)",
      "evaluationALaValeurDuMarcheAuJourDu": "Valuation at market value on the date of death",
      "lienAvecLeDefunt": "Relationship to the deceased",
      "conjointPartenaireEnregistre": "Spouse / Registered partner",
      "enfantsPetitsEnfants": "Children / Grandchildren",
      "freresEtSUrs": "Brothers and sisters",
      "dationEnPaiementDisponible": "💡 Transfer in lieu of payment available",
      "leCantonDe": "The canton of",
      "permetDePayerLImpotSurLesSuccessionsEn": "allows inheritance tax to be paid by transferring a work of significant cultural value to the state.",
      "cantonDeVaudLdpi2005": "Canton of Vaud (LDPI 2005)",
      "serviceDesAffairesCulturellesSeracEvalueLInteret": "• The cultural affairs department (SERAC) assesses the cultural interest",
      "enrichissementDesCollectionsDuMuseeCantonal": "• Enrichment of the Cantonal Museum collections",
      "procedureDAgrementRequise": "• Prior approval procedure required",
      "envisagerLaDationEnPaiementPourCetteUvre": "Consider transferring this work in lieu of payment",
      "specificitesDuCanton": "📋 Cantonal specifics",
      "26SystemesDifferents0A50": ": 26 different systems, with rates from 0% to 50%",
      "impotCommunal": "Municipal tax",
      "peutSAjouterALImpotCantonal": ": may be added to cantonal tax",
      "delaiDePaiement": "Payment deadline",
      "generalement30JoursApresNotification": ": generally 30 days after notice",
      "evaluationAuJourDuDecesMarcheSecondaire": ": valuation on the date of death, based on the secondary market",
      "pasDImpotFederal": "No federal inheritance tax",
      "seulsLesCantonsPreleventLImpot": ": inheritance tax is levied only by the cantons",
      "changerDeCanton": "← Change canton",
      "faireEtablirUnInventaireParUnCommissairePriseurOu": "Have an inventory prepared by an auctioneer or expert",
      "montantForfaitaireFaibleEtSimple": "Low and straightforward lump-sum amount",
      "utiliserLeForfaitMobilierStandard": "Use the standard furniture allowance",
      "comparerInventaireVsForfaitSelonValeurReelle": "Compare the inventory with the allowance based on the actual value",
      "consulterUnNotaireOuExpertComptable": "Consult a notary or tax adviser",
      "successionEnFranceArticle764Cgi": "🇫🇷 Estate in France · Article 764 of the French Tax Code",
      "hierarchieLegale1VentePublique2Ans2Inventaire": "Legal hierarchy: 1) Public sale within 2 years → 2) Inventory within 5 years → 3) Insurance policy less than 10 years old → 4) 5% allowance or estimated declaration",
      "informationsSurLaSuccession": "Estate information",
      "valeurTotaleDeLaSuccessionAvantDeductionDesDettes": "Total value of the estate before deducting liabilities",
      "inclutImmobilierPlacementsAutresBiensMobiliers": "Includes real estate, investments and other movable assets",
      "forfaitMobilier5": "5% furniture allowance =",
      "siVousUtilisezLeForfaitLesMeublesUvresSeront": "When the allowance is used, furniture and works of art are valued at no less than this amount.",
      "concernantLUvreAEstimer": "Regarding the work to be valued:",
      "ventePubliqueDansLes2Ans": "Public sale within 2 years",
      "prixDeVenteObligatoireSiVenteAuxEncheresApres": "The auction sale price is mandatory when the sale takes place after death.",
      "dateDeLaVente": "Sale date",
      "prixDeVente": "Sale price (€)",
      "inventaireDansLes5Ans": "Inventory within 5 years",
      "parNotaireCommissairePriseurOuExpert": "Prepared by a notary, auctioneer or expert",
      "dateDeLInventaire": "Inventory date",
      "valeurEstimee": "Estimated value (€)",
      "contratDAssuranceDeMoinsDe10Ans": "Insurance policy less than 10 years old",
      "volIncendieOuDommage": "Theft, fire or damage",
      "dateDuContrat": "Policy date",
      "valeurAssuree": "Insured value (€)",
      "voirLaRecommandation": "View recommendation",
      "recapitulatif": "Summary",
      "valeurTotaleSuccession": "Total estate value",
      "forfaitMobilier547ea06": "5% furniture allowance",
      "valeurInventaire": "Inventory value",
      "recommandation": "Recommendation:",
      "pointsDAttention": "⚠️ Points to consider",
      "lAdministrationFiscalePeutContesterEtDemanderUnePreuve": "The tax authorities may challenge the valuation and request supporting evidence.",
      "distinctionEntreMeublesMeublantsTableauxDOrnementEtObjets": "A distinction is made between household furniture, including decorative paintings, and works of art or collectibles held in a private gallery.",
      "delaisVentePublique2AnsInventaire5AnsAssurance": "Deadlines: public sale within 2 years, inventory within 5 years and insurance policy less than 10 years old.",
      "conserverTousLesJustificatifsFacturesExpertisesContrats": "Keep all supporting documents, including invoices, appraisals and policies.",
      "besoinDUnAccompagnementProfessionnel": "Need professional assistance?",
      "unExpertComptableSpecialiseEnFiscaliteDesSuccessionsOu": "A tax adviser specialising in estates or an auctioneer can help optimise the valuation and avoid costly errors.",
      "modifierLesDonnees": "Edit information",
      "estimationPourSuccession": "Estate valuation",
      "outilDAideALaDeclarationFiscaleSelonVotre": "Tax declaration support tool adapted to your jurisdiction",
      "leModuleDEstimationSuccessionPourCePaysEst": "The estate valuation module for this country is under development.",
      "choisirUnAutrePays": "Choose another country",
      "ressourcesUtiles": "Useful resources",
      "article764DuCodeGeneralDesImpotsFrance": "→ Article 764 of the French General Tax Code",
      "bofipEvaluationDesBiensMeublesFrance": "→ BOFiP guidance on the valuation of movable assets in France",
      "fichePratiqueSuccessionArtkiv": "→ Artkiv practical guide to estates"
    },
    "data": {
      "country": {
        "FR": {
          "name": "France",
          "regulations": "Article 764 of the French Tax Code: 5% flat rate or inventory"
        },
        "BE": {
          "name": "Belgium",
          "regulations": "Market value on the date of death"
        },
        "CH": {
          "name": "Switzerland",
          "regulations": "Rules vary by canton"
        },
        "US": {
          "name": "United States",
          "regulations": "Fair Market Value - IRS"
        },
        "UK": {
          "name": "United Kingdom",
          "regulations": "Probate valuation - HMRC"
        }
      },
      "region": {
        "WAL": {
          "name": "Wallonia",
          "info": "Walloon inheritance tax code"
        },
        "BXL": {
          "name": "Brussels-Capital",
          "info": "Brussels-Capital Region"
        },
        "FLA": {
          "name": "Flanders",
          "info": "Erfbelasting: 2023 reform with expanded payment in kind"
        }
      },
      "canton": {
        "GE": {
          "name": "Geneva",
          "exemption": "Direct descendants and spouses are exempt"
        },
        "VD": {
          "name": "Vaud",
          "exemption": "Children: CHF 250k exempt"
        },
        "ZH": {
          "name": "Zurich",
          "exemption": "Direct descendants are exempt"
        },
        "BE": {
          "name": "Bern",
          "exemption": "Direct descendants and spouses are exempt"
        },
        "VS": {
          "name": "Valais",
          "exemption": "According to the cantonal scale"
        },
        "TI": {
          "name": "Ticino",
          "exemption": "According to the cantonal scale"
        },
        "SZ": {
          "name": "Schwyz",
          "exemption": "No inheritance tax"
        },
        "OW": {
          "name": "Obwalden",
          "exemption": "No inheritance tax"
        }
      }
    },
    "recommendation": {
      "inventory": "Inventory",
      "flatRate": "5% flat rate",
      "toEvaluate": "Further assessment required",
      "savings": "Estimated inheritance-tax saving of {{amount}}"
    }
  },
  "estimationAssurance": {
    "ui": {
      "factureDAchat": "Purchase invoice",
      "expertiseAgreee": "Accredited appraisal",
      "certificatDAuthenticite": "Certificate of authenticity",
      "historiqueProvenance": "Provenance history",
      "uvresComparables": "Comparable works",
      "etatExcellent": "Excellent condition",
      "estimationPourAssurance": "Insurance valuation",
      "constituezUnDossierSolidePourJustifierVotreValeurDeclaree": "Build a robust file to substantiate your declared value",
      "valeurDeclareeVsValeurAgreee": "💡 Declared value vs agreed value",
      "valeurDeclaree": "Declared value",
      "vousEstimezVousMemeLaValeurAvecJustificatifsPlus": ": You estimate the value yourself and provide supporting documents. This is simpler and faster and is recommended up to €80,000.",
      "valeurAgreee": "Agreed value",
      "expertiseParUnProfessionnelAgreeCnesObligatoireAuDela": ": Appraisal by a CNES-accredited professional. Required above €80,000 and recommended for significant works.",
      "quelleMethodeDEvaluationChoisir": "Which valuation method should you choose?",
      "vousEstimezVousMemeAvecDesJustificatifsFactureComparables": "You estimate the value yourself using supporting evidence such as invoices, comparables, photographs and provenance. Artkiv helps you build the file by identifying missing elements.",
      "rapideEtSimple": "✓ Quick and straightforward",
      "recommandeJusquA80000": "✓ Recommended up to €80,000",
      "coutGratuitDansVotreAbonnement": "✓ Cost: free with your subscription",
      "expertRequis": "Expert required",
      "expertiseParUnProfessionnelAgreeCnesChambreNationaleDes": "Appraisal by a CNES-accredited professional. Provides the highest level of assurance for the insurer.",
      "obligatoire80000": "✓ Required above €80,000",
      "reconnueParTousLesAssureurs": "✓ Accepted by all insurers",
      "cout150500SelonUvre": "✓ Cost: €150–€500 depending on the work",
      "votreUvreActuelle": "📊 Your current work",
      "valeurActuelleDansArtkiv": "Current value in Artkiv",
      "expertiseRecommandee": "Appraisal recommended",
      "valeurDeclareeSuffisante": "Declared value is sufficient",
      "changerDeMethode": "Change method",
      "constituerVotreDossierDeJustification": "Build your supporting file",
      "valeurDeclareePourLAssurance": "Declared value for insurance (€)",
      "ex15000": "E.g. 15000",
      "valeurDeRemplacementPrixDAchatInflationMarge10": "Replacement value: purchase price + inflation + 10–20% margin",
      "prixDAchatInitial": "Initial purchase price",
      "ex12000": "E.g. 12000",
      "dateDAchat": "Purchase date",
      "suggestionBaseeSurInflationMargeRemplacement": "💡 Suggestion based on inflation and replacement margin",
      "utiliserCetteValeur": "Use this value",
      "documentsJustificatifs": "📎 Supporting documents",
      "factureDAchatRecuFortementRecommande": "Purchase invoice / Receipt (strongly recommended)",
      "sourcesComparablesOptionnel": "Comparable sources (optional)",
      "exArtpriceChristieSSothebyS": "E.g. Artprice, Christie's, Sotheby's...",
      "etatDeConservation": "Condition",
      "tresBon": "Very good",
      "necessiteRestauration": "Requires restoration",
      "analyserLeDossier": "Analyse the file →",
      "demanderUneExpertiseAgreee": "Request an accredited appraisal",
      "unExpertAgreeCnesPartenaireDArtkivVaEvaluer": "A CNES-accredited expert who partners with Artkiv will assess your work based on:",
      "authenticiteCertificatsProvenanceSignature": "Authenticity: certificates, provenance and signature",
      "etatDeConservationRestaurationsAlterations": "Condition: restorations and alterations",
      "rareteEtDemandeDuMarcheActuel": "Rarity and current market demand",
      "historiqueDeLUvreEtDeLArtiste": "History of the work and the artist",
      "comparablesRecentsVentesAuxEncheresGaleries": "Recent comparables from auctions and galleries",
      "tarifsIndicatifs": "💰 Indicative fees",
      "uvre10000": "Work under €10,000",
      "uvre10k100k": "Work from €10,000 to €100,000",
      "uvre100000": "Work over €100,000",
      "surDevis": "On request",
      "valeurEstimeeOptionnel": "Estimated value (optional)",
      "ex150000": "E.g. 150000",
      "pourOrienterLExpertNonContractuel": "Helps direct the expert; non-binding",
      "messagePourLExpert": "Message to the expert",
      "informationsComplementairesUrgencePreferences": "Additional information, urgency, preferences...",
      "demandeEnvoyeeAuxExpertsArtkiv": "Request sent to the Artkiv experts!",
      "demanderUnDevisExpert": "Request an expert quote",
      "contacterDirectement": "Contact directly",
      "modifierLeDossier": "Edit the file",
      "analyseDeVotreDossier": "Analysis of your file",
      "forceDeJustification": "Strength of supporting evidence",
      "scoreBaseSur": "Score based on",
      "criteres": "criteria",
      "typeDAssuranceRecommande": "Recommended type of insurance",
      "assuranceSpecialiseeObjetDArt": "Specialist fine-art insurance",
      "extensionAssuranceHabitation": "Home insurance extension",
      "primeEstimee": "Estimated premium: approx.",
      "an": "per year",
      "dossierSolide": "✅ Strong file",
      "dossierARenforcer": "⚠️ File needs strengthening",
      "dossierInsuffisant": "❌ Insufficient file",
      "ajoutezUneFactureDAchat": "Add a purchase invoice",
      "cEstLeJustificatifLePlusImportant": ": this is the most important supporting document",
      "expertiseObligatoire": "Appraisal required",
      "votreUvreDepasse80000": ": your work exceeds €80,000",
      "ajoutezDes": "Add",
      "sourcesDeComparables": "comparable sources",
      "artpriceMaisonsDeVentes": "from Artprice or auction houses",
      "completezL": "Complete the",
      "historiqueDeProvenance": "provenance history",
      "dansLaFicheUvre": "in the artwork record",
      "etatMoyenEnvisagezUne": "Average condition: consider",
      "avantAssurance": "before arranging insurance",
      "prochainesEtapes": "Next steps",
      "dossierEnregistreDansLUvre": "File saved to the artwork!",
      "enregistrerDansLUvre": "Save to the artwork",
      "retourALaFiche": "Back to artwork",
      "contacterUnCourtierPartenaire": "Contact a partner broker",
      "aSavoirSurLAssurance": "📋 Insurance essentials",
      "renouvellementExpertise": "Renewing the appraisal",
      "tousLes10AnsArtAncienOu2Ans": ": every 10 years for historic art or every 2 years for contemporary art",
      "couvertureClouAClou": "“Nail-to-nail” cover",
      "protegeDurantTransportEtExpositionTemporaire": ": protects the work during transport and temporary exhibitions",
      "verifiezLeMontantSouvent510DeLaValeur": ": check the deductible amount, often 5–10% of the value",
      "securite": "Security",
      "certainsAssureursExigentAlarmeCoffreOuSurveillance": ": some insurers require an alarm, safe or surveillance system",
      "declarationModification": "Reporting changes",
      "informezVotreAssureurDeTouteRestaurationOuChangementD": ": inform your insurer of any restoration or change in condition",
      "ressourcesUtiles": "Useful resources",
      "expertsPartenairesArtkiv": "Artkiv partner experts",
      "demanderUneMiseEnRelation": "→ Request an introduction",
      "annuaireCnesExpertsAgrees": "→ CNES directory of accredited experts",
      "courtiersSpecialises": "Specialist brokers",
      "nosCourtiersPartenaires": "→ Our partner brokers",
      "guideAssuranceUvresDArt": "→ Guide to insuring works of art",
      "pourLesFamilyOffices": "For family offices:",
      "artkivProposeUnServiceDedieDeGestionPatrimonialeIncluant": "Artkiv offers a dedicated wealth-management service covering appraisal, comprehensive insurance and tax optimisation.",
      "contactezNotreEquipe": "Contact our team",
      "conditionExcellent": "Excellent",
      "conditionGood": "Good",
      "conditionFair": "Fair",
      "franchise": "Deductible",
      "restoration": "restoration"
    }
  },
  "auth": {
    "required": {
      "title": "Sign-in required",
      "text": "Sign in to access your profile."
    },
    "login": "Sign in"
  },
  "sharedDashboard": {
    "common": {
      "untitled": "Untitled",
      "client": "Client",
      "clientNumber": "Client #{{id}}",
      "ownCollection": "My collection"
    },
    "report": {
      "defaultTitle": "Report — {{collection}}",
      "noArtworks": "There are no artworks in this collection.",
      "generateError": "The report could not be generated.",
      "title": "Generate a report",
      "loadingArtworks": "Loading artworks…",
      "artworkCount": "{{count}} artwork in this collection",
      "artworkCount_plural": "{{count}} artworks in this collection",
      "artworkCount_one": "{{count}} artwork in this collection",
      "artworkCount_other": "{{count}} artworks in this collection",
      "titleLabel": "Report title",
      "includedContent": "Included content",
      "options": {
        "title": "Artwork title",
        "artist": "Artist",
        "medium": "Medium",
        "dimensions": "Dimensions",
        "price": "Valuation / Price",
        "location": "Location",
        "thumbnail": "Thumbnails",
        "date": "Report date"
      },
      "coBrandingPrefix": "The report will include your branding if you have added your logo under",
      "profileIdentity": "Profile → Professional identity",
      "cancel": "Cancel",
      "generating": "Generating…",
      "downloadPdf": "Download PDF"
    },
    "tabs": {
      "collections": "Collections ({{count}})",
      "artworks": "Artworks ({{count}})"
    },
    "searchPlaceholder": "Search…",
    "allClients": "All clients",
    "sort": {
      "recentlyUpdated": "Recently updated",
      "recentlyCreated": "Recently created",
      "name": "Name (A-Z)",
      "ascending": "Ascending",
      "descending": "Descending"
    },
    "reload": "Reload",
    "errors": {
      "load": "The shared data could not be loaded."
    },
    "loading": "Loading data…",
    "empty": {
      "collection": "No shared collections",
      "artwork": "No shared artworks"
    },
    "badges": {
      "shared": "SHARED",
      "edit": "EDIT ACCESS",
      "view": "VIEW ONLY"
    },
    "labels": {
      "client": "Client:",
      "modifiedOn": "Updated on {{date}}"
    },
    "actions": {
      "viewCollection": "View collection →",
      "viewArtwork": "View artwork →",
      "reportPdf": "↓ PDF report"
    }
  },
  "sharedPresentation": {
    "errors": {
      "expired": "This presentation link has expired.",
      "invalid": "This presentation link is no longer valid.",
      "generic": "This presentation cannot be accessed."
    },
    "loading": "Loading presentation…",
    "accessDenied": "Access denied",
    "backToArtkiv": "Back to Artkiv"
  },
  "sharePresentationModal": {
    "title": "Share presentation",
    "close": "Close",
    "description": "Create a temporary link to share this collection with your client. They can view the presentation on any device without signing in.",
    "expiryLabel": "Link expiry:",
    "duration": {
      "hour_one": "{{count}} hour",
      "hour_other": "{{count}} hours",
      "day_one": "{{count}} day",
      "day_other": "{{count}} days"
    },
    "generating": "Generating…",
    "generate": "Generate link",
    "scanMobile": "Scan to open on mobile",
    "copied": "✓ Copied",
    "copy": "Copy",
    "expiresOn": "Expires on:",
    "directAccess": "This link provides direct access to the presentation without authentication.",
    "revoke": "Revoke link",
    "errors": {
      "create": "The link could not be generated.",
      "revoke": "The link could not be revoked.",
      "empty": "The sharing link could not be created."
    }
  },
  "sharingSettings": {
    "title": "Shared experts",
    "empty": "No experts currently have shared access"
  },
  "sharedAccessManager": {
    "title": "Shared access",
    "stats": "{{experts}} expert(s) • {{users}} user(s)",
    "loading": "Loading…",
    "empty": "No shared access at the moment",
    "errors": {
      "load": "Shared access could not be loaded.",
      "revoke": "The access could not be removed.",
      "update": "The view or edit permission could not be updated."
    },
    "sections": {
      "experts": "Experts ({{count}})",
      "users": "Other users ({{count}})"
    },
    "fallback": {
      "collection": "Unnamed collection",
      "allCollections": "All collections",
      "user": "User",
      "expert": "Expert"
    },
    "certified": "Certified",
    "sharedCollections": "Shared collections ({{count}})",
    "sharedOn": "Shared on {{date}}",
    "permission": {
      "edit": "Edit",
      "view": "View only",
      "switchConfirm": "Change {{name}}’s permissions for “{{collection}}”?",
      "toView": "Switch to view only",
      "toEdit": "Enable editing"
    },
    "revoke": {
      "collectionConfirm": "Remove {{name}}’s access to “{{collection}}”?",
      "collectionTitle": "Remove this collection",
      "allConfirm": "Remove all access for {{name}}?",
      "allTitle": "Remove all access",
      "button": "Remove"
    },
    "roles": {
      "user": "User",
      "familyOffice": "Family Office",
      "expert": "Expert",
      "team": "Team"
    },
    "plan": "Plan: {{plan}}"
  },
  "sharedCollectionsList": {
    "loading": "Loading…",
    "empty": "No shared collections.",
    "fallbackTitle": "Collection",
    "view": "View collection"
  },
  "artistQuoteTools": {
    "common": {
      "artistPlaceholder": "Artist name"
    },
    "mediums": {
      "huile": "Oil on canvas",
      "huile_sur_toile": "Oil on canvas",
      "aquarelle": "Watercolour",
      "dessin": "Drawing",
      "sculpture": "Sculpture"
    },
    "mediumBreakdown": {
      "title": "Breakdown by medium",
      "averagePrice": "Average price: {{value}}",
      "analyzed": "{{count}} artwork analysed",
      "analyzed_one": "{{count}} artwork analysed",
      "analyzed_other": "{{count}} artworks analysed"
    },
    "formatAnalysis": {
      "title": "Analysis by size",
      "formatLabel": "{{format}} format",
      "formats": {
        "petit": "small",
        "moyen": "medium",
        "grand": "large"
      },
      "averagePrice": "Average price: {{value}} ({{count}} artwork)",
      "averagePrice_one": "Average price: {{value}} ({{count}} artwork)",
      "averagePrice_other": "Average price: {{value}} ({{count}} artworks)",
      "noData": "No data available"
    },
    "trendAlerts": {
      "positive": "🚀 Strong increase: +{{value}}% over the past 6 months.",
      "negative": "📉 Strong decrease: −{{value}}% over the past 6 months."
    },
    "engine": {
      "title": "Artist market value estimate",
      "widthPlaceholder": "Width (cm)",
      "heightPlaceholder": "Height (cm)",
      "mediumLabel": "Medium",
      "periodLabel": "Artistic period",
      "periods": {
        "major": "Major period",
        "minor": "Minor period",
        "neutral": "Neutral period"
      },
      "pricePerSqM": "Average price per m² (€)",
      "estimate": "Estimate: {{value}}"
    },
    "iaAlert": {
      "title": "Create an AI alert",
      "types": {
        "vente_recommandee": "Sale recommended",
        "hausse_cote": "Market value increase",
        "baisse_cote": "Market value decrease"
      },
      "messagePlaceholder": "Alert message",
      "save": "Save alert",
      "saved": "Alert saved.",
      "error": "Unable to save the alert: {{message}}"
    },
    "quoteForm": {
      "title": "Add an artist valuation",
      "averageValue": "Average value (€)",
      "pricePerSqM": "Average price per m² (€)",
      "notesPlaceholder": "Source or comment (e.g. Artprice, 2024 sales…)",
      "save": "Save",
      "success": "Artist valuation saved successfully!",
      "error": "Error: {{message}}"
    },
    "chart": {
      "noData": "No data found for this artist and medium.",
      "title": "Market value trend",
      "averageValue": "Average value"
    },
    "dashboard": {
      "title": "Dashboard: {{artist}}"
    }
  },
  "museumProposalPayment": {
    "loading": "Loading payment",
    "errors": {
      "createPayment": "Unable to create the payment.",
      "payment": "The payment could not be completed."
    },
    "checkout": {
      "processing": "Processing…",
      "pay": "Pay {{amount}} excl. VAT"
    },
    "title": {
      "auction": "Auction placement service",
      "institution": "Institutional placement service"
    },
    "summary": {
      "title": "Request summary",
      "artwork": "Artwork",
      "target": {
        "auction": "Target auction house",
        "institution": "Target institution"
      },
      "service": "Service",
      "serviceName": {
        "auction": "Auction placement",
        "institution": "Institutional placement"
      },
      "initialAmount": "Initial amount",
      "amountExVat": "{{amount}} excl. VAT"
    },
    "partner": {
      "team": "Artkiv team"
    },
    "service": {
      "title": "Service details",
      "partner": "Our partner: {{name}}",
      "partnerDescription": {
        "auction": "A team specialising in auctions and artwork appraisal",
        "institution": "An expert in placing artworks with cultural institutions"
      },
      "includesTitle": "The service includes",
      "includes": {
        "auction": {
          "1": "Artwork assessment and auction-market valuation",
          "2": "Recommendations for the most suitable specialised sales",
          "3": "Introductions to specialist auctioneers",
          "4": "Negotiation of sale terms, including fees and reserve",
          "5": "Follow-up through to the final sale"
        },
        "institution": {
          "1": "Analysis of the artwork and its potential for the target institution",
          "2": "Professional drafting of a tailored presentation letter",
          "3": "Direct contact with curators and acquisition teams",
          "4": "Six months of proposal follow-up",
          "5": "Monthly progress report"
        }
      }
    },
    "pricing": {
      "title": "Pricing",
      "fixed": "Fixed fee: {{amount}} excl. VAT (payable now)",
      "hourly": "Additional work: €80 excl. VAT per hour",
      "commission": {
        "auction": "Commission if sold at auction: variable according to the artwork value, as detailed in the terms of service",
        "institution": "Commission if sold: variable according to the artwork value, as detailed in the terms of service"
      }
    },
    "paymentTitle": "Payment",
    "legal": {
      "acceptance": "By proceeding with payment, you accept our <terms>terms of service</terms>.",
      "additionalInvoices": "Any additional hours will be submitted to you for approval before invoicing."
    }
  },
  "proposalCancelled": {
    "fallbackArtwork": "your artwork",
    "title": "Request cancelled",
    "subtitle": "The service request for {{artwork}} has been cancelled.",
    "noCharge": "Your request was cancelled successfully. You will not be charged.",
    "help": "To submit another request later or ask a question, contact our team.",
    "back": "Back to my dashboard"
  },
  "upcomingAuctions": {
    "loading": "Loading upcoming auctions…",
    "error": "Error: {{message}}",
    "empty": {
      "title": "No upcoming auctions",
      "description": "Upcoming auctions will appear here soon.",
      "text": "Upcoming auctions will appear here."
    },
    "title": "Upcoming auctions",
    "subtitle": "International auction houses · Global top 10",
    "filters": {
      "allHouses": "All auction houses",
      "ariaLabel": "Filter by auction house"
    },
    "saleCount": "{{count}} sale(s)",
    "saleCount_one": "{{count}} sale",
    "saleCount_other": "{{count}} sales",
    "saleCount_plural": "{{count}} sales",
    "topRank": "Top {{rank}}",
    "openWebsite": "Open the {{house}} website",
    "footer": "{{count}} upcoming sale(s) · Updated daily",
    "footer_one": "{{count}} upcoming sale · Updated daily",
    "footer_other": "{{count}} upcoming sales · Updated daily",
    "footer_plural": "{{count}} upcoming sales · Updated daily",
    "allHouses": "All auction houses",
    "salesCount": "{{count}} sales"
  },
  "requireStaff": {
    "checkingAccess": "Checking your access rights…"
  },
  "refPricingAdmin": {
    "title": "Price references (ref_pricing)",
    "newRule": "+ New rule",
    "searchPlaceholder": "Search (movement, medium, artist, source)",
    "refresh": "↻ Refresh",
    "loading": "Loading…",
    "empty": "No rules",
    "page": "Page {{page}}",
    "previous": "Previous",
    "next": "Next",
    "edit": "Edit",
    "delete": "Delete",
    "confirmDelete": "Delete this rule?",
    "deleteError": "Unable to delete the rule: {{message}}",
    "loadError": "Unable to load the rules: {{message}}",
    "sort": {
      "newest": "Newest",
      "oldest": "Oldest",
      "priceDesc": "€/m² ↓",
      "priceAsc": "€/m² ↑",
      "confidenceDesc": "Confidence ↓",
      "confidenceAsc": "Confidence ↑"
    },
    "table": {
      "movement": "Movement",
      "artist": "Artist",
      "medium": "Medium",
      "minCm2": "min cm²",
      "maxCm2": "max cm²",
      "pricePerM2": "€/m²",
      "lowPct": "− %",
      "highPct": "+ %",
      "recency": "Recency",
      "confidence": "Confidence",
      "created": "Created",
      "actions": "Actions"
    },
    "fields": {
      "artistOptional": "Artist (optional)",
      "movement": "Movement",
      "medium": "Medium",
      "minCm2": "min cm²",
      "maxCm2": "max cm²",
      "pricePerM2": "€/m²",
      "lowPct": "− % (low)",
      "highPct": "+ % (high)",
      "recencyMonths": "Recency (months)",
      "sourceNote": "Source / Note",
      "confidence": "Confidence (0–100)"
    },
    "editor": {
      "editTitle": "Edit rule",
      "newTitle": "New rule",
      "close": "Close",
      "save": "Save",
      "saving": "Saving…",
      "saved": "✅ Saved",
      "saveError": "❌ {{message}}"
    }
  },
  "adminInvite": {
    "title": "Invite a team member",
    "email": "Email",
    "submit": "Invite",
    "sending": "Sending…",
    "success": "Invitation sent ✅",
    "errorFallback": "Invitation failed",
    "error": "Error: {{message}}",
    "role": {
      "label": "Role",
      "expert": "Expert",
      "team": "Team",
      "admin": "Administrator"
    },
    "plan": {
      "label": "Plan",
      "standard": "Standard",
      "premium": "Premium"
    },
    "description": "The invitation creates the user from their email address, initializes the profile with the selected role and plan, and marks the profile as approved."
  },
  "estimationComparableForm": {
    "title": "Add a comparable sale",
    "success": "✅ Sale successfully saved in realized_sales",
    "saving": "Saving…",
    "cancel": "Cancel",
    "add": "Add",
    "errors": {
      "missingArtwork": "No artwork is associated with this comparable sale.",
      "insert": "Unable to save the comparable sale: {{message}}"
    },
    "fields": {
      "sourceType": {
        "label": "Source (website, press, etc.)",
        "placeholder": "Sotheby’s, The Art Newspaper, etc."
      },
      "title": "Artwork title",
      "artist": "Artist",
      "estimatedValue": "Estimated value (€)",
      "exactSource": "Exact source (link, citation…)",
      "medium": "Medium / support",
      "dimensions": {
        "label": "Dimensions (cm)",
        "height": "Height",
        "width": "Width",
        "depth": "Depth"
      },
      "comment": "Comment (optional)"
    }
  },
  "pendingProfiles": {
    "loading": "Loading pending profiles…",
    "title": "🛂 Profiles awaiting approval",
    "empty": "No new profiles are awaiting approval.",
    "approve": "✅ Approve",
    "approving": "Approving…",
    "notProvided": "Not provided",
    "contact": "📧 {{email}} | 📞 {{phone}}",
    "createdAt": "Created on: {{date}}",
    "errors": {
      "load": "Unable to load profiles: {{message}}",
      "approve": "Unable to approve this profile: {{message}}"
    }
  },
  "myValidationRequests": {
    "loading": "Loading your requests…",
    "title": "My validation requests",
    "count": "{{count}} request(s)",
    "count_one": "{{count}} request",
    "count_other": "{{count}} requests",
    "count_plural": "{{count}} requests",
    "empty": "You have not submitted any validation requests yet.",
    "createEstimate": "Create an estimate",
    "untitledArtwork": "Untitled artwork",
    "requestedAt": "Requested on {{date}}",
    "status": {
      "pending": "Pending",
      "in_progress": "In progress",
      "completed": "Validated",
      "rejected": "Rejected"
    },
    "method": {
      "label": "Method:",
      "points": "Points method",
      "comparables": "Comparables"
    },
    "cost": {
      "label": "Cost:",
      "free": "Free"
    },
    "expertNotes": "Expert notes:",
    "rejectionReason": "Reason for rejection:",
    "downloadReport": "Download report",
    "processingDelay": "⏱️ Your request is being processed. Estimated time: 48 to 72 business hours.",
    "errors": {
      "load": "Unable to load your requests: {{message}}"
    }
  },
  "icmsSubscription": {
    "title": "Comparable artworks valuation — ICMS",
    "intro": "⚠️ The valuation remains <strong>validated by a human expert</strong>. AI and ICMS calculations provide an explainable and traceable foundation.",
    "common": {
      "untitled": "Untitled",
      "unknownArtwork": "Unknown artwork"
    },
    "errors": {
      "load": "Unable to load the data: {{message}}"
    },
    "alerts": {
      "maxExternal": "You can add up to five external comparables.",
      "selectArtwork": "Select an artwork.",
      "staffFallbackRequired": "Fewer than three comparables: complete the fallback fields (dimensions + €/m²).",
      "clientVerificationRequired": "Fewer than three comparables: request an Artkiv review for a format-based calculation.",
      "humanValidationRequired": "Human validation is required: tick the confirmation box.",
      "notLoggedIn": "User is not signed in.",
      "reportUploadError": "The report could not be uploaded.",
      "requestError": "Unable to save the review request: {{message}}",
      "saveError": "Unable to save the valuation: {{message}}",
      "saved": "ICMS valuation saved and report generated."
    },
    "artwork": {
      "label": "Artwork to value",
      "placeholder": "Select an artwork"
    },
    "internalComparables": {
      "title": "Select internal comparable artworks",
      "noValue": "No estimated value",
      "valuePlaceholder": "Value €",
      "missingValue": "Missing value: request an Artkiv review"
    },
    "externalComparables": {
      "title": "Add external comparables (up to 5)",
      "add": "Add an external comparable artwork",
      "remove": "Remove",
      "fields": {
        "title": "Title",
        "artist": "Artist",
        "source": "Source (website, press)",
        "medium": "Medium",
        "dimensions": "Dimensions",
        "value": "Estimated value (€)",
        "date": "Sale or publication date",
        "comment": "Comment"
      }
    },
    "subscription": {
      "standard": "⚠️ Your plan is <strong>Standard</strong>: the Artkiv team may need to review this valuation.",
      "premium": "✅ Your plan is <strong>Premium</strong>: one Artkiv team review per month is included.",
      "requestVerification": "Request an Artkiv review",
      "requesting": "Submitting request…",
      "requestSaved": "✅ Request saved",
      "lastVerification": "Last review: {{date}}",
      "nextDue": "— Next due date: {{date}}"
    },
    "fallback": {
      "title": "Format-price fallback",
      "active": "Active (fewer than three comparables)",
      "inactive": "Inactive",
      "staffDescription": "Staff only: enter the dimensions and the gallery’s price per square metre. This value is used only for this calculation and remains subject to human validation.",
      "height": "Height (cm)",
      "width": "Width (cm)",
      "basePrice": "Base price (€/m²)",
      "surface": "Area: {{area}} m²",
      "autoSwitch": "As soon as three or more comparables are available, ICMS automatically takes precedence.",
      "clientDescription": "With fewer than three comparables, the format-based calculation must be confirmed by the Artkiv team. Use the review request button above."
    },
    "values": {
      "title": "Calculated values",
      "icmsBase": "ICMS (base):",
      "fmv": "FMV (after adjustments):",
      "retailReplacement": "Retail replacement value (insurance):",
      "succession": "Estate value:"
    },
    "confidence": {
      "title": "Confidence score",
      "volume": "Comparable volume: {{score}}/35",
      "dispersion": "Price dispersion: {{score}}/35",
      "diversity": "Source diversity: {{score}}/10",
      "recency": "Recency (≤ 24 months): {{score}}/20"
    },
    "explain": {
      "title": "Explainable AI — source weighting",
      "description": "These percentages show which sources materially influence the valuation and improve calculation transparency.",
      "factors": {
        "sameArtistNamed": "Recent sales by the same artist ({{artist}})",
        "sameArtist": "Recent sales by the same artist",
        "movementNamed": "Recent {{movement}} sales",
        "similarContemporary": "Recent sales by similar contemporary artists",
        "internalComparables": "Internal comparables (client collection)",
        "otherExternalSales": "Other external sales",
        "aiTrendAdjustment": "AI trend adjustment",
        "expertAdjustment": "Expert adjustment",
        "recentExternalSales": "Recent external sales",
        "aiExpertAdjustment": "AI / expert adjustment"
      }
    },
    "movements": {
      "impressionism": "Impressionism",
      "streetArt": "street art",
      "contemporaryAbstraction": "contemporary abstraction",
      "contemporaryFigurative": "contemporary figurative art",
      "digitalNft": "digital art / NFT",
      "other": "similar movement"
    },
    "advanced": {
      "show": "Show advanced settings",
      "hide": "Hide advanced settings",
      "title": "Weights and adjustments",
      "internalWeight": "Internal comparable weight (%)",
      "externalWeight": "External comparable weight (%)",
      "aiTrend": "AI trend adjustment (%)",
      "expertAdjustment": "Expert adjustment (%)",
      "insuranceMarkup": "Insurance markup (%)",
      "successionDiscount": "Estate discount (%)",
      "hint": "Keep the combined weights close to 100% (internal + external). They are automatically normalized when one comparable family is empty."
    },
    "validation": {
      "label": "I confirm that I have <strong>reviewed and validated</strong> this valuation as an expert or gallery professional."
    },
    "actions": {
      "save": "Save the valuation and generate the PDF",
      "cancel": "Cancel"
    },
    "pdf": {
      "title": "Valuation report — Comparable artworks method (ICMS)",
      "date": "Date: {{date}}",
      "artwork": "Valued artwork: {{title}}",
      "calculatedValues": "Calculated values:",
      "icmsBase": "• ICMS (base): {{value}}",
      "fmv": "• Fair Market Value (after adjustments): {{value}}",
      "retailReplacement": "• Retail replacement value (insurance): {{value}}",
      "successionValue": "• Estate value: {{value}}",
      "fallbackMode": "Format-price fallback enabled — {{area}} m² × {{price}} €/m²",
      "icmsDetails": "ICMS details:",
      "internalMean": "• Robust internal mean: {{value}} — weight {{weight}}%",
      "externalMean": "• Robust external mean: {{value}} — weight {{weight}}%",
      "adjustments": "• AI trend adjustment: {{ai}}% — Expert adjustment: {{expert}}%",
      "markups": "• Insurance markup: +{{insurance}}% — Estate discount: −{{succession}}%",
      "confidenceBreakdown": "Confidence score — breakdown:",
      "volume": "• Comparable volume: {{score}}/35",
      "dispersion": "• Price dispersion: {{score}}/35",
      "diversity": "• Source diversity: {{score}}/10",
      "recency": "• Recency (≤ 24 months): {{score}}/20",
      "explainability": "AI explanation:",
      "factorLine": "• {{weight}}% — {{label}}",
      "internalComparables": "Internal comparables:",
      "externalComparables": "External comparables:",
      "comparableLine": "• {{title}} — {{artist}} {{date}} — {{value}} — {{source}}"
    }
  },
  "artworkImages": {
    "alt": {
      "main": "Main artwork image",
      "primary": "Main image",
      "thumbnail": "Thumbnail {{id}}",
      "view": "View {{id}}"
    },
    "selected": "Selected",
    "primary": "Primary",
    "addImage": "Add an image",
    "deleteConfirm": "Delete this image?",
    "deleteTitle": "Delete this image",
    "formats": "Supported formats: JPEG, PNG, WEBP",
    "limit": "Limit: 10 images (30 MB maximum per image)"
  },
  "artworkImageManager": {
    "quotaReached": "You have reached the maximum number of images allowed by your plan.",
    "onlyRemaining": "Only {{count}} additional image(s) can be added with your plan.",
    "uploadPrompt": "Drop your images here or click to add them",
    "uploadDisabled": "Image uploads are disabled",
    "formats": "Supported formats: JPEG, PNG, WEBP",
    "usage": "Images used: {{count}} / {{max}}",
    "unlimited": "unlimited",
    "familyOfficeNote": "With the Family Office plan, only your clients can add or edit images. You have a consolidated view.",
    "artworkAlt": "Artwork",
    "primary": "Primary",
    "setCover": "Set as cover",
    "deletePrimaryConfirm": "Delete the primary image? Another image will automatically become primary.",
    "deleteConfirm": "Delete this image?"
  },
  "artworkNft": {
    "title": "NFT & blockchain",
    "subtitle": "Record the blockchain details of an already-tokenized artwork",
    "info": {
      "title": "Blockchain at ARTKIV",
      "body": "This tab records the details of an already-tokenized artwork (NFT or on-chain certificate). ARTKIV also timestamps a SHA-256 fingerprint of the record; public anchoring (e.g. Tezos) and minting via a partner are not active yet.",
      "fingerprintCta": "View the ARTKIV digital fingerprint"
    },
    "smartstamp": {
      "title": "Blockchain certification",
      "body": "This artwork has not yet been certified. You can use our partner SmartStamp to create a secure blockchain certification.",
      "cta": "Discover SmartStamp"
    },
    "certificationType": "Certification type",
    "types": {
      "digital": {
        "label": "Digital artwork",
        "description": "Authenticated digital artistic creation"
      },
      "certificate": {
        "label": "Certificate of authenticity",
        "description": "Blockchain certification for a physical artwork"
      },
      "hybrid": {
        "label": "Hybrid artwork",
        "description": "A fusion of physical and digital art"
      }
    },
    "blockchainOther": "Other blockchain",
    "contractAddress": "Contract address",
    "tokenId": "Token ID",
    "tokenPlaceholder": "Token identifier",
    "provider": "Provider",
    "providerSelect": "Select a provider",
    "providerOther": "Other",
    "mintDate": "Creation date",
    "explorerLink": "Explorer link",
    "linkedPhysicalTitle": "Linked to a physical artwork",
    "linkedPhysicalDescription": "This certification corresponds to a physical artwork",
    "certificateTitle": "Blockchain certificate"
  },
  "artworkLocationTab": {
    "lossTypes": {
      "vol": "Theft",
      "perte": "Loss",
      "destruction": "Destruction",
      "incendie": "Fire",
      "inondation": "Flood",
      "autre": "Other"
    },
    "locationTypes": {
      "museum": "Museum",
      "gallery": "Gallery",
      "home": "Home",
      "residence": "Residence",
      "warehouse": "Warehouse",
      "storage": "Storage",
      "loan": "Loan",
      "exhibition": "Exhibition",
      "other": "Other"
    },
    "lossModal": {
      "badge": "Declaration",
      "title": "Loss · Theft · Destruction",
      "untitled": "Untitled artwork",
      "successTitle": "Declaration saved",
      "successBody": "Open the Loss & Theft module to access the full report.",
      "eventType": "Event type",
      "eventDate": "Event date",
      "declaredValue": "Declared value (€)",
      "estimatedValue": "Estimated value",
      "location": "Location at the time of the event",
      "locationPlaceholder": "E.g. main residence, Gallery XY…",
      "policeReport": "Police report filed",
      "policeRef": "Police report number",
      "insuranceClaim": "Insurance claim",
      "insuranceRef": "Claim reference",
      "indemnity": "Indemnity received (€)",
      "notes": "Additional notes",
      "notesPlaceholder": "Circumstances, witnesses, attached documents…",
      "fiscalNote": "Tax note — In France, losses and thefts of artworks may be deductible under certain conditions. A police report is generally required. Consult your notary or accountant.",
      "error": "An error occurred while saving.",
      "cancel": "Cancel",
      "saving": "Saving…",
      "save": "Save declaration"
    },
    "lossStatus": {
      "incident": "Incident",
      "declared": "Artwork declared: {{type}}",
      "police": "Police report filed"
    },
    "loan": {
      "outgoing": "On outgoing loan",
      "contact": "Contact: {{value}}",
      "from": "From {{date}}",
      "to": "to {{date}}",
      "agreementRef": "Agreement ref.: {{value}}",
      "borrowerLocation": "The artwork is currently located at the borrowing institution. Define its usual storage location once the loan ends."
    },
    "currentLocation": "Current location",
    "hiddenLocation": "This artwork is linked to a location defined by your client. Your current permissions do not allow you to view or edit its details.",
    "noLocation": "No location has been defined for this artwork.",
    "defineLocation": "Define a location",
    "declareLoss": "Declare a loss · theft · destruction",
    "change": "Change",
    "fields": {
      "address": "Address",
      "city": "City",
      "country": "Country",
      "contact": "Contact",
      "email": "Email",
      "phone": "Phone",
      "notes": "Notes"
    },
    "history": "Location history",
    "available": "Other available locations",
    "viewAll": "View all locations ({{count}})",
    "manage": "Manage my locations"
  },
  "artworkComparables": {
    "methods": {
      "cup_alleges": "Streamlined comparative method (summary)",
      "cup_complet": "Full CUP method (documented comparable)",
      "cup_ifrs": "CUP — IFRS 13 / BOFiP"
    },
    "saveError": "Save error: {{message}}",
    "unknownError": "Unknown error",
    "title": "CUP appraisal",
    "subtitle": "Comparable Uncontrolled Price method, compliant with IFRS 13 / BOFiP",
    "saved": "Saved",
    "save": "Save appraisal",
    "expertValueSection": "Expert fair market value",
    "estimatedValue": "Estimated value (€ excl. tax)",
    "estimatedPlaceholder": "E.g. 4500",
    "method": "Method",
    "select": "Select…",
    "expertDate": "Appraisal date",
    "range": "±10% range:",
    "comparablesAverage": "Comparable average:",
    "gapWarning": "Difference greater than 30% compared with the comparables",
    "comparablesTitle": "Comparable sales ({{count}}/3 minimum)",
    "addComparable": "Add a comparable",
    "empty": "No comparables entered. Add at least 3 reference sales.",
    "firstComparable": "First comparable",
    "comparable": "Comparable {{number}}",
    "auctionHouse": "Auction house",
    "auctionHousePlaceholder": "E.g. Christie’s, Artcurial, Millon…",
    "saleDate": "Sale date",
    "soldArtwork": "Title / description of the sold artwork",
    "soldArtworkPlaceholder": "E.g. signed lithograph, 45 × 60 cm, edition of 20",
    "hammerPrice": "Hammer price (€)",
    "hammerPricePlaceholder": "E.g. 3800",
    "adjustment": "Adjustment (%)",
    "adjustmentPlaceholder": "E.g. -10 or +5",
    "adjustedValue": "Adjusted value",
    "adjustmentNote": "Adjustment note / rationale",
    "adjustmentNotePlaceholder": "E.g. smaller format, fair condition, declining market",
    "expertNote": "Expert note (included in the report)",
    "expertNotePlaceholder": "Observations on condition, rarity, market and provenance… This note will be included in the CUP report sheet.",
    "complete": "CUP sheet complete and ready for the report.",
    "missingValue": "fair market value missing",
    "missingComparables": "{{count}} comparable(s) missing",
    "incomplete": "Incomplete sheet: {{reason}}."
  },
  "artworkProvenance": {
    "title": "Provenance",
    "add": "Add an item",
    "empty": "No provenance item has been recorded.",
    "edit": "Edit",
    "delete": "Delete",
    "types": {
      "direct_artiste": "Direct from artist",
      "echange_production": "Exchange / production",
      "galerie": "Gallery",
      "vente_privee": "Private sale",
      "encheres": "Auction",
      "succession": "Inheritance / estate",
      "don": "Gift",
      "collection_privee": "Private collection",
      "autre": "Other"
    }
  },
  "artworkSpecifications": {
    "sections": {
      "dimensions": "Artwork dimensions",
      "framed": "Framed dimensions",
      "paper": "Paper dimensions",
      "duration": "Duration"
    },
    "hints": {
      "dimensions": "The artwork alone, without frame or margins (the “view”).",
      "framed": "Overall size, frame included — useful for hanging, shipping and insurance.",
      "paper": "Works on paper: dimensions of the full sheet, often larger than the image."
    },
    "fields": {
      "height": "Height",
      "width": "Width",
      "depth": "Depth",
      "unit": "Unit",
      "framedHeight": "Framed height",
      "framedWidth": "Framed width",
      "framedDepth": "Framed depth",
      "frameUnit": "Frame unit",
      "paperHeight": "Paper height",
      "paperWidth": "Paper width",
      "paperUnit": "Paper unit"
    },
    "swapTitle": "Swap height and width",
    "swap": "Swap H/W",
    "units": {
      "inches": "inches"
    },
    "durationPlaceholder": "E.g. 12 min 30 sec, video loop, temporary performance…"
  },
  "artworkDocumentsTab": {
    "view": "View",
    "loading": "Loading…",
    "openError": "Unable to open this document. Please try again.",
    "title": "Documents",
    "deleteConfirm": "Delete this document?",
    "types": {
      "certificate": "Certificate of authenticity",
      "invoice": "Invoice",
      "condition_report": "Condition report",
      "exhibition": "Exhibition documents",
      "photo": "High-resolution photograph",
      "other": "Other"
    },
    "loan": {
      "title": "Outgoing loan agreement",
      "noReference": "No reference",
      "institution": "Institution",
      "location": "Location",
      "contact": "Contact",
      "start": "Start",
      "end": "Expected end",
      "conditions": "Conditions",
      "empty": "Artwork on loan. Enter the institution and dates from the Edit screen."
    },
    "lot": {
      "title": "Lot documents — {{title}}",
      "add": "Add to lot",
      "referenceAlt": "Lot reference",
      "referenceTitle": "Reference photograph (lot)",
      "referenceSubtitle": "Image shared by all copies",
      "empty": "No shared document for this lot.",
      "remove": "Remove from lot"
    },
    "aiScore": "AI score:",
    "certificate": {
      "missingTitle": "Certificate of authenticity missing",
      "missingBody": "Add a certificate to increase the value and traceability of your artwork.",
      "classicTitle": "Traditional certificate detected",
      "classicBody": "Strengthen its protection with a dated, tamper-proof proof of authenticity.",
      "blockchainTitle": "Proof of authenticity validated",
      "blockchainBody": "Your artwork has tamper-proof proof of authenticity{{blockchain}}."
    },
    "empty": "No document is associated with this artwork",
    "addedOn": "Added on {{date}}",
    "reclassify": "Change category",
    "add": "Add a document"
  },
  "ocrEnrich": {
    "fields": {
      "year": "Year",
      "dimensions": "Dimensions",
      "medium": "Medium / technique",
      "mediumCategory": "Category",
      "acquisitionPrice": "Acquisition price",
      "acquisitionType": "Acquisition type",
      "acquisitionDate": "Acquisition date",
      "seller": "Donor / seller",
      "buyer": "Beneficiary / buyer",
      "title": "Title",
      "artist": "Artist",
      "signature": "Signature",
      "authentication": "Certificate / authentication",
      "signatureNotes": "Signature notes",
      "auctionHouse": "Auction house",
      "auctionSaleName": "Sale name",
      "auctionSaleDate": "Sale date",
      "auctionLotNumber": "Lot number",
      "auctionHammerPrice": "Hammer price (€)",
      "auctionFees": "Buyer’s premium and fees"
    },
    "mediumCategory": {
      "painting": "Painting",
      "photography": "Photography",
      "sculpture": "Sculpture",
      "print": "Print",
      "drawing": "Drawing",
      "work_on_paper": "Work on paper",
      "mixed_media": "Mixed media",
      "installation": "Installation",
      "film_video": "Film / video",
      "digital": "Digital art",
      "ceramics": "Ceramics",
      "textile": "Textile",
      "design": "Design",
      "other": "Other"
    },
    "button": {
      "title": "Extract metadata from the artwork’s PDF documents",
      "analyzing": "Analyzing…",
      "enrich": "Enrich with OCR"
    },
    "documentTypes": {
      "invoice": "Invoice / Auction receipt / Donation or exchange deed",
      "certificate": "Certificate of authenticity",
      "condition_report": "Condition report",
      "exhibition": "Exhibition document",
      "other": "Other"
    },
    "modal": {
      "title": "Fields extracted by OCR",
      "subtitle": "Select the fields to apply to the artwork record"
    },
    "sections": {
      "documentsAnalyzed": "Documents analyzed",
      "auction": "Auction sale"
    },
    "documents": {
      "changeCategory": "Change category",
      "rerun": "↺ Run the analysis again with corrected types",
      "untitled": "Document"
    },
    "confidence": {
      "title": "OCR confidence score",
      "description": "The score combines source quality, invoice-to-artwork matching, and any inconsistencies detected.",
      "level": {
        "veryHigh": "Very high",
        "high": "High",
        "medium": "Medium",
        "careful": "Use caution"
      }
    },
    "dimensions": {
      "warningTitle": "Dimension discrepancy detected",
      "record": "Record:",
      "document": "Invoice:",
      "differenceEachSide": "Difference of {{diff}} cm on each side —",
      "recordLikelyFramed": "The record probably includes the frame (overall dimensions).",
      "documentLikelyFramed": "The invoice probably includes the frame.",
      "mismatch": "The dimensions do not match. Check them before applying.",
      "applyQuestion": "Apply the invoice dimensions to the artwork record?",
      "yesApply": "Yes, apply {{dimensions}}",
      "noKeep": "No, keep {{dimensions}}",
      "confirmed": "The invoice dimensions will be applied",
      "rejected": "Dimensions unchanged. Check them manually.",
      "confirmationRequired": "⚠ confirmation required above",
      "onlyWarning": "No other fields need updating. Review the dimension discrepancy above."
    },
    "titleTechnicalWarning": "⚠ technical description detected",
    "actions": {
      "saving": "Saving…",
      "applied": "Applied",
      "applyCount": "Apply {{count}} field{{plural}}"
    },
    "alerts": {
      "noNewInfo": "OCR found no new information in these documents.",
      "ocrError": "OCR error: {{message}}",
      "noFieldSelected": "No field selected.",
      "noPatch": "No usable data remained after normalization.",
      "saveError": "Save error: {{message}}"
    },
    "errors": {
      "urlInaccessible": "Document unavailable: {{name}}",
      "readFailed": "The document could not be read ({{status}})",
      "emptyDocument": "The document is empty or unreadable."
    }
  },
  "servicesCuratorialPage": {
    "back": "← Back",
    "title": "Curatorial guidance",
    "intro": "Give your collection a <strong>curatorial perspective</strong>: thematic directions, coherent titles, relevant <strong>keywords</strong> and editorial framing. This work structures your artwork records and <strong>supports long-term valuation</strong>.",
    "pricing": {
      "title": "Paid service, quoted individually",
      "description": "Our partner experts will provide a <strong>personalized quote</strong> based on the scope of the assignment. You remain free to accept or decline it after receiving the quote."
    },
    "scope": {
      "label": "Scope",
      "collection": "Entire collection"
    },
    "goals": {
      "label": "Primary objective",
      "options": {
        "structure": "Structure my collection (themes, titles and keywords)",
        "presentation": "Prepare a presentation or display",
        "narrative": "Create a narrative and editorial storyline",
        "audit": "Complete curatorial audit",
        "other": "Other, described below"
      }
    },
    "details": {
      "label": "Details / context",
      "placeholder": "For example: focus on contemporary photography, a decade-by-decade direction, thematic indexing…",
      "startingPoint": "Starting point: artwork {{id}}"
    },
    "expert": {
      "label": "Expert selection",
      "auto": {
        "title": "Let Artkiv select for me",
        "description": "We will suggest the expert best suited to your collection."
      },
      "choose": {
        "title": "I will choose my expert",
        "description": "Browse our directory of certified experts."
      },
      "loading": "Loading experts…",
      "empty": "No experts are currently available.",
      "generic": "Expert",
      "directory": "View the full expert directory"
    },
    "contact": {
      "email": "Contact email",
      "preference": "Preferred contact method",
      "methods": {
        "email": "Email",
        "phone": "Phone",
        "video": "Video call"
      }
    },
    "submit": {
      "send": "Send request",
      "sending": "Sending…"
    },
    "error": {
      "generic": "An error occurred. Please try again."
    },
    "success": {
      "title": "Request sent ✓",
      "artwork": "Thank you. Our <strong>partner curatorial team</strong> will review your needs and contact you within <strong>48 hours</strong> with a <strong>personalized quote</strong> for this artwork.",
      "collection": "Thank you. Our <strong>partner curatorial team</strong> will review your needs and contact you within <strong>48 hours</strong> with a <strong>personalized quote</strong> for your entire collection.",
      "backCollection": "Return to my collection"
    },
    "note": "Note: this guidance is provided by selected <strong>partner experts</strong>. You will receive a personalized quote within 48 hours and remain free to accept or decline it."
  },
  "servicesValuationPage": {
    "back": "← Back",
    "title": "Request an expert valuation",
    "intro": "Send this artwork to a <strong>partner expert</strong> — one you choose, or one Artkiv suggests — to get a <strong>reasoned valuation</strong>, distinct from our self-service valuation tools.",
    "pricing": {
      "title": "Paid service, quoted individually",
      "description": "The partner expert will provide a <strong>personalized quote</strong> based on the scope of the assignment. You remain free to accept or decline it after receiving it."
    },
    "artwork": {
      "label": "Artwork concerned",
      "unknown": "Selected artwork"
    },
    "purpose": {
      "label": "Purpose of the valuation",
      "options": {
        "sale": "Preparing a sale",
        "insurance": "Insurance",
        "succession": "Estate / inheritance planning",
        "donation": "Donation",
        "other": "Other, described below"
      }
    },
    "details": {
      "label": "Details / context",
      "placeholder": "For example: history, known provenance, urgency, documents already in hand…"
    },
    "expert": {
      "label": "Expert selection",
      "auto": {
        "title": "Let Artkiv select for me",
        "description": "We will suggest the expert best suited to this artwork."
      },
      "choose": {
        "title": "I will choose my expert",
        "description": "Browse our directory of partner experts."
      },
      "loading": "Loading experts…",
      "empty": "No experts are currently available.",
      "generic": "Expert",
      "noAccountHint": "Listed expert without an Artkiv account — the Artkiv team will contact them manually.",
      "directory": "View the full expert directory"
    },
    "contact": {
      "email": "Contact email",
      "preference": "Preferred contact method",
      "methods": {
        "email": "Email",
        "phone": "Phone",
        "video": "Video call"
      }
    },
    "submit": {
      "send": "Send request",
      "sending": "Sending…"
    },
    "error": {
      "generic": "An error occurred. Please try again."
    },
    "success": {
      "title": "Request sent ✓",
      "body": "Thank you! Your request has been sent to the <strong>partner expert</strong> (or to our team if they don't yet have an Artkiv account). You will receive a <strong>personalized quote</strong> within 48 hours.",
      "backArtwork": "Return to the artwork record",
      "backCollection": "Return to my collection"
    },
    "note": "Note: this valuation is carried out by a <strong>partner expert</strong>, distinct from the Artkiv team. You will receive a personalized quote within 48 hours and remain free to accept or decline it."
  },
  "teamAuctionHouses": {
    "title": "Auction houses",
    "searchPlaceholder": "Search by name, city, country or website",
    "refresh": "Refresh",
    "creating": "Creating…",
    "add": "Add",
    "loading": "Loading…",
    "saving": "Saving…",
    "save": "Save",
    "empty": "No results",
    "fields": {
      "name": "Name",
      "nameRequired": "Name *",
      "city": "City",
      "country": "Country",
      "website": "Website",
      "websitePlaceholder": "Website (https://…)",
      "topTen": "Top 10",
      "rank": "Rank",
      "active": "Active",
      "action": "Action"
    }
  },
  "proposeMuseum": {
    "common": {
      "loading": "Loading…",
      "untitled": "Untitled"
    },
    "auth": {
      "title": "Sign-in required",
      "description": "Please sign in to propose an artwork.",
      "login": "Sign in"
    },
    "title": "Propose an artwork",
    "subtitle": "Submit your artwork to an institution or auction house.",
    "type": {
      "title": "What is your goal?",
      "auctionNote": "A sale follows a distinct path: estimate, reserve, fees and schedule. Museum fields are not requested.",
      "institution_gift": { "title": "Gift or bequest", "description": "Propose an entry into a permanent collection." },
      "institution_loan": { "title": "Exhibition loan", "description": "Respond to a temporary curatorial project." },
      "auction_sale": { "title": "Auction sale", "description": "Request appraisal, estimate and consignment." },
      "museum": {
        "title": "Museum / Institution",
        "description": "A temporary or permanent exhibition to enhance the visibility of your artwork."
      },
      "auction": {
        "title": "Auction house",
        "description": "An auction sale designed to achieve the best possible positioning."
      }
    },
    "institutionType": {
      "label": "Institution type",
      "options": { "museum": "Museum", "foundation": "Foundation", "frac": "Art centre / FRAC", "university": "University", "public": "Hospital / public body", "other": "Other" }
    },
    "contact": {
      "name": "Identified contact",
      "namePlaceholder": "Name (optional)",
      "role": "Role",
      "rolePlaceholder": "Curatorial, acquisitions…"
    },
    "missionFit": {
      "label": "Fit with the institution's mission and collections",
      "placeholder": "What gap, scholarly focus or curatorial project does this artwork genuinely serve?"
    },
    "provenance": {
      "label": "Provenance and title of ownership",
      "placeholder": "Ownership history, invoice, certificate, elements still to verify…",
      "ownership": "I confirm I own or am mandated to propose this artwork."
    },
    "documents": {
      "label": "Documents already available",
      "items": { "images": "High-resolution images", "invoice": "Invoice / proof of ownership", "provenance": "Documented provenance", "condition": "Condition report", "authenticity": "Certificate / authenticity opinion", "valuation": "Independent valuation" }
    },
    "restrictions": {
      "label": "Envisaged conditions",
      "hint": "Institutions generally prefer gifts without excessive restrictions.",
      "options": { "none": "No particular restriction", "credit_line": "Credit line requested", "display_request": "Display wish (not guaranteed)", "other": "Other conditions to discuss" }
    },
    "artwork": {
      "label": "Your artwork",
      "loading": "Loading artworks…",
      "empty": "No artworks are available. Add artworks to your collection first.",
      "select": "Select an artwork"
    },
    "institution": {
      "auctionLabel": "Auction house",
      "museumLabel": "Target institution",
      "auctionPlaceholder": "For example: Christie’s, Sotheby’s…",
      "museumPlaceholder": "For example: Centre Pompidou, MoMA…"
    },
    "message": {
      "label": "Presentation message",
      "auctionPlaceholder": "Information about the artwork, its provenance and condition…",
      "museumPlaceholder": "Why does this artwork deserve to be exhibited?"
    },
    "museum": {
      "artistBio": "Artist biography",
      "artistBioPlaceholder": "Career, exhibitions and biographical information…",
      "artworkDescription": "Artwork description",
      "artworkDescriptionPlaceholder": "Technique, dimensions and context of creation…",
      "relevance": "Artistic / curatorial relevance",
      "relevancePlaceholder": "Why would this artwork belong in the target institution?"
    },
    "exhibitions": {
      "title": "Exhibition history",
      "close": "Close",
      "add": "Add an exhibition",
      "delete": "Delete",
      "save": "Save exhibition",
      "fields": {
        "title": "Exhibition title",
        "venue": "Venue / institution",
        "location": "City / country",
        "description": "Description"
      }
    },
    "auction": {
      "estimateLabel": "Target estimate",
      "estimatePlaceholder": "For example: 12,000",
      "reserveLabel": "Reserve price",
      "reservePlaceholder": "For example: 9,000",
      "reserveHint": "Minimum price below which the artwork is not sold (optional)."
    },
    "services": {
      "title": "Expert service",
      "service": "Service",
      "clientRate": "Client fee, excl. VAT",
      "expertCost": "Expert cost, excl. VAT",
      "expertService": "Expert service",
      "selectedExpert": "Selected expert",
      "defaultDescription": "Institutional placement, €500 excl. VAT flat fee"
    },
    "expert": {
      "label": "Partner expert",
      "select": "Select an expert…",
      "directory": "View the directory"
    },
    "sendMethod": {
      "title": "Delivery method",
      "professional": {
        "title": "Professional service, €500 excl. VAT",
        "auctionDescription": "Our expert negotiates on your behalf and follows the proposal for six months.",
        "museumDescription": "Our expert submits your artwork and follows the proposal for six months."
      },
      "self": {
        "title": "I will manage it myself, free",
        "description": "Receive the formatted proposal by email and manage the contacts yourself."
      },
      "emailLabel": "Your email",
      "emailPlaceholder": "email@example.com"
    },
    "submit": {
      "toPayment": "Continue to payment",
      "send": "Send proposal"
    },
    "alerts": {
      "exhibitionRequired": "Please enter at least the exhibition title and venue.",
      "selectArtwork": "Please select an artwork.",
      "selectExpert": "Choose an expert before continuing.",
      "createFailed": "The proposal could not be created.",
      "submitError": "Submission error: {{message}}",
      "unknownError": "Unknown error"
    },
    "payment": {
      "title": "Secure payment",
      "description": "Complete the assignment to launch the institutional proposal.",
      "amountExclTax": "Amount excl. VAT",
      "vat": "VAT 20%",
      "totalInclTax": "Total incl. VAT",
      "processing": "Processing…",
      "pay": "Pay {{amount}} excl. VAT",
      "createError": "The payment could not be created.",
      "genericError": "Payment error."
    },
    "history": {
      "title": "Your proposal history",
      "museum": "Institution",
      "auction": "Auction",
      "type": { "institution_gift": "Gift / bequest", "institution_loan": "Exhibition loan", "auction_sale": "Auction sale", "museum": "Institution", "auction": "Auction", "other": "Proposal" },
      "status": {
        "pending": "Pending",
        "paid": "Paid",
        "awaitingPayment": "Payment required"
      }
    }
  },
  "supportImportCancel": {
    "title": "Payment canceled",
    "description": "You can try again at any time from the assisted import page.",
    "back": "Return to assisted import"
  },
  "supportImportSuccess": {
    "title": "Thank you!",
    "description": "Your payment has been confirmed. An Artkiv expert will contact you.",
    "dashboard": "Back to dashboard"
  },
  "stripeSuccess": {
    "title": "Payment successful!",
    "description": "Your ARTKIV subscription is now active.",
    "redirect": "Redirecting to your personal area…"
  },
  "newsletterUnsubscribe": {
    "loading": "Processing…",
    "successTitle": "Unsubscribed successfully",
    "successDescription": "You have been unsubscribed from our newsletter.",
    "errorTitle": "Error",
    "errorDescription": "An error occurred while unsubscribing."
  },
  "pendingApproval": {
    "title": "Awaiting approval",
    "thanks": "Thank you for registering with Artkiv.",
    "reviewing": "Your account is currently being reviewed by our team.",
    "delayWarning": "⚡ If you have not heard from us within 48 hours,",
    "contact": "please contact us at {{email}}.",
    "emailNotice": "You will receive an email as soon as your account is activated."
  },
  "authCallback": {
    "verifyingEmail": "Verifying your email…",
    "invalidSession": "Invalid session, redirecting…",
    "emailConfirmed": "Email confirmed! Checking your subscription…",
    "subscriptionFound": "Subscription found, redirecting…",
    "redirectPayment": "Redirecting to payment…",
    "error": "Error: {{message}}",
    "pleaseWait": "Please wait…"
  },
  "updatePassword": {
    "title": "New password",
    "newPassword": "New password",
    "newPasswordPlaceholder": "At least {{count}} characters",
    "confirmPassword": "Confirm password",
    "confirmPasswordPlaceholder": "Confirm your password",
    "updating": "Updating…",
    "submit": "Update password",
    "success": "✅ Password updated successfully!",
    "errors": {
      "mismatch": "The passwords do not match.",
      "tooShort": "The password must contain at least {{count}} characters.",
      "generic": "An error occurred while updating the password."
    }
  },
  "emailConfirmationWaiting": {
    "defaultEmail": "your address",
    "title": "Confirm your email address",
    "sentTo": "We sent a confirmation link to",
    "stepInboxTitle": "Step 1: Check your inbox",
    "stepInboxDescription": "Open your email and click the confirmation link we sent you.",
    "spamTitle": "Check your spam folder",
    "spamDescription": "If you cannot see our email, check your spam or junk folder.",
    "stepPaymentTitle": "Step 2: Complete your payment",
    "stepPaymentDescription": "After confirming your email, you will be redirected automatically to Stripe to complete your subscription.",
    "notReceived": "Didn’t receive the email?",
    "sending": "Sending…",
    "retryIn": "Try again in {{seconds}}s",
    "resend": "Resend confirmation email",
    "success": "✓ Email resent successfully!",
    "error": "✗ The email could not be sent. Please try again.",
    "importantLabel": "Important:",
    "importantDescription": "You will not be able to access your personal area until your email is confirmed and your subscription is completed.",
    "needHelp": "Need help?",
    "contactSupport": "Contact support",
    "backToLogin": "Back to login"
  },
  "supportTicketDetail": {
    "back": "Back",
    "notFound": "Ticket not found.",
    "dashboard": "Dashboard",
    "priority": "Priority: {{value}}",
    "channel": "Channel: {{value}}",
    "mode": "Mode: {{value}}",
    "createdAgo": "Created {{count}} day(s) ago",
    "createdAgo_one": "Created {{count}} day ago",
    "createdAgo_other": "Created {{count}} days ago",
    "client": "Client: #{{id}}",
    "markResolved": "Mark as resolved",
    "message": "Message",
    "metadata": "Metadata",
    "status": {
      "open": "Open",
      "pending": "Pending",
      "sent": "Sent",
      "resolved": "Resolved",
      "closed": "Closed",
      "canceled": "Canceled"
    }
  },
  "supportImportPage": {
    "title": "Expert-assisted import",
    "introStandard": "Let us import your artworks from a spreadsheet or document. {{price}} for a standard import.",
    "introExtended": "For larger volumes: {{hourlyPrice}} per hour.",
    "requesterEmail": "Your email (billing / contact)",
    "collectorEmail": "Collector email",
    "importType": "Import type",
    "scope": {
      "standard": "Standard — {{price}}",
      "extended": "Extended — {{hourlyPrice}}/h"
    },
    "estimatedHours": "Estimated number of hours",
    "fileLabel": "File (CSV/XLSX/DOCX/PDF) — optional",
    "fileHelp": "You can also send it to us later if the file is large.",
    "notesLabel": "Useful details (number of entries, specific requirements…)",
    "estimatedAmount": "Estimated amount:",
    "amountInclTax": "{{amount}} incl. VAT",
    "redirecting": "Redirecting…",
    "pay": "Proceed to payment",
    "details": {
      "standardTitle": "Standard ({{price}}):",
      "standardDescription": "structured file (CSV/XLSX) or a simple Doc/PDF list of reasonable size.",
      "extendedTitle": "Extended ({{hourlyPrice}}/h):",
      "extendedDescription": "large unstructured lists, multiple sources, or substantial data cleanup."
    },
    "afterPayment": "After payment, an Artkiv expert handles your import, sends you a review preview and finalizes the integration.",
    "errors": {
      "emailsRequired": "Requester and collector email addresses are required.",
      "hoursRequired": "Enter a number of hours greater than or equal to 1.",
      "checkoutNotCreated": "The checkout session could not be created.",
      "generic": "An error occurred."
    }
  },
  "intergenerationalMatchingPage": {
    "title": "Intergenerational matching test",
    "matchAlert": "✅ Pass “{{artwork}}” on to {{heir}}",
    "rejectLog": "❌ “{{artwork}}” rejected for {{heir}}",
    "heirs": {
      "sarah": {
        "preferences": {
          "landArt": "Land Art",
          "sustainableArt": "Sustainable art"
        },
        "values": {
          "sustainability": "Sustainability",
          "transmission": "Legacy"
        }
      },
      "james": {
        "preferences": {
          "classical": "Classical art",
          "renaissance": "Renaissance"
        },
        "values": {
          "investment": "Investment"
        }
      }
    },
    "artworks": {
      "suspendedForests": {
        "title": "Suspended Forests",
        "medium": "Acrylic on canvas"
      },
      "emeraldCascade": {
        "title": "Emerald Cascade",
        "medium": "Photography"
      }
    }
  },
  "warehouseVisit": {
    "title": "Storage visit",
    "common": {
      "loading": "Loading…",
      "untitled": "Untitled"
    },
    "conditions": {
      "excellent": "Excellent",
      "very_good": "Very good",
      "good": "Good",
      "fair": "Fair",
      "poor": "Poor",
      "partially_restorable": "Partially restorable",
      "heavily_damaged": "Heavily damaged",
      "irreparable": "Irreparable"
    },
    "risks": {
      "faible": "Low risk",
      "moyen": "Medium risk",
      "eleve": "High risk",
      "urgent": "URGENT"
    },
    "fields": {
      "condition": "Condition",
      "riskLevel": "Risk level",
      "visitNotes": "Visit notes",
      "notesPlaceholder": "Observed damage, urgent issues, notes…",
      "randomNotesPlaceholder": "Notes and observed damage…",
      "medium": "Medium",
      "dimensions": "Dimensions",
      "estimatedValue": "Estimated value"
    },
    "actions": {
      "saved": "Saved",
      "save": "Save",
      "record": "Record",
      "next": "Next",
      "inspect": "Inspect",
      "back": "Back",
      "exportPdf": "Export report PDF",
      "finish": "Finish visit · view summary"
    },
    "client": {
      "title": "Choose a client",
      "description": "Select the collector to inspect",
      "empty": "No accessible client"
    },
    "location": {
      "title": "Choose a location",
      "description": "Select the location to inspect today",
      "loading": "Loading locations…",
      "empty": "No saved location",
      "lastVisit": "Last visit"
    },
    "risk": {
      "zone": "Risk zone: {{risk}}",
      "zoneArtwork": "Storage risk zone: {{risk}} — this artwork may be affected",
      "unsuitable": "Conservation conditions are unsuitable"
    },
    "random": {
      "title": "Random artwork"
    },
    "summary": {
      "completed": "Visit completed",
      "title": "Visit summary",
      "priority": "Priority items ({{count}})",
      "noUrgency": "No urgent issue identified",
      "allGood": "All inspected artworks are in good condition"
    },
    "stats": {
      "present": "Artworks present",
      "evaluated": "Assessed",
      "damaged": "Poor condition",
      "highRisk": "High risk / urgent",
      "total": "Total",
      "notEvaluated": "Not assessed",
      "damagedShort": "Damaged",
      "evaluatedProgress": "{{evaluated}}/{{total}} assessed"
    },
    "inspection": {
      "title": "Inspection",
      "search": "Title, artist, inventory no.…",
      "loading": "Loading artworks…",
      "empty": "No artwork saved at this location",
      "noResults": "No results",
      "resultCount": "{{count}} artwork",
      "resultCount_other": "{{count}} artworks",
      "sortedByCondition": "sorted by condition"
    },
    "filters": {
      "all": "All ({{count}})",
      "damaged": "Damaged ({{count}})",
      "random": "Random"
    },
    "pdf": {
      "title": "Storage visit report",
      "location": "Location",
      "visitDate": "Visit on",
      "riskZone": "Location classified as risk level {{risk}}",
      "unsuitable": "The conservation conditions at this location are unsuitable for preserving artworks.",
      "evaluatedVisit": "Assessed during this visit",
      "intervention": "Artworks requiring intervention",
      "noUrgency": "No urgent issue identified during this visit",
      "artwork": "Artwork",
      "artist": "Artist",
      "inventoryNumber": "Inventory no.",
      "fullInventory": "Complete visit inventory",
      "generatedOn": "Report generated on {{date}}",
      "confidential": "Confidential"
    }
  },
  "collectionReports": {
    "title": "Create a report",
    "error": "Error",
    "types": {
      "inventory": "Inventory report",
      "artist": "Report by artist",
      "location": "Report by location",
      "valuation": "Valuation report",
      "insurance": "Insurance report",
      "exhibition": "Exhibition catalogue",
      "acquisition": "Acquisition history",
      "condition": "Artwork condition report",
      "completude": "Completeness report — Missing data"
    },
    "actions": {
      "viewExisting": "View existing reports",
      "generating": "Generating…",
      "generatePdf": "Generate PDF"
    },
    "fields": {
      "reportType": "Report type",
      "reportName": "Report name"
    },
    "common": {
      "notProvided": "Not provided"
    },
    "selection": {
      "advisorTitle": "Select collector and collection",
      "collectionTitle": "Select collection",
      "collector": "Collector",
      "allCollectors": "All collectors",
      "sharedCollectors": "{{count}} collector with shared access",
      "sharedCollectors_other": "{{count}} collectors with shared access",
      "collection": "Collection",
      "allCollections": "All collections",
      "untitledCollection": "Untitled collection",
      "loadedInCollection": "{{count}} artwork loaded in this collection",
      "loadedInCollection_other": "{{count}} artworks loaded in this collection",
      "loadedTotal": "{{count}} artwork loaded in total",
      "loadedTotal_other": "{{count}} artworks loaded in total"
    },
    "largeCollection": {
      "title": "Your selection contains {{count}} artworks.",
      "description": "For large collections, we recommend generating the report by collection or artist rather than for the entire selection. The result will be clearer and faster to produce.",
      "thumbnails": "Thumbnails will be limited to the first 50 artworks to ensure PDF generation."
    },
    "completeness": {
      "title": "Fields to check",
      "description": "Select the information for which you want to identify gaps.",
      "essential": "essential",
      "note": "Fields marked “essential” are required for a defensible estimate or valuation."
    },
    "options": {
      "title": "Report options",
      "includeDate": "Include today’s date",
      "includeThumbnails": "Include thumbnails (artwork images)",
      "valueTotals": "Artwork value totals",
      "purchaseTotal": "Total purchase value"
    },
    "data": {
      "title": "Data to include",
      "image": "Main image",
      "artist": "Artist name",
      "dimensions": "Dimensions",
      "medium": "Technique / medium",
      "mediumShort": "Medium",
      "creationYear": "Creation year",
      "estimatedValue": "Estimated value",
      "invoiceCertificate": "Invoice or certificate",
      "inventoryRef": "Inventory reference",
      "description": "Description",
      "acquisitionPrice": "Acquisition price",
      "location": "Location",
      "priceEstimated": "Price / Estimated value",
      "valueSource": "Cite value sources"
    },
    "whiteLabel": {
      "title": "Custom report",
      "description": "Generate a report with your professional identity",
      "enable": "Enable",
      "company": "Company or firm name",
      "current": "Current",
      "editProfile": "Edit in my profile",
      "logo": "Your logo",
      "changeLogo": "Change logo",
      "noLogo": "No logo uploaded. Add your logo in your profile to customise your reports.",
      "addLogo": "Add a logo",
      "note": "Reports will use your professional identity instead of Artkiv branding—ideal for presenting to clients."
    },
    "layout": {
      "title": "Layout",
      "groupBy": "Group by",
      "none": "No grouping",
      "artist": "Artist",
      "location": "Location",
      "medium": "Medium",
      "year": "Year",
      "sortBy": "Sort by",
      "titleSort": "Title",
      "value": "Value",
      "acquisitionDate": "Acquisition date"
    }
  },
  "valuationPdf": {
    "reportTitle": "Valuation report",
    "preparedFor": "Document prepared for validation and guidance by the Art Advisor",
    "purpose": "Purpose",
    "preparedBy": "Prepared by",
    "date": "Date",
    "client": "Client",
    "executiveSummary": "Executive summary",
    "artworksValued": "Artworks valued",
    "lowRange": "Low range",
    "highRange": "High range",
    "retainedValue": "Retained value",
    "averageConfidence": "Average confidence score",
    "confidenceNote": "This score measures the documentary robustness of the valuation, not a guarantee that the price will be achieved.",
    "artworkDetail": "Valuation detail by artwork",
    "marketToDocument": "Market to document",
    "expertValidationRequired": "Expert validation required",
    "untitled": "Untitled",
    "artistMissing": "Artist not provided",
    "confidence": "Confidence",
    "liquidity": "Liquidity",
    "risk": "Risk",
    "trend": "Trend",
    "marketReading": "Market assessment",
    "method": "Method",
    "sources": "Sources",
    "notProvidedF": "Not provided",
    "notProvidedPlural": "not provided",
    "sourcesWeighting": "Sources / comparables and weighting",
    "recommendation": "Art Advisor recommendation",
    "generalNotes": "General notes from the Art Advisor",
    "methodologyTitle": "Methodology",
    "methodologyDescription": "The valuation applies ARTKIV rules by group: Group A uses direct CUP; Group B uses analogy with at least five references; Group C uses the formula (H + L) × point value. Results older than five years are excluded unless no alternative exists. Gallery prices are used only as a ceiling.",
    "disclaimer": "This valuation report is a decision-support document prepared by an Art Advisor using information available on the issue date. It is not a judicial, tax or estate appraisal. Values are indicative and should be confirmed by an accredited expert.",
    "defaultFinality": "Market valuation",
    "defaultBadge": "Expert working document",
    "buttonTitle": "Export {{count}} artwork(s), retained value {{value}}",
    "noArtwork": "No artwork to export",
    "generating": "Generating PDF…",
    "export": "Export valuation report PDF",
    "methodology": {
      "direct_cup": "Group A — Direct CUP: recent results for the same artist are weighted; results older than five years are excluded. Gallery price is used only as a ceiling.",
      "analogy_cup": "Group B — CUP by analogy: recent comparables are weighted, with a prudence discount where no direct results exist.",
      "point_method": "Group C — Points method: formula (H + L) × point value."
    }
  },
  "artpriceImport": {
    "messages": {
      "loginRequired": "You must be signed in to import a PDF.",
      "importError": "Import error",
      "processing": "PDF imported. Analysis in progress ({{id}}…)",
      "processed": "PDF imported and analysed. {{count}} job completed.",
      "queued": "PDF imported. Analysis queued.",
      "houseAdded": "Auction house added.",
      "returnToCup": "Return to CUP to load the comparables."
    },
    "context": {
      "title": "Import context",
      "description": "Each imported comparable will be linked to its owner: client, expert or Artkiv team.",
      "importedBy": "Imported by",
      "visibility": "Calculated visibility",
      "client": "Relevant client",
      "selectClient": "Select a client",
      "clientUuid": "Client UUID",
      "clientWarning": "An expert must select a client before importing into a client space."
    },
    "house": {
      "optional": "Auction house (optional)",
      "search": "Search…",
      "addTitle": "Add an auction house",
      "name": "Name",
      "city": "City",
      "country": "Country",
      "website": "Website",
      "aliases": "Aliases (comma-separated)"
    },
    "actions": {
      "add": "Add",
      "cancel": "Cancel",
      "saving": "Saving…",
      "import": "Import",
      "importing": "Importing…",
      "backToCup": "Back to CUP assistant"
    },
    "table": {
      "artist": "Artist",
      "title": "Title",
      "estimate": "Estimate",
      "hammer": "Hammer",
      "sale": "Sale",
      "owner": "Owner"
    }
  },
  "valuationReport": {
    "loading": "Loading valuation module…",
    "kicker": "Report · Art Advisor Premium",
    "title": "Valuation Report",
    "description": "Select artworks, classify artists into Groups A/B/C, define ranges by artist, medium and format, apply them to artwork records, adjust exceptions and save.",
    "inflation": {
      "title": "Inflation report (INSEE CPI) available",
      "description": "purchase-price adjustment without a CUP valuation"
    },
    "steps": {
      "purpose": "Purpose",
      "artworks": "Artworks",
      "artists": "Artists A/B/C",
      "records": "Artwork records"
    },
    "actions": {
      "open": "Open",
      "chooseArtworks": "Choose artworks",
      "back": "Back",
      "defineRanges": "Define ranges",
      "saving": "Saving…",
      "saveQuotes": "Save my personal artist/medium valuations",
      "applyAll": "Apply all ranges to artwork records",
      "backToArtists": "Back to artist classification",
      "saveArtworks": "Save to artworks",
      "exportPdf": "Export PDF",
      "exportWord": "Export Word"
    },
    "fields": {
      "clientName": "Client name",
      "clientPlaceholder": "Client / file",
      "artist": "Artist"
    },
    "common": {
      "untitled": "Untitled",
      "date": "date",
      "artworkCount": "{{count}} artwork",
      "artworkCount_other": "{{count}} artworks"
    },
    "purpose": {
      "title": "Report purpose",
      "options": {
        "assurance": {
          "label": "Insurance",
          "description": "Documented value for insurance coverage or renewal."
        },
        "succession": {
          "label": "Estate / transfer",
          "description": "Prudent, explainable and traceable valuation for estate distribution."
        },
        "marche": {
          "label": "Market / disposal",
          "description": "Actionable market range for a sale, hold or acquisition decision."
        },
        "pret": {
          "label": "Collateral / loan",
          "description": "Prudent assessment incorporating liquidity, documentation and risk."
        }
      }
    },
    "selection": {
      "title": "Select artworks",
      "description": "Inventory references are displayed to prevent confusion in large groups.",
      "selected": "{{count}} selected",
      "selected_other": "{{count}} selected",
      "phaseTitle": "Phase 0 — personal expert valuations",
      "phaseDescription": "After selection, ARTKIV checks whether you have already saved valuations for the artists and media present. If so, Groups A/B/C and ranges are prefilled. Otherwise, enter them and save them only if you wish.",
      "allCollections": "All collections",
      "search": "Search artist, title or inventory…",
      "toggleAll": "Select / deselect all ({{count}})",
      "savedQuote": "Saved valuation",
      "noRange": "No range",
      "loadingQuotes": "Searching valuations…",
      "classify": "Classify artists ({{count}})"
    },
    "classification": {
      "title": "Classify artists into Groups A/B/C",
      "description": "First choose the method for each artist. Ranges are then developed by artist, medium and format.",
      "prefilled": "{{count}} personal valuation preloaded. Fields remain editable.",
      "prefilled_other": "{{count}} personal valuations preloaded. Fields remain editable.",
      "none": "No existing personal valuation was found for this selection. Complete the groups now, then save your valuations if you want to reuse them.",
      "comparableArtists": "Comparable artists: artist A, artist B…",
      "analogyReason": "Same gallery, generation, shared exhibition…",
      "expertNote": "Expert note on market value, liquidity, caution and trend…",
      "otherArtworks": "{{count}} other artwork",
      "otherArtworks_other": "{{count}} other artworks"
    },
    "confidence": {
      "low": "Low confidence",
      "medium": "Medium confidence",
      "high": "High confidence"
    },
    "ranges": {
      "title": "Ranges by artist + medium + format",
      "description": "Save personal expert valuations only when you want to enrich your private library. Then apply ranges to artwork records and adjust exceptions individually.",
      "prefilled": "Personal valuation prefilled",
      "artworkPrefilled": "Valuation already entered on artwork records — ranges and weighting preloaded",
      "applyToRecords": "Apply to {{count}} records",
      "pointLow": "Low point rate",
      "pointHigh": "High point rate",
      "low": "Low range €",
      "high": "High range €",
      "average": "Average value €",
      "weightingTitle": "Weighting methodology",
      "weightingDescription": "Results older than five years are excluded. The current gallery price is used only as a ceiling, never as an average.",
      "savedNote": "Saved valuation note for this artist/medium/format",
      "ownRecentCount": "Own results <3 years",
      "ownRecentMedian": "Median own results <3 years €",
      "ownOldCount": "Own results 3–5 years",
      "ownOldMedian": "Median own results 3–5 years €",
      "compRecentCount": "Comparables <3 years",
      "compRecentMedian": "Median comparables <3 years €",
      "compOldCount": "Comparables 3–5 years",
      "compOldMedian": "Median comparables 3–5 years €",
      "galleryCap": "Current gallery price, ceiling only €",
      "prudenceDiscount": "Prudence discount with no own results %",
      "sourcesDetail": "Detailed sources and comparable rationale"
    },
    "adjustments": {
      "title": "Manual adjustments / exceptions by artwork",
      "description": "The expert can correct a historic, museum-quality or atypical artwork after bulk application.",
      "finalValue": "Final value",
      "certificate": "Certificate +5%",
      "provenance": "Artist provenance +2%",
      "followUp": "Impeccable follow-up +5%",
      "expertOverride": "Exceptional expert adjustment",
      "sources": "Sources consulted",
      "justification": "Client-facing justification for this artwork…",
      "low": "Low €",
      "high": "High €",
      "retained": "Retained value €",
      "forcedValue": "Forced final value €",
      "overrideReason": "Reason: historic artwork, major exhibition…"
    },
    "losses": {
      "title": "Artworks excluded from the active total",
      "description": "Irreparable artworks are shown as losses and are not included in the active total."
    },
    "totalAdjusted": "Adjusted active total",
    "generalNotes": "General report notes"
  },
  "artistQuotes": {
    "loading": "Loading artist valuations…",
    "backToTools": "Back to tools",
    "kicker": "Private expert library",
    "title": "Artist valuations",
    "description": "Save your A/B/C groups, value ranges, analogies and decision parameters. In Group A, sales by the same artist are also weighted by dimensions, technique, format proximity and recency. In Group B, each comparable artist has a separate expert discount.",
    "messages": {
      "required": "Artist and medium are required.",
      "saved": "Artist valuation saved to your private library.",
      "confirmDelete": "Delete this personal valuation?",
      "deleted": "Valuation deleted."
    },
    "methods": {
      "directCup": "Group A — Direct CUP",
      "directCupPrudent": "C+ — Prudent direct CUP / series",
      "analogyCup": "Group B — CUP by analogy",
      "analogyCupRatio": "C+ — Analogy / pivot ratio",
      "hybridPointsCup": "C+ — Points + partial comparables",
      "pointMethod": "Group C — Points method"
    },
    "confidence": {
      "label": "Confidence",
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "microSegment": {
      "kicker": "Expert eye · micro-segment",
      "title": "Create a dedicated line when a series becomes more reliable than the general medium",
      "description": "Example: do not combine all Yuki Onodera photography if the expert has identified several consistent results for the Transvest series. The valuation then becomes a dedicated artist + series / format / technique line, classified as C+ or prudent direct CUP: the market remains thin, but observable.",
      "item1": "Same artist, but also the same identifiable series or body of work.",
      "item2": "Similar formats, comparable technique and clearly documented editions.",
      "item3": "Several consistent results or estimates, even if liquidity remains low.",
      "item4": "The dedicated line prevents the signal from being diluted in an overly broad medium.",
      "prefill": "Prefill Yuki Onodera · Transvest example"
    },
    "form": {
      "editTitle": "Edit a valuation",
      "newTitle": "New valuation",
      "artist": "Artist",
      "medium": "Medium / format, e.g. iron sculpture · large format",
      "priceLow": "Low range €",
      "priceHigh": "High range €",
      "averageValue": "Average value €",
      "recentWeight": "Weight <3 years %",
      "oldWeight": "Weight 3–5 years %",
      "galleryCap": "Gallery cap €",
      "minReferences": "Min. references",
      "dimension": "Dimensions %",
      "technique": "Technique %",
      "proximity": "Proximity %",
      "freshness": "Recency %",
      "pointLow": "Low point rate €",
      "pointHigh": "High point rate €",
      "comparableArtist": "Comparable artist",
      "logic": "Rationale: same generation, material…",
      "source": "Source",
      "careerDiscount": "Career discount %",
      "maxPriceWeight": "Max. price weight %",
      "observedLow": "Observed low €",
      "observedHigh": "Observed high €",
      "discount": "Discount %",
      "weight": "Weight %",
      "notes": "Expert notes, sources, caution, market, trend…"
    },
    "groupA": {
      "title": "Group A parameters — enhanced comparison",
      "description": "The same artist does not automatically mean comparable: ARTKIV also weights dimensions, technique, format proximity and sale recency. Sales older than five years are excluded unless manually reinstated by the expert."
    },
    "groupB": {
      "title": "Group B comparables",
      "description": "Enter at least three comparable artists. The discount remains an expert decision; coefficients qualify dimensions, technique, proximity and recency.",
      "comparable": "Comparable #{{number}}",
      "expertOverride": "Personal expert decision: retain this analogue despite a market difference.",
      "adjustedResult": "Adjusted result:",
      "calculatedRange": "Calculated Group B range:",
      "average": "average"
    },
    "marketRoles": {
      "trendOnly": "Trend analogue",
      "context": "Context only",
      "priceComparable": "Low-weight price comparable"
    },
    "marketTiers": {
      "inferior": "Lower market",
      "equivalent": "Equivalent market",
      "superior": "Higher market",
      "different": "Different market"
    },
    "actions": {
      "add": "Add",
      "delete": "Delete",
      "edit": "Edit",
      "saving": "Saving…",
      "update": "Update",
      "save": "Save",
      "cancel": "Cancel"
    },
    "list": {
      "title": "My personal valuations",
      "search": "Search artist or medium…",
      "empty": "No valuations found.",
      "groupARecorded": "Group A: dimensions / technique / proximity / recency weighting saved.",
      "groupB": "Group B:",
      "marketRules": "Custom market rules: {{count}} artist(s)",
      "average": "Average:"
    }
  },
  "artistQuotePage": {
    "title": "🎨 Artist market search",
    "artistName": "Artist name",
    "artistPlaceholder": "E.g. Bernar Venet",
    "medium": "Medium",
    "mediums": {
      "oil": "Oil on canvas",
      "watercolor": "Watercolor",
      "drawing": "Drawing",
      "sculpture": "Sculpture"
    },
    "submit": "Show dashboard"
  },
  "accountPage": {
    "loading": "Loading your subscription…",
    "title": "My subscription",
    "plan": "Plan:",
    "status": "Status:",
    "trialActive": "⏳ Trial active — you have {{count}} day(s) left to decide.",
    "trialActive_one": "⏳ Trial active — you have {{count}} day left to decide.",
    "trialActive_other": "⏳ Trial active — you have {{count}} days left to decide.",
    "active": "✓ Subscription active",
    "pastDue": "Payment overdue — update your payment method.",
    "frozen": "🔒 Your profile is temporarily frozen. Subscribe to a plan to restore all features.",
    "manage": "Manage my subscription",
    "invoices": "My invoices",
    "noSubscription": "No active subscription.",
    "choosePlan": "Choose a plan",
    "plans": {
      "standard": "Standard",
      "premium": "Premium",
      "family_office": "Family Office",
      "art_advisor": "Art Advisor",
      "art_advisor_premium": "Art Advisor Premium",
      "expert": "Expert"
    },
    "statuses": {
      "active": "Active",
      "trialing": "Trialing",
      "past_due": "Past due",
      "canceled": "Canceled",
      "unpaid": "Unpaid",
      "incomplete": "Incomplete",
      "paused": "Paused"
    }
  },
  "conservationTrackingPage": {
    "title": "Conservation monitoring",
    "values": {
      "notProvidedMasculine": "Not provided",
      "notProvidedFeminine": "Not provided",
      "assessmentPending": "Assessment pending",
      "toCalculate": "To be calculated",
      "toSchedule": "To be scheduled",
      "sampleRecommendation": "The artwork is in excellent condition, including the corners and surface. Schedule the next visual inspection in 1 year and a full condition report in 5 years. Maintain a temperature of 18–20°C and relative humidity of 45–55%. Avoid direct UV exposure."
    }
  },
  "messaging": {
    "back": "Back",
    "title": "Messages",
    "conversations": "Conversations",
    "loading": "Loading…",
    "emptyConversations": "No conversations yet.",
    "conversation": "Conversation",
    "selectConversation": "Select a conversation",
    "chooseConversation": "Choose a conversation from the list.",
    "emptyMessages": "No messages yet. Start the conversation 🙂",
    "placeholder": "Write a message…",
    "send": "Send",
    "user": "User",
    "userWithId": "User ({{id}}…)",
    "errors": {
      "loadConversations": "Unable to load conversations.",
      "loadMessages": "Unable to load messages.",
      "send": "Unable to send the message."
    },
    "rlsNote": "RLS security: access is limited to authorised conversations and messages."
  },
  "insuranceRequest": {
    "header": {
      "title": "Insurance request",
      "subtitle": "Request a quote and control exactly which information is shared with the broker."
    },
    "dataControl": {
      "title": "Shared data controls",
      "description": "You decide exactly which artwork-record details are sent to the broker. By default, the required technical data is shared while sensitive information, such as detailed provenance, purchase price and exact location, remains protected.",
      "sharedCountSuffix": "/{{total}} fields shared",
      "hide": "Hide",
      "customize": "Customise",
      "controlLabel": "data controls",
      "shareAll": "✓ Share all",
      "minimum": "🔐 Essential minimum"
    },
    "sections": {
      "identity": "🎨 Artwork identity",
      "technical": "🔬 Technical characteristics",
      "condition": "⚙️ Condition and conservation",
      "authenticity": "✅ Authenticity",
      "values": "💰 Values",
      "acquisitionWarning": "Acquisition information, sharing not recommended",
      "other": "Other data"
    },
    "labels": {
      "recommended": "(recommended)",
      "premiumImpact": "(affects the premium)",
      "sensitive": "(sensitive)",
      "verySensitive": "(highly sensitive)"
    },
    "fields": {
      "title": "Title",
      "artist": "Artist",
      "year": "Year",
      "typeOfArt": "Type of art",
      "medium": "Medium / technique",
      "dimensions": "Dimensions",
      "condition": "Condition",
      "conditionNotes": "Condition notes",
      "provenance": "Provenance",
      "certificate_auth": "Certificate of authenticity",
      "signature": "Signature",
      "signature_desc": "Signature description",
      "editionInfo": "Edition information",
      "acquisition_date": "Acquisition date",
      "acquisition_source": "Acquisition source",
      "acquisition_price": "Acquisition price",
      "acquisition_type": "Acquisition type",
      "estimated_value": "Estimated value",
      "valuation_estimated_value": "Valuation estimate",
      "last_estimation_date": "Last valuation date",
      "location_id": "Exact location",
      "image_url": "Image",
      "description": "Description",
      "documents": "Documents",
      "specifications": "Specifications",
      "subjectMatter": "Subject / theme",
      "styles": "Styles"
    },
    "anonymization": {
      "active": "Active anonymisation:"
    },
    "anonymized": {
      "workByArtist": "Artwork by {{artist}}",
      "longProvenance": "Documented history spanning several decades",
      "establishedProvenance": "Established and documented provenance",
      "specializedGallery": "Specialist European gallery",
      "publicAuction": "Public auction",
      "professionalSource": "Established professional source",
      "secureLocation": "Secure location, identifier hidden"
    },
    "artwork": {
      "fallbackTitle": "Artwork",
      "year": "Year",
      "medium": "Medium",
      "dimensions": "Dimensions",
      "condition": "Condition",
      "certificate": "Certificate of authenticity",
      "currentEstimate": "Current estimate",
      "sharedSummary": "{{shared}} of {{total}} fields will be sent to the broker.",
      "tipTitle": "Tip:",
      "tipBody": "Start the request from the artwork record so the broker automatically receives the necessary information without unnecessary back-and-forth."
    },
    "coverage": {
      "question": "What is your situation?",
      "homePremium": {
        "title": "Premium home insurance",
        "body": "Check the cover for my artworks, identify limits and request additional protection."
      },
      "fineArt": {
        "title": "Dedicated fine-art policy",
        "body": "A dedicated policy with tailored protection based on the actual value of the works."
      }
    },
    "policy": {
      "label": "Preferred policy type",
      "select": "— Select —",
      "nailToNail": "🧷 Nail-to-nail, event, transport or exhibition",
      "allRisks": "🛡️ All risks, comprehensive cover",
      "transportRequired": "Transport required"
    },
    "event": {
      "start": "Event start, optional",
      "end": "Event end, optional"
    },
    "form": {
      "storageLocation": "Storage location",
      "storagePlaceholder": "Home, storage facility, gallery, freeport…",
      "insuredValue": "Value to insure (EUR)",
      "prefilled": "(pre-filled from your artwork record)",
      "valuePlaceholder": "E.g. 12000",
      "context": "Additional context or message, optional",
      "contextPlaceholder": "Details about your expectations, deadlines or special conditions…",
      "name": "Your name, optional",
      "email": "Your email, optional"
    },
    "consent": {
      "title": "Insurance referral service framework",
      "description": "By submitting this request, you acknowledge that Artkiv acts solely as an introduction platform and does not sell insurance products. Partner brokers operate independently. No insurance contract is concluded through Artkiv.",
      "checkbox": "I have read the service framework and wish to submit this request.",
      "link": "Read the full terms"
    },
    "actions": {
      "sending": "Sending…",
      "submit": "✨ Send request",
      "cancel": "Cancel"
    },
    "errors": {
      "acceptTerms": "Please accept the service framework before submitting the request.",
      "noSession": "No active session.",
      "invalidInsuredValue": "The insured value is invalid.",
      "selectPolicy": "Please select a policy type: nail-to-nail or all risks.",
      "submit": "An error occurred while submitting the request."
    },
    "footer": {
      "title": "Why share all this information?",
      "body": "A specialist broker assesses risk based on the technique, condition, provenance and recent value. A complete file allows them to recommend a suitable solution from the first exchange.",
      "note": "⚡ Faster handling and clearer communication"
    }
  },
  "insuranceRequestDetail": {
    "loading": "Loading your request…",
    "notFound": "Request not found.",
    "artworkFallback": "Artwork",
    "errors": {
      "load": "Unable to load the request.",
      "updateStatus": "Unable to update the status."
    },
    "header": {
      "title": "Request details",
      "subtitle": "Track your insurance request",
      "createdAt": "Created on {{date}}"
    },
    "actions": {
      "back": "← Back",
      "backToRequests": "← Back to my requests",
      "refresh": "🔄 Refresh",
      "accept": "✓ Accept proposal",
      "reject": "✗ Decline"
    },
    "status": {
      "pending": "Pending",
      "seen": "Viewed",
      "answered": "Response received",
      "quoted": "Quote received",
      "accepted": "Accepted",
      "rejected": "Declined",
      "done": "Closed",
      "unknown": "Unknown status"
    },
    "statusExplanation": {
      "pending": "Your partner broker has received the request and will review it within 48 hours.",
      "seen": "Your broker has opened the request and is preparing a recommendation.",
      "answered": "You have received a response. Take time to review it before deciding.",
      "quoted": "You have received a proposal. Take time to review it before deciding.",
      "accepted": "You accepted the proposal. The broker will contact you to finalise it.",
      "rejected": "You declined the proposal. You may submit a new request if needed.",
      "done": "This request is closed.",
      "unknown": "This request’s status is being updated."
    },
    "analysis": {
      "title": "How does the broker assess your request?",
      "body": "Using information from the artwork record, including provenance, certificates and condition, the broker can assess the risks accurately and recommend suitable cover without asking for numerous documents by email.",
      "note": "⚡ Faster handling and a more accurate recommendation for your collection."
    },
    "details": {
      "requestType": "Request type",
      "insuredValue": "Insured value",
      "context": "Context"
    },
    "requestType": {
      "insurance_quote": "Insurance quote request"
    },
    "coverage": {
      "home_premium": "Premium home insurance",
      "fine_art_policy": "Dedicated fine-art policy"
    },
    "policy": {
      "nail_to_nail": "Nail-to-nail",
      "all_risks": "All risks"
    },
    "coverageDetails": {
      "title": "📋 Requested cover details",
      "policyType": "Policy type",
      "storageLocation": "Storage location",
      "transportRequired": "Transport required for this artwork",
      "eventPeriod": "Event period"
    },
    "sharedInfo": {
      "title": "📄 Information shared with the broker",
      "description": "These details were voluntarily shared for this request. They help the broker understand your needs without repeated exchanges."
    },
    "partner": {
      "title": "Partner broker recommendation",
      "noticeTitle": "What you should know",
      "noticeBody": "The proposal below is indicative. Read it carefully, ask questions and decide freely.",
      "message": "Broker’s message",
      "quoteAmount": "Proposed premium",
      "percentage": "Approximately {{percentage}}% of the insured value, a reasonable cost for protecting your assets.",
      "importantTitle": "Important:",
      "importantBody": "If you accept, the contract is concluded directly with the partner broker outside the Artkiv platform. You will be contacted within 48 hours to finalise the terms."
    },
    "pending": {
      "title": "Assessment in progress",
      "body": "Your partner broker has received the request and is reviewing the information. You should receive a recommendation within 48 hours on average.",
      "note": "A careful review helps identify the most suitable solution."
    },
    "footer": {
      "title": "Why is fine-art insurance relatively affordable?",
      "body": "Fine-art insurance premiums typically represent 0.1% to 0.3% of the value per year. For a €20,000 work, this is about €20–€60 per month. Compared with the financial and emotional impact of a total loss, it is a protective investment.",
      "note": "✨ Some policies include valuations, emergency restoration and legal assistance."
    }
  },
  "insuranceRequests": {
    "hero": {
      "title": "My insurance requests",
      "subtitle": "Track your quote requests, certificates and value updates."
    },
    "actions": {
      "newRequest": "✨ New request",
      "refresh": "🔄 Refresh",
      "viewDetails": "View details"
    },
    "errors": {
      "noSession": "No active session.",
      "load": "Unable to load insurance requests."
    },
    "loading": "Loading your requests…",
    "artworkFallback": "Artwork",
    "education": {
      "whyInsure": {
        "title": "Why insure an art collection?",
        "protection": "Protect what matters. Even in a secure location, risks remain: water damage, fire, theft or accidental damage during a move.",
        "affordable": "An affordable premium. Insuring an artwork generally costs 0.1% to 0.3% of its value per year. For a €10,000 work, that is roughly €10–€30 per month.",
        "note": "💬 Our partner brokers review the artwork record to recommend tailored cover."
      },
      "sharing": {
        "title": "Why share information from my artwork record?",
        "body": "Each request gives the partner broker access only to the details you select, such as provenance, certificates, condition reports or the latest valuation.",
        "result": "Result: faster assessment, a more accurate recommendation and less email back-and-forth.",
        "note": "🔒 The partner can access only this request, never the rest of your collection."
      }
    },
    "privacy": {
      "title": "Control and confidentiality",
      "body": "Artkiv does not sell insurance products. The platform introduces you to a fine-art specialist broker selected for their expertise.",
      "scope": "The information shared is strictly limited to what is needed for the assessment. The broker sees nothing else."
    },
    "empty": {
      "title": "No requests yet.",
      "body": "Submit your first request to receive an insurance recommendation tailored to your collection. It is quick, confidential and non-binding.",
      "cta": "Create my first request"
    },
    "coverage": {
      "home_premium": "Premium home insurance",
      "fine_art_policy": "Fine-art policy"
    },
    "policy": {
      "nail_to_nail": "Nail-to-nail",
      "all_risks": "All risks"
    },
    "labels": {
      "transport": "Transport",
      "type": "Type",
      "insuredValue": "Insured value"
    },
    "requestType": {
      "insurance_quote": "Insurance quote request"
    },
    "status": {
      "pending": "Pending",
      "seen": "Viewed",
      "answered": "Response received",
      "quoted": "Quote received",
      "accepted": "Accepted",
      "rejected": "Declined",
      "done": "Closed"
    },
    "footer": {
      "title": "More than ordinary insurance",
      "body": "Each request connects you with a specialist who understands the financial and emotional value of your collection. You receive a tailored assessment rather than a generic form or unsuitable cover.",
      "note": "💬 Questions about your current cover? Our partner brokers usually respond within 48 hours."
    }
  },
  "partners": {
    "back": "Back",
    "loading": "Loading…",
    "close": "Close",
    "title": "Our service partners",
    "subtitle": "Qualified, trusted professionals who can support the management of your collection.",
    "search": "Search…",
    "service": "Service",
    "categories": {
      "labels": {
        "all": "All",
        "insurance": "Insurance brokers",
        "transport": "Art transporters",
        "conservation": "Conservators",
        "other": "Other services"
      },
      "descriptions": {
        "all": "All partners",
        "insurance": "Protection for your artworks",
        "transport": "Specialist art transport",
        "conservation": "Conservation and restoration",
        "other": "Complementary services"
      }
    },
    "contact": "Contact",
    "addToContacts": "Add to my contacts",
    "alert": {
      "loginRequired": "Please sign in to add this partner to your contacts.",
      "addedToContacts": "Partner added to your contacts.",
      "comingSoon": "This feature will soon be available for this type of partner.",
      "error": "Unable to add the partner."
    },
    "errors": {
      "load": "Unable to load partners."
    },
    "modal": {
      "title": "Contact the partner",
      "desc": "Use the contact details below to reach this partner:",
      "company": "Company",
      "email": "Email",
      "phone": "Phone",
      "address": "Address"
    },
    "empty": {
      "title": "No partners found",
      "search": "Try a different search",
      "filter": "Select another category"
    }
  },
  "eventLanding": {
    "ribbon": {
      "onSite": "On site:",
      "followStories": "Follow our stories →"
    },
    "events": {
      "when": {
        "thisWeek": "this week",
        "nextWeek": "next week",
        "december": "in December"
      }
    },
    "hero": {
      "title": "Meet us at the fair.",
      "subtitle": "Artkiv combines AI, blockchain and human expertise to document, value and protect your artworks. Art is not only collected, it is passed on.",
      "freeTrial": "🎁 14-day free trial",
      "requestMeeting": "📅 Request a meeting at the fair"
    },
    "audiences": {
      "collectors": {
        "title": "Collectors",
        "body": "A living record for each artwork, provenance and documents, clear valuations and simpler family transmission."
      },
      "families": {
        "title": "Families and heirs",
        "body": "Inherited art? We clarify what you own, what it is worth and how to avoid legal or tax mistakes."
      },
      "professionals": {
        "title": "Family offices and insurers",
        "body": "Actionable cultural-asset files, traceability and evidence to reduce risk and streamline cover."
      }
    },
    "meeting": {
      "title": "Shall we talk for 15 minutes at the fair?",
      "body": "Bring a specific artwork, photo, invoice or certificate, or simply a question about inheritance or insurance. We will reserve a discreet time slot during the fair.",
      "emailSubject": "Art fair meeting",
      "emailCta": "✉️ Send my request",
      "instagramCta": "DM @artkiv_official on Instagram"
    },
    "footer": {
      "tagline": "A trusted tool for private collections: value, traceability and protection."
    }
  },
  "sharedPage": {
    "title": "Collections shared with me"
  },
  "artworkCharts": {
    "title": "Collection statistics",
    "collection": "Collection",
    "allCollections": "All",
    "noCollection": "No collection",
    "untitled": "Untitled",
    "unknown": "Unknown",
    "notProvided": "Not provided",
    "notLocated": "Not located",
    "loadError": "Unable to load artworks.",
    "charts": {
      "valueByLocation": "Total value by location",
      "artworksByArtist": "Number of artworks by artist",
      "byMedium": "Breakdown by medium",
      "byType": "Breakdown by art type",
      "byPeriod": "Breakdown by period",
      "byTotalValue": "Breakdown by total value"
    },
    "datasets": {
      "totalValue": "Total value",
      "artworks": "Artworks"
    },
    "periodHelp": "Artworks without a year are grouped under “Unknown”.",
    "noValueData": "No value data available",
    "tooltipCount": "{{value}} ({{percent}}%)"
  },
  "artworkCosts": {
    "title": "Cost tracking – {{artwork}}",
    "artworkFallback": "Artwork #{{id}}",
    "back": "Back to artwork",
    "addTitle": "Add a cost",
    "selectType": "Select a type",
    "amountPlaceholder": "Amount (€)",
    "description": "Description",
    "provider": "Service provider",
    "automaticCategory": "Automatic category:",
    "saving": "Saving…",
    "add": "Add",
    "history": "Cost history",
    "columns": {
      "date": "Date",
      "type": "Type",
      "amount": "Amount",
      "lot": "Lot",
      "description": "Description",
      "provider": "Service provider"
    },
    "total": "Total",
    "saveError": "Unable to save the cost.",
    "loadError": "Unable to load costs.",
    "empty": "No costs recorded.",
    "lots": {
      "lot1": "Lot 1",
      "lot2": "Lot 2"
    },
    "types": {
      "fabrication": "Production",
      "framing": "Framing",
      "otherTechnical": "Other (technical)",
      "exhibition": "Exhibition",
      "documentation": "Documentation",
      "legalFees": "Legal fees",
      "otherEnhancement": "Other (enhancement)"
    }
  },
  "smartDashboardRedirect": {
    "loadingDashboard": "Loading dashboard…",
    "loadingPartner": "Loading partner area…"
  },
  "marketInsights": {
    "loading": "Loading Art Basel 2025 data…",
    "loadError": "Unable to load Art Basel data",
    "title": "Art Basel 2025 Insights",
    "subtitle": "Contemporary art market data and analysis",
    "nav": {
      "overview": "Overview",
      "sectors": "Sectors",
      "prices": "Prices",
      "recommendations": "Recommendations"
    },
    "overview": {
      "title": "2025 market overview",
      "globalSales": "Global sales",
      "billionUsd": "USD billions",
      "onlineShare": "E-commerce share",
      "vs2024": "+2% vs 2024",
      "volumeGrowth": "Volume growth",
      "transactions": "Transactions",
      "averageValue": "Average value",
      "perTransaction": "Per transaction",
      "topMarkets": "Top markets"
    },
    "sectors": {
      "title": "Performance by sector",
      "performance": "Performance:",
      "volume": "Volume:"
    },
    "prices": {
      "title": "Price segments",
      "volumeShare": "Volume share:",
      "valueShare": "Value share:",
      "growth": "Growth:"
    },
    "recommendations": {
      "title": "AI recommendations",
      "collectorInsights": "Collector insights",
      "artAllocation": "Average art allocation",
      "onlinePreference": "Prefer buying online",
      "millennials": "Millennial participation"
    },
    "footer": {
      "source": "Sources: Art Basel & UBS Report 2025 • Algorithm version {{version}}",
      "updated": "Last updated: {{date}}"
    },
    "countries": {
      "United States": "United States",
      "United Kingdom": "United Kingdom",
      "China": "China",
      "France": "France",
      "Switzerland": "Switzerland",
      "Hong Kong": "Hong Kong"
    },
    "sectorNames": {
      "Contemporary Art": "Contemporary Art",
      "Modern Art": "Modern Art",
      "Post-War Art": "Post-War Art",
      "Impressionist and Post-Impressionist": "Impressionist and Post-Impressionist",
      "Old Masters": "Old Masters"
    }
  },
  "expertsDirectory": {
    "badge": "Artkiv Expert",
    "requestLabel": "Request",
    "defaultIntro": "Hello, I would like to add you as my personal Art Advisor.",
    "conversationError": "Conversation could not be created",
    "loginRequired": "Please sign in.",
    "artkivOnly": "Available to Artkiv experts only.",
    "notAuthenticated": "User not authenticated",
    "alreadyRequested": "A request is already pending or accepted.",
    "requestDescription": "Personal advisor request",
    "success": "Invitation sent. Waiting for the expert’s response.",
    "sendError": "Unable to send the request.",
    "title": "Artkiv Experts",
    "search": "Search for an expert…",
    "allSpecialties": "All specialties",
    "becomeAdvisor": "Make this expert my personal advisor",
    "messagePlaceholder": "Message to the expert (optional)",
    "sending": "Sending…",
    "send": "Send request"
  },
  "addArtwork": {
    "title": "Add an artwork",
    "tabs": {
      "details": "Details",
      "specifications": "Specifications",
      "provenance": "Provenance",
      "documents": "Documents",
      "location": "Location",
      "nft": "NFT"
    },
    "collection": {
      "label": "Select a collection",
      "auto": "Automatically create a collection (default)",
      "unnamed": "Unnamed collection ({{id}})",
      "create": "+ Create a new collection",
      "prompt": "Name of the new collection:",
      "created": "Collection created.",
      "createError": "Unable to create the collection."
    },
    "uploadError": "Unable to upload the image.",
    "success": "Artwork added successfully.",
    "saveError": "Error: {{message}}",
    "saving": "Adding…",
    "submit": "Add artwork"
  },
  "acceptCollectionTransfer": {
    "errors": {
      "invalid": "Invalid link.",
      "notFound": "Link not found or expired.",
      "expired": "This link has expired (7-day validity).",
      "cancelled": "This transfer was cancelled by the Art Advisor.",
      "network": "Network error. Please try again.",
      "generic": "Error"
    },
    "loading": "Checking link…",
    "invalidTitle": "Invalid link",
    "home": "Back to home",
    "wrongUserTitle": "Incorrect account",
    "wrongUserBody": "This link is intended for {{expected}}. You are signed in as {{current}}.",
    "wrongUserHelp": "Sign out and sign in again with the correct account.",
    "switchAccount": "Sign out and switch account",
    "doneTitle": "Collections transferred",
    "doneBody": "The collections are now available in your Artkiv space.",
    "viewCollections": "View my collections",
    "accepting": "Transfer in progress…",
    "eyebrow": "TRANSFER INVITATION",
    "title": "Your Art Advisor is transferring collections to you",
    "included": "Included collections",
    "notice": "By accepting, these collections will appear in your space and your Art Advisor will retain limited access to assist you.",
    "accept": "Accept transfer",
    "loginHelp": "Sign in or create an account with {{email}} to accept.",
    "login": "Sign in",
    "register": "Create an account"
  },
  "transportPreforum": {
    "documentTitle": "Artwork transport – Quote request | ARTKIV",
    "authRequired": "You must be signed in to send a transport request.",
    "sendError": "The request could not be sent. Please try again.",
    "title": "Artwork transport – Quote request",
    "subtitle": "Information collection for a quote from a transport partner.",
    "steps": {
      "one": "Step 1 – Locations and artworks",
      "two": "Step 2 – Options and insurance",
      "three": "Step 3 – Review and send"
    },
    "prefill": "Prefilling the address…",
    "fields": {
      "carrier": "Carrier",
      "salutation": "Title",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone",
      "pickupAddress": "Pickup address",
      "deliveryAddress": "Delivery address",
      "city": "City",
      "country": "Country",
      "desiredDate": "Preferred date",
      "distance": "Estimated distance (km)",
      "floor": "Floor (if no lift)",
      "pieces": "Number of pieces",
      "category": "Category",
      "length": "L (cm)",
      "width": "W (cm)",
      "height": "H (cm)",
      "weight": "Weight (kg)",
      "packing": "Packing",
      "crate": "Protective crate",
      "volume": "Volume",
      "handling": "Handling",
      "international": "International transport",
      "temperature": "Temperature control",
      "declaredValue": "Declared value (€) for insurance",
      "customs": "Customs formalities",
      "attachments": "Add photos or documents"
    },
    "hintApprox": "approx.",
    "pickupPlaceholder": "Example: 55 Storage Road, Boston, MA 02215, USA",
    "salutations": {
      "mrs": "Ms",
      "mr": "Mr",
      "other": "Other"
    },
    "categories": {
      "painting": "Painting",
      "sculpture": "Sculpture",
      "paper": "Drawing / Paper",
      "photography": "Photography",
      "object": "Furniture / Object"
    },
    "packing": {
      "bubble": "Bubble wrap / foam",
      "foam": "High-density foam",
      "crate": "Dedicated crate"
    },
    "crate": {
      "none": "None",
      "cardboard": "Reinforced cardboard",
      "museum": "Wood (museum quality)"
    },
    "volume": {
      "small": "Small",
      "medium": "Medium",
      "large": "Large"
    },
    "handling": {
      "simple": "Simple",
      "medium": "Medium",
      "complex": "Complex (hanging / rigging)"
    },
    "yes": "Yes",
    "no": "No",
    "toPlan": "Required",
    "import": "Import",
    "filesAdded": "{{count}} file added",
    "filesAdded_plural": "{{count}} files added",
    "quickEstimate": "Quick estimate",
    "quote": {
      "subtotal": "Logistics subtotal",
      "insurance": "Insurance (estimate)",
      "vat": "VAT 20%",
      "estimatedTotal": "Estimated total incl. tax",
      "partnerEstimate": "ARTKIV partner estimate (indicative)"
    },
    "cancel": "Cancel",
    "back": "Back",
    "continue": "Continue",
    "indicative": "indicative estimate",
    "readyTitle": "Ready to send to the logistics partner",
    "readyBody": "We will record your request. An active transport partner will contact you to confirm the schedule, access, team and quote.",
    "summaryRequest": "Request summary",
    "copy": "Copy",
    "sending": "Sending…",
    "send": "Send",
    "submittedTitle": "Request recorded",
    "submittedBody": "Your transport request has been recorded{{reference}}. A transport partner will contact you by email or phone.",
    "reference": " (reference {{id}})",
    "backArtwork": "Back to artwork",
    "summary": "Summary",
    "partner": "Partner:",
    "route": "Route",
    "floorLabel": "Floor:",
    "artworks": "Artwork(s)",
    "selectedOptions": "Selected options",
    "packingLabel": "Packing:",
    "crateLabel": "Crate:",
    "volumeLabel": "Volume:",
    "handlingLabel": "Handling:",
    "temperatureLabel": "Temperature:",
    "internationalLabel": "International:",
    "customsLabel": "Customs: Yes – Incoterm {{incoterm}}",
    "activeControl": "Active control",
    "other": "Other",
    "artkiv": "ARTKIV"
  },
  "delegatedAccess": {
    "roles": {
      "team_member": "Team member",
      "team_readonly": "Read-only access",
      "expert": "Guest expert",
      "assistant": "Assistant",
      "client": "Client",
      "collaborator": "Collaborator"
    },
    "tabs": {
      "collections": "Collections",
      "artworks": "Artworks",
      "locations": "Locations",
      "reports": "Reports",
      "vision": "Vision AI"
    },
    "edit": "Edit",
    "untitled": "Untitled",
    "untitledCollection": "Untitled collection",
    "noSharedCollections": "No shared collections",
    "artworkCount": "{{count}} artwork",
    "artworkCount_plural": "{{count}} artworks",
    "editable": "EDITABLE",
    "search": "Title, artist…",
    "loading": "Loading…",
    "noArtwork": "No artworks.",
    "page": "Page {{current}} / {{total}}",
    "allArtworksLoading": "Loading all artworks…",
    "allArtists": "All artists",
    "allMediums": "All media",
    "clear": "Clear",
    "results": "{{count}} result",
    "results_plural": "{{count}} results",
    "previous": "Prev.",
    "next": "Next",
    "unknownLocation": "Location not provided",
    "reportsPermissionTitle": "Permission not granted",
    "reportsPermissionBody": "Report generation is not included in your collaborator access.",
    "reportsIntro": "Access inventory and valuation reports for shared collections.",
    "reportInventory": "PDF inventory report",
    "reportInventoryDesc": "Generate a complete collection inventory",
    "reportValuation": "Valuation report",
    "reportValuationDesc": "Estimation and valuation report",
    "visionPermissionBody": "Access to Vision AI tools is not included in your collaborator access.",
    "visionIntro": "Access visual analysis and artwork record enrichment tools.",
    "openVision": "Open Artkiv Vision",
    "noAccess": "No active collaborator access.",
    "genericError": "Error.",
    "ownerFallback": "your expert",
    "loadingPage": "Loading…",
    "accessUnavailable": "Access unavailable",
    "logout": "Sign out",
    "logoutShort": "Sign out",
    "access": "Access:",
    "permissions": {
      "view": "View",
      "edit": "Edit",
      "add": "Add",
      "delete": "Delete",
      "export": "Export",
      "reports": "Reports",
      "ai": "AI"
    },
    "footer": "Your access is managed by {{owner}} and may be changed or revoked at any time. All your actions are logged. This space does not require a subscription."
  },
  "inflationReport": {
    "back": "Back",
    "title": "Inflation-adjusted acquisition value",
    "subtitle": "Purchase price adjustment – INSEE CPI base 100 (2015)",
    "ipc": {
      "live": "Live CPI – {{date}}",
      "embedded": "Embedded CPI – {{date}}",
      "loading": "Loading CPI…",
      "unavailable": "CPI unavailable"
    },
    "collection": "Collection",
    "select": "Select…",
    "clientName": "Client name (for the report)",
    "clientPlaceholder": "Example: RX Gallery",
    "loadingArtworks": "Loading artworks…",
    "stats": {
      "total": "Total artworks",
      "withPrice": "With purchase price",
      "computable": "Computable",
      "missing": "Missing data"
    },
    "financial": {
      "purchaseTotal": "Total purchase value",
      "updatedTotal": "Total adjusted value",
      "globalVariation": "Overall change"
    },
    "missing": {
      "summary": "{{count}} artwork has no purchase price or acquisition date and is excluded from the calculation.",
      "summary_plural": "{{count}} artworks have no purchase price or acquisition date and are excluded from the calculation.",
      "excelNotice": "A “Missing data” sheet will be included in the Excel export.",
      "hide": "Hide from preview",
      "show": "Show in preview",
      "hidden": "({{count}} missing-data rows hidden)",
      "noPrice": "Purchase price missing",
      "noDate": "Acquisition date missing",
      "ipc": "CPI unavailable for this period",
      "ipcBefore": "CPI unavailable for an acquisition before 2010"
    },
    "preview": "Calculation preview",
    "columns": {
      "inventory": "Inventory no.",
      "artwork": "Artwork",
      "date": "Acquisition date",
      "purchasePrice": "Purchase price",
      "coefficient": "Coeff.",
      "updatedValue": "Adjusted value",
      "variation": "+/−"
    },
    "untitled": "Untitled",
    "formatTitle": "Report format",
    "formats": {
      "pdf": "Professional layout",
      "word": "Editable .docx file",
      "excel": "3 sheets: calculations, missing data and summary"
    },
    "alerts": {
      "chooseFormat": "Select at least one format.",
      "noIpc": "CPI data is unavailable.",
      "generation": "Generation error: {{message}}"
    },
    "generating": "Generating…",
    "downloadMultiple": "Download {{formats}}",
    "downloadOne": "Download {{format}}",
    "selectFormat": "Select a format",
    "noComputable": "No artworks have both a purchase price and an acquisition date.",
    "legal": "This report adjusts the purchase price according to changes in the cost of living (INSEE CPI). It does not reflect the artist’s market level or the artwork’s market value. It may be used as a reference floor for inheritance (Article 761 of the French Tax Code) or insurance.",
    "referenceIndex": "Reference index: {{value}} – {{date}}.",
    "empty": "No artworks in this collection.",
    "export": {
      "untitled": "Untitled",
      "sheetRevaluation": "Adjustment",
      "sheetMissing": "Missing data",
      "sheetSummary": "Summary",
      "headers": {
        "inventory": "Inventory no.",
        "title": "Title",
        "artist": "Artist",
        "acquisitionDate": "Acquisition date",
        "purchasePrice": "Purchase price (EUR)",
        "acquisitionIpc": "Acquisition CPI",
        "referenceIpc": "Reference CPI",
        "coefficient": "Coefficient",
        "updatedValue": "Adjusted value (EUR)",
        "variation": "Change (%)",
        "missing": "Missing data",
        "parameter": "Parameter",
        "value": "Value"
      },
      "summary": {
        "collection": "Collection",
        "client": "Client",
        "reportDate": "Report date",
        "referenceIpc": "Reference CPI",
        "totalArtworks": "Total artworks",
        "computedArtworks": "Computed artworks",
        "missingData": "Missing data",
        "totalPurchase": "Total purchase price (EUR)",
        "totalUpdated": "Total adjusted value (EUR)",
        "globalVariation": "Overall change (%)",
        "indexSource": "Index source",
        "legalReference": "Legal reference",
        "indexSourceValue": "INSEE consumer price index, France excluding tobacco, base 100 (2015)",
        "legalValue": "Article 761, French Tax Code – inheritance / insurance"
      },
      "coverTitle": "INFLATION-ADJUSTED ACQUISITION VALUE",
      "coverSubtitle": "Cost-of-living adjustment – INSEE CPI base 100 (2015)",
      "coverMethod": "Method consistent with Article 761 of the French Tax Code – Floor reference for inheritance and insurance",
      "collection": "Collection: {{name}}",
      "client": "Client: {{name}}",
      "reportDate": "Report date: {{date}}",
      "referenceIpc": "Reference CPI: {{value}} ({{date}})",
      "worksWithPrice": "ARTWORKS WITH PURCHASE PRICE",
      "totalUpdated": "TOTAL ADJUSTED VALUE",
      "averageCoefficient": "AVERAGE COEFFICIENT",
      "tableTitle": "ADJUSTMENT TABLE",
      "computedCount": "{{count}} artwork computed – CPI {{date}}",
      "computedCount_plural": "{{count}} artworks computed – CPI {{date}}",
      "tableHeaders": {
        "inventory": "Inventory no.",
        "titleArtist": "Title / Artist",
        "acquisition": "Acq.",
        "purchase": "Purchase price",
        "coefficient": "Coeff.",
        "updated": "Adjusted value",
        "variation": "+/−"
      },
      "total": "TOTAL",
      "missingTitle": "MISSING DATA FOR INFLATION CALCULATION",
      "missingIntro": "These artworks are excluded from the calculation because their purchase price or acquisition date is missing.",
      "exclusionReason": "Exclusion reason",
      "methodologyTitle": "METHODOLOGY NOTE",
      "methodology": {
        "objectTitle": "PURPOSE OF THE REPORT",
        "object1": "This report presents the acquisition value of each artwork adjusted for changes in the cost of living in France.",
        "object2": "It is neither an estimate of the artwork’s market value nor an appraisal certificate.",
        "indexTitle": "INDEX USED",
        "index1": "Consumer Price Index (CPI) – France excluding tobacco, base 100 in 2015.",
        "index2": "Source: INSEE, series 001641683. Seasonally adjusted data. Coverage: 2000 to date.",
        "formulaTitle": "FORMULA",
        "formula1": "Adjusted value = Purchase price × (CPI at report date / CPI in acquisition month)",
        "formula2": "The coefficient is calculated to 3 decimal places. The adjusted value is rounded to the nearest euro.",
        "currenciesTitle": "FOREIGN CURRENCIES",
        "currencies1": "For artworks acquired in a currency other than EUR, the calculation uses acquisition_price_eur when available.",
        "currencies2": "Otherwise, the artwork is excluded from the total and the conversion is reported as unavailable.",
        "useTitle": "USE",
        "use1": "This value may be used as a reference floor for inheritance, insurance or an indicative asset review.",
        "use2": "It is not a substitute for an expert opinion of market value.",
        "privacyTitle": "CONFIDENTIALITY",
        "privacy1": "This document is strictly confidential and is prepared solely at the request of the named client.",
        "privacy2": "It may not be disclosed to third parties without QUANG & CO’s written consent.",
        "legalUseTitle": "LEGAL USE",
        "legalUse1": "Floor reference for inheritance declarations (Article 761, French Tax Code) and insurance contracts.",
        "legalUse2": "It is not a substitute for a market-value appraisal."
      },
      "established": "Prepared on {{date}}",
      "worksWithAcquisition": "{{count}} artwork with a purchase price",
      "worksWithAcquisition_plural": "{{count}} artworks with a purchase price",
      "referenceShort": "Reference CPI: {{value}} – {{date}}",
      "priceMissing": "Price missing",
      "dateMissing": "Date missing",
      "ipcMissing": "CPI unavailable",
      "confidential": "Estimates are provided for guidance only. QUANG & CO – Confidential.",
      "excludedCount": "{{count}} artwork excluded from the calculation",
      "excludedCount_plural": "{{count}} artworks excluded from the calculation",
      "companyExpert": "QUANG & CO – Independent art valuation expert",
      "companyArtAdvisory": "QUANG & CO – Art advisory"
    }
  },
  "expertReport": {
    "back": "My Collection",
    "title": "Appraisal report",
    "subtitle": "Generate the CUP report and Excel workbook — QUANG & CO",
    "collection": "Collection",
    "select": "Select…",
    "clientName": "Client name (for the report)",
    "clientPlaceholder": "Example: RX Gallery",
    "loading": "Loading artworks…",
    "stats": {
      "total": "Total artworks",
      "valued": "Valued",
      "cupComplete": "Complete CUP sheets",
      "totalValue": "Total estimated value"
    },
    "detected": {
      "title": "Detected option:",
      "basedOn": "Based on {{count}} complete CUP sheet",
      "basedOn_plural": "Based on {{count}} complete CUP sheets"
    },
    "options": {
      "synthese": {
        "label": "Option 1 — Summary",
        "short": "Option 1",
        "description": "Global summary",
        "price": "€2,000 excl. VAT"
      },
      "cup_60": {
        "label": "Option 2 — 60 CUP sheets",
        "short": "Option 2",
        "description": "Up to 60 CUP sheets",
        "price": "€3,500 excl. VAT"
      },
      "cup_200": {
        "label": "Option 3 — 200 CUP sheets",
        "short": "Option 3",
        "description": "All CUP sheets",
        "price": "€7,800 excl. VAT"
      }
    },
    "incomplete": "{{count}} sheet has incomplete comparables. The PDF report will include only complete CUP sheets. The Excel workbook will include all artworks.",
    "incomplete_plural": "{{count}} sheets have incomplete comparables. The PDF report will include only complete CUP sheets. The Excel workbook will include all artworks.",
    "reportMode": "PDF report mode",
    "formatTitle": "Report format",
    "formats": {
      "pdf": "Professional layout",
      "word": "Editable .docx file"
    },
    "alerts": {
      "selectFormat": "Select at least one format (PDF or Word).",
      "generation": "Report generation error: {{message}}",
      "excel": "Excel generation error: {{message}}"
    },
    "actions": {
      "generating": "Generating…",
      "downloadBoth": "Download PDF + Word",
      "downloadWord": "Download Word (.docx)",
      "downloadPdf": "Download PDF report",
      "excelGenerating": "Generating Excel…",
      "downloadExcel": "Download Excel workbook"
    },
    "common": {
      "untitled": "Untitled",
      "unattributed": "Unattributed",
      "yes": "Yes",
      "no": "No",
      "unknown": "Unknown",
      "notProvided": "Not provided"
    },
    "methods": {
      "direct": "Direct CUP — the artist’s auction sales",
      "analogy": "Analogy CUP — artists with a similar profile",
      "points": "Points method — structured primary market"
    },
    "risks": {
      "low": "Low risk",
      "medium": "Medium risk",
      "high": "High risk"
    },
    "conditions": {
      "excellent": "Excellent",
      "very_good": "Very good",
      "good": "Good",
      "fair": "Fair",
      "very_poor": "Very poor",
      "poor": "Poor",
      "damaged": "Damaged",
      "heavily_damaged": "Heavily damaged (restorable)",
      "partially_restorable": "Partially restorable",
      "to_restore": "To restore",
      "irreparable": "Irrecoverable"
    },
    "documents": {
      "invoice": "invoice",
      "certificate": "certificate",
      "condition": "condition / conservation report",
      "count": "{{count}} document",
      "count_plural": "{{count}} documents"
    },
    "export": {
      "filePrefix": "Appraisal_Report",
      "sheets": {
        "recap": "Summary",
        "comparables": "CUP Comparables",
        "artists": "Artist summary"
      },
      "excel": {
        "inventory": "Inventory no.",
        "title": "Title",
        "artist": "Artist",
        "year": "Year",
        "medium": "Medium",
        "dimensions": "Dimensions",
        "estimated": "Estimated value (€)",
        "low": "Low range",
        "high": "High range",
        "method": "Method",
        "expertDate": "Appraisal date",
        "complete": "Complete CUP sheet",
        "artworkTitle": "Artwork title",
        "comparableNo": "Comparable no.",
        "auctionHouse": "Auction house",
        "saleDate": "Sale date",
        "soldArtwork": "Artwork sold",
        "hammer": "Hammer price (€)",
        "adjustment": "Adjustment (%)",
        "note": "Note",
        "count": "No. of artworks",
        "total": "Total value (€)",
        "average": "Average value (€)"
      },
      "coverTitle": "APPRAISAL REPORT",
      "coverSubtitle": "Valuation of an art collection",
      "coverMethod": "CUP method — IFRS 13 / BOFiP compliant",
      "company": "QUANG & CO — Art advisory",
      "summaryByArtist": "Summary by artist",
      "stats": {
        "evaluated": "ARTWORKS VALUED",
        "totalValue": "TOTAL ESTIMATED VALUE",
        "estimatedSheets": "VALUATION SHEETS"
      },
      "methodologyTitle": "VALUATION METHODOLOGY",
      "methodologyBase": "Basis: IFRS 13 / BOFiP",
      "sections": {
        "method": "SELECTED METHOD",
        "ranges": "RETAINED RANGES",
        "artistSales": "THE ARTIST’S AUCTION SALES",
        "referenceSales": "AUCTION SALES RETAINED AS REFERENCES",
        "expertNote": "EXPERT NOTE",
        "marketValue": "MARKET VALUE BY EXPERT OPINION",
        "unknownCondition": "CONDITION: UNKNOWN (to be specified by expert opinion)",
        "documentation": "DOCUMENTATION",
        "analogArtists": "ANALOGOUS ARTISTS",
        "storage": "LOCATION & STORAGE CONDITIONS",
        "signature": "SIGNATURE & AUTHENTICITY",
        "reference": "REFERENCE SALES",
        "writeoff": "IRREPARABLE ARTWORKS — ZERO VALUE (WRITE-OFF)",
        "losses": "LOSSES / THEFTS / DESTRUCTION / IRREPARABLE — ZERO VALUE",
        "sold": "SOLD / TRANSFERRED ARTWORKS — OUTSIDE COLLECTION",
        "pending": "ARTWORKS AWAITING VALUATION"
      },
      "table": {
        "artworkArtist": "Artwork / Artist",
        "source": "Source",
        "hammer": "Hammer",
        "artwork": "Artwork",
        "detail": "Detail",
        "inventory": "Inventory",
        "artist": "Artist",
        "titleYear": "Title / Year",
        "medium": "Medium",
        "dimensions": "Dim.",
        "theoretical": "Theoretical value",
        "condition": "Condition",
        "auctionDate": "House / Date",
        "price": "PRICE",
        "count": "No.",
        "totalValue": "Total value",
        "averageValue": "Average value"
      },
      "disclaimer": "Valuations are established by expert opinion. They do not constitute certificates of authenticity. QUANG & CO — Confidential.",
      "pendingDisclaimer": "These artworks will be subject to an additional valuation. QUANG & CO — Confidential.",
      "soldDisclaimer": "These artworks have left the collection and are not included in the valuation. QUANG & CO — Confidential.",
      "lossDisclaimer": "These artworks are recorded for information with a zero value. QUANG & CO — Confidential.",
      "methodologyIntro": "The value retained in this report is market value under IFRS 13: the price at which an asset could be exchanged between informed and independent parties under normal market conditions. Three methods are applied according to the depth of each artist’s secondary market.",
      "groups": {
        "aTitle": "GROUP A — DIRECT CUP (Comparable Uncontrolled Price)",
        "a1": "Applicable when the artist has a documented secondary market with recent results.",
        "a2": "Principle: value is derived from the artist’s own public auction sales.",
        "a3": "Source: Artprice results weighted by recency.",
        "a4": "Reliability: high when transaction volume is sufficient.",
        "bTitle": "GROUP B — CUP BY ANALOGY",
        "b1": "Applicable when the artist’s secondary market is insufficient or outdated.",
        "b2": "Principle: comparison with artists of a similar profile.",
        "b3": "Source: sales of analogous artists selected by the expert, with a prudential discount where appropriate.",
        "b4": "Reliability: moderate, because selecting analogues is an expert judgement.",
        "cTitle": "GROUP C — POINTS METHOD (primary market)",
        "c1": "Applicable when the artist has no established secondary market.",
        "c2": "Principle: a multi-criteria grid based on dimensions and medium.",
        "c3": "Additional factors: institutional recognition, exhibitions, publications and gallery representation.",
        "c4": "Reliability: indicative, reflecting the primary market."
      },
      "adjustmentsTitle": "ADJUSTMENT GRID (applies to all methods)",
      "adjustmentHeaders": {
        "criterion": "Criterion",
        "impact": "Impact",
        "description": "Description"
      },
      "adjustments": {
        "excellent": "Excellent / Very good / Good",
        "none": "No discount",
        "fair": "Fair",
        "fairDesc": "Non-structural wear or scratches",
        "veryPoor": "Very poor",
        "veryPoorDesc": "Significant deterioration; restoration advised",
        "restorable": "Heavily damaged but restorable",
        "restorableDesc": "Restoration required",
        "irreparable": "Irrecoverable",
        "zero": "Zero value",
        "totalLoss": "Total depreciation",
        "certificate": "Certificate of authenticity",
        "artistProvenance": "Direct artist provenance",
        "documentBonus": "Documentation premium"
      },
      "fairValueDisclaimer": "Valuations represent fair value at the report date. They do not guarantee a sale price.",
      "confidentialShort": "QUANG & CO — Confidential.",
      "present": "Present",
      "absent": "Absent",
      "writeoffSummary": "{{count}} artwork | Retained value: EUR 0",
      "writeoffSummary_plural": "{{count}} artworks | Retained value: EUR 0",
      "writeoffIntro": "These artworks were examined for conservation and found to be irreparably damaged. Their current market value is retained at EUR 0. The theoretical pre-loss value is provided for information only and cannot be relied upon without certified restoration.",
      "irreparable": "Irrecoverable",
      "theoreticalDisclaimer": "The theoretical pre-loss value is estimated from the market at the appraisal date and does not constitute an insured value. QUANG & CO — Confidential.",
      "zeroValueCount": "{{count}} artwork — zero value",
      "zeroValueCount_plural": "{{count}} artworks — zero value",
      "event": "Event",
      "coverDescription": "Valuation of an art collection",
      "analogues": "Analogues: {{names}}",
      "lossTypes": {
        "vol": "Theft",
        "loss": "Loss",
        "destruction": "Destruction",
        "fire": "Fire",
        "flood": "Flood",
        "other": "Other event"
      }
    },
    "narrative": {
      "method": "Selected method: {{method}}.",
      "pointsRange": "Value estimated by points ({{segment}} segment): {{low}} - {{high}}.",
      "retainedRange": "Retained range: {{low}} - {{high}}.",
      "retainedValue": "Retained market value: {{value}}.",
      "groupC": "Group C — structured primary market. No auction sales retained.",
      "referenceRange": "Reference range: {{low}} - {{high}} per artwork.",
      "directSales": "Direct artist sales retained: {{count}} auction result(s).",
      "selectedSales": "Retained sales: {{direct}} direct, {{extrapolations}} extrapolation(s), {{analogies}} analogy(ies).",
      "references": "References retained by the expert:",
      "row": "{{index}}. {{kind}}: {{artist}}, “{{title}}”, {{source}}, retained at {{price}}{{weight}}.",
      "weight": ", weight {{weight}}",
      "pendingSales": "Artist sales are being added to the expert knowledge base.",
      "kinds": {
        "direct": "direct sale",
        "extrapolation": "extrapolation",
        "analogy": "analogy"
      },
      "artistMissing": "Artist not provided",
      "sourceMissing": "source not provided",
      "priceMissing": "price not provided"
    }
  },
  "suiviIAPage": {
    "backToArtwork": "Back to artwork"
  },
  "exportDossiers": {
    "loading": "Loading…",
    "authRequired": {
      "title": "Sign-in required",
      "text": "Sign in to generate your professional files.",
      "login": "Sign in"
    },
    "title": "Generate a professional dossier",
    "subtitle": "Create museum-quality PDF dossiers for your artworks.",
    "defaults": {
      "collector": "Collector",
      "collectionName": "My Collection",
      "collectionType": "Contemporary art",
      "collectionFocus": "Private collection",
      "collectionHistory": "A collection built with passion.",
      "themeContemporary": "Contemporary art",
      "themePainting": "Painting",
      "themeSculpture": "Sculpture"
    },
    "formats": {
      "donation": {
        "title": "Donation Dossier",
        "pages": "20 to 30 pages",
        "description": "Permanent donation to a museum"
      },
      "loan": {
        "title": "Loan Dossier",
        "pages": "12 to 15 pages",
        "description": "Temporary exhibition loan"
      },
      "book": {
        "title": "Collection Book",
        "pages": "40 to 60 pages",
        "description": "Prestige catalogue format"
      }
    },
    "descriptions": {
      "donation": {
        "title": "Donation Dossier",
        "text": "For proposing a permanent donation to a museum. Includes the full history, tax considerations and a proposed donation schedule.",
        "features": {
          "history": "Collection history",
          "tax": "Tax considerations",
          "schedule": "Proposed schedule",
          "appendices": "Document appendices"
        }
      },
      "loan": {
        "title": "Loan Dossier",
        "text": "A concise format for a temporary loan or exhibition, focused on insurance, transport and conservation requirements.",
        "features": {
          "insurance": "Insurance terms",
          "transport": "Specialist transport",
          "conservation": "Detailed conservation",
          "facility": "Facility report"
        }
      },
      "book": {
        "title": "Collection Book",
        "text": "A prestige format for a solo exhibition, catalogue or art book, with an optional critical essay and flexible organisation.",
        "features": {
          "essay": "Critical essay",
          "organisation": "4 organisation modes",
          "index": "Detailed index",
          "colophon": "Professional colophon"
        }
      }
    },
    "actions": {
      "selectAll": "Select all",
      "deselectAll": "✓ Deselect all"
    },
    "selection": {
      "count": "{{selected}} / {{total}} artworks selected"
    },
    "artworks": {
      "loading": "Loading your artworks…",
      "empty": "There are no artworks in your collection",
      "add": "Add artworks",
      "fallbackArtwork": "Artwork",
      "noImage": "No image",
      "unknownArtist": "Unknown artist",
      "untitled": "Untitled",
      "mediumUnknown": "Medium not specified"
    }
  },
  "resetPasswordPage": {
    "errors": {
      "send": "Unable to send the reset email"
    },
    "success": {
      "title": "Email sent ✅",
      "messageBefore": "A password-reset link has been sent to",
      "messageAfter": "Check your spam folder if you cannot see it.",
      "portalNote": "Family Offices, experts and partners use the same sign-in portal."
    },
    "actions": {
      "backToLogin": "Back to sign in",
      "explorePlatform": "Explore the platform",
      "explore": "Explore",
      "exploreFirst": "I would like to explore the platform first"
    },
    "imageAlt": "Artkiv background",
    "hero": {
      "line1": "Forgot your password? It happens.",
      "line2": "We will send you a secure link to get started again."
    },
    "mobileIntro": "We will send you a password-reset link.",
    "form": {
      "title": "Reset your password",
      "descriptionLine1": "Enter your email address to receive a secure link.",
      "descriptionLine2": "Nothing changes until you use that link.",
      "emailLabel": "Email",
      "emailPlaceholder": "you@example.com",
      "emailHint": "Use the email address associated with your Artkiv client, expert, Family Office or partner account.",
      "sending": "Sending…",
      "submit": "Send reset link"
    },
    "footerHelp": "Nothing received? Check your spam folder, then try again."
  },
  "ficheDetailPage": {
    "backToGuides": "Back to practical guides",
    "notFoundTitle": "Guide not found",
    "steps": "Steps",
    "usefulLinks": "Useful links",
    "otherGuides": "Other useful guides",
    "comingSoon": "coming soon"
  },
  "authRedirect": {
    "redirecting": "Redirecting…"
  },
  "paymentSuccessPage": {
    "serverError": "Server error"
  },
  "artBaselService": {
    "countries": {
      "us": "United States",
      "uk": "United Kingdom",
      "china": "China",
      "france": "France"
    },
    "sectors": {
      "postWarContemporary": "Post-War & Contemporary",
      "modernArt": "Modern Art",
      "impressionist": "Impressionist",
      "oldMasters": "Old Masters"
    },
    "sectorInsights": {
      "postWarContemporary": "Value declined while transaction volume grew, broadening market participation.",
      "modernArt": "Opportunities in the middle market, with weaker activity at the high end.",
      "impressionist": "Scarcer supply and a higher number of transactions.",
      "oldMasters": "Lowest level in fifteen years, with few lots above $10 million."
    },
    "priceInsights": {
      "under50k": "The only segment growing in value.",
      "between50k1m": "The middle market remains under pressure.",
      "over1m": "Sharp contraction in the premium segment.",
      "over10m": "A marked decline in exceptional lots."
    },
    "adminRecommendations": {
      "accessible": "Prioritise the sub-$50,000 segment for new collectors.",
      "midMarket": "Highlight middle-market opportunities between $50,000 and $1 million where discounts may emerge.",
      "premiumCaution": "Use caution for valuations above $1 million in a highly selective market.",
      "accessibleContemporary": "Favour accessible contemporary art over established high-end works.",
      "democratization": "Include a market-democratisation factor in compatibility scoring."
    },
    "profile": {
      "emergingWorks": "Emerging works recommended",
      "diversification": "Diversification suggested"
    },
    "market": {
      "trendContemporary": "2025 contemporary-art trend",
      "digitalGrowth": "Digital market growing",
      "investmentRecommended": "Investment recommended"
    },
    "matching": {
      "styleCompatibility": "Stylistic compatibility",
      "budgetAligned": "Budget aligned",
      "suggestion1": "Suggestion 1",
      "suggestion2": "Suggestion 2"
    },
    "context": {
      "internationalFairs": "Presence at international fairs",
      "establishedGallery": "Representation by an established gallery",
      "collectorInterest": "Growing collector interest",
      "artBaselTrend": "Art Basel 2025 market trend"
    },
    "gallery": {
      "international": "International gallery",
      "artBasel": "Art Basel representation"
    },
    "personalized": {
      "emergingCreative": "Works by emerging artists with strong creative potential",
      "classicProvenance": "Classic works with established provenance",
      "boldContemporary": "Bold investments in contemporary art",
      "safeValues": "Established values in the art market",
      "buyBeforeRise": "Acquisition opportunity before the expected rise",
      "entryPoint": "Ideal entry point for starting your collection"
    },
    "longTerm": {
      "diversification": "Gradual collection diversification",
      "trendMonitoring": "Monitoring Art Basel trends",
      "sectorExpertise": "Developing sector expertise"
    },
    "marketTiming": {
      "favorable": "Favourable time to acquire",
      "observation": "Period for observation and selection"
    },
    "trends": {
      "digitalArtists": "Emerging digital artists",
      "sculpturalPractices": "New sculptural practices",
      "conceptualArt": "Contemporary conceptual art"
    },
    "heirFactors": {
      "styleAligned": "Aligned artistic style",
      "historicalInterest": "Period of historical interest",
      "budgetCompatible": "Compatible budget",
      "displaySpace": "Suitable display space"
    },
    "heirRecommendations": {
      "recommended": "Artwork recommended for this profile",
      "appreciation": "Excellent appreciation potential",
      "tasteAlignment": "Aligned with the stated tastes"
    }
  },
  "conservationReport": {
    "loading": "Loading…",
    "analyzing": "AI analysis in progress…",
    "confirmDeleteImage": "Delete this image?",
    "fields": {
      "lastFullReport": "Latest full report",
      "lastInspection": "Latest visual inspection",
      "lastTransport": "Latest transport",
      "riskLevel": "Risk level",
      "nextInspection": "Next inspection",
      "nextFullReport": "Next full report",
      "photographedZone": "Photographed area",
      "addHdPhotos": "Add HD photos",
      "recommendation": "AI / expert recommendation"
    },
    "risks": {
      "low": "Low",
      "moderate": "Moderate",
      "high": "High"
    },
    "zones": {
      "surface": "Surface",
      "topLeft": "Top left corner",
      "topRight": "Top right corner",
      "bottomLeft": "Bottom left corner",
      "bottomRight": "Bottom right corner",
      "reverse": "Reverse",
      "frame": "Frame",
      "other": "Other",
      "unknown": "Unknown area"
    },
    "images": {
      "previewAlt": "Preview {{number}}",
      "existingAlt": "View {{number}}",
      "clickToDelete": "Click to delete"
    },
    "actions": {
      "back": "Back to artwork",
      "saving": "Saving…",
      "update": "Update",
      "create": "Create"
    },
    "alerts": {
      "saved": "Report saved successfully.",
      "saveError": "The report could not be saved."
    }
  },
  "philanthropyAdvisor": {
    "title": "Philanthropy & patronage",
    "subtitle": "Strategy assistant for the Family Office’s active client",
    "noActiveClient": "No active client is selected for this Family Office.",
    "regimes": {
      "frFlatTax": "France — 6.5% flat tax above €5,000 per disposal",
      "frCapitalGain": "France — 19% capital gain tax plus 17.2%, with a 5% annual allowance after two years",
      "ukCgt": "United Kingdom — Simplified 20% CGT, indicative",
      "dePrivate": "Germany — Indicative exemption after more than one year of private ownership",
      "none": "Not selected"
    },
    "levers": {
      "loan": {
        "title": "Loans to institutions",
        "detail1": "Temporary deposit or long-term loan agreement",
        "detail2Fr": "Conservation, insurance or restoration costs may be deductible, subject to confirmation",
        "detail2Other": "Costs may be deductible depending on the country",
        "detail3": "Visibility and institutional recognition for the collection"
      },
      "dation": {
        "title": "Payment in kind in France",
        "detail1": "Settlement of inheritance tax with works of art",
        "detail2": "Market-value assessment without capital-gain taxation in this framework",
        "detail3": "Acceptance is reserved for exceptional works and subject to approval"
      },
      "foundation": {
        "title": "Corporate or hosted foundation",
        "detail1": "Long-term structure for managing the collection",
        "detail2": "Tax deduction for contributions depending on the jurisdiction",
        "detail3": "Organisation of exhibitions and museum loans"
      },
      "usufruct": {
        "title": "Gift with usufruct or bare ownership in France",
        "detail1": "The donor retains enjoyment of the work",
        "detail2": "Immediate tax reduction based on the bare-ownership value",
        "detail3": "Gradual transfer that may reduce inheritance taxation"
      }
    },
    "alerts": {
      "createdNotStored": "The plan was created but could not be archived because the table is unavailable.",
      "createdStored": "The plan was created and archived.",
      "pdfError": "The PDF could not be generated."
    },
    "actions": {
      "exportPdfTitle": "Export the plan as PDF",
      "exportPdfShort": "PDF export",
      "exportPdf": "Export PDF",
      "saving": "Saving…",
      "createPlan": "Create plan"
    },
    "clientCard": {
      "client": "Client",
      "taxRegime": "Tax regime",
      "taxCountry": "Tax country: {{country}}"
    },
    "plan": {
      "title": "Philanthropy plan — Summary",
      "estimatedBenefit": "Estimated tax benefit, indicative"
    },
    "eligibility": {
      "eligible": "Eligible",
      "notApplicable": "Not applicable"
    },
    "beyondTax": {
      "title": "Benefits beyond taxation",
      "legitimacy": {
        "title": "Recognition & expertise",
        "point1": "Collaboration with curators and experts",
        "point2": "Academic documentation and stronger provenance"
      },
      "network": {
        "title": "Access & network",
        "point1": "Private invitations and acquisition committees",
        "point2": "Network of directors, curators and collectors"
      },
      "value": {
        "title": "Asset enhancement",
        "point1": "Public visibility may support resale value",
        "point2": "Catalogues and exhibition history"
      },
      "transmission": {
        "title": "Transfer & protection",
        "point1": "Clearer rights and stronger insurance coverage",
        "point2": "Traceability and AML/KYC documentation"
      }
    },
    "note": {
      "label": "Family Office note",
      "placeholder": "Key points, potential partners, target institutions…"
    },
    "disclaimer": {
      "title": "Disclaimer.",
      "text": "Indicative estimates based on information available in Artkiv. Check the applicable rules with a tax adviser or lawyer. Policies and thresholds vary by jurisdiction."
    }
  },
  "expertNews": {
    "empty": "No shared collection detected",
    "artistCount": "{{count}} artists represented in your clients’ collections",
    "more": "{{count}} additional artists"
  },
  "notFound": {
    "title": "Page not found",
    "message": "The requested resource does not exist or is not accessible."
  },
  "blockchainShowcase": {
    "current": {
      "title": "ARTKIV digital fingerprint",
      "subtitle": "Integrity evidence for the data recorded on an artwork file.",
      "available": "Available",
      "coming": "Coming soon",
      "fingerprint": {
        "title": "SHA-256 fingerprint",
        "description": "ARTKIV creates a unique hash from a snapshot of the artwork information."
      },
      "timestamp": {
        "title": "Timestamp",
        "description": "The fingerprint creation date is stored with the snapshot."
      },
      "verify": {
        "title": "Integrity verification",
        "description": "A matching fingerprint confirms that the data corresponds to the ARTKIV record."
      },
      "tezos": {
        "title": "Public Tezos anchoring",
        "description": "Future step: publish only the hash on Tezos without exposing private artwork data."
      },
      "scope": {
        "title": "What it proves",
        "text": "The fingerprint documents the integrity of a data state. It does not determine the artistic authenticity of an artwork."
      },
      "privacy": {
        "title": "Private data",
        "text": "Artwork information remains in ARTKIV. A future public anchor would contain only the hash."
      }
    },
    "title": "Blockchain & security",
    "subtitle": "Protect and trace your artworks with blockchain technology",
    "partnership": {
      "technology": "Blockchain technology",
      "europe": "Europe"
    },
    "roles": {
      "standard": "Standard",
      "premium": "Premium",
      "artAdvisor": "Art Advisor",
      "artAdvisorPremium": "Art Advisor Premium",
      "familyOffice": "Family Office"
    },
    "features": {
      "certificate": {
        "title": "Blockchain certificate",
        "description": "Each artwork receives a unique, tamper-resistant blockchain certificate that can be verified internationally."
      },
      "history": {
        "title": "Tamper-resistant traceable history",
        "description": "Movements and transactions can be recorded permanently and transparently. Coming soon."
      },
      "smartContracts": {
        "title": "Loan and rental smart contracts",
        "description": "Automate loan and rental agreements with blockchain security."
      },
      "explorer": {
        "title": "Blockchain explorer export",
        "description": "Export and view your data directly in a blockchain explorer."
      },
      "auditTrail": {
        "title": "Complete audit trail",
        "description": "Audit trail for all changes and access to collections. Coming soon."
      },
      "kyc": {
        "title": "Automated AML-KYC compliance",
        "description": "Automated compliance checks for significant transactions. Coming soon."
      }
    },
    "status": {
      "available": "Available",
      "viewOnly": "View only",
      "upgrade": "Upgrade your plan"
    },
    "info": {
      "why": {
        "title": "Why Tezos?",
        "text": "Tezos is a next-generation blockchain used by participants in the European art market. Its consensus mechanism keeps energy use and transaction costs low. It can record evidence of authenticity and provenance with a reduced environmental footprint."
      },
      "security": {
        "title": "Security & European data sovereignty",
        "text": "Artkiv relies on European infrastructure to support GDPR compliance and data control. Certificates are timestamped and verifiable, while sensitive information remains in Artkiv’s secure database. Only the authenticity proof is written to the blockchain."
      },
      "how": {
        "title": "How does it work?",
        "text": "When an artwork is certified, Artkiv creates a unique digital fingerprint, or SHA-256 hash, of its certificate. The fingerprint is recorded permanently on the Tezos blockchain. It can verify the certificate without exposing confidential information about the artwork or its owner."
      }
    },
    "upgrade": {
      "title": "Unlock every blockchain feature",
      "text": "Upgrade to Family Office to access the full blockchain security toolkit.",
      "button": "Discover Family Office"
    }
  },
  "blockchainDemo": {
    "selectorLabel": "Explore the blockchain features available with each plan:",
    "monthlyPrice": "{{price}} / month",
    "roles": {
      "standard": "Standard",
      "premium": "Premium",
      "artAdvisor": "Art Advisor",
      "artAdvisorPremium": "Art Advisor Premium",
      "familyOffice": "Family Office"
    },
    "footer": {
      "title": "Ready to secure your collection with blockchain?",
      "text": "Join collectors and Art Advisors who use Artkiv to protect and enhance their artworks through European blockchain certification.",
      "startTrial": "Start free trial",
      "scheduleDemo": "Schedule a demo"
    }
  },
  "validationRequests": {
    "loading": "Loading your requests…",
    "title": "My validation requests",
    "count": "{{count}} requests",
    "empty": "You do not have any validation requests yet.",
    "createEstimation": "Create an estimate",
    "status": {
      "pending": "Pending",
      "inProgress": "In progress",
      "completed": "Validated",
      "rejected": "Rejected"
    },
    "requestedOn": "Requested on",
    "method": {
      "label": "Method",
      "points": "Points method",
      "comparables": "Comparables"
    },
    "cost": "Cost",
    "free": "Free",
    "expertNotes": "Expert notes",
    "rejectionReason": "Reason for rejection",
    "downloadReport": "Download report",
    "processingDelay": "Your request is being processed. Estimated time: 48 to 72 business hours."
  },
  "artistAuctions": {
    "dateUnavailable": "Date unavailable",
    "emptyArtists": {
      "title": "No artists in your collection or watchlist",
      "text": "Add artworks or follow artists to see auctions involving them."
    },
    "followingCount": "{{count}} artists followed",
    "noUpcoming": "No upcoming auctions involving your artists this month.",
    "title": "Auctions involving your artists",
    "summary": "{{artists}} artists followed · {{auctions}} upcoming auctions",
    "collectionArtists": "Artists in your collection"
  },
  "artworkAccessHistory": {
    "title": "History of artwork-record views and edits by your expert",
    "tabs": {
      "all": "All",
      "views": "Views",
      "edits": "Edits"
    },
    "error": "Error: {{message}}",
    "empty": "No events in this tab.",
    "actions": {
      "edit": "Edit",
      "view": "View"
    },
    "user": "User",
    "note": "Note: {{note}}",
    "source": "Source: {{source}}"
  },
  "successionEstimation": {
    "title": "Inheritance planning",
    "subtitle": "Simulate the tax impact of an estate transfer and anticipate planning strategies. This tool helps the Family Office and notary prepare the estate in accordance with Article 764 of the French General Tax Code.",
    "reportTitle": "Inheritance-planning simulation",
    "common": {
      "toDetermine": "To be determined"
    },
    "methods": {
      "publicAuction": "Public auction, Article 764 of the French General Tax Code",
      "insuranceUnder10Years": "Insurance policy less than ten years old, Article 764 of the French General Tax Code",
      "furnitureFlatRate": "5% household-furniture lump sum, Article 764 of the French General Tax Code",
      "marketValue": "Market value on the date of death, based on an expert appraisal"
    },
    "alerts": {
      "selectArtwork": "Please select an artwork.",
      "notConnected": "The user is not signed in.",
      "reportError": "The report could not be generated.",
      "saveError": "The simulation could not be saved.",
      "success": "The simulation was saved and the report was generated successfully."
    },
    "artworkSection": {
      "title": "Artwork concerned",
      "selectLabel": "Select the artwork to analyse",
      "selectPlaceholder": "Choose an artwork",
      "artist": "Artist",
      "medium": "Medium",
      "currentValue": "Current estimated value",
      "lastEstimation": "Latest valuation date"
    },
    "parameters": {
      "title": "Simulation parameters",
      "noteTitle": "Note:",
      "noteText": "The simulation date defaults to 31 December of the previous year to support forward-looking calculations without personal implications.",
      "simulationDate": "Simulation date",
      "artworkStatus": "Artwork status",
      "furnitureHelp": "A painting displayed in a home may qualify as household furniture and fall under the 5% lump-sum rule.",
      "totalEstateValue": "Total estate value",
      "totalEstatePlaceholder": "500000",
      "flatRateHelp": "The artwork will be valued at 5% of the total under the lump-sum method."
    },
    "status": {
      "identifiedCollection": "Identified collection",
      "furniture": "Household furniture / decoration"
    },
    "valuationMethods": {
      "title": "Tax valuation methods, Article 764 of the French General Tax Code",
      "auction": "Public auction within five years",
      "hammerPrice": "Hammer price",
      "hammerPricePlaceholder": "25000",
      "saleDate": "Sale date",
      "insurance": "Insurance policy less than ten years old",
      "insuredValue": "Insured value",
      "insuredValuePlaceholder": "30000",
      "contractDate": "Policy date",
      "expert": "Expert consulted, optional",
      "expertPlaceholder": "Name of the auctioneer or expert"
    },
    "notes": {
      "label": "Additional notes",
      "placeholder": "Context, provenance, particular features…"
    },
    "results": {
      "title": "Simulation results",
      "fiscalValue": "Estimated taxable value",
      "inheritanceTax": "Inheritance tax",
      "averageRate": "Average estimate at 25%",
      "dation": "Payment in kind",
      "recommended": "Recommended",
      "notNecessary": "Not necessary",
      "aboveThreshold": "Value above €150,000",
      "belowThreshold": "Value below €150,000",
      "method": "Selected valuation method",
      "dationRecommendation": "Recommendation: the high value of this artwork warrants an assessment of payment in kind, subject to ministerial approval and professional advice."
    },
    "actions": {
      "back": "Back to estimates",
      "saveAndGenerate": "Save the simulation and generate the report"
    },
    "legal": {
      "title": "Disclaimer:",
      "text": "This document is an indicative estate-planning simulation. It does not replace detailed legal and tax advice from a notary, tax lawyer or auctioneer. Applicable rates, allowances and rules may change."
    },
    "pdf": {
      "title": "INHERITANCE-PLANNING SIMULATION",
      "confidential": "Confidential report — Working document",
      "generatedOn": "Generated on: {{date}}",
      "sections": {
        "artwork": "1. ARTWORK CONCERNED",
        "assumptions": "2. SIMULATION ASSUMPTIONS",
        "fiscalValuation": "3. TAX VALUATION, ARTICLE 764",
        "inheritanceTax": "4. ESTIMATED INHERITANCE TAX",
        "recommendations": "5. RECOMMENDATIONS"
      },
      "fields": {
        "title": "Title: {{value}}",
        "artist": "Artist: {{value}}",
        "medium": "Medium: {{value}}",
        "dimensions": "Dimensions: {{value}}",
        "simulationDate": "Simulation date: {{date}}",
        "artworkStatus": "Artwork status: {{value}}",
        "method": "Selected method: {{value}}",
        "fiscalValue": "Estimated taxable value: {{value}}",
        "estimatedTax": "Estimated tax, using an average rate: {{value}}"
      },
      "taxNoteLine1": "The actual amount depends on the family relationship, applicable allowances and",
      "taxNoteLine2": "the progressive scale in force when the estate is settled.",
      "dation": {
        "title": "Payment in kind recommended",
        "line1": "The artwork’s value warrants an assessment of payment in kind for the tax due.",
        "line2": "Subject to conditions, the artwork may be transferred to the State in settlement",
        "line3": "of inheritance tax after approval by the competent authorities."
      },
      "recommendations": {
        "expertise": "• Obtain an appraisal from an accredited auctioneer or expert",
        "documents": "• Assemble a complete file: provenance, certificates and condition information",
        "donation": "• Consider a lifetime gift with reserved usufruct",
        "notary": "• Consult a notary specialising in art law"
      },
      "disclaimerLine1": "This simulation is provided for information and cannot replace",
      "disclaimerLine2": "detailed legal and tax advice from qualified professionals.",
      "footer": "Confidential document — Strictly internal use",
      "page": "Page {{current}}/{{total}}"
    }
  },
  "round36": {
    "actualitesModule": {
      "dateUnavailable": "Date unavailable",
      "exhibitions": {
        "emptyDescription": "Exhibitions featuring your artists will appear here.",
        "emptyTitle": "No upcoming exhibitions",
        "loadError": "Unable to load exhibitions.",
        "technicalError": "Technical error while loading exhibitions."
      },
      "saleFallback": "Sale",
      "view": "View"
    },
    "artistMarketRatio": {
      "actions": {
        "addToEstimation": "Add to valuation",
        "calculating": "Calculating…",
        "loadSales": "Load sales",
        "saveRatio": "Save ratio"
      },
      "description": "For cases with few direct comparables: choose a benchmark artist among validated analogues, then build two comparable sales baskets.",
      "enoughData": "Samples are sufficient to calculate the ratio.",
      "errors": {
        "selectArtists": "Choose a benchmark artist and a target artist before loading sales.",
        "supabase": "Error while loading market data."
      },
      "extrapolationComment": "ARTKIV extrapolation: {{price}} × ratio {{ratio}} × caution {{caution}}. Ratio ID: {{ratioId}}.",
      "fields": {
        "analogSource": "Analogues suggested from the artist market profile.",
        "caution": "Caution factor",
        "chooseValidatedAnalog": "Choose a validated analogue",
        "format": "Format",
        "mediumBucket": "Medium category",
        "noAnalogPlaceholder": "No validated analogue",
        "otherArtist": "Other artist…",
        "periodEnd": "Period end",
        "periodStart": "Period start",
        "pivotArtist": "Benchmark artist",
        "pivotPlaceholder": "Benchmark artist name",
        "referencePlaceholder": "Reference sale price",
        "referenceSale": "Benchmark reference price",
        "targetArtist": "Target artist"
      },
      "match": "match {{score}}/100",
      "medium": {
        "other": "Other",
        "painting": "Painting",
        "print": "Print / edition",
        "sculptureObject": "Sculpture / object",
        "workOnPaper": "Work on paper"
      },
      "notEnoughData": "Select at least two sales in each basket.",
      "notSaved": "not saved",
      "pendingEstimation": "Calculate the ratio to obtain an extrapolated value.",
      "pivotMedian": "Benchmark median: {{value}}",
      "ratioCaution": "Market ratio: {{ratio}} · caution: {{caution}}",
      "result": "Extrapolated value",
      "savedComment": "Ratio generated from {{pivot}} benchmark sales and {{target}} target sales. Unsold lots excluded.",
      "size": {
        "all": "All sizes",
        "large": "Large",
        "medium": "Medium",
        "small": "Small"
      },
      "targetMedian": "Target median: {{value}}",
      "title": "Artist market-ratio extrapolation",
      "unknownDate": "unknown date",
      "unknownDimensions": "dimensions unknown",
      "unknownHouse": "Auction house not specified",
      "unknownMedium": "medium unknown",
      "untitled": "Untitled"
    },
    "clientManagement": {
      "actions": {
        "cancel": "Cancel",
        "corporateReports": "Corporate reports",
        "report": "Report",
        "requestAccess": "Request client access",
        "view": "View"
      },
      "cards": {
        "activeClients": "Active clients",
        "notYetOnArtkiv": "including {{count}} not yet on Artkiv",
        "pending": "Pending",
        "trackedArtworks": "Tracked artworks"
      },
      "columns": {
        "actions": "Actions",
        "artworks": "Artworks",
        "client": "Client",
        "collections": "Collections",
        "status": "Status",
        "type": "Type"
      },
      "confirm": {
        "cancelRequest": "Cancel this request?"
      },
      "description": "Manage access requests and monitor your clients.",
      "duplicate": {
        "accepted": "You already have access to this client.",
        "pending": "A request is already pending for this client."
      },
      "empty": "No request sent.",
      "errors": {
        "cancel": "Error while cancelling",
        "invalidEmail": "Invalid email",
        "send": "Error while sending",
        "updateClientType": "Error while updating the client type"
      },
      "form": {
        "clientType": "Client type *",
        "corporateDescription": "Company, foundation, hotel or firm, with audit report",
        "description": "If the client is already on Artkiv, they will receive an immediate notification. Otherwise, they will be notified when they create an account.",
        "email": "Client email *",
        "emailPlaceholder": "client@example.com",
        "message": "Message (optional)",
        "messagePlaceholder": "Hello, I would like to access your collections…",
        "privateDescription": "Private collector, access to their collection",
        "send": "Send request",
        "sending": "Sending…",
        "title": "Request access to a client"
      },
      "health": {
        "noPhoto": "{{count}} without a photo",
        "noValue": "{{count}} without a value"
      },
      "loading": "Loading…",
      "notOnArtkiv": "Not yet on Artkiv",
      "note": {
        "add": "Add a note",
        "editTitle": "Click to edit",
        "placeholder": "Note about this client…",
        "saveError": "Error while saving",
        "saved": "Note saved"
      },
      "sections": {
        "corporate": "Corporate clients",
        "counts": "{{active}} active · {{pending}} pending",
        "none": "No {{type}} client.",
        "private": "Private clients"
      },
      "status": {
        "accepted": "Accepted",
        "cancelled": "Cancelled",
        "declined": "Declined",
        "expired": "Expired",
        "pending": "Pending"
      },
      "success": {
        "cancelled": "Request cancelled",
        "sentFuture": "Request sent to {{email}}. The client will be notified when they join Artkiv.",
        "sentKnown": "Request sent to {{name}}."
      },
      "title": "My clients",
      "types": {
        "corporate": "Corporate",
        "corporateLower": "corporate",
        "private": "Private client",
        "privateLower": "private"
      }
    },
    "collectionBreakdown": {
      "allCollections": "All collections",
      "artworkCount": "{{count}} artwork(s)",
      "byArtworkCount": "Breakdown by artwork count",
      "charts": {
        "medium": "Breakdown by medium",
        "period": "Breakdown by period",
        "top10Artists": "Top 10 artists",
        "top5Artists": "Top 5 artists",
        "type": "Breakdown by art type",
        "valueByCollection": "Value by collection",
        "valueByLocation": "Value by location",
        "valueByMedium": "Value by medium"
      },
      "collectionLabel": "Collection",
      "loadError": "Error while loading artworks.",
      "loading": "Loading analytics…",
      "modeAria": "Choose breakdown mode",
      "modes": {
        "collections": "Collections",
        "locations": "Locations"
      },
      "noArtworkAvailable": "No artwork available.",
      "noArtworkSelection": "No artwork for this selection.",
      "numberOfArtworks": "Number of artworks",
      "periodUnknownNote": "{{count}} artwork(s) with no recorded creation year (not shown above).",
      "periodUnknownLotNote": "Including {{count}} in a lot: set the lot's year to date them.",
      "summary": "{{count}} artwork(s) · total value {{value}}",
      "totalValue": "Total value",
      "unclassified": "Unclassified",
      "unknownArtist": "Unknown artist",
      "unlocated": "No location",
      "untitled": "Untitled"
    },
    "collectionDetail": {
      "actions": {
        "delete": "Delete",
        "edit": "Edit",
        "editTitle": "Edit collection",
        "expert": "Expert",
        "expertise": "Request an appraisal",
        "exportComplete": "Full export (ZIP + images)",
        "lot": "Create a lot",
        "ocr": "Enrich with OCR",
        "present": "Share presentation",
        "report": "Create report",
        "share": "Share"
      },
      "share": {
        "access": "Access (rights)",
        "presentation": "Presentation"
      },
      "sidebar": {
        "artworks": "Artworks",
        "exports": "Exports & dossiers",
        "manage": "Management",
        "share": "Sharing & presentation",
        "viewPresentation": "View presentation"
      },
      "authRequired": {
        "button": "Sign in",
        "description": "Sign in to view this collection.",
        "title": "Login required"
      },
      "banners": {
        "deposit": {
          "complete": "Complete deposit information",
          "description": "These artworks belong to a third party and are excluded from your art assets.",
          "title": "Collection on deposit"
        },
        "donation": {
          "clarify": "Clarify legal status",
          "description": "These artworks were received by donation or bequest. Their legal status must be documented.",
          "title": "Donation or bequest"
        },
        "foundationDeposit": {
          "complete": "Complete the deposit agreement",
          "description": "The foundation holds these artworks on behalf of an institutional third party.",
          "title": "Institutional deposit"
        },
        "foundationOwned": {
          "description": "These artworks belong to the foundation and are included in its asset valuation.",
          "title": "Foundation property"
        },
        "founderLoan": {
          "complete": "Complete lender information",
          "description": "These artworks are made available by the founder without transfer of ownership.",
          "title": "Founder loan"
        },
        "inalienable": {
          "clarify": "Clarify the legal status",
          "description": "The value is indicative and disposals are subject to the applicable legal regime.",
          "title": "Inalienable collection"
        }
      },
      "convention": "Agreement: {{value}}",
      "legalStatus": {
        "a_clarifier": "To be clarified",
        "autre": "Other status",
        "dation": "Payment in kind",
        "don_avec_reserve_usufruit": "Donation with retained usufruct",
        "don_legs_inalienable": "Donation / bequest with inalienability clause",
        "etat_musees_de_france": "French State, Musées de France",
        "fondation_abritee": "Hosted foundation",
        "pret_artiste_vivant": "Loan from a living artist",
        "pret_institution": "Institutional loan",
        "tresor_national": "Classified national treasure"
      },
      "lenderLabel": "Lender",
      "loading": "Loading…",
      "loadingCollection": "Loading collection…",
      "loanValidUntil": "Loan valid until {{date}}",
      "notFound": {
        "back": "Back to collections",
        "description": "This collection does not exist or you do not have access to it.",
        "title": "Collection not found"
      },
      "ownerLabel": "Owner",
      "reference": "Reference: {{value}}",
      "sharedWithYou": "Collection shared with you",
      "stats": {
        "artworks": "Artworks",
        "estimatedValue": "Estimated value"
      },
      "translationUnavailable": "Translation unavailable",
      "unnamedCollection": "Untitled collection",
      "validUntil": "Valid until {{date}}"
    },
    "collectionEdit": {
      "imagePreviewAlt": "Collection preview",
      "importCsvXlsx": "Import a CSV / XLSX file",
      "inventoryMissing": "Inventory reference missing",
      "inventoryNumber": "Inventory reference: {{number}}"
    },
    "collectionTypeBadge": {
      "types": {
        "deposit": "On deposit",
        "foundation_deposit": "Institutional deposit",
        "foundation_donation": "Donation / bequest",
        "foundation_founder": "Founder loan",
        "foundation_owned": "Foundation property",
        "inalienable": "Inalienable",
        "private": "Private"
      }
    },
    "collectionTypeSelector": {
      "fields": {
        "conditions": "Special conditions (optional)",
        "contractEnd": "Contract end",
        "contractReference": "Contract reference (optional)",
        "contractStart": "Contract start",
        "conventionReference": "Agreement reference (optional)",
        "insuredBy": "Insurance arranged by",
        "legalReference": "File reference / classification number (optional)",
        "legalStatus": "Legal status",
        "ownerName": "Owner name",
        "ownerType": "Owner type",
        "partyEnd": "End date",
        "partyName": "Third-party name",
        "partyStart": "Start date",
        "partyType": "Third-party type"
      },
      "hints": {
        "deposit": "Artworks on deposit are excluded from the calculation of your art assets.",
        "foundation": "This information distinguishes works owned by the foundation from those held on behalf of third parties.",
        "foundationDeposit": "These artworks remain the property of the named third party and are not included in the foundation’s asset value.",
        "foundationDonation": "Document donation or bequest clauses to secure management and any restrictions.",
        "inalienable": "These artworks will be shown with the note “indicative value, not realisable on the market”."
      },
      "insuredBy": {
        "foundation": "The foundation",
        "owner": "The owner",
        "shared": "Shared",
        "unspecified": "To be specified"
      },
      "label": "Collection type",
      "legalStatuses": {
        "a_clarifier": "To be clarified",
        "autre": "Other status",
        "dation": "Payment in kind",
        "don_avec_reserve_usufruit": "Donation with retained usufruct",
        "don_legs_inalienable": "Donation / bequest with inalienability clause",
        "etat_musees_de_france": "French State, Musées de France",
        "fondation_abritee": "Hosted foundation",
        "pret_artiste_vivant": "Loan from a living artist",
        "pret_institution": "Institutional loan",
        "tresor_national": "Classified national treasure"
      },
      "ownerTypes": {
        "a_clarifier": "To be clarified",
        "family_succession": "Family / estate",
        "institution": "Institution (museum, foundation)",
        "private_collector": "Private collector"
      },
      "panels": {
        "depositTitle": "Deposit information",
        "foundationLegalTitle": "Foundation legal status",
        "founderLender": "Lender information",
        "inalienableTitle": "Legal-status details",
        "realOwner": "Legal owner / depositor"
      },
      "partyTypes": {
        "a_clarifier": "To be clarified",
        "artiste": "Artist",
        "autre": "Other",
        "donateur_prive": "Donor / family",
        "etat": "French State",
        "fondation": "Other foundation",
        "institution": "Private institution",
        "musee": "Public museum"
      },
      "placeholders": {
        "conditions": "Insurance, restrictions, other clauses…",
        "contractReference": "e.g. Loan agreement dated 15/03/2026",
        "conventionReference": "e.g. Agreement no. 2026-04",
        "legalReference": "e.g. Ministry file no. 2018-345",
        "ownerName": "Name or company name",
        "partyName": "Name of the state, museum, institution or donor"
      },
      "types": {
        "deposit": {
          "description": "Works lent by a third party. Outside the owner’s assets and governed by contract.",
          "title": "Deposit"
        },
        "foundation_deposit": {
          "description": "Works held by the foundation. Owner: state, museum or institution.",
          "title": "Institutional deposit"
        },
        "foundation_donation": {
          "description": "Works received by donation or bequest. They may be transferred to institutions.",
          "title": "Donation / bequest"
        },
        "foundation_founder": {
          "description": "The founder’s personal collection made available to the foundation.",
          "title": "Founder loan"
        },
        "foundation_owned": {
          "description": "Works acquired by the foundation. Active valuation and full management.",
          "title": "Foundation property"
        },
        "inalienable": {
          "description": "Protected heritage status. Indicative valuation; disposal subject to authorisation.",
          "title": "Inalienable artworks"
        },
        "private": {
          "description": "Full ownership. Free management, valuation and disposal permitted.",
          "title": "Private collection"
        }
      }
    },
    "collectionsList": {
      "tabs": {
        "all": "All",
        "own": "My collections",
        "shared": "Client collections"
      },
      "transfer": {
        "button": "Transfer collections",
        "title": "Transfer my collections"
      }
    },
    "diagnosticImport": {
      "actions": {
        "analyzing": "Analysing…",
        "fix": "Fix automatically",
        "fixing": "Fixing…",
        "run": "Run diagnostic",
        "technicalDetails": "View technical details"
      },
      "alerts": {
        "fixError": "Error while fixing: {{error}}",
        "fixSuccess": "Fix successful. {{count}} artwork(s) corrected. Refresh the page to see them.",
        "selectCollection": "Please select a collection first."
      },
      "checks": {
        "allArtworks": {
          "found": "{{count}} artwork(s) found in total",
          "name": "Artworks without client_id filter"
        },
        "clientId": {
          "name": "client_id analysis",
          "ok": "All client_id values match.",
          "problem": "Problem detected: {{count}} artwork(s) have an incorrect client_id."
        },
        "collection": {
          "found": "Collection found. Owner: {{owner}}",
          "name": "Collection",
          "notFound": "Collection not found: {{error}}"
        },
        "generalError": "General error",
        "visibleArtworks": {
          "found": "{{count}} artwork(s) visible to your account",
          "name": "Artworks with client_id filter"
        }
      },
      "common": {
        "errorWithMessage": "Error: {{error}}",
        "none": "none"
      },
      "confirm": {
        "fixClientIds": "WARNING\n\nThis action will change the client_id of every artwork in this collection.\n\nDo you want to continue?"
      },
      "description": "This diagnostic checks why imported artworks are not displayed and can fix them automatically.",
      "labels": {
        "collectionId": "Collection ID",
        "count": "Count: {{count}}",
        "userId": "Your ID"
      },
      "recommendations": {
        "allGood": "Everything is working correctly. All {{count}} artwork(s) are visible.",
        "causeLabel": "Cause",
        "causeText": "The client_id of the imported artworks does not match your user ID.",
        "foundIds": "ID(s) found",
        "mixed": "Mixed situation. Review the details above.",
        "noArtwork": "No artwork has been imported into this collection.",
        "partial": "Partial situation: {{visible}}/{{total}} artwork(s) visible.",
        "partialCause": "Some artworks were probably imported with an incorrect client_id.",
        "problemDetected": "Problem detected: {{count}} artwork(s) are in the database but none are visible.",
        "title": "Recommendations",
        "toFix": "Artworks to fix",
        "useFixButton": "Use the “Fix automatically” button above to solve this issue.",
        "useFixButtonShort": "Use “Fix automatically” to correct all artworks."
      },
      "title": "Import diagnostic"
    },
    "estimationSemblables": {
      "actions": {
        "addExternal": "Add manual comparable",
        "remove": "Remove",
        "save": "Save valuation"
      },
      "alerts": {
        "artworkUpdateError": "The report was created, but the artwork record could not be updated.",
        "maxExternal": "You can add up to five manual external comparables.",
        "saveError": "Error while saving the valuation.",
        "saved": "Valuation saved successfully.",
        "selectForVision": "Select an artwork and at least three comparables before running Vision.",
        "uploadError": "Error while generating or uploading the report."
      },
      "averageLabel": "Estimated average",
      "clientContext": "Client: {{client}} · role: {{role}} · plan: {{plan}}",
      "counts": "{{internal}} internal · {{imported}} imported · {{manual}} manual",
      "description": "Select at least three internal, imported or manual comparables to calculate a valuation.",
      "errors": {
        "notConnected": "User not signed in",
        "vision": "Vision error",
        "visionAnalysis": "Error during Vision analysis.",
        "visionNotConfigured": "Vision API is not configured."
      },
      "fields": {
        "artwork": "Artwork to value",
        "selectArtwork": "Select an artwork"
      },
      "global": "global",
      "importedHint": "Select the results that are genuinely comparable to the artwork being valued.",
      "loadingImported": "Loading imported comparables…",
      "minimumComparables": "At least three comparables are required.",
      "noDetails": "No details",
      "noEstimatedValue": "Value not provided",
      "noImported": "No imported comparable available.",
      "pdf": {
        "artwork": "Valued artwork: {{title}}",
        "date": "Date: {{date}}",
        "estimatedValue": "Estimated value: {{value}}",
        "externalComparables": "Manual external comparables:",
        "importedComparables": "Imported comparables:",
        "internalComparables": "Internal comparables:",
        "title": "Valuation report, comparable artworks",
        "visionConfidence": "Vision confidence score: {{value}}",
        "visionReading": "Vision interpretation:",
        "visionValue": "Vision refinement: {{value}}"
      },
      "placeholders": {
        "artist": "Artist",
        "comment": "Comment",
        "dimensions": "Dimensions",
        "medium": "Medium",
        "source": "Source / auction house",
        "title": "Title",
        "value": "Value"
      },
      "sections": {
        "imported": "Imported comparables",
        "internal": "Internal comparables",
        "manual": "Manual external comparables"
      },
      "title": "Valuation using comparable artworks",
      "unknownArtist": "Unknown artist",
      "unknownArtwork": "Unknown artwork",
      "unknownSource": "Unknown source",
      "untitled": "Untitled",
      "visibilityContext": "{{visibility}} · client {{client}}",
      "vision": {
        "action": "Run Vision",
        "confidence": "Confidence: {{value}}",
        "loading": "Vision analysis…",
        "range": "Range: {{low}} to {{high}}",
        "result": "Vision estimate",
        "saveHint": "The Vision value will be used when saving.",
        "title": "Vision refinement"
      }
    },
    "expertClientAccessStatus": {
      "checking": "Checking sharing status…",
      "pending": "Waiting for the client to share",
      "readError": "Unable to read permissions",
      "shared": "Shared",
      "sharedOn": "Shared on {{date}}"
    },
    "messagesButton": {
      "label": "Messages"
    },
    "museumLoanExport": {
      "actions": {
        "cancel": "Cancel",
        "generatePdf": "Generate PDF",
        "generating": "Generating…"
      },
      "button": "Loan dossier ({{count}})",
      "errors": {
        "generation": "Unable to generate the loan dossier."
      },
      "fields": {
        "curatorText": "Curatorial presentation text",
        "endDate": "Exhibition end",
        "exhibitionTheme": "Exhibition theme",
        "exhibitionTitle": "Exhibition title",
        "installationDate": "Installation date",
        "museumName": "Museum / institution",
        "photographyAllowed": "Photography permitted",
        "restitutionDate": "Return date",
        "startDate": "Exhibition start",
        "transportMethod": "Transport method"
      },
      "modal": {
        "title": "Configure loan dossier"
      },
      "pdf": {
        "acquiredFrom": "Acquired from {{source}}",
        "acquisitionToComplete": "Acquisition information to be completed",
        "annotationPlaceholder": "Annotations / identified areas / conservation notes",
        "annotationZones": "ANNOTATION AREAS",
        "arrivalMuseum": "Arrival at museum",
        "artist": "Artist",
        "artworkConditionsSheet": "ARTWORK SHEET {{current}}/{{total}}, CONDITIONS",
        "artworkCount": "• Number of proposed artworks: {{count}}",
        "artworkVisualSheet": "ARTWORK SHEET {{current}}/{{total}}, IMAGE",
        "authorized": "authorised",
        "collection": "Collection {{name}}",
        "conditionPlaceholder": "Excellent / Good / Fair",
        "conditionReport": "Detailed condition report to be produced before departure",
        "conditionSection": "CONDITION",
        "conditionToSpecify": "Condition to be specified",
        "contact": "Contact: {{value}}",
        "coverImagePlaceholder": "Cover image",
        "coverTitle": "LOAN PROPOSAL",
        "credit": "Credit",
        "currentPrivateCollection": "Current private collection",
        "deductibleBorrower": "Any deductible is borne by the borrower",
        "defaultCredit": "Courtesy of Collection {{name}}",
        "defaultPresentation": "For your exhibition “{{title}}”, I would like to propose the loan of {{count}} artwork(s) from my collection that resonate with your curatorial approach to {{theme}}. This selection would enrich the exhibition and offer an additional perspective on its themes.",
        "departureCollection": "Departure from collection",
        "exhibition": "Exhibition: {{start}} to {{end}}",
        "exhibitionPeriod": "• Exhibition period: {{dates}}",
        "facilityReport": "FACILITY REPORT, MUSEUM SECTION",
        "generalConditions": "GENERAL LOAN CONDITIONS",
        "image": "Image",
        "imagePlaceholder": "Image placeholder",
        "installation": "Installation: {{date}}",
        "installationRestitution": "• Installation: {{installation}} | Return: {{restitution}}",
        "insuranceTotal": "• Total insurance value: {{value}}",
        "keyInformation": "KEY INFORMATION",
        "lighting": "Lighting adapted to the medium",
        "loanConditionsReference": "The loan is subject to the conditions detailed below and in the attached agreement.",
        "loanDuration": "LOAN PERIOD",
        "museum": "• Museum: {{name}}",
        "museumPacking": "Packing and unpacking by qualified personnel",
        "nailToNail": "Nail-to-nail insurance at the borrower’s expense",
        "noArtworkSelected": "No artwork selected.",
        "noDirectSun": "No direct sunlight",
        "noThumbnails": "No thumbnails available.",
        "notAuthorized": "not authorised",
        "observations": "Observations:",
        "phonePlaceholder": "Telephone:",
        "photographyCredit": "Photography credit: {{credit}}",
        "photographyPermission": "Photography: {{status}}",
        "placeholders": {
          "contactDetails": "Name, role, email, telephone",
          "date": "[Date]",
          "dates": "[Dates]",
          "endDate": "[End date]",
          "exhibitionDates": "[Exhibition dates]",
          "exhibitionName": "[Exhibition name]",
          "ifApplicable": "[if applicable]",
          "museumName": "[Museum name]",
          "name": "[Name]",
          "startDate": "[Start date]",
          "theme": "[theme]",
          "title": "[Title]"
        },
        "presentation": "Presentation",
        "proposedArtworks": "Proposed artworks",
        "proposedThumbnails": "Proposed artworks, thumbnails",
        "provenance": "SUMMARY PROVENANCE",
        "referGeneralConditions": "Refer to the attached general conditions.",
        "restitution": "Return: {{date}}",
        "roundTripConditionReport": "Condition report on departure and return",
        "secureDisplay": "Secure display and handling",
        "summaryNotes": "Summary / Notes",
        "temperature": "Stable temperature and humidity",
        "toCompleteByConservation": "To be completed by the conservation department",
        "toCompleteByMuseum": "To be completed and signed by the borrowing institution.",
        "unknownArtist": "Unknown artist",
        "unspecifiedDimensions": "Dimensions not specified",
        "unspecifiedMedium": "Medium not specified",
        "untitled": "Untitled",
        "visitAvailability": "Availability for a preliminary visit: {{value}}",
        "visitAvailabilityPlaceholder": "Yes / No / Dates"
      },
      "placeholders": {
        "curatorText": "Present the selection and its relevance to the exhibition…",
        "exhibitionTheme": "Theme or curatorial concept",
        "exhibitionTitle": "Exhibition title",
        "museumName": "Museum or institution name",
        "photographyCredit": "Required photography credit"
      },
      "transport": {
        "other": "To be agreed with the museum",
        "self": "Transport arranged by the lender",
        "specialized": "Specialist art transporter"
      }
    },
    "museumProposal": {
      "actions": {
        "add": "Add",
        "addExhibition": "Add exhibition",
        "cancel": "Cancel",
        "continuePayment": "Continue to payment",
        "delete": "Delete",
        "downloadCompletePdf": "Download complete dossier",
        "downloadPdf": "Download PDF",
        "generating": "Generating…",
        "generatingPdf": "Generating PDF…",
        "preview": "Preview",
        "requestCancellation": "Request cancellation",
        "sendProposal": "Submit proposal"
      },
      "cancellationPending": "Cancellation requested",
      "chooseArtwork": "Choose an artwork",
      "confirm": {
        "cancel": "Request cancellation?",
        "delete": "Confirm deletion?"
      },
      "defaults": {
        "artistBio": "{{artist}} is a contemporary artist working primarily with {{medium}}.",
        "artisticRelevance": "This work is part of a relevant practice exploring contemporary themes through {{medium}}.",
        "artworkDescription": "{{title}} {{year}} {{medium}} represents {{subject}} in a distinctive and compelling way.",
        "subject": "a subject",
        "thisArtwork": "This artwork",
        "thisTechnique": "this technique"
      },
      "emailHint": "Used only to prepare your self-service submission.",
      "errors": {
        "cancel": "Cancellation-request error: {{error}}",
        "cancelGeneric": "An error occurred during the cancellation request.",
        "delete": "Deletion error: {{error}}",
        "deleteGeneric": "An error occurred during deletion.",
        "exhibitionRequired": "Enter at least the exhibition title, venue and start date.",
        "pdf": "Error while generating the PDF dossier.",
        "selectArtwork": "Please select an artwork.",
        "selectArtworkFirst": "Select an artwork first.",
        "submit": "Submission error: {{error}}",
        "unknown": "Unknown error"
      },
      "exhibition": {
        "fields": {
          "description": "Description",
          "endDate": "End date",
          "location": "City / country",
          "startDate": "Start date",
          "title": "Title",
          "venue": "Venue / institution"
        },
        "title": "Add an exhibition"
      },
      "fields": {
        "artistBio": "Artist biography",
        "artwork": "Select your artwork",
        "artworkDescription": "Artwork description",
        "email": "Institution email",
        "institution": "Target institution",
        "presentationMessage": "Presentation message",
        "previousExhibitions": "Previous exhibitions",
        "relevance": "Artistic and cultural relevance"
      },
      "loadingArtworks": "Loading artworks…",
      "noArtwork": "No artwork available. Add artworks to your collection first.",
      "noExhibitions": "No exhibition provided.",
      "placeholders": {
        "artistBio": "Briefly describe the artist’s background and practice…",
        "artworkDescription": "Describe the artwork, its technique and subject…",
        "email": "contact@institution.org",
        "institution": "e.g. Museum of Modern Art, Centre Pompidou…",
        "presentationMessage": "Present your approach and the reason for this proposal…",
        "relevance": "Explain why this artwork is relevant in the current artistic and cultural context…"
      },
      "preview": {
        "artworkAlt": "Proposed artwork",
        "exhibitionProposal": "Exhibition proposal",
        "fields": {
          "artist": "Artist",
          "medium": "Medium",
          "title": "Title",
          "year": "Year"
        },
        "hint": "This preview shows the information that will be included in the dossier.",
        "noBiography": "No biography provided.",
        "noDescription": "No description provided.",
        "noMessage": "No presentation message.",
        "noRelevance": "No relevance statement provided.",
        "notSpecified": "Not specified",
        "title": "Dossier preview",
        "unknownArtist": "Unknown artist",
        "untitled": "Untitled"
      },
      "sections": {
        "artistArtwork": "Artist and artwork information",
        "details": "Proposal details",
        "previousProposals": "Previous proposals",
        "submissionMethod": "Submission method"
      },
      "self": {
        "description": "Download the dossier and manage submission to the institution yourself.",
        "free": "Free",
        "manage": "You manage correspondence and follow-ups",
        "ready": "Ready-to-send dossier",
        "title": "Self-service submission"
      },
      "service": {
        "additionalFees": "Possible additional fees depending on the assignment",
        "description": "Artkiv prepares, reviews and tracks your proposal.",
        "fixedFee": "Service fee",
        "followUp": "Proposal follow-up",
        "monthlyReport": "Monthly report",
        "title": "Artkiv service"
      },
      "status": {
        "paid": "Paid",
        "pending": "Pending"
      },
      "title": "Propose an artwork to a museum or institution",
      "types": {
        "auction": "Auction",
        "museum": "Museum / institution"
      },
      "untitledArtwork": "Untitled artwork"
    },
    "pendingExpertAccess": {
      "acceptedOn": "Accepted on {{date}}",
      "alerts": {
        "error": "Error: {{error}}",
        "shared": "Collections shared with the expert."
      },
      "description": "These experts accepted your invitation and are waiting for you to share your collections.",
      "expertFallback": "Expert",
      "loading": "Loading…",
      "message": "Message: {{message}}",
      "shareNow": "Share now",
      "sharing": "Sharing…",
      "title": "{{count}} expert(s) waiting for access"
    },
    "purchaseProposal": {
      "alerts": {
        "sent": "Your purchase proposal has been sent. We will contact you shortly."
      },
      "errors": {
        "unavailable": "Artwork not found or unavailable."
      },
      "fields": {
        "email": "Your email",
        "message": "Message / Offer",
        "name": "Your name",
        "placeholder": "I would like to make an offer of…"
      },
      "loading": "Loading…",
      "price": "Listed price: € {{price}} (excluding taxes and fees)",
      "submit": "Send my proposal",
      "summary": "Artist: {{artist}} | Year: {{year}} | Medium: {{medium}}",
      "title": "Make an offer for “{{title}}”",
      "undefined": "Not specified",
      "warning": "Warning:"
    },
    "saleModal": {
      "actions": {
        "cancel": "Cancel",
        "confirm": "Record sale",
        "saving": "Saving…"
      },
      "errors": {
        "priceRequired": "Enter a valid sale price.",
        "save": "Error while saving the sale."
      },
      "fields": {
        "buyer": "Buyer",
        "buyerPlaceholder": "Buyer name",
        "notes": "Notes",
        "notesPlaceholder": "Additional information about the sale",
        "saleDate": "Sale date",
        "salePrice": "Sale price (€)"
      },
      "success": "Sale recorded.",
      "title": "Record a sale"
    }
  },
  "partnerBilling": {
    "title": "Partner billing — {{type}}",
    "partnerTypes": {
      "transport": "Transport",
      "insurance": "Insurance"
    },
    "description": "These invoices cover ARTKIV commissions or fees related to your services.",
    "invoiceFallback": "Invoice",
    "issuedOn": "Issued on {{date}}",
    "dueOn": "Due on {{date}}",
    "noDueDate": "No due date",
    "pay": "Pay",
    "empty": "No invoices to display.",
    "status": {
      "paid": "Paid",
      "pending": "Pending",
      "open": "Open",
      "overdue": "Overdue",
      "void": "Void",
      "draft": "Draft",
      "unknown": "Unknown status"
    }
  },
  "estimationPointMethod": {
    "loading": "Loading…",
    "title": "Point-method valuation",
    "formula": "Modern formula: (Height + Width) × Artist rating",
    "common": {
      "untitled": "Untitled"
    },
    "errors": {
      "load": "Unable to load the artwork: {{message}}",
      "requiredFields": "Please complete all required fields.",
      "depthRequired": "Please enter the depth for a sculpture."
    },
    "actions": {
      "backToEstimations": "Back to valuations",
      "backToArtwork": "Back to artwork record",
      "calculate": "Calculate valuation",
      "requestValidation": "Request expert validation"
    },
    "missingDimensions": {
      "title": "Missing dimensions",
      "description": "To use the point method, the artwork’s height and width must be recorded in your collection.",
      "add": "Add dimensions"
    },
    "parameters": {
      "title": "Parameters",
      "artworkType": "Artwork type",
      "type2d": "Painting / Drawing (2D)",
      "type3d": "Sculpture (3D)",
      "dimensions": "Dimensions (cm)",
      "prefilled": "✓ Pre-filled from your collection",
      "height": "Height",
      "width": "Width",
      "depth": "Depth",
      "artistRating": "Artist rating"
    },
    "categories": {
      "young": {
        "label": "Emerging artists and recent graduates",
        "description": "Early exhibitions and limited market experience"
      },
      "regional": {
        "label": "Established regional artists",
        "description": "Regional recognition, regular exhibitions and gallery representation"
      },
      "national": {
        "label": "Nationally recognised artists",
        "description": "National presence and occasional auction sales"
      },
      "international": {
        "label": "Established international artists",
        "description": "Presence in collections, museums and recognised galleries"
      },
      "iconic": {
        "label": "Art-historical icons",
        "description": "Historical significance and top-tier sales"
      }
    },
    "result": {
      "title": "Result",
      "empty": "Complete the parameters, then click “Calculate valuation”.",
      "calculation": "Calculation:",
      "indicativePrice": "Indicative price:",
      "range": "Range (±20%):"
    },
    "validation": {
      "title": "💳 Validation service",
      "standard": "• Standard: 10 validations included per month, then €150 per validation",
      "premium": "• Premium: 50 validations included per month, then €150 per validation",
      "responseTime": "Response time: 48–72 business hours"
    }
  },
  "estimationSuccessionFiscal": {
    "title": "Inheritance tax report",
    "subtitle": "Forward-looking tax analysis for estate planning",
    "common": {
      "unknownHeir": "Unknown heir",
      "untitled": "Untitled"
    },
    "alerts": {
      "loadError": "Unable to load the data: {{message}}",
      "selectPlan": "Select an inheritance plan.",
      "uploadError": "Unable to upload the PDF report.",
      "generated": "Inheritance tax report generated."
    },
    "reportTitle": "Inheritance tax report – {{name}}",
    "plan": {
      "title": "Inheritance plan",
      "loading": "Loading plans…",
      "empty": "No inheritance plan was found. First create a plan in your dashboard with the heirs and the proposed allocation of artworks.",
      "choose": "— Choose a plan —",
      "heirs": "Heirs",
      "artworks": "Artworks",
      "status": "Status"
    },
    "status": {
      "draft": "Draft",
      "pending": "Pending",
      "active": "Active",
      "completed": "Completed",
      "archived": "Archived"
    },
    "heirTypes": {
      "child": "Child",
      "daughter": "Daughter",
      "son": "Son",
      "spouse": "Spouse",
      "sibling": "Sibling",
      "family": "Family",
      "institution": "Institution",
      "other": "Other"
    },
    "summary": {
      "title": "Tax summary",
      "totalValue": "Total value",
      "inheritanceTax": "Inheritance tax",
      "dation": "Payment in kind",
      "recommended": "✓ Recommended",
      "notNecessary": "Not required"
    },
    "distribution": {
      "title": "Allocation by heir",
      "typeAndCount": "{{type}} · {{count}} artwork(s)",
      "taxes": "Tax: {{value}}",
      "assignedWorks": "Artworks allocated by affinity score",
      "moreWorks": "… and {{count}} other artwork(s)",
      "moreWorks_one": "… and 1 other artwork",
      "moreWorks_other": "… and {{count}} other artworks"
    },
    "actions": {
      "back": "← Back",
      "generatePdf": "Generate PDF report"
    },
    "difference": {
      "title": "⚠️ Important distinction",
      "validationTitle": "Artkiv validation",
      "validationIntro": "Internal review service carried out by our experts. Suitable for:",
      "personalCollection": "Personal collection management",
      "insuranceUnder": "Insurance for artworks below €80,000",
      "firstEvaluation": "Initial assessment before a sale",
      "validationPrice": "Price: 10–50 validations per month depending on the plan, then €150 per validation",
      "cnesTitle": "CNES appraisal",
      "cnesIntro": "Physical appraisal by an accredited expert. Required for:",
      "insuranceOver": "Insurance for artworks above €80,000",
      "majorEstate": "Significant estate",
      "auction": "Auction sale",
      "bankGuarantee": "Bank guarantee or litigation",
      "cnesPrice": "Price: from €300, including travel and a certified report",
      "contact": "💡 Artkiv can connect you with accredited CNES experts for high-value artworks or legal requirements."
    },
    "pdf": {
      "title": "INHERITANCE TAX REPORT",
      "plan": "Plan: {{name}}",
      "date": "Date: {{date}}",
      "valuation": "VALUATION",
      "totalValue": "Total value: {{value}}",
      "estimatedTaxes": "Estimated tax: {{value}}",
      "distribution": "ALLOCATION BY HEIR",
      "receivedValue": "Value received: {{value}}",
      "taxes": "Tax: {{value}}",
      "artworks": "Artworks: {{count}}",
      "artworks_one": "Artwork: 1",
      "artworks_other": "Artworks: {{count}}"
    }
  },
  "autoCUPAssistant": {
    "header": {
      "eyebrow": "CUP Assistant",
      "title": "Pre-analysis of imported comparables",
      "description": "Analyses Artprice lots, reads the expert’s personal artist quote and incorporates Group B analogies.",
      "premiumOnly": "Art Advisor Premium only",
      "active": "Active"
    },
    "loading": "Loading imported comparables…",
    "errors": {
      "load": "Unable to load imported comparables."
    },
    "methodGroups": {
      "directCup": "Group A — Direct CUP",
      "analogyCup": "Group B — CUP by analogy",
      "pointMethod": "Group C — Point method",
      "directCupPrudent": "Prudent direct CUP",
      "analogyCupRatio": "Analogical CUP by ratio",
      "hybridPointsCup": "Hybrid points + comparables",
      "unknown": "Method not specified"
    },
    "mediums": {
      "painting": "Painting",
      "sculpture": "Sculpture",
      "photography": "Photography",
      "drawing": "Drawing",
      "print": "Print",
      "mixed_media": "Mixed media",
      "installation": "Installation",
      "video": "Video",
      "textile": "Textile",
      "ceramic": "Ceramics",
      "nft": "NFT / Digital art",
      "other": "Other",
      "oil_on_canvas": "Oil on canvas",
      "acrylic_on_canvas": "Acrylic on canvas",
      "ink_on_paper": "Ink on paper",
      "watercolor_on_paper": "Watercolour on paper",
      "pencil_on_paper": "Pencil on paper",
      "charcoal_on_paper": "Charcoal on paper",
      "mixed_media_on_paper": "Mixed media on paper"
    },
    "supports": {
      "oil_canvas": "oil on canvas",
      "acrylic_canvas": "acrylic on canvas",
      "paper_mounted_canvas": "paper mounted on canvas",
      "paper_work": "work on paper",
      "canvas": "canvas"
    },
    "exclusions": {
      "condition": "Irreparable condition: excluded from the calculation and retained as context.",
      "freshness": "Result older than five years or inconsistent date: excluded from the calculation and retained as context."
    },
    "marketSegments": {
      "primary": "Primary segment",
      "secondary": "Adjacent segment",
      "own_context": "Same artist · distant technique",
      "analog_same_segment": "Analogue in the same segment",
      "analog_context": "Contextual analogue",
      "unclassified": "Unclassified segment"
    },
    "minimum": {
      "groupA": "At least 3 comparables in Group A",
      "groupB": "At least 5 references in Group B",
      "pointMethod": "Point method"
    },
    "quote": {
      "loaded": "Personal artist quote loaded",
      "date": "date: {{date}}",
      "analogies": "analogies: {{names}}"
    },
    "empty": {
      "title": "No imported comparable was found for this artist or their analogues.",
      "description": "Import Artprice records. In Group B, the assistant will also search the comparable artists defined in the personal artist quote.",
      "import": "Import Artprice records"
    },
    "metrics": {
      "comparables": "Comparables",
      "minimum": "{{current}}/{{minimum}} minimum",
      "breakdown": "{{primary}} primary · {{secondary}} adjacent · {{analog}} analogue · {{sameSegment}} same segment",
      "calculationStatus": "Calculation status",
      "weightedMedian": "Weighted median",
      "proposedRange": "Proposed range",
      "confidence": "Confidence"
    },
    "status": {
      "finalizable": "Ready to finalise",
      "provisional": "Provisional",
      "insufficient": "Insufficient"
    },
    "notices": {
      "provisional": "A preliminary estimate has been calculated from {{count}} reference(s). Full CUP validation remains locked until the business threshold is met: {{minimum}}.",
      "insufficient": "Add at least three usable sales to display a preliminary estimate. {{minimum}} to finalise.",
      "marketStructure": "Technique structures the submarket: primary segment = same artist and same technique, adjacent segment = same artist and a related technique family, analogues = market context. Analogues are shown but carry little weight in the median."
    },
    "badges": {
      "analogyB": "Group B analogy",
      "ownGroupB": "Artist’s own result · Group B",
      "directGroupA": "Direct Group A"
    },
    "row": {
      "technique": "Technique",
      "supportDriver": "key support: {{support}}",
      "decision": "Decision: condition {{condition}} · dim. {{dimensions}} · tech. {{technique}} · proximity {{proximity}} · freshness {{freshness}} · weight {{weight}}",
      "afterDiscount": "After discount: {{value}}",
      "estimateRange": "Est. {{low}} – {{high}}",
      "match": "Match {{score}}/100"
    },
    "analog": {
      "reasonFallback": "Group B artist comparable"
    },
    "summary": {
      "analogDiscount": "Group B analogy, {{discount}}% discount",
      "analog": "Group B analogy",
      "ownGroupB": "Artist’s own result · expert qualitative adjustment (Group B)",
      "directGroupA": "Group A — Direct CUP"
    },
    "stock": {
      "eyebrow": "Complete artist stock",
      "found": "{{count}} auction result(s) found for {{artist}}",
      "found_one": "1 auction result found for {{artist}}",
      "found_other": "{{count}} auction results found for {{artist}}",
      "auditHelp": "The CUP remains based on the strongest comparables; this stock supports audit and expert selection.",
      "tabs": {
        "all": "All auction results",
        "sameTechnique": "Same technique",
        "sameFamily": "Related technique family",
        "priced": "Sales with prices",
        "estimates": "Estimates only"
      },
      "empty": "No auction result in this tab.",
      "autoSelected": "auto-selected by CUP",
      "addedToForm": "added to the form",
      "family": "Family",
      "technique": "Technique",
      "supportDriver": "Key support: {{support}}",
      "priceUnpublished": "Price not published",
      "alreadyAdded": "Already added",
      "addToForm": "Add to form"
    },
    "sources": {
      "artprice": "Open Artprice",
      "invaluable": "Open Invaluable",
      "artnet": "Open Artnet",
      "sothebys": "Open Sotheby’s",
      "christies": "Open Christie’s",
      "named": "Open {{name}} source",
      "generic": "Open source"
    },
    "suggestion": {
      "finalizable": "Finalisable proposal: apply the strongest weighted comparables.",
      "provisional": "Provisional proposal: the calculation is visible, but final validation still requires the missing references.",
      "expertControl": "The expert retains control of the Group B discount and final adjustment.",
      "apply": "Apply suggestion"
    },
    "locked": {
      "title": "Automatic pre-analysis is reserved for Premium",
      "description": "With Art Advisor Standard, the expert enters comparables manually. With Art Advisor Premium, ARTKIV reads Artprice imports and proposes a usable CUP range."
    },
    "common": {
      "untitled": "Untitled",
      "thisArtist": "this artist"
    }
  },
  "auctionProposalPage": {
    "title": "Submit an artwork to an auction house",
    "loading": "Loading artwork…",
    "artworkSection": {
      "title": "Artwork information"
    },
    "summary": {
      "title": "Title",
      "artist": "Artist",
      "year": "Year",
      "medium": "Medium",
      "dimensions": "Dimensions",
      "value": "Value"
    },
    "fallbacks": {
      "untitled": "Untitled",
      "untitledArtwork": "Untitled artwork",
      "unknownArtist": "Unknown artist",
      "notSpecifiedFeminine": "Not specified",
      "notSpecifiedMasculine": "Not specified",
      "notSpecifiedPlural": "Not specified",
      "artwork": "Artwork",
      "artworkFile": "artwork",
      "auctionHouseFile": "auction-house"
    },
    "form": {
      "title": "Proposal details",
      "auctionHouse": "Auction house",
      "auctionHousePlaceholder": "e.g. Christie’s, Sotheby’s, Drouot…",
      "message": "Presentation message",
      "messagePlaceholder": "Additional information about the artwork, its provenance and condition…",
      "email": "Your email address for the report",
      "emailPlaceholder": "your@email.com",
      "emailHelp": "We will send the formatted report to this address."
    },
    "actions": {
      "preview": "Preview",
      "downloadPdf": "Download PDF",
      "generating": "Generating…",
      "submit": "Submit proposal",
      "closePreview": "Close preview",
      "generatingPdf": "Generating PDF…",
      "downloadFullPdf": "Download full PDF"
    },
    "preview": {
      "title": "Proposal preview",
      "heading": "Auction consignment proposal"
    },
    "notFound": {
      "title": "Artwork not found",
      "description": "The artwork could not be found in the database.",
      "back": "Back to dashboard"
    },
    "errors": {
      "loadArtwork": "Unable to load the artwork information.",
      "pdf": "Unable to generate the PDF report.",
      "required": "Please complete all required fields.",
      "submit": "Unable to submit the proposal: {{message}}",
      "unknown": "Unknown error"
    },
    "pdf": {
      "filePrefix": "auction-proposal"
    }
  },
  "readiness": {
    "dimensions": {
      "identification": "Identification",
      "documentation": "Documentation",
      "provenance": "Authenticity / provenance",
      "valuation": "Up-to-date valuation",
      "insurance": "Insurance",
      "conservation": "Conservation monitored",
      "property": "Ownership clarified",
      "transmission": "Succession prepared"
    },
    "actions": {
      "identification_one": "Complete identification for {{count}} artwork",
      "identification_other": "Complete identification for {{count}} artworks",
      "documentation_one": "Add invoice / certificate for {{count}} artwork",
      "documentation_other": "Add invoice / certificate for {{count}} artworks",
      "provenance_one": "Document provenance for {{count}} artwork",
      "provenance_other": "Document provenance for {{count}} artworks",
      "valuation_one": "Update valuation for {{count}} artwork",
      "valuation_other": "Update valuations for {{count}} artworks",
      "insurance_one": "Check insurance for {{count}} artwork",
      "insurance_other": "Check insurance for {{count}} artworks",
      "conservation_one": "Record condition for {{count}} artwork",
      "conservation_other": "Record condition for {{count}} artworks",
      "property_one": "Clarify ownership status for {{count}} artwork",
      "property_other": "Clarify ownership status for {{count}} artworks",
      "transmission_one": "Prepare succession for {{count}} artwork",
      "transmission_other": "Prepare succession for {{count}} artworks",
      "generic_one": "{{count}} artwork",
      "generic_other": "{{count}} artworks"
    },
    "priority": {
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "cards": {
      "artwork": {
        "eyebrow": "Art Asset Readiness",
        "subtitle": "Patrimonial readiness of the artwork",
        "missingPrefix": "To complete:",
        "dossierTitle": "Generate a structured patrimonial dossier (identification, ownership, valuation, market, risk)",
        "dossierButton": "Prepare patrimonial dossier (PDF)"
      },
      "advisor": {
        "eyebrow": "Collections under mandate",
        "title": "Work queue: patrimonial readiness",
        "subtitle_one": "{{count}} artwork in your scope. Priority actions are listed below.",
        "subtitle_other": "{{count}} artworks in your scope. Priority actions are listed below.",
        "average": "Average readiness",
        "exceptional_one": "⚠️ {{count}} exceptional artwork without succession planning.",
        "exceptional_other": "⚠️ {{count}} exceptional artworks without succession planning.",
        "allCovered": "All readiness dimensions are covered across your scope."
      },
      "collection": {
        "eyebrow": "Patrimonial status",
        "title": "Preparing your collection",
        "subtitle_one": "What is ready and what needs your attention across {{count}} artwork.",
        "subtitle_other": "What is ready and what needs your attention across {{count}} artworks.",
        "readinessLabel": "Collection Readiness",
        "exceptional_one": "⚠️ {{count}} exceptional artwork without succession planning.",
        "exceptional_other": "⚠️ {{count}} exceptional artworks without succession planning.",
        "actionsTitle": "To improve your readiness",
        "viewCollection": "View my collection →"
      },
      "portfolio": {
        "eyebrow": "Art assets under supervision",
        "title": "Portfolio Readiness",
        "subtitle": "Patrimonial readiness by family, with strict data separation.",
        "consolidated": "Consolidated",
        "columns": {
          "family": "Family",
          "artValue": "Art value",
          "readiness": "Collection Readiness",
          "priority": "Priority"
        }
      }
    }
  },
  "artAssetDossierPdf": {
    "common": {
      "yes": "Yes",
      "no": "No",
      "present": "Present",
      "missing": "Missing"
    },
    "header": {
      "eyebrow": "ART ASSET DOSSIER — PATRIMONIAL FILE",
      "untitled": "Untitled artwork",
      "completeness": "Dossier completeness"
    },
    "ownership": {
      "full": "Full ownership",
      "usufruct": "Usufruct",
      "bare_ownership": "Bare ownership"
    },
    "condition": {
      "excellent": "Excellent",
      "very_good": "Very good",
      "good": "Good",
      "fair": "Fair",
      "very_poor": "Very poor",
      "poor": "Poor",
      "heavily_damaged": "Heavily damaged (restorable)",
      "partially_restorable": "Partially restorable",
      "irreparable": "Irreparable"
    },
    "sections": {
      "identification": {
        "title": "Identification",
        "artist": "Artist",
        "artworkTitle": "Title",
        "year": "Year",
        "medium": "Medium",
        "dimensions": "Dimensions",
        "inventory": "Inventory no."
      },
      "acquisition": {
        "title": "Ownership & acquisition",
        "owner": "Owner",
        "ownershipStatus": "Ownership status",
        "date": "Acquisition date",
        "source": "Source",
        "price": "Acquisition price",
        "documents": "Supporting documents"
      },
      "authenticity": {
        "title": "Authenticity & documentation",
        "invoice": "Invoice",
        "certificate": "Certificate of authenticity",
        "provenance": "Provenance",
        "signature": "Signature"
      },
      "valuation": {
        "title": "Valuation",
        "currentValue": "Current value",
        "range": "Low / high estimate",
        "method": "Method",
        "comparables": "Comparables",
        "date": "Valuation date"
      },
      "market": {
        "title": "Market (indicative)",
        "liquidity": "Indicative liquidity",
        "trend": "Trend",
        "demand": "Demand"
      },
      "risk": {
        "title": "Physical risk",
        "condition": "Condition",
        "lastInspection": "Last inspection",
        "storage": "Storage",
        "insurance": "Insurance",
        "insured": "Insured",
        "uninsured": "Uninsured"
      }
    },
    "missing": {
      "title": "Items to complete for a complete dossier"
    },
    "footer": {
      "disclaimer": "Dossier generated via ARTKIV on {{date}}. ARTKIV provides structured, traceable and shareable data; decisions regarding financing, disposal or expertise remain human and professional. Market indicators are provided for information only and are subject to methodological caveats."
    },
    "file": {
      "prefix": "art-asset-dossier",
      "untitledSlug": "artwork"
    }
  },
  "familyOfficeReportPdf": {
    "header": {
      "eyebrow": "FAMILY OFFICE REPORT — ART ASSETS",
      "defaultName": "Family Office",
      "portfolioReadiness": "Portfolio Readiness"
    },
    "summary": {
      "supervisedFamilies": "Families supervised",
      "consolidatedArtValue": "Consolidated art value"
    },
    "families": {
      "title": "Readiness by family",
      "columns": {
        "family": "Family",
        "artValue": "Art value",
        "readiness": "Collection Readiness",
        "priority": "Priority"
      }
    },
    "attention": {
      "title": "Consolidated attention points",
      "valuation": "Valuations to update",
      "insurance": "Underinsured artworks",
      "documentation": "Documentation to complete",
      "provenance": "Provenance to complete",
      "conservation": "Condition to document",
      "exceptional": "Exceptional artworks without succession planning"
    },
    "footer": {
      "disclaimer": "Consolidated report prepared via ARTKIV on {{date}}. Strict separation is maintained between families; each family retains control of its data. ARTKIV structures patrimonial data; decisions and validations remain the responsibility of duly authorised professionals."
    },
    "file": {
      "prefix": "family-office-report"
    }
  },
  "aiConsentInfoPage": {
    "backToProfile": "Back to my profile",
    "eyebrow": "Artificial intelligence & data",
    "title": "How ARTKIV uses AI and your artwork data",
    "intro": "This page explains ARTKIV’s artificial intelligence features, the data they may use, their limits, and the choices you keep at every stage.",
    "principle": {
      "title": "ARTKIV principle",
      "body": "AI assists documentation, analysis and decision preparation. It is not intended to decide for you. You retain final validation."
    },
    "access": {
      "title": "Access to AI features",
      "body": "Access to AI modules depends on your ARTKIV role and plan. When an AI feature is included in your plan, it remains disabled until you choose to activate AI at account level.",
      "standardTitle": "Account without AI access",
      "standardBody": "You can continue managing your collection manually. Features requiring AI remain unavailable until they are included in your plan.",
      "eligibleTitle": "AI-eligible account",
      "eligibleBody": "Your consent authorises AI features when you actively use them. It does not trigger automatic analysis of your entire collection."
    },
    "purposes": {
      "title": "What are the AI modules used for?",
      "visual": {
        "title": "Visual analysis",
        "body": "Suggest a classification, style, keywords or descriptive elements from artwork images."
      },
      "documents": {
        "title": "Documents & OCR",
        "body": "Read an invoice, certificate or other document and suggest information for the artwork record. Suggested data must be reviewed before validation."
      },
      "conservation": {
        "title": "Conservation",
        "body": "Help structure condition observations, identify items to monitor and prepare documentary follow-up. This assistance does not replace a professional condition assessment."
      },
      "valuation": {
        "title": "AI-assisted valuation",
        "body": "Combine artwork information with comparables and available data to produce value indications and analytical context."
      }
    },
    "data": {
      "title": "What data may be processed?",
      "intro": "Depending on the feature you use, ARTKIV may send to the relevant module only the elements needed for the requested task, including:",
      "items": {
        "images": "artwork images you choose to analyse;",
        "documents": "documents you submit to OCR or document analysis;",
        "metadata": "useful artwork metadata such as artist, title, date, medium or dimensions;",
        "condition": "condition observations and information required by the relevant conservation module;",
        "valuation": "valuation data, comparables and market information useful for calculation or analysis;",
        "outputs": "results generated by the modules so that they can be displayed, reviewed or attached to your artwork record."
      }
    },
    "control": {
      "title": "You stay in control",
      "items": {
        "onDemand": "Account activation does not automatically analyse every artwork. An AI feature is used when you launch the corresponding action.",
        "review": "AI results are suggestions that you can review, correct, accept or ignore depending on the workflow.",
        "noSilentWrite": "Sensitive data extracted by OCR or suggested by AI should not be silently written into business fields without the validation step provided by the interface.",
        "permissions": "Activating AI does not change existing collection sharing rules, access rights or permissions."
      }
    },
    "limits": {
      "title": "What ARTKIV AI does not do",
      "items": {
        "indicative": "AI analyses and valuations are indicative and may contain errors or uncertainty.",
        "noAuthentication": "An AI analysis does not, by itself, constitute authentication, proof of authenticity or a formal appraisal.",
        "noProfessionalReplacement": "It does not replace the judgement of an expert, conservator, insurer, auctioneer, legal adviser or notary when professional validation is required.",
        "uncertainty": "When available information is insufficient, contradictory or uncertain, the result should be reviewed and completed by a person."
      }
    },
    "statistics": {
      "title": "Aggregated statistics: a separate choice",
      "body": "Account-level consent to AI features is separate from an artwork’s opt-in to ARTKIV anonymised aggregated statistics and analyses. Enabling AI never enables this artwork opt-in automatically. It is managed separately on the artwork record."
    },
    "consent": {
      "title": "Activation and withdrawal",
      "body": "When your plan includes AI access, you can choose to activate it from your profile. ARTKIV then records your choice and its date so that access rules can be applied correctly.",
      "withdrawal": "You can withdraw your consent from the same setting. Withdrawal blocks new AI processing that requires this consent.",
      "afterWithdrawal": "Withdrawal does not automatically delete data, documents or results already stored in your ARTKIV record. Their management remains subject to the normal rules of your account and the deletion features available to you."
    },
    "privacy": {
      "title": "Privacy and permissions",
      "permissions": "Enabling AI does not grant any additional rights to a third party and never bypasses existing ARTKIV permissions.",
      "noPublicity": "Enabling AI features does not make your collection public and does not turn a private record into a public one.",
      "technicalDetails": "Technical information that may change, including providers, hosting, retention periods or possible transfers, should remain described in ARTKIV’s up-to-date privacy documentation. This page describes product behaviour and does not replace that documentation."
    },
    "footer": {
      "title": "Change my choice",
      "body": "The AI activation setting remains available in your profile. If your plan does not include AI features, your collection data remains accessible and can still be managed manually.",
      "cta": "Back to AI settings"
    }
  }
};

export default en;
